// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/myapps.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/home.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/services.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/extended_solutions.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/add_application.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/carousel.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/activitylog.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/session_control.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/role_definition.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/new_role.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/user_mapping.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/assign_role.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_12___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/intro.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_13___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/application_registration.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_14___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/banner_image.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_15___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/common.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_16___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/contact_abb.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_17___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/new_uesr_request.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_18___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/casecreationform.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_19___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/import_export.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_20___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/variables/fonts.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_21___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/fonts/Abb_Dias_font/style.css";
import ___CSS_LOADER_AT_RULE_IMPORT_22___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./assets/styles/my_learing.scss";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Rg.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Rg.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Rg.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Rg.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Md.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Md.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Md.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Md.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Lt.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Lt.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Lt.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Lt.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Bd.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Bd.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Bd.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./assets/fonts/ABBVoice/ABBvoice_W_Bd.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_12___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_13___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_14___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_15___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_16___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_17___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_18___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_19___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_20___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_21___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* @import url("./assets/styles/bootstrap.min.css"); */
html[data-theme=light] {
  --text-primary-color: #1F1F1F;
  --text-secondary-color: #696969;
  --text-blue-color: #3366FF;
  --red: #FF000F;
  --primary-default: #3366FF;
  --primary-hover: #4D85FF;
  --primary-active: #2934FF;
  --primary-disabled: #9CBDF7;
  --white: #FFFFFF;
  --grey-100: #FAFAFA;
  --grey-200: #F5F5F5;
  --grey-300: #EBEBEB;
  --grey-400: #DBDBDB;
  --grey-500: #BABABA;
  --grey-600: #9F9F9F;
  --grey-700: #868686;
  --grey-800: #696969;
  --grey-900: #333333;
  --left-pane: #FAFAFA;
  --accordion-expanded-bg: #DEE6FF;
  --accordion-border: #3366ff70;
  --card-bg: #FFFFFF;
  --card-hover: #DEE6FF70;
  --toolbar-bg: #F5F5F5;
  --segmented-control-hover: #EBEBEB;
  --icon-hover: #F5F5F5;
  --shadow-blue: #3366FF8F;
  --shadow-grey-100: #BABABA4F;
  --shadow-grey-200: #00000029;
  --status-success: #21A67A;
  --status-success-hover: #218C69;
  --status-success-transparent: #EDF8F4;
  --status-warning: #FFA200;
  --status-warning-hover: #D58906;
  --status-warning-transparent: #FFF8EB;
  --status-error: #EF3934;
  --status-error-hover: #C73430;
  --status-error-transparent: #FEEFEF;
  --status-info: #0052FF;
  --status-info-hover: #0648D5;
  --status-info-transparent: #EAEFFF;
}

html[data-theme=dark] {
  --text-primary-color: #FFFFFF;
  --text-secondary-color: #DBDBDB;
  --text-blue-color: #7DA7FF;
  --red: #FF000F;
  --primary-default: #7DA7FF;
  --primary-hover: #ADC7FD;
  --primary-active: #4580FF;
  --primary-disabled: #4C5463;
  --white: #1F1F1F;
  --grey-100: #333333;
  --grey-200: #0F0F0F;
  --grey-300: #0F0F0F;
  --grey-400: #696969;
  --grey-500: #707070;
  --grey-600: #DBDBDB;
  --grey-700: #DCDCDC;
  --grey-800: #DBDBDB;
  --grey-900: #FAFAFA;
  --left-pane: #333333;
  --accordion-expanded-bg: #4C5463;
  --accordion-border: #4580FFCC;
  --card-bg: #333333;
  --card-hover: #4C5463;
  --toolbar-bg: #333333;
  --icon-hover: #696969;
  --segmented-control-hover: #333333;
  --shadow-blue: #7EA8FB8F;
  --shadow-grey-100: #8686864F;
  --shadow-grey-200: #00000011;
  --status-success: #4DB895;
  --status-success-hover: #3EA483;
  --status-success-transparent: #1D2D1E;
  --status-warning: #FFB533;
  --status-warning-hover: #E9A225;
  --status-warning-transparent: #352122;
  --status-error: #F2615D;
  --status-error-hover: #DC514D;
  --status-error-transparent: #300C0A;
  --status-info: #7DA7FF;
  --status-info-hover: #7BA1F1;
  --status-info-transparent: #222635;
}

html[data-theme=light] {
  --text-primary-color: #1F1F1F;
  --text-secondary-color: #696969;
  --text-blue-color: #3366FF;
  --red: #FF000F;
  --primary-default: #3366FF;
  --primary-hover: #4D85FF;
  --primary-active: #2934FF;
  --primary-disabled: #9CBDF7;
  --white: #FFFFFF;
  --grey-100: #FAFAFA;
  --grey-200: #F5F5F5;
  --grey-300: #EBEBEB;
  --grey-400: #DBDBDB;
  --grey-500: #BABABA;
  --grey-600: #9F9F9F;
  --grey-700: #868686;
  --grey-800: #696969;
  --grey-900: #333333;
  --left-pane: #FAFAFA;
  --accordion-expanded-bg: #DEE6FF;
  --accordion-border: #3366ff70;
  --card-bg: #FFFFFF;
  --card-hover: #DEE6FF70;
  --toolbar-bg: #F5F5F5;
  --segmented-control-hover: #EBEBEB;
  --icon-hover: #F5F5F5;
  --shadow-blue: #3366FF8F;
  --shadow-grey-100: #BABABA4F;
  --shadow-grey-200: #00000029;
  --status-success: #21A67A;
  --status-success-hover: #218C69;
  --status-success-transparent: #EDF8F4;
  --status-warning: #FFA200;
  --status-warning-hover: #D58906;
  --status-warning-transparent: #FFF8EB;
  --status-error: #EF3934;
  --status-error-hover: #C73430;
  --status-error-transparent: #FEEFEF;
  --status-info: #0052FF;
  --status-info-hover: #0648D5;
  --status-info-transparent: #EAEFFF;
}

html[data-theme=dark] {
  --text-primary-color: #FFFFFF;
  --text-secondary-color: #DBDBDB;
  --text-blue-color: #7DA7FF;
  --red: #FF000F;
  --primary-default: #7DA7FF;
  --primary-hover: #ADC7FD;
  --primary-active: #4580FF;
  --primary-disabled: #4C5463;
  --white: #1F1F1F;
  --grey-100: #333333;
  --grey-200: #0F0F0F;
  --grey-300: #0F0F0F;
  --grey-400: #696969;
  --grey-500: #707070;
  --grey-600: #DBDBDB;
  --grey-700: #DCDCDC;
  --grey-800: #DBDBDB;
  --grey-900: #FAFAFA;
  --left-pane: #333333;
  --accordion-expanded-bg: #4C5463;
  --accordion-border: #4580FFCC;
  --card-bg: #333333;
  --card-hover: #4C5463;
  --toolbar-bg: #333333;
  --icon-hover: #696969;
  --segmented-control-hover: #333333;
  --shadow-blue: #7EA8FB8F;
  --shadow-grey-100: #8686864F;
  --shadow-grey-200: #00000011;
  --status-success: #4DB895;
  --status-success-hover: #3EA483;
  --status-success-transparent: #1D2D1E;
  --status-warning: #FFB533;
  --status-warning-hover: #E9A225;
  --status-warning-transparent: #352122;
  --status-error: #F2615D;
  --status-error-hover: #DC514D;
  --status-error-transparent: #300C0A;
  --status-info: #7DA7FF;
  --status-info-hover: #7BA1F1;
  --status-info-transparent: #222635;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit 100%;
  vertical-align: baseline;
}

table, th {
  border-right: 0 !important;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-spacing: 0;
}

.clearfix::after {
  content: "";
  clear: both;
  display: table;
}

* {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  width: 100%;
}

.icon_abb_16 {
  font-size: 1rem;
}

.icon_abb_24 {
  font-size: 1.5rem;
}

.icon_abb_32 {
  font-size: 2rem;
}

.accordion-wrapper .MuiPaper-root {
  min-width: 650px;
  width: 100%;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root {
  margin: 8px 0px 0px 0px;
  background-color: transparent;
  color: var(--text-primary-color);
  box-shadow: none;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root {
  background-color: var(--grey-400);
  padding: 0 20px;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .open-close-icons {
  margin-right: 10px;
  transform: rotate(0deg);
  transition-duration: 300ms;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root .open-close-icons + div {
  width: 60%;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root.Mui-expanded .open-close-icons {
  transform: rotate(90deg);
  transition-duration: 300ms;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root .MuiAccordionDetails-root {
  margin-top: 8px;
  color: var(--text-primary-color);
  font-weight: 400;
  font-size: 1rem;
  background-color: var(--white);
  border: 1px solid var(--grey-400);
  padding: 20px;
  border-radius: 4px;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root.Mui-expanded {
  margin: 8px 0px;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root .MuiButtonBase-root {
  color: var(--text-primary-color);
  font-weight: 400;
  font-size: 1rem;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root .MuiButtonBase-root.MuiAccordionSummary-root {
  min-height: 40px;
  border-radius: 4px;
  height: 40px;
  border: 1px solid transparent;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root .MuiButtonBase-root.MuiAccordionSummary-root .MuiAccordionSummary-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root .MuiButtonBase-root.MuiAccordionSummary-root .MuiAccordionSummary-content .first-part {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root .MuiButtonBase-root.MuiAccordionSummary-root .MuiAccordionSummary-content .second-part {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root .MuiButtonBase-root.MuiAccordionSummary-root .label {
  margin-right: 8px;
  text-wrap: nowrap;
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root .MuiButtonBase-root.MuiAccordionSummary-root:hover {
  background-color: var(--accordion-expanded-bg);
  border: 1px solid var(--accordion-border);
}
.accordion-wrapper .MuiPaper-root.MuiAccordion-root .MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded {
  background-color: var(--accordion-expanded-bg);
  border: 1px solid var(--accordion-border);
}

.accordion-wrapper {
  min-width: 650px;
  margin: 8px auto;
}
.accordion-wrapper .expand-collapse-all {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 8px;
}
.accordion-wrapper .expand-collapse-all .link {
  font-size: 0.875rem;
  cursor: pointer;
  color: var(--primary-default);
}
.accordion-wrapper .expand-collapse-all .link svg {
  font-size: inherit;
}
.accordion-wrapper .expand-collapse-all .link:hover {
  text-decoration: underline;
}

.edit-field-wrapper {
  display: flex;
  align-items: center;
}
.edit-field-wrapper p {
  width: auto !important;
  margin-right: 8px;
}
.edit-field-wrapper .MuiOutlinedInput-root {
  background-color: var(--white);
}
.edit-field-wrapper .MuiOutlinedInput-root .MuiOutlinedInput-input {
  height: 1.5rem;
  padding: 4px 8px;
  font-size: 0.875rem;
  color: var(--text-primary-color);
  border-radius: 4px;
  max-width: 120px;
}

.avatar {
  color: var(--text-primary-color);
  border-radius: 50%;
  font-weight: 500;
  line-height: 2.54rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid transparent;
}
.avatar.initials {
  background-color: var(--grey-400);
}
.avatar .size-128 {
  width: 8rem;
  height: 8rem;
  font-size: 3rem;
  border-radius: 50%;
}
.avatar .size-68 {
  width: 4.25rem;
  height: 4.25rem;
  font-size: 1.5rem;
  border-radius: 50%;
}
.avatar .size-48 {
  width: 3rem;
  height: 3rem;
  font-size: 1.125rem;
  border-radius: 50%;
}
.avatar .size-40 {
  width: 2.5rem;
  height: 2.5rem;
  font-size: 0.875rem;
  border-radius: 50%;
}
.avatar .size-32 {
  width: 2rem;
  height: 2rem;
  font-size: 0.875rem;
  border-radius: 50%;
}
.avatar .size-24 {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.75rem;
  border-radius: 50%;
}
.avatar.size-128 {
  width: 8rem;
  height: 8rem;
  font-size: 3rem;
  border-radius: 50%;
}
.avatar.size-68 {
  width: 4.25rem;
  height: 4.25rem;
  font-size: 1.5rem;
}
.avatar.size-48 {
  width: 3rem;
  height: 3rem;
  font-size: 1.125rem;
}
.avatar.size-40 {
  width: 2.5rem;
  height: 2.5rem;
  font-size: 0.875rem;
}
.avatar.size-32 {
  width: 2rem;
  height: 2rem;
  font-size: 0.875rem;
}
.avatar.size-24 {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.75rem;
}
.avatar.white-border {
  border: 2px solid var(--white);
}
.avatar:hover {
  color: var(--text-primary-color);
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid var(--grey-600);
}
.avatar:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.avatar.disabled {
  color: var(--grey-600);
  opacity: 0.7;
  border-radius: 50%;
  cursor: not-allowed;
  border: none;
}
.avatar.disabled:focus-visible {
  outline: none;
}

.avatar-group {
  display: flex;
  flex-direction: row;
}

.badge {
  flex-direction: row;
  justify-content: center;
  box-sizing: border-box;
  align-items: center;
  display: inline-flex;
  gap: 4px;
}
.badge.mt-4 {
  margin-top: 4px;
}
.badge.primary {
  background-color: var(--status-info);
  color: var(--white);
}
.badge.primary.outlined-square-badge {
  border: 1px solid var(--status-info);
  color: var(--status-info);
  background-color: var(--white);
}
.badge.primary.filled-square-badge {
  border: 1px solid var(--status-info);
  color: var(--status-info);
  background: var(--status-info-transparent);
}
.badge.primary.without-bg {
  background-color: transparent;
  color: var(--text-primary-color);
  border: none;
}
.badge.primary.without-bg .leading-icon {
  font-size: 0.75rem;
  margin-top: 2px;
  color: var(--status-info);
}
.badge.secondary {
  border: 1px solid var(--grey-500);
  color: var(--text-primary-color);
  background-color: var(--grey-400);
}
.badge.secondary.outlined-square-badge {
  border: 1px solid var(--grey-500);
  color: var(--text-primary-color);
  background-color: var(--white);
}
.badge.secondary.filled-square-badge {
  border: 1px solid var(--grey-500);
  color: var(--text-primary-color);
  background: var(--grey-400);
}
.badge.secondary.filled-square-badge .leading-icon {
  color: var(--grey-600);
}
.badge.secondary.without-bg {
  background-color: transparent;
  color: var(--text-primary-color);
  border: none;
}
.badge.secondary.without-bg .leading-icon {
  color: var(--grey-600);
  font-size: 0.75rem;
  margin-top: 2px;
}
.badge.positive {
  background-color: var(--status-success);
  color: var(--white);
}
.badge.positive.outlined-square-badge {
  border: 1px solid var(--status-success);
  color: var(--status-success);
  background-color: var(--white);
}
.badge.positive.filled-square-badge {
  border: 1px solid var(--status-success);
  color: var(--status-success);
  background: var(--status-success-transparent);
}
.badge.positive.without-bg {
  background-color: transparent;
  color: var(--text-primary-color);
  border: none;
}
.badge.positive.without-bg .leading-icon {
  color: var(--status-success);
  font-size: 0.75rem;
  margin-top: 2px;
}
.badge.warning {
  background-color: var(--status-warning);
  color: var(--white);
}
.badge.warning.outlined-square-badge {
  border: 1px solid var(--status-warning);
  color: var(--status-warning);
  background-color: var(--white);
}
.badge.warning.filled-square-badge {
  border: 1px solid var(--status-warning);
  color: var(--status-warning);
  background: var(--status-warning-transparent);
}
.badge.warning.without-bg {
  background-color: transparent;
  color: var(--text-primary-color);
  border: none;
}
.badge.warning.without-bg .leading-icon {
  color: var(--status-warning);
  font-size: 0.75rem;
  margin-top: 2px;
}
.badge.negative {
  background-color: var(--status-error);
  color: var(--white);
}
.badge.negative.outlined-square-badge {
  border: 1px solid var(--status-error);
  color: var(--status-error);
  background-color: var(--white);
}
.badge.negative.filled-square-badge {
  border: 1px solid var(--status-error);
  color: var(--status-error);
  background: var(--status-error-transparent);
}
.badge.negative.without-bg {
  background-color: transparent;
  color: var(--text-primary-color);
  border: none;
}
.badge.negative.without-bg .leading-icon {
  color: var(--status-error);
  font-size: 0.75rem;
  margin-top: 2px;
}
.badge.neutral {
  background-color: var(--white);
  color: var(--grey-600);
  border: 1px solid var(--grey-600);
}
.badge.size-4 {
  height: 4px;
  width: 4px;
  border-radius: 20px;
}
.badge.size-8 {
  height: 8px;
  width: 8px;
  border-radius: 20px;
}
.badge.size-16 {
  height: 16px;
  width: 16px;
  border-radius: 20px;
  font-size: 0.75rem;
}
.badge.size-24 {
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 20px;
  font-weight: 400 !important;
  line-height: 1.375rem;
  font-size: 0.75rem !important;
  white-space: nowrap;
}
.badge.rounded-small-badge {
  padding: 2.5px 0.5rem;
  height: 16px;
  border-radius: 20px;
  line-height: 1.375rem;
  font-weight: 400 !important;
  font-size: 0.75rem !important;
  white-space: nowrap;
  min-width: 24px;
}
.badge.rounded-badge {
  padding: 2.5px 8px;
  min-height: 20px;
  border-radius: 20px;
  font-weight: 400 !important;
  font-size: 0.75rem !important;
}
.badge.square-badge {
  padding: 4.5px 8px;
  min-height: 24px;
  border-radius: 0.375rem;
  font-weight: 400 !important;
  font-size: 0.75rem !important;
  white-space: nowrap;
}
.badge.outlined-square-badge {
  padding: 4.5px 8px;
  min-height: 24px;
  border-radius: 0.375rem;
  font-weight: 400 !important;
  font-size: 0.75rem !important;
  white-space: nowrap;
}
.badge.filled-square-badge {
  padding: 4.5px 8px;
  border-radius: 0.375rem;
  height: 24px;
  font-weight: 400 !important;
  font-size: 0.75rem !important;
  white-space: nowrap;
}
.badge.without-bg {
  font-weight: 400;
  font-size: 0.75rem;
  margin-top: 2px;
}

.MuiBreadcrumbs-ol {
  font-family: "ABBVoice", Verdana;
}
.MuiBreadcrumbs-ol .MuiBreadcrumbs-separator {
  margin-left: 0.375rem;
  margin-right: 0.5rem;
  margin-top: 0.25rem;
}

.current-page {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--text-primary-color);
  font-weight: 400;
  font-size: 0.75rem;
  margin-top: 2px;
  font-family: "ABBVoice", Verdana;
}
.current-page .down-icon {
  margin-top: 2px;
  margin-left: 4px;
  color: var(--text-primary-color);
}

.previous-label-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 8px;
  font-family: "ABBVoice", Verdana;
}
.previous-label-container .icon {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.previous-label-container .icon.bg-white {
  background-color: var(--white);
}
.previous-label-container .icon.bg-gray {
  background-color: var(--grey-300);
}
.previous-label-container .icon .icon-left {
  margin-top: 2px;
  color: var(--text-primary-color);
}
.previous-label-container .previous-label {
  font-family: "ABBVoice", Verdana;
  font-size: 0.875rem;
  color: var(--text-primary-color);
  font-weight: 400;
  line-height: 1.15;
  display: inline-block;
}

.icon-right {
  color: var(--text-primary-color);
}

.ellipsis-icon {
  color: var(--text-primary-color);
  cursor: pointer;
}

.MuiButtonBase-root.MuiButton-root {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: fit-content;
  flex-shrink: 0;
  text-align: center;
  border-radius: 20px;
  text-transform: capitalize;
}
.MuiButtonBase-root.MuiButton-root .btn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.MuiButtonBase-root.MuiButton-root .label {
  font-size: 0.875rem;
  text-wrap: nowrap;
  font-weight: 500;
  font-family: "ABBVoice", Verdana;
}
.MuiButtonBase-root.MuiButton-root .btn-section {
  display: flex;
  border-top-left-radius: 20px;
  gap: 4px;
  border-bottom-left-radius: 20px;
  justify-content: center;
  align-items: center;
}
.MuiButtonBase-root.MuiButton-root .btn-section.size-32 {
  min-height: 32px;
  padding: 0 8px 0 16px !important;
}
.MuiButtonBase-root.MuiButton-root .btn-section.size-40 {
  min-height: 40px;
  max-height: 48px;
  padding: 0 12px 0 20px;
}
.MuiButtonBase-root.MuiButton-root .icon-section {
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.MuiButtonBase-root.MuiButton-root .icon-section.size-32 {
  min-height: 32px;
  padding: 0 8px 0 8px;
}
.MuiButtonBase-root.MuiButton-root .icon-section.size-40 {
  min-height: 40px;
  padding: 0 12px 0 12px;
}
.MuiButtonBase-root.MuiButton-root.split {
  padding: 0 !important;
}
.MuiButtonBase-root.MuiButton-root .icon {
  font-size: 1rem;
}
.MuiButtonBase-root.MuiButton-root .icon-down {
  font-size: 1rem;
}
.MuiButtonBase-root.MuiButton-root .divider {
  width: 0.5px;
}
.MuiButtonBase-root.MuiButton-root .divider.size-32 {
  min-height: 32px;
}
.MuiButtonBase-root.MuiButton-root .divider.size-40 {
  min-height: 40px;
}
.MuiButtonBase-root.MuiButton-root.round {
  border-radius: 50%;
  padding: 12px;
  min-width: auto;
}
.MuiButtonBase-root.MuiButton-root.primary {
  background-color: var(--primary-default);
  color: var(--white);
}
.MuiButtonBase-root.MuiButton-root.primary:hover {
  background-color: var(--primary-hover);
}
.MuiButtonBase-root.MuiButton-root.primary:active {
  background-color: var(--primary-active);
}
.MuiButtonBase-root.MuiButton-root.primary:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.MuiButtonBase-root.MuiButton-root.primary.disabled {
  background-color: var(--primary-disabled);
  pointer-events: none;
  cursor: not-allowed;
}
.MuiButtonBase-root.MuiButton-root.secondary {
  background-color: var(--grey-400);
  color: var(--text-primary-color);
}
.MuiButtonBase-root.MuiButton-root.secondary:hover {
  background-color: var(--grey-500);
}
.MuiButtonBase-root.MuiButton-root.secondary:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.MuiButtonBase-root.MuiButton-root.secondary:active {
  background-color: var(--grey-600);
}
.MuiButtonBase-root.MuiButton-root.secondary.disabled {
  background-color: var(--grey-400);
  color: var(--grey-600);
  pointer-events: none;
  cursor: not-allowed;
}
.MuiButtonBase-root.MuiButton-root.ghost {
  background-color: transparent;
  color: var(--text-primary-color);
  border: 2px solid var(--grey-500);
}
.MuiButtonBase-root.MuiButton-root.ghost:hover {
  background-color: var(--grey-400);
  border: 2px solid var(--grey-700);
}
.MuiButtonBase-root.MuiButton-root.ghost:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.MuiButtonBase-root.MuiButton-root.ghost:active {
  background-color: var(--grey-500);
  border: 2px solid var(--grey-700);
}
.MuiButtonBase-root.MuiButton-root.ghost.disabled {
  color: var(--grey-600);
  border: 2px solid var(--grey-500);
  pointer-events: none;
  cursor: not-allowed;
}
.MuiButtonBase-root.MuiButton-root.ghost.disabled:hover {
  background-color: transparent;
  color: var(--grey-600);
  pointer-events: none;
  border: 2px solid var(--grey-500);
}
.MuiButtonBase-root.MuiButton-root.discreet {
  background-color: transparent;
  color: var(--text-primary-color);
}
.MuiButtonBase-root.MuiButton-root.discreet:hover {
  background-color: var(--grey-400);
}
.MuiButtonBase-root.MuiButton-root.discreet:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.MuiButtonBase-root.MuiButton-root.discreet:active {
  background-color: var(--grey-500);
}
.MuiButtonBase-root.MuiButton-root.discreet.disabled {
  color: var(--grey-600);
  pointer-events: none;
  background-color: transparent;
  cursor: not-allowed;
}
.MuiButtonBase-root.MuiButton-root.success {
  background-color: var(--status-success);
  color: var(--white);
}
.MuiButtonBase-root.MuiButton-root.success:hover {
  background-color: var(--status-success-hover);
}
.MuiButtonBase-root.MuiButton-root.success:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.MuiButtonBase-root.MuiButton-root.error {
  background-color: var(--status-error);
  color: var(--white);
}
.MuiButtonBase-root.MuiButton-root.error:hover {
  background-color: var(--status-error-hover);
}
.MuiButtonBase-root.MuiButton-root.error:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.MuiButtonBase-root.MuiButton-root.warning {
  background-color: var(--status-warning);
  color: var(--white);
}
.MuiButtonBase-root.MuiButton-root.warning:hover {
  background-color: var(--status-warning-hover);
}
.MuiButtonBase-root.MuiButton-root.warning:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.MuiButtonBase-root.MuiButton-root.size-32 {
  min-height: 32px;
  max-height: 32px;
  padding: 0 16px !important;
}
.MuiButtonBase-root.MuiButton-root.size-40 {
  min-height: 40px;
  max-height: 40px;
  padding: 0 20px !important;
}
.MuiButtonBase-root.MuiButton-root.primary-split-button {
  background-color: var(--primary-default);
  border: solid 2px var(--primary-default);
  color: var(--white);
  padding: 0 !important;
}
.MuiButtonBase-root.MuiButton-root.primary-split-button .divider {
  background-color: var(--white);
}
.MuiButtonBase-root.MuiButton-root.primary-split-button:hover {
  border: solid 2px var(--primary-hover);
}
.MuiButtonBase-root.MuiButton-root.primary-split-button:active {
  border: solid 2px var(--primary-active);
}
.MuiButtonBase-root.MuiButton-root.primary-split-button:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.MuiButtonBase-root.MuiButton-root.primary-split-button .btn-section:hover {
  background-color: var(--primary-hover);
}
.MuiButtonBase-root.MuiButton-root.primary-split-button .btn-section:active {
  background-color: var(--primary-active);
}
.MuiButtonBase-root.MuiButton-root.primary-split-button .btn-section.disabled {
  background-color: var(--primary-disabled);
  pointer-events: none;
}
.MuiButtonBase-root.MuiButton-root.primary-split-button .icon-section:hover {
  background-color: var(--primary-hover);
}
.MuiButtonBase-root.MuiButton-root.primary-split-button .icon-section:active {
  background-color: var(--primary-active);
}
.MuiButtonBase-root.MuiButton-root.primary-split-button .icon-section.disabled {
  background-color: var(--primary-disabled);
  pointer-events: none;
}
.MuiButtonBase-root.MuiButton-root.primary-split-button.disabled {
  background-color: var(--primary-disabled);
  border: solid 2px var(--primary-disabled);
  pointer-events: none;
  cursor: not-allowed;
}
.MuiButtonBase-root.MuiButton-root.secondary-split-button {
  background-color: var(--grey-400);
  border: solid 1px var(--grey-600);
  color: var(--text-primary-color);
  padding: 0 !important;
}
.MuiButtonBase-root.MuiButton-root.secondary-split-button .divider {
  background-color: var(--grey-600);
}
.MuiButtonBase-root.MuiButton-root.secondary-split-button:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.MuiButtonBase-root.MuiButton-root.secondary-split-button .btn-section:hover {
  background-color: var(--shadow-grey-200);
}
.MuiButtonBase-root.MuiButton-root.secondary-split-button .btn-section:active {
  background-color: var(--grey-500);
}
.MuiButtonBase-root.MuiButton-root.secondary-split-button .btn-section.disabled {
  background-color: var(--grey-400);
  color: var(--grey-700);
  pointer-events: none;
}
.MuiButtonBase-root.MuiButton-root.secondary-split-button .icon-section:hover {
  background-color: var(--shadow-grey-200);
}
.MuiButtonBase-root.MuiButton-root.secondary-split-button .icon-section:active {
  background-color: var(--grey-500);
}
.MuiButtonBase-root.MuiButton-root.secondary-split-button .icon-section.disabled {
  background-color: var(--grey-400);
  color: var(--grey-700);
  cursor: not-allowed;
  pointer-events: none;
}
.MuiButtonBase-root.MuiButton-root.secondary-split-button.disabled {
  background-color: var(--grey-400);
  color: var(--grey-700);
  border: solid 1px var(--grey-500);
  cursor: not-allowed;
  pointer-events: none;
}

.cards-container {
  display: flex;
  background-color: var(--card-bg);
  flex-direction: column;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.1019607843) 0 1px 3px, rgba(0, 0, 0, 0.0588235294) 0 1px 2px;
  border-radius: 8px;
  opacity: 1;
  border: 1px solid var(--grey-300);
  height: 100%;
  min-height: 120px;
}
.cards-container:not(.no-hover):not(.disabled):hover {
  box-shadow: 1px 1px 5px var(--shadow-blue);
  background-color: var(--card-hover);
  border: 1px solid var(--accordion-border);
  cursor: pointer;
}
.cards-container:not(.no-hover):not(.disabled):hover .gray {
  background-color: var(--card-hover);
}
.cards-container.selected {
  border: 1px solid var(--accordion-border);
}
.cards-container.align {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-height: 60px;
  padding: 8px 24px;
  box-shadow: none;
  box-sizing: border-box;
  background: var(--white);
  line-height: 2.188rem;
  border-radius: 0;
  border: 2px solid transparent;
  border-bottom: 1px solid var(--grey-500);
}
.cards-container.align .w-15 {
  width: 15%;
}
.cards-container.align .w-25 {
  width: 25%;
}
.cards-container.align .secondary-text {
  color: var(--grey-800);
  font-size: 0.875rem;
  line-height: 1.15;
}
.cards-container.align .title {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.15;
  color: var(--text-primary-color);
}
.cards-container.align .description {
  text-align: left;
  font-size: 0.875rem;
  letter-spacing: 0;
  color: var(--text-primary-color);
  opacity: 1;
  overflow: hidden;
  line-height: 1.15;
}
.cards-container.align .supporting-text {
  color: var(--grey-800);
  text-transform: capitalize;
  font-size: 0.75rem;
  overflow: hidden;
  line-height: 1.15;
}
.cards-container.align:not(.disabled):hover {
  box-shadow: 1px 1px 5px var(--shadow-blue);
  background-color: var(--card-hover);
  border: 1px solid var(--accordion-border);
  cursor: pointer;
}
.cards-container.align.selected {
  border: 1px solid var(--accordion-border);
}
.cards-container.disabled {
  opacity: 0.6;
  cursor: not-allowed !important;
}
.cards-container:hover .image-container {
  background: var(--white);
}
.cards-container:hover .hover {
  background: var(--white);
}
.cards-container .top-content {
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
  display: flex;
  flex: 1 1 0.000000001px;
  padding: 6px 16px 16px;
  gap: 8px;
}
.cards-container .top-content.gap-12 {
  gap: 12px;
}
.cards-container .top-content .secondary-text {
  color: var(--grey-800);
  font-size: 0.875rem;
  text-transform: capitalize;
  line-height: 1.15;
}
.cards-container .top-content .title {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.15;
  color: var(--text-primary-color);
}
.cards-container .top-content .description {
  text-align: left;
  font-size: 0.875rem;
  letter-spacing: 0;
  color: var(--text-primary-color);
  opacity: 1;
  overflow: hidden;
  line-height: 1.15;
  margin-top: 8px;
}
.cards-container .bottom-content {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: center;
  padding: 8px 16px;
  border-top: 1px solid var(--grey-400);
  min-width: 100%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.cards-container .bottom-content.gray {
  background: var(--grey-200);
}
.cards-container .bottom-content .supporting-text {
  color: var(--grey-800);
  text-transform: capitalize;
  font-size: 0.75rem;
  overflow: hidden;
  line-height: 1.15;
}

.list-card-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.list-card-container .align {
  border-bottom: none;
  border-radius: 4px;
}

.MuiButtonBase-root.MuiChip-root {
  box-sizing: border-box;
  border-radius: 20px;
  font-size: 0.875rem;
  margin-right: 4px !important;
  margin-left: 0 !important;
  font-weight: 400;
  background-color: var(--grey-400);
  border: 1.5px solid var(--grey-400);
  color: var(--text-primary-color);
  font-family: "ABBVoice", Verdana;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  justify-content: center;
}
.MuiButtonBase-root.MuiChip-root .MuiChip-label {
  padding: 0;
}
.MuiButtonBase-root.MuiChip-root .MuiChip-icon {
  margin: 0;
  font-size: 1rem;
}
.MuiButtonBase-root.MuiChip-root:hover {
  background: var(--grey-300);
  color: var(--text-primary-color);
}
.MuiButtonBase-root.MuiChip-root:hover .MuiChip-deleteIcon {
  color: var(--text-primary-color);
}
.MuiButtonBase-root.MuiChip-root:active {
  box-shadow: none;
}
.MuiButtonBase-root.MuiChip-root .MuiChip-deleteIcon {
  font-size: 12px;
  margin: 0;
  color: var(--text-primary-color);
}
.MuiButtonBase-root.MuiChip-root .MuiChip-deleteIcon.disabled {
  cursor: not-allowed;
}
.MuiButtonBase-root.MuiChip-root .leadingIconName {
  color: var(--text-primary-color);
}
.MuiButtonBase-root.MuiChip-root .leadingIconName.disabled {
  cursor: not-allowed;
}
.MuiButtonBase-root.MuiChip-root.disabled {
  background: var(--grey-400);
  color: var(--grey-600);
  cursor: not-allowed;
  pointer-events: inherit;
  opacity: 1;
}
.MuiButtonBase-root.MuiChip-root.disabled .MuiChip-icon {
  color: var(--grey-600);
}
.MuiButtonBase-root.MuiChip-root.disabled .MuiChip-deleteIcon {
  color: var(--grey-600);
}
.MuiButtonBase-root.MuiChip-root.size-24 {
  height: 24px;
  padding: 0 8px;
}
.MuiButtonBase-root.MuiChip-root.size-32 {
  height: 32px;
  padding: 0 12px;
}
.MuiButtonBase-root.MuiChip-root.size-40 {
  height: 40px;
  padding: 0 16px;
}
.MuiButtonBase-root.MuiChip-root .end-icon-container {
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: center;
  align-items: center;
}
.MuiButtonBase-root.MuiChip-root .end-icon-container .down-icon {
  padding-right: 4px;
}
.MuiButtonBase-root.MuiChip-root .end-icon-container .border {
  border-right: 1px solid var(--grey-700);
}
.MuiButtonBase-root.MuiChip-root.clicked-chip {
  cursor: pointer;
  background-color: var(--status-info-transparent);
  color: var(--primary-default);
  border: 1px solid var(--primary-default);
  font-weight: 500;
}
.MuiButtonBase-root.MuiChip-root.clicked-chip .MuiChip-icon {
  color: var(--primary-default);
}
.MuiButtonBase-root.MuiChip-root.clicked-chip .end-icon-container .border {
  border-right: 1px solid var(--primary-default);
}
.MuiButtonBase-root.MuiChip-root.clicked-chip .MuiChip-deleteIcon {
  color: var(--primary-default);
}
.MuiButtonBase-root.MuiChip-root.clicked-chip:hover {
  background: var(--accordion-expanded-bg);
}

.counter {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 0 8px;
}
.counter.custom {
  gap: 8px;
}
.counter .icon {
  cursor: pointer;
  color: var(--text-primary-color);
}

.MuiButtonBase-root.MuiCheckbox-root {
  padding: 4px 0px;
}

.blank-checkbox {
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--grey-500);
  border-radius: 4px;
  background: transparent;
  z-index: 20;
  cursor: pointer;
}
.blank-checkbox:hover {
  border: 2px solid var(--grey-600);
  background-color: var(--grey-300);
}
.blank-checkbox.disabled {
  border: 2px solid var(--grey-400);
  background-color: var(--grey-300);
}
.blank-checkbox.hover {
  border: 2px solid var(--grey-600);
  background-color: var(--grey-300);
}
.blank-checkbox:active {
  border: 2px solid var(--grey-700);
  background-color: var(--grey-400);
}
.blank-checkbox:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.blank-checkbox.size-16 {
  width: 16px;
  height: 16px;
}
.blank-checkbox.size-24 {
  width: 24px;
  height: 24px;
}

.checked-container {
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  align-items: center;
  padding: 2px;
  justify-content: center;
  border: 2px solid var(--primary-default);
  border-radius: 4px;
  background: var(--primary-default);
  color: var(--white);
  z-index: 20;
  cursor: pointer;
}
.checked-container .checked {
  display: flex;
  justify-content: center;
  align-items: center;
}
.checked-container.disabled {
  border: 2px solid var(--primary-disabled);
  background-color: var(--primary-disabled);
}
.checked-container .size-16 {
  font-size: 16px;
}
.checked-container .size-8 {
  font-size: 8px;
}
.checked-container.size-16 {
  width: 16px;
  height: 16px;
}
.checked-container.size-24 {
  width: 24px;
  height: 24px;
}
.checked-container:hover {
  border: 2px solid var(--primary-hover);
  background-color: var(--primary-hover);
}
.checked-container.hover {
  border: 2px solid var(--primary-hover);
  background-color: var(--primary-hover);
}
.checked-container:active {
  border: 2px solid var(--primary-active);
  background-color: var(--primary-active);
}
.checked-container:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}

.checkbox-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}
.checkbox-container .size-16 {
  font-size: 1rem;
}
.checkbox-container.disabled {
  cursor: not-allowed;
}
.checkbox-container .checkbox-label {
  font-family: "ABBVoice", Verdana;
  font-size: 0.875rem;
  margin-left: 8px;
  color: var(--text-primary-color);
  text-wrap: nowrap;
  cursor: pointer;
}
.checkbox-container .checkbox-label.disabled {
  color: var(--grey-700);
  cursor: not-allowed;
}

.table-wrapper {
  background-color: var(--white);
  overflow-x: auto;
}
.table-wrapper .MuiTable-root {
  min-width: 550px;
}
.table-wrapper.border {
  border: 1px solid var(--grey-500);
}
.table-wrapper .table-title {
  font-size: 1rem;
  font-weight: 700;
  margin: 1.125rem;
}
.table-wrapper .data-grid-input-wrapper {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  min-width: 125px;
  max-width: 200px;
  width: 60%;
}
.table-wrapper .data-grid-input-wrapper.end {
  justify-self: end;
}
.table-wrapper .data-grid-input-wrapper .MuiInputBase-root.MuiInput-root.MuiInput-underline {
  font-size: 0.875rem;
  font-family: "ABBVoice", Verdana !important;
  color: var(--text-primary-color);
}
.table-wrapper .data-grid-input-wrapper .MuiInputBase-root.MuiInput-root.MuiInput-underline::before {
  border-bottom: 1px solid var(--grey-400);
}
.table-wrapper .data-grid-input-wrapper .MuiInputBase-root.MuiInput-root.MuiInput-underline:hover::before {
  border-bottom: 1px solid var(--text-primary-color);
}
.table-wrapper .data-grid-input-wrapper .MuiInputBase-root.MuiInput-root.MuiInput-underline::after {
  border-bottom: 1px solid var(--primary-default);
}
.table-wrapper .data-grid-input-wrapper .discreet-edit-icons {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root {
  font-family: "ABBVoice", Verdana;
  font-weight: 500;
  font-size: 0.875rem;
  color: var(--text-primary-color);
  border-bottom: 1px solid var(--text-primary-color);
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root:hover {
  background-color: var(--grey-300);
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root .MuiButtonBase-root.MuiCheckbox-root {
  padding: 0;
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root.status {
  padding: 0;
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root.status:hover {
  background-color: var(--white);
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root.main-header {
  font-weight: 500;
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root.gray-border {
  border-bottom: 1px solid var(--grey-500);
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root .transparent-border {
  border-bottom: 1px solid transparent;
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root.topHeader {
  border-bottom: 1px solid var(--grey-500);
  border-right: 1px solid var(--grey-500);
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root.topHeader:last-child {
  border-right: none;
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root.bg-white {
  background-color: var(--white);
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root.bg-white:hover {
  background-color: var(--grey-300);
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root.bg-white.no-hover {
  background-color: var(--white) !important;
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root.bg-gray {
  background-color: var(--grey-200);
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root.bg-gray:hover {
  background-color: var(--grey-300);
}
.table-wrapper .MuiTableHead-root .MuiTableCell-root.bg-gray.no-hover {
  background-color: var(--grey-200) !important;
}
.table-wrapper .MuiTableHead-root .light {
  color: var(--text-primary-color);
  opacity: 0.6;
}
.table-wrapper .MuiTableHead-root .sort-icon {
  font-size: 1.2rem;
}
.table-wrapper .MuiTableHead-root .blue-border {
  border-bottom: 2px solid var(--primary-default);
}
.table-wrapper .MuiTableHead-root .MuiTableSortLabel-root:hover {
  color: var(--text-primary-color);
}
.table-wrapper .MuiTableHead-root .MuiTableSortLabel-root:focus {
  color: var(--text-primary-color);
}
.table-wrapper .MuiTableBody-root .MuiTableRow-root.Mui-selected {
  background-color: var(--white);
}
.table-wrapper .MuiTableBody-root .MuiTableRow-root.bg-white {
  background-color: var(--white);
}
.table-wrapper .MuiTableBody-root .MuiTableRow-root.bg-gray {
  background-color: var(--grey-200);
}
.table-wrapper .MuiTableBody-root .MuiTableRow-root.zebra {
  background-color: var(--grey-100);
}
.table-wrapper .MuiTableBody-root .MuiTableRow-root:hover {
  background-color: var(--grey-300);
}
.table-wrapper .MuiTableBody-root .MuiTableRow-root.no-hover {
  background-color: var(--white) !important;
}
.table-wrapper .MuiTableBody-root .MuiTableRow-root.bg-blue {
  background-color: var(--accordion-expanded-bg);
}
.table-wrapper .MuiTableBody-root .MuiTableRow-root .MuiButtonBase-root.MuiCheckbox-root {
  padding: 0;
}
.table-wrapper .MuiTableCell-root {
  font-family: "ABBVoice", Verdana !important;
  font-size: 0.875rem;
  text-wrap: nowrap;
  color: var(--text-primary-color);
  border-bottom: 1px solid var(--grey-500);
}
.table-wrapper .MuiTableCell-root.checkbox-cell {
  padding: 0 10px 0 20px;
}
.table-wrapper .MuiTableCell-root.hovered {
  background-color: var(--grey-300);
}
.table-wrapper .MuiTableCell-root.status {
  width: auto;
  min-width: 10px;
  max-width: 10px;
  padding: 0 0 0 4px;
}
.table-wrapper .MuiTableCell-root.size-24 {
  height: 24px;
  padding: 0 12px;
}
.table-wrapper .MuiTableCell-root.size-32 {
  height: 32px;
  padding: 0 16px;
}
.table-wrapper .MuiTableCell-root.size-40 {
  height: 40px;
  padding: 0 20px;
}
.table-wrapper .MuiTableCell-root.size-48 {
  height: 48px;
  padding: 0 20px;
}
.table-wrapper .MuiTableCell-root.size-60 {
  height: 60px;
  padding: 0 20px;
}
.table-wrapper .MuiTableCell-root.border-right {
  border-right: 1px solid var(--grey-500);
}
.table-wrapper .MuiTableCell-root .open {
  transform: rotate(90deg);
  transition-duration: 300ms;
}
.table-wrapper .MuiTableCell-root.remove-border {
  border-bottom: none;
}
.table-wrapper .MuiTableCell-root .status-indicator {
  height: 100%;
  margin: 4px 0px;
  border-radius: 4px;
  width: 4px;
}
.table-wrapper .MuiTableCell-root .status-indicator.primary {
  background-color: var(--primary-default);
}
.table-wrapper .MuiTableCell-root .status-indicator.warning {
  background-color: var(--status-warning);
}
.table-wrapper .MuiTableCell-root .status-indicator.negative {
  background-color: var(--status-error);
}
.table-wrapper .MuiTableCell-root .status-indicator.positive {
  background-color: var(--status-success);
}
.table-wrapper .MuiTableCell-root .status-indicator.size-24 {
  height: 16px;
}
.table-wrapper .MuiTableCell-root .status-indicator.size-32 {
  height: 24px;
}
.table-wrapper .MuiTableCell-root .status-indicator.size-40 {
  height: 32px;
}
.table-wrapper .MuiTableCell-root .status-indicator.size-48 {
  height: 40px;
}
.table-wrapper .MuiTableCell-root .status-indicator.size-60 {
  height: 52px;
}
.table-wrapper .MuiTableCell-root.sticky {
  position: sticky;
  left: 0;
  background: var(--grey-300) !important;
  z-index: 99;
}
.table-wrapper .MuiTableCell-root.sticky:hover {
  background: var(--grey-200) !important;
}
.table-wrapper .MuiTableCell-root.text-link {
  color: var(--primary-default);
}
.table-wrapper .MuiTableCell-root.text-link:hover {
  text-decoration: underline;
}

.table-with-toolbar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  color: var(--text-primary-color);
}
.table-with-toolbar .first-part {
  gap: 8px;
  align-items: center;
  margin-right: 16px;
  padding-left: 16px;
}

.data-grid-container {
  position: relative;
}
.data-grid-container .action-container {
  max-width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
}
.data-grid-container .header-cell {
  font-family: "ABBVoice", Verdana;
  font-weight: 500;
  padding: 0 20px;
  font-size: 0.875rem;
  color: var(--text-primary-color);
  border-bottom: 1px solid var(--grey-500);
  background-color: transparent;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
}
.data-grid-container .header-cell .light {
  color: var(--text-primary-color);
  opacity: 0.6;
  font-size: 1.313rem;
}
.data-grid-container .header-cell.blue-border {
  border-bottom: 2px solid var(--primary-default);
}
.data-grid-container .border {
  border-bottom: 1px solid var(--grey-500);
  margin-bottom: 4px;
  padding: 0 20px;
}
.data-grid-container .data-row {
  margin-bottom: 4px;
  border-radius: 4px;
  border: 1px solid var(--grey-300);
  background-color: var(--white);
}
.data-grid-container .data-row.selected {
  background-color: var(--accordion-expanded-bg);
  border: 1px solid var(--primary-default);
}
.data-grid-container .data-row.primary {
  border-left: 4px solid var(--primary-default);
}
.data-grid-container .data-row.warning {
  border-left: 4px solid var(--status-warning);
}
.data-grid-container .data-row.negative {
  border-left: 4px solid var(--status-error);
}
.data-grid-container .data-row.positive {
  border-left: 4px solid var(--status-success);
}
.data-grid-container .data-row:hover {
  background-color: var(--grey-300);
}
.data-grid-container .filter-icon {
  position: absolute;
  top: 22px;
  right: 20px;
  color: var(--text-primary-color);
}
.data-grid-container .filter-container {
  width: 100%;
  box-sizing: border-box;
  font-family: "ABBVoice", Verdana;
  font-weight: 400;
  padding: 8px 20px;
  font-size: 0.875rem;
  color: var(--text-primary-color);
  display: flex;
  align-items: center;
  justify-content: start;
  margin-bottom: 8px;
  border-radius: 8px;
  gap: 8px;
  border: 1px solid var(--grey-200);
  background-color: var(--grey-200);
  border-radius: 8px;
}
.data-grid-container .data-cell {
  font-family: "ABBVoice", Verdana;
  font-weight: 400;
  padding: 0 20px;
  font-size: 0.875rem;
  color: var(--text-primary-color);
  display: flex;
  align-items: center;
  justify-content: start;
}
.data-grid-container.text-link {
  color: var(--primary-default);
}
.data-grid-container.text-link:hover {
  text-decoration: underline;
}

.MuiInputAdornment-root {
  padding-right: 2px;
  margin: 0 !important;
}
.MuiInputAdornment-root .calender-icon {
  color: var(--text-primary-color);
}
.MuiInputAdornment-root .MuiButtonBase-root.MuiIconButton-root {
  padding: 0;
  margin: 0;
}

.MuiPickersLayout-root {
  font-family: "ABBVoice", Verdana !important;
}
.MuiPickersLayout-root ::-webkit-scrollbar {
  display: none;
}
.MuiPickersLayout-root .MuiDateCalendar-root {
  height: auto;
  width: 256px;
  padding: 24px;
}
.MuiPickersLayout-root .MuiDayCalendar-weekContainer {
  margin: 0;
}
.MuiPickersLayout-root .MuiDayCalendar-weekContainer .dayIsBetween {
  background-color: var(--accordion-expanded-bg);
}
.MuiPickersLayout-root .MuiDayCalendar-weekContainer .dayIsBetween:hover {
  background: var(--accordion-expanded-bg);
}
.MuiPickersLayout-root .MuiDayCalendar-weekContainer .isFirstDay {
  border-top-left-radius: "50%";
  border-bottom-left-radius: "50%";
  color: var(--white);
}
.MuiPickersLayout-root .MuiDayCalendar-weekContainer .isFirstDay:hover {
  background: transparent;
}
.MuiPickersLayout-root .MuiDayCalendar-weekContainer .isLastDay {
  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;
  background-color: var(--primary-default);
  color: var(--white);
}
.MuiPickersLayout-root .MuiDayCalendar-weekContainer .isLastDay:hover {
  background: transparent;
}
.MuiPickersLayout-root .MuiPickersCalendarHeader-root {
  padding: 0 0px 8px 7px;
  margin: 0;
  min-height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.MuiPickersLayout-root .MuiPickersCalendarHeader-root .MuiButtonBase-root.MuiIconButton-root {
  color: var(--text-primary-color);
}
.MuiPickersLayout-root .MuiPickersCalendarHeader-root .MuiButtonBase-root.MuiIconButton-root:hover {
  background: transparent;
}
.MuiPickersLayout-root .MuiPickersCalendarHeader-root .pr-8 {
  padding-right: 8px;
  font-size: 1.1rem;
}
.MuiPickersLayout-root .MuiPickersCalendarHeader-root .pl-8 {
  font-size: 1.1rem;
}
.MuiPickersLayout-root .MuiPickersCalendarHeader-root .MuiPickersCalendarHeader-labelContainer {
  font-weight: 500;
  font-size: 1rem;
  color: var(--text-primary-color);
  font-family: "ABBVoice", Verdana !important;
}
.MuiPickersLayout-root .MuiPickersCalendarHeader-root .MuiPickersCalendarHeader-labelContainer.MuiPickersCalendarHeader-label {
  margin-right: 0 !important;
}
.MuiPickersLayout-root .MuiDayCalendar-header .MuiTypography-root.MuiTypography-caption.MuiDayCalendar-weekDayLabel {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--text-primary-color);
  font-family: "ABBVoice", Verdana !important;
  height: 24px;
  width: 36px;
}
.MuiPickersLayout-root .MuiPickersDay-today {
  border: 1px solid var(--primary-default) !important;
  background-color: transparent !important;
}
.MuiPickersLayout-root .MuiPickersDay-root {
  height: 28px;
  width: 28px;
  padding: 4px;
  margin: 4px;
  font-weight: 500;
  font-size: 0.875rem;
  color: var(--text-primary-color);
  font-family: "ABBVoice", Verdana !important;
}
.MuiPickersLayout-root .MuiPickersDay-root:hover {
  background-color: var(--grey-300);
}
.MuiPickersLayout-root .MuiPickersDay-root.MuiPickersDay-dayOutsideMonth {
  color: var(--grey-400);
}
.MuiPickersLayout-root .MuiPickersDay-root.MuiPickersDay-dayOutsideMonth:hover {
  background-color: var(--grey-300);
}
.MuiPickersLayout-root .MuiPickersDay-root.Mui-selected {
  background-color: var(--primary-default) !important;
  color: var(--white);
}
.MuiPickersLayout-root .MuiPickersYear-yearButton {
  font-family: "ABBVoice", Verdana !important;
  width: 60px;
  height: 36px;
  color: var(--text-primary-color);
}
.MuiPickersLayout-root .MuiPickersYear-yearButton.Mui-selected {
  background-color: var(--primary-default) !important;
  color: var(--white);
}
.MuiPickersLayout-root .MuiPickersMonth-monthButton {
  font-family: "ABBVoice", Verdana !important;
  width: 60px;
  height: 36px;
  color: var(--text-primary-color);
}
.MuiPickersLayout-root .MuiPickersMonth-monthButton.Mui-selected {
  background-color: var(--primary-default) !important;
  color: var(--white);
}
.MuiPickersLayout-root .MuiYearCalendar-root {
  height: 256px;
  width: 256px;
}
.MuiPickersLayout-root .MuiPickersMonth-root {
  flex-basis: 26%;
}
.MuiPickersLayout-root .MuiPickersSlideTransition-root.MuiDayCalendar-slideTransition {
  min-height: 212px;
}

.MuiPickersLayout-contentWrapper .MuiDivider-root {
  border-width: 0;
}

.MuiPickersLayout-actionBar {
  display: none !important;
}

.date-range-wrapper {
  position: relative;
}
.date-range-wrapper .position-date-range-close {
  position: absolute;
  top: 0;
  right: 0;
}

.header-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 24px 30px 8px 30px;
}
.header-container.mt-0 {
  padding-top: 16px;
  padding-bottom: 0;
  padding-right: 4px;
  padding-left: 28px;
}
.header-container.padding {
  padding-left: 30px;
}
.header-container .first-part {
  display: flex;
}
.header-container .first-part .year-month-toggle {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.header-container .first-part .year-month-toggle .mt-2 {
  margin-top: 2px;
}
.header-container .first-part .year-month-toggle .arrow-icon {
  color: var(--text-primary-color);
}
.header-container .first-part .year-month-toggle .year-month {
  font-weight: 500;
  font-size: 1rem;
  color: var(--text-primary-color);
  font-family: "ABBVoice", Verdana;
}
.header-container .second-part {
  display: flex;
  align-items: center;
  gap: 16px;
}
.header-container .second-part .arrow-icon {
  color: var(--text-primary-color);
}

.day-name-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  padding: 8px 16px 8px 24px;
}
.day-name-container.custom-picker {
  padding-right: 0;
  padding-left: 20px;
}
.day-name-container .day-name {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--text-primary-color);
  font-family: "ABBVoice", Verdana !important;
  height: 24px;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.days-container {
  height: 215px;
  padding-left: 24px;
  padding-bottom: 8px;
}
.days-container.pb-24 {
  padding-bottom: 24px;
}
.days-container.mt-0 {
  padding-bottom: 8px;
}
.days-container .week-container {
  display: flex;
  flex-direction: row;
}

.date-range-container {
  width: 300px;
  height: 328px;
  display: flex;
  flex-direction: row;
}
.date-range-container .defined-range-container {
  display: flex;
  font-family: "ABBVoice", Verdana;
  flex-direction: column;
  width: 200px;
}
.date-range-container .defined-range-container .defined-range-title {
  background-color: var(--white);
  padding: 16px;
  color: var(--text-primary-color);
  font-size: 0.875rem;
  font-weight: 500;
  border-right: 1px solid var(--grey-400);
}
.date-range-container .defined-range-container .list-item-container {
  height: 100%;
  background-color: var(--grey-200);
  border-right: 1px solid var(--grey-400);
}
.date-range-container .defined-range-container .list-item-container .list-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px;
  font-weight: 400;
  font-size: 0.875rem;
  height: 32px;
  color: var(--text-primary-color);
  border-left: 4px solid transparent;
  cursor: pointer;
}
.date-range-container .defined-range-container .list-item-container .list-item:hover {
  background-color: var(--grey-300);
}
.date-range-container .defined-range-container .list-item-container .list-item.selected {
  background-color: var(--accordion-expanded-bg);
  border-left: 4px solid var(--primary-default);
}
.date-range-container .calender-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 24px;
  box-sizing: border-box;
}
.date-range-container .calender-container .time-picker-button-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  justify-content: end;
  padding-bottom: 24px;
}
.date-range-container .calender-container .text-field-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-left: 24px;
}
.date-range-container .calender-container .text-field-container .text-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 16px;
}
.date-range-container .calender-container .text-field-container .label {
  color: var(--text-primary-color);
  font-weight: 500;
  font-size: 0.875rem;
}
.date-range-container .calender-container .to {
  color: var(--grey-800);
  font-weight: 500;
  font-size: 0.875rem;
  margin-top: 32px;
}
.date-range-container .calender-container .calender-part {
  display: flex;
  flex-direction: row;
}
.date-range-container .calender-container .calender-time-container {
  display: flex;
  flex-direction: row;
}
.date-range-container .calender-container .calender-time-container .time-range-container {
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  padding-bottom: 4px;
}
.date-range-container .calender-container .calender-time-container .time-range-container .from-to-label {
  color: var(--text-primary-color);
  font-weight: 400;
  font-size: 0.875rem;
}

*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

*::-webkit-scrollbar-thumb {
  background-color: var(--grey-400);
  border-radius: 20px;
  border: 2px solid var(--white);
}

.month-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px 0px 24px 24px;
  max-width: 262px;
}
.month-container .month {
  width: 59px;
  border-radius: 20px;
  margin: 8px;
  height: 36px;
  color: var(--text-primary-color);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.75;
  cursor: pointer;
}
.month-container .month:hover {
  background-color: var(--grey-300);
}
.month-container .month.selected {
  background-color: var(--primary-default);
  color: var(--white);
}

.date-range-picker .calender-icon {
  font-size: 1.5rem;
  margin-right: 8px;
}
.date-range-picker .mt-2 {
  margin-top: 2px;
  margin-left: 6px;
}

.year-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px 0px 24px 24px;
  height: 200px;
  overflow-y: auto;
  max-width: 262px;
}
.year-container .year {
  width: 68px;
  border-radius: 20px;
  margin: 4px;
  height: 36px;
  color: var(--text-primary-color);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.75;
  cursor: pointer;
}
.year-container .year:hover {
  background-color: var(--grey-300);
}
.year-container .year.selected {
  background-color: var(--primary-default);
  color: var(--white);
}

.day-button-container {
  display: flex;
  cursor: pointer;
}
.day-button-container.left-border-radius {
  border-radius: 50% 0 0 50%;
}
.day-button-container.right-border-radius {
  border-radius: 0 50% 50% 0;
}
.day-button-container.highlighted {
  background-color: var(--accordion-expanded-bg);
}
.day-button-container .button {
  height: 28px;
  width: 28px;
  margin: 4px;
  font-weight: 500;
  font-size: 0.875rem;
  font-family: "ABBVoice", Verdana !important;
  color: var(--text-primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.day-button-container .button:hover {
  background-color: var(--grey-300);
}
.day-button-container .button.outlined {
  border: 1px solid var(--primary-default);
}
.day-button-container .button.outOfCurrentMonth {
  color: var(--grey-500);
}
.day-button-container .button.filled {
  background-color: var(--primary-default);
  border-radius: 50%;
  color: var(--white);
}
.day-button-container .button.filled:hover {
  background-color: var(--primary-default) !important;
}
.day-button-container.highlighted .button:hover {
  background-color: var(--accordion-expanded-bg);
}

.MuiDialog-root .MuiBackdrop-root.MuiModal-backdrop {
  background-color: rgba(0, 0, 0, 0.32);
}

.MuiPaper-root.MuiPaper-elevation.MuiDialog-paper {
  background-color: var(--card-bg);
  max-width: none;
}

.MuiDialog-paper .modal-container {
  border-radius: 4px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  min-width: 350px;
  max-width: 350px;
  position: relative;
}
.MuiDialog-paper .modal-container .close-icon {
  position: absolute;
  top: 24px;
  right: 24px;
  color: var(--text-primary-color);
  font-size: 1.2rem;
}
.MuiDialog-paper .modal-container.default-modal {
  max-width: none;
  padding: 32px;
}
.MuiDialog-paper .modal-container.default-modal .close-icon {
  position: absolute;
  top: 32px;
  right: 32px;
  color: var(--text-primary-color);
}
.MuiDialog-paper .modal-container .heading {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}
.MuiDialog-paper .modal-container .heading .heading-left {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.MuiDialog-paper .modal-container .heading.border-bottom {
  border-bottom: 1px solid var(--grey-400);
  padding-bottom: 16px;
  margin-bottom: 16px;
}
.MuiDialog-paper .modal-container .heading .heading-icon {
  font-size: 24px;
}
.MuiDialog-paper .modal-container .heading .heading-text {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary-color);
  line-height: 1.563rem;
}
.MuiDialog-paper .modal-container .heading .dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary-color);
}
.MuiDialog-paper .modal-container .heading .subtitle {
  color: var(--grey-800);
  font-size: 0.875rem;
  border-left: 1px solid var(--grey-500);
  margin-left: 8px;
  padding-left: 16px;
}
.MuiDialog-paper .modal-container.information .heading-icon {
  color: var(--status-info);
}
.MuiDialog-paper .modal-container.error .heading-icon {
  color: var(--status-error);
}
.MuiDialog-paper .modal-container.success .heading-icon {
  color: var(--status-success);
}
.MuiDialog-paper .modal-container.warning .heading-icon {
  color: var(--status-warning);
}
.MuiDialog-paper .modal-container.default .heading-icon {
  color: var(--text-primary-color);
}
.MuiDialog-paper .modal-container .content {
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--text-primary-color);
  line-height: 1.313rem;
  margin-left: 32px;
  margin-bottom: 16px;
}
.MuiDialog-paper .modal-container .content-container {
  min-width: 520px;
  min-height: 22.75rem;
  overflow-y: auto;
  padding-top: 16px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  background-color: var(--grey-300);
}
.MuiDialog-paper .modal-container .modal-button-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  gap: 8px;
}

.empty-state {
  background-color: var(--white);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 4px;
}
.empty-state .primary-text {
  font-weight: 500;
  font-size: 1.313rem;
  color: var(--text-primary-color);
}
.empty-state .secondary-text {
  font-weight: 300;
  font-size: 1rem;
  color: var(--text-primary-color);
}
.empty-state .empty-state-button-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
  margin-top: 4px;
}
.empty-state .empty-image {
  width: 8%;
}

.multi-file-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.multi-file-container .uploader-label {
  font-family: "ABBVoice", Verdana;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.16px;
  color: var(--text-primary-color);
}
.multi-file-container .uploader-description {
  font-family: "ABBVoice", Verdana;
  font-size: 0.875rem;
  letter-spacing: 0.16px;
  color: var(--text-secondary-color);
}
.multi-file-container .button-upload-content {
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: 8px;
}
.multi-file-container .button-upload-content .uploaded-file-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.multi-file-container .button-upload-content .uploaded-file-container .error-text {
  font-size: 0.75rem;
  color: var(--status-error);
}
.multi-file-container .button-upload-content .uploaded-file-container .file-content {
  background: var(--segmented-control-hover);
  border-radius: 4px;
  padding: 0 12px 0px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 34px;
  max-width: 200px;
  min-width: 200px;
  color: var(--text-primary-color);
}
.multi-file-container .button-upload-content .uploaded-file-container .file-content .text-overflow {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 190px;
}
.multi-file-container .button-upload-content .uploaded-file-container .file-content.error {
  border-bottom: 2px solid var(--status-error);
}
.multi-file-container .button-upload-content .uploaded-file-container .file-content .file-name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 173px;
  padding-right: 16px;
  font-size: 0.875rem;
  line-height: 1.5rem;
}

.parent-container {
  min-width: 276px;
  max-width: 276px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  background: var(--grey-200) 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
  height: 40px;
  border: 1px solid var(--grey-200);
}
.parent-container .single-file-container {
  display: flex;
  font-family: "ABBVoice", Verdana;
  flex-direction: row;
  align-items: center;
  padding: 0 16px;
  min-height: 36px;
  gap: 8px;
  color: var(--text-primary-color);
}
.parent-container .single-file-container.error {
  border-bottom: 2px solid var(--status-error);
}
.parent-container .single-file-container.space-between {
  justify-content: space-between;
}
.parent-container .single-file-container .icon-name-container {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-primary-color);
}
.parent-container .single-file-container .icon-name-container .text-overflow {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 190px;
}
.parent-container .single-file-container .icon-name-container .file-name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 190px;
}
.parent-container .single-file-container .dragndrop {
  font-family: "ABBVoice", Verdana;
  font-size: 0.875rem;
  color: var(--grey-600);
}

.app-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
  min-width: 939px;
  align-items: center;
  height: 64px;
  background-color: var(--white);
  border-bottom: 1px solid var(--grey-500);
  border-top: 1px solid var(--grey-500);
  color: var(--text-primary-color);
}
.app-header .first-part {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 20px;
}
.app-header .first-part .abb-logo {
  width: 4.25rem;
  height: 1.625rem;
  min-width: 4.25rem;
  margin: 0 12px 0 0;
}
.app-header .first-part .header-text {
  padding-right: 12px;
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  color: var(--text-primary-color);
  font-weight: 400;
}
.app-header .first-part .divider {
  height: 36px;
  width: 1px;
  background: var(--grey-500);
}
.app-header .first-part .app-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.5;
  font-size: 0.875rem;
  color: var(--text-primary-color);
  padding-left: 12px;
}
.app-header .first-part #nav-icon {
  margin-right: 20px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  position: relative;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-header .first-part #nav-icon span {
  position: absolute;
  height: 1.5px;
  width: 22px;
  background: var(--text-primary-color);
  border-radius: 9px;
  opacity: 1;
  left: 0;
  transition: all 0.4s;
  cursor: pointer;
}
.app-header .first-part #nav-icon span:nth-child(1) {
  top: 6.5px;
}
.app-header .first-part #nav-icon span:nth-child(2) {
  top: 12.5px;
}
.app-header .first-part #nav-icon span:nth-child(3) {
  top: 18.5px;
}
.app-header .first-part #nav-icon.open span:nth-child(1) {
  top: 12px;
  transform: rotate(45deg);
  left: 0;
}
.app-header .first-part #nav-icon.open span:nth-child(2) {
  width: 0;
  opacity: 0;
}
.app-header .first-part #nav-icon.open span:nth-child(3) {
  transform: rotate(-45deg);
  top: 12px;
  left: 0;
}
.app-header .tab-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-header .tab-container .tab-text {
  border-bottom: 0.25rem solid transparent;
  cursor: pointer;
  font-size: 0.875rem;
  color: var(--text-primary-color);
  display: inline-flex;
  align-items: center;
  place-content: center;
  gap: 8px;
  height: 100%;
  padding: 1.9rem 2.25rem;
}
.app-header .tab-container .tab-text .down-icon {
  margin-top: 2px;
}
.app-header .tab-container .tab-text:hover {
  font-weight: 500;
}
.app-header .tab-container .tab-text.active {
  font-weight: 500;
}
.app-header .tab-container .active-tab-indicator {
  position: absolute;
  bottom: 10px;
  height: 0.25rem;
  background-color: var(--primary-default);
  transition: left 0.3s ease;
}
.app-header .second-part {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 20px;
  gap: 0.75rem;
}
.app-header .second-part .part-one {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
}
.app-header .second-part .part-one .position {
  position: absolute;
  top: 9px;
  right: 69px;
}
.app-header .second-part .part-one .search-container {
  display: flex;
  align-items: center;
  position: relative;
}
.app-header .second-part .part-one .search-container .header-search-bar {
  position: absolute;
  top: 0;
  right: 24px;
  width: 0;
  z-index: 2;
  opacity: 0;
  transition: transform 0.3s ease, opacity 0.3s ease, width 0.3s ease;
  transform: translateX(100%);
}
.app-header .second-part .part-one .search-container .header-search-bar.active {
  opacity: 1;
  right: 30px;
  width: 160px;
  top: 0px;
  z-index: 99;
  transform: translateX(0);
}
.app-header .second-part .part-one .notification {
  position: relative;
}
.app-header .second-part .part-one .copilot {
  padding: 6px 12px 4px 12px;
  background-color: var(--grey-300);
  border-radius: 8px;
}
.app-header .second-part .part-one .copilot .copilot-img {
  max-width: 80px;
}
.app-header .second-part .divider {
  height: 36px;
  width: 1px;
  background: var(--grey-500);
}
.app-header .second-part .part-two {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
}
.app-header .second-part .header-icon {
  font-size: 1.5rem;
  z-index: 10;
}
.app-header .second-part .global-icon {
  font-size: 2rem;
}
.app-header .second-part .pr-12 {
  padding-right: 0.75rem;
}

.p-0 {
  padding: 0 !important;
  max-width: none;
  min-width: 68vw;
}
.p-0 .css-1d3ml05-MuiPopper-root-MuiTooltip-popper .MuiTooltip-arrow {
  width: 11em !important;
  height: 1.9em !important;
  margin-top: -1.9em;
  margin-left: 4em;
}
.p-0.MuiTooltip-tooltip.theme-light .MuiTooltip-arrow::before {
  color: var(--grey-200) !important;
}

.header-navigation-container {
  display: flex;
  flex-direction: row;
  min-width: 68vw;
}
.header-navigation-container .left-part {
  width: 40%;
  background-color: var(--white);
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
}
.header-navigation-container .left-part .top {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.header-navigation-container .left-part .top .text-link {
  gap: 0;
  display: flex;
}
.header-navigation-container .left-part .heading {
  font-size: 1.313rem;
  font-weight: 500;
  text-wrap: nowrap;
  color: var(--text-primary-color);
}
.header-navigation-container .left-part .list-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
.header-navigation-container .left-part .list-container .nav-list-item {
  display: flex;
  align-items: center;
  justify-content: start;
  height: 32px;
  font-size: 0.875rem;
  font-weight: 500;
  width: 88%;
  border-left: 4px solid transparent;
  padding: 0 16px;
  cursor: pointer;
  margin-bottom: 0.5rem;
  border-radius: 8px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.header-navigation-container .left-part .list-container .nav-list-item:hover {
  background-color: var(--grey-300);
}
.header-navigation-container .left-part .list-container .nav-list-item.selected {
  border-left: 4px solid var(--primary-default);
  background-color: var(--accordion-expanded-bg);
}
.header-navigation-container .left-part .digital-img {
  width: 52px;
  height: 52px;
}
.header-navigation-container .right-part {
  width: 60%;
  background-color: var(--grey-200);
  padding: 24px;
}
.header-navigation-container .right-part .card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  height: 200px;
  overflow-y: auto;
}
.header-navigation-container .right-part .app-item {
  width: 48%;
  display: flex;
  align-items: center;
  border: 0;
  box-shadow: none;
  gap: 16px;
  background: transparent;
}
.header-navigation-container .right-part .app-item .icon-container {
  border-radius: 12px;
  box-sizing: border-box;
  width: 56px;
  height: 56px;
  border: 1px solid transparent;
  background-color: var(--white);
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.0509803922);
}
.header-navigation-container .right-part .app-item .icon-container .icon {
  width: 54%;
  cursor: default;
}
.header-navigation-container .right-part .app-item .icon-container.hover {
  background-color: var(--accordion-expanded-bg);
  border: 1px solid var(--primary-default);
  cursor: pointer;
}
.header-navigation-container .right-part .app-item .content {
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--text-primary-color);
}
.header-navigation-container .right-part .app-item .content.hover {
  font-weight: 500;
  cursor: pointer;
}
.header-navigation-container .right-part .heading {
  font-size: 1rem;
  font-weight: 500;
  color: var(--text-primary-color);
  margin-bottom: 16px;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent !important;
  color: var(--text-primary-color);
  cursor: pointer;
  border-radius: 50%;
}
.icon-container.size-8 {
  font-size: 0.5rem;
  padding: 0.188rem;
}
.icon-container.size-12 {
  font-size: 0.75rem;
  padding: 0.25rem;
}
.icon-container.size-16 {
  font-size: 1rem;
  padding: 0.375rem;
}
.icon-container.size-24 {
  font-size: 1.5rem;
  padding: 0.5rem;
}
.icon-container.size-32 {
  font-size: 2rem;
  padding: 0.75rem;
}
.icon-container:not(.disable-hover):not(.disabled):hover {
  background-color: var(--grey-200) !important;
}
.icon-container.list:not(.disable-hover):not(.disabled):hover {
  background-color: var(--icon-hover) !important;
}
.icon-container:not(.disable-hover):not(.disabled):active {
  background-color: var(--grey-300) !important;
}
.icon-container.selected {
  background-color: var(--accordion-expanded-bg) !important;
}
.icon-container.disabled {
  color: var(--grey-600);
  background-color: transparent;
  cursor: not-allowed;
}

.input-group .middle .MuiFormControl-root.MuiTextField-root:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.input-group .middle .Mui-focused {
  border-left: none;
  border-right: none;
}
.input-group .middle .MuiOutlinedInput-notchedOutline {
  border-left: none;
  border-right: none;
}
.input-group .disabled {
  background-color: var(--grey-200);
  cursor: not-allowed;
  pointer-events: none;
}
.input-group .disabled .disabled {
  opacity: 0.6;
}
.input-group .read-only-input-group {
  font-size: 0.875rem;
  color: var(--text-primary-color);
  font-weight: 400;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
}
.input-group .read-only-input-group.border {
  border-left: 1px solid var(--grey-500);
}
.input-group .MuiInputBase-root.MuiInput-root.MuiInput-underline::before {
  border-bottom: 1px solid var(--grey-400);
}
.input-group .MuiInputBase-root.MuiInput-root.MuiInput-underline:hover:not(.Mui-disabled, .Mui-error):before {
  border-bottom: 1px solid var(--text-primary-color);
}
.input-group .MuiInputBase-root.MuiInput-root.MuiInput-underline::after {
  border-bottom: 1px solid var(--primary-default);
}

.leftNav {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
  z-index: 100;
  overflow-x: hidden;
  min-height: 600px;
  background-color: var(--grey-100);
  border-width: 2px solid var(--grey-400);
  box-shadow: 0 3px 6px var(--shadow-grey-200);
  transition: width 0.5s ease;
}
.leftNav .nav-container-submenu {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.leftNav .submenu {
  overflow: hidden;
  height: 0;
  transition: height 0.3s ease;
}
.leftNav .submenu-item {
  padding: 16px 38px 16px 54px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
  background-color: var(--white);
  color: var(--text-primary-color);
  cursor: pointer;
}
.leftNav .submenu-item:hover {
  background-color: var(--grey-300);
}
.leftNav .submenu-item.selected {
  background-color: var(--accordion-expanded-bg);
  font-weight: 500;
}
.leftNav .submenu-item .submenu-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 8px;
}
.leftNav .submenu-item .badge-container {
  display: flex;
  align-items: center;
}
.leftNav .submenu-item.border-color {
  border-left: 4px solid var(--primary-default);
}
.leftNav .submenu-item.border-transparent {
  border-left: 4px solid transparent;
}
.leftNav .submenu-icon {
  font-size: 16px;
}
.leftNav .submenu-label {
  font-size: 0.875rem;
}
.leftNav .hierarchy {
  display: flex;
  align-items: center;
  overflow: hidden;
  min-height: 64px;
  gap: 16px;
  cursor: pointer;
  color: var(--text-primary-color);
  border-bottom: 1px solid var(--grey-400);
  margin-bottom: 4px;
}
.leftNav .hierarchy:hover {
  background-color: var(--grey-400);
}
.leftNav .hierarchy.justify-start {
  justify-content: start;
  padding-left: 20px;
}
.leftNav .hierarchy.justify-center {
  padding-left: 20px;
}
.leftNav .hierarchy .hierarchy-text.visible {
  display: block;
}
.leftNav .hierarchy .hierarchy-text.hidden {
  display: none;
}
.leftNav .hierarchy .nav-icon {
  font-size: 24px;
  color: var(--text-primary-color);
}
.leftNav .navigation {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  min-height: 64px;
  height: auto;
  gap: 16px;
  cursor: pointer;
  border-left: 4px solid transparent;
  color: var(--text-primary-color);
}
.leftNav .navigation:hover {
  background-color: var(--grey-400);
  transition: all 0.2s ease-in-out;
}
.leftNav .navigation.bg-highlight {
  background-color: var(--accordion-expanded-bg);
}
.leftNav .navigation.bg-highlight.border-left {
  border-left: 4px solid var(--primary-default);
}
.leftNav .navigation.bg-white {
  background-color: var(--white);
}
.leftNav .navigation.bg-white.border-left {
  border-left: 4px solid var(--primary-default);
}
.leftNav .navigation.justify-start {
  justify-content: space-between;
}
.leftNav .navigation.pl-16 {
  padding-left: 16px;
}
.leftNav .navigation.disabled {
  color: var(--grey-600);
  background-color: var(--grey-100);
  cursor: not-allowed;
}
.leftNav .navigation .left-nav-badge-position {
  position: absolute;
  right: 12px;
  top: 16px;
}
.leftNav .navigation .nav-content-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 16px;
}
.leftNav .navigation .nav-wrapper-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.leftNav .navigation .nav-content-left {
  padding-right: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.leftNav .navigation .nav-content-left .visible {
  visibility: visible;
}
.leftNav .navigation .nav-content-left .hidden {
  visibility: hidden;
}
.leftNav .navigation .nav-content-left .rotate-arrow {
  transform: rotate(90deg);
  transition: transform 0.3s linear;
}
.leftNav .navigation .nav-content-left .right-arrow {
  transition: transform 0.3s linear;
}
.leftNav .navigation .nav-icon {
  position: relative;
  font-size: 24px;
  color: var(--text-primary-color);
}
.leftNav .navigation .nav-icon.icon-blue {
  color: var(--primary-default);
}
.leftNav .navigation .nav-icon.disabled {
  color: var(--grey-600);
  background-color: var(--grey-100);
  cursor: not-allowed;
}
.leftNav .navigation .nav-text {
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--text-primary-color);
  white-space: nowrap;
  overflow: hidden;
}
.leftNav .navigation .nav-text.text-blue {
  color: var(--primary-default);
  font-weight: 500;
}
.leftNav .navigation .nav-text.visible {
  display: block;
}
.leftNav .navigation .nav-text.hidden {
  display: none;
}
.leftNav .navigation .nav-text.disabled {
  color: var(--grey-600);
  background-color: var(--grey-100);
  cursor: not-allowed;
}
.leftNav.w-80 {
  width: 300px;
}
.leftNav.w-64 {
  width: 64px;
}

.text-link {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;
  color: var(--text-blue-color) !important;
  cursor: pointer;
  text-decoration: none !important;
  display: inline-block;
  text-wrap: nowrap;
}
.text-link.mb-4 {
  margin-bottom: 4px;
}
.text-link:hover {
  text-decoration: underline !important;
}
.text-link.disabled {
  cursor: "not-allowed";
  color: var(--text-primary-color) !important;
  opacity: 50%;
  cursor: not-allowed;
  text-decoration: none !important;
}
.text-link .icon {
  margin-bottom: 4px;
  padding-right: 8px;
}
.text-link .trailing-icon {
  margin-bottom: -2px;
}
.text-link .text {
  margin-right: 0.125rem;
}
.text-link.size-12 {
  font-size: 0.75rem;
}
.text-link.size-14 {
  font-size: 0.875rem;
}
.text-link.size-16 {
  font-size: 1rem;
}

.MuiList-root {
  background-color: var(--card-bg);
  border-radius: 4px;
  box-sizing: border-box;
  min-width: 300px;
}
.MuiList-root.MuiList-root {
  padding: 0;
}
.MuiList-root.MuiList-root .zebra-stripe {
  background-color: var(--toolbar-bg);
}
.MuiList-root.MuiList-root .zebra-white {
  background-color: var(--white);
}
.MuiList-root.MuiList-root .MuiListItem-root .size-40 {
  min-height: 40px;
  padding: 0 20px;
}
.MuiList-root.MuiList-root .MuiListItem-root .size-32 {
  min-height: 32px;
  padding: 0 16px;
}
.MuiList-root.MuiList-root .MuiListItem-root .size-24 {
  min-height: 24px;
  padding: 0 12px;
}
.MuiList-root.MuiList-root .MuiListItem-root.pl-less .size-40 {
  padding: 0 14px 0 20px;
}
.MuiList-root.MuiList-root .MuiListItem-root.pl-less .size-32 {
  padding: 0 10px 0 16px;
}
.MuiList-root.MuiList-root .MuiListItem-root.pl-less .size-24 {
  padding: 0 6px 0 12px;
}
.MuiList-root .MuiDivider-root {
  background: var(--grey-400);
}
.MuiList-root .MuiListItem-root {
  padding: 0;
}
.MuiList-root .MuiListItem-root .MuiButtonBase-root.MuiListItemButton-root {
  font-family: "ABBVoice", Verdana;
  color: var(--text-primary-color);
  font-size: 0.875rem;
  font-weight: 400;
  border-left: 4px solid transparent;
}
.MuiList-root .MuiListItem-root .MuiButtonBase-root.MuiListItemButton-root:hover {
  background-color: var(--grey-300);
}
.MuiList-root .MuiListItem-root .MuiButtonBase-root.MuiListItemButton-root.Mui-selected {
  background-color: var(--accordion-expanded-bg);
}
.MuiList-root .MuiListItem-root .MuiButtonBase-root.MuiListItemButton-root.Mui-selected.multi {
  border-left: 4px solid transparent;
}
.MuiList-root .MuiListItem-root .MuiButtonBase-root.MuiListItemButton-root.Mui-selected.single {
  border-left: 4px solid var(--primary-default);
}
.MuiList-root .MuiListItem-root .MuiButtonBase-root.MuiListItemButton-root .MuiCheckbox-root {
  padding: 0;
}
.MuiList-root .MuiListItem-root .MuiButtonBase-root.MuiListItemButton-root .MuiListItemIcon-root {
  min-width: 0;
  padding-right: 8px;
  font-size: 1rem;
  color: var(--text-primary-color);
}
.MuiList-root .MuiListItem-root .MuiButtonBase-root.MuiListItemButton-root .MuiListItemText-primary {
  font-family: "ABBVoice", Verdana;
  color: var(--text-primary-color);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.313rem;
}
.MuiList-root .MuiListItem-root .MuiButtonBase-root.MuiListItemButton-root .MuiListItemText-secondary {
  font-family: "ABBVoice", Verdana;
  color: var(--grey-800);
  font-size: 0.875rem;
  line-height: 1.313rem;
}

.loading-indicator-container {
  min-width: 350px;
}

.loading-indicator-label {
  color: var(--grey-800);
  font-size: 0.875rem;
  font-weight: 400;
  font-family: "ABBVoice", Verdana;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 64px;
}
.loading-indicator-label .mr-20 {
  margin-right: 20px;
}
.loading-indicator-label.large {
  position: absolute;
  top: 38px;
  left: 34px;
}

.loading-indicator-description {
  color: var(--grey-800);
  font-size: 0.75rem;
  font-weight: 400;
}

.progress-bar-container {
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
}
.progress-bar-container .success {
  color: var(--status-success);
}

.MuiLinearProgress-root.MuiLinearProgress-colorPrimary {
  background-color: var(--grey-400);
  border-radius: 4px;
  width: 100%;
}
.MuiLinearProgress-root.MuiLinearProgress-colorPrimary.size-small {
  height: 4px;
}
.MuiLinearProgress-root.MuiLinearProgress-colorPrimary.size-medium {
  height: 6px;
}
.MuiLinearProgress-root.MuiLinearProgress-colorPrimary.size-large {
  height: 8px;
}
.MuiLinearProgress-root.MuiLinearProgress-colorPrimary .MuiLinearProgress-bar {
  background-color: var(--primary-default);
}
.MuiLinearProgress-root.MuiLinearProgress-colorPrimary.green-bg .MuiLinearProgress-bar {
  background-color: var(--status-success);
}
.MuiLinearProgress-root.MuiLinearProgress-colorPrimary.disabled .MuiLinearProgress-bar {
  background-color: var(--grey-600);
}

.circular-progress-container {
  display: flex;
  flex-direction: row;
  gap: 8px;
  position: relative;
}
.circular-progress-container .tick-icon {
  color: var(--status-success);
  position: absolute;
  top: 0;
  left: 0;
}
.circular-progress-container .tick-icon.small {
  font-size: 0.75rem;
  top: 3px;
  left: 2px;
}
.circular-progress-container .tick-icon.large {
  top: 12px;
  left: 12px;
  font-size: 5rem;
}
.circular-progress-container .tick-icon.medium {
  top: 6px;
  left: 4px;
  font-size: 2.5rem;
}

.MuiCircularProgress-root.MuiCircularProgress-colorPrimary {
  color: var(--primary-default);
}
.MuiCircularProgress-root.MuiCircularProgress-colorPrimary.bg-circle-radial {
  color: var(--grey-400);
}
.MuiCircularProgress-root.MuiCircularProgress-colorPrimary.green-bg {
  color: var(--status-success);
}
.MuiCircularProgress-root.MuiCircularProgress-colorPrimary.disabled {
  color: var(--grey-600);
}

.dot-pulse {
  position: relative;
  left: -9999px;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background-color: var(--primary-default);
  color: var(--primary-default);
  box-shadow: 9999px 0 0 -5px var(--primary-default);
  animation: dotPulse 1.5s infinite linear;
  animation-delay: 0.25s;
}

.dot-pulse::before,
.dot-pulse::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background-color: var(--primary-default);
  color: var(--primary-default);
}

.dot-pulse::before {
  box-shadow: 9984px 0 0 -5px var(--primary-default);
  animation: dotPulseBefore 1.5s infinite linear;
  animation-delay: 0s;
}

.dot-pulse::after {
  box-shadow: 10014px 0 0 -5px var(--primary-default);
  animation: dotPulseAfter 1.5s infinite linear;
  animation-delay: 0.5s;
}

@keyframes dotPulseBefore {
  0% {
    box-shadow: 9984px 0 0 -5px var(--primary-default);
  }
  30% {
    box-shadow: 9984px 0 0 2px var(--primary-default);
  }
  60%, 100% {
    box-shadow: 9984px 0 0 -5px var(--primary-default);
  }
}
@keyframes dotPulse {
  0% {
    box-shadow: 9999px 0 0 -5px var(--primary-default);
  }
  30% {
    box-shadow: 9999px 0 0 2px var(--primary-default);
  }
  60%, 100% {
    box-shadow: 9999px 0 0 -5px var(--primary-default);
  }
}
@keyframes dotPulseAfter {
  0% {
    box-shadow: 10014px 0 0 -5px var(--primary-default);
  }
  30% {
    box-shadow: 10014px 0 0 2px var(--primary-default);
  }
  60%, 100% {
    box-shadow: 10014px 0 0 -5px var(--primary-default);
  }
}
.MuiMenu-list {
  min-width: 200px;
}

.MuiButtonBase-root.MuiMenuItem-root {
  color: var(--text-primary-color);
  font-size: 0.875rem;
  font-family: "ABBVoice", Verdana;
  font-weight: 400;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: start;
  gap: 8px;
}
.MuiButtonBase-root.MuiMenuItem-root:hover {
  background-color: var(--grey-300);
}
.MuiButtonBase-root.MuiMenuItem-root.size-40 {
  min-height: 40px;
  padding: 4px 20px;
}
.MuiButtonBase-root.MuiMenuItem-root.size-32 {
  min-height: 32px;
  padding: 4px 16px;
}
.MuiButtonBase-root.MuiMenuItem-root.size-24 {
  min-height: 24px;
  padding: 0 12px;
}
.MuiButtonBase-root.MuiMenuItem-root.selected {
  background-color: var(--accordion-expanded-bg);
}
.MuiButtonBase-root.MuiMenuItem-root .menu-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.MuiButtonBase-root.MuiMenuItem-root .menu-item .first-part {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: start;
}
.MuiButtonBase-root.MuiMenuItem-root .menu-item .label {
  display: flex;
  flex-direction: column;
}
.MuiButtonBase-root.MuiMenuItem-root .menu-item .label .title {
  font-size: 0.875rem;
  color: var(--text-primary-color);
}
.MuiButtonBase-root.MuiMenuItem-root .menu-item .label .description {
  font-size: 0.75rem;
  color: var(--grey-800);
  font-family: "ABBVoice", Verdana;
}
.MuiButtonBase-root.MuiMenuItem-root + .MuiDivider-root {
  margin: 0;
}

.MuiList-root .MuiDivider-root {
  color: var(--grey-400);
  margin: 0;
}

.MuiSnackbar-root.position {
  top: 64px !important;
  right: 8px !important;
}
.MuiSnackbar-root .notification-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 16px;
  border-radius: 4px;
  min-width: 300px;
  min-height: 24px;
  height: 56px;
  font-size: 1rem;
  font-weight: 500;
  position: relative;
  color: var(--text-primary-color);
  box-shadow: 0 3px 6px var(--shadow-grey-200);
}
.MuiSnackbar-root .notification-container .container {
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: center;
}
.MuiSnackbar-root .notification-container.sm {
  padding: 10px 16px;
  height: 36px;
  font-size: 0.875rem;
  min-height: 6px;
}
.MuiSnackbar-root .notification-container.banner {
  width: 100vw;
  height: auto;
  position: absolute;
}
.MuiSnackbar-root .notification-container.banner .w-4 {
  width: 4%;
}
.MuiSnackbar-root .notification-container .content-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}
.MuiSnackbar-root .notification-container .content-container .secondary-text {
  color: var(--text-primary-color);
  font-size: 0.75rem;
  font-weight: 300;
}
.MuiSnackbar-root .notification-container.neutral {
  background-color: var(--white);
}
.MuiSnackbar-root .notification-container.neutral-sm {
  background-color: var(--grey-200);
  border: 1px solid var(--grey-500);
}
.MuiSnackbar-root .notification-container.primary {
  background-color: var(--white);
  border-radius: 0 0 5px 5px;
  border-top: 4px solid var(--status-info);
}
.MuiSnackbar-root .notification-container.primary .notification-icon {
  color: var(--status-info);
  font-size: 1.75rem;
}
.MuiSnackbar-root .notification-container.primary-sm {
  background-color: var(--status-info-transparent);
  border: 1px solid var(--status-info);
}
.MuiSnackbar-root .notification-container.primary-sm .notification-icon {
  color: var(--status-info);
  font-size: 1.25rem;
}
.MuiSnackbar-root .notification-container.success {
  background-color: var(--white);
  border-radius: 0 0 5px 5px;
  border-top: 4px solid var(--status-success);
}
.MuiSnackbar-root .notification-container.success .notification-icon {
  color: var(--status-success);
  font-size: 1.75rem;
}
.MuiSnackbar-root .notification-container.success-sm {
  background-color: var(--status-success-transparent);
  border: 1px solid var(--status-success);
}
.MuiSnackbar-root .notification-container.success-sm .notification-icon {
  color: var(--status-success);
  font-size: 1.25rem;
}
.MuiSnackbar-root .notification-container.warning {
  background-color: var(--white);
  border-radius: 0 0 5px 5px;
  border-top: 4px solid var(--status-warning);
}
.MuiSnackbar-root .notification-container.warning .notification-icon {
  color: var(--status-warning);
  font-size: 1.75rem;
}
.MuiSnackbar-root .notification-container.warning-sm {
  background-color: var(--status-warning-transparent);
  border: 1px solid var(--status-warning);
}
.MuiSnackbar-root .notification-container.warning-sm .notification-icon {
  color: var(--status-warning);
  font-size: 1.25rem;
}
.MuiSnackbar-root .notification-container.error {
  background-color: var(--white);
  border-radius: 0 0 5px 5px;
  border-top: 4px solid var(--status-error);
}
.MuiSnackbar-root .notification-container.error .notification-icon {
  color: var(--status-error);
  font-size: 1.75rem;
}
.MuiSnackbar-root .notification-container.error-sm {
  background-color: var(--status-error-transparent);
  border: 1px solid var(--status-error);
}
.MuiSnackbar-root .notification-container.error-sm .notification-icon {
  color: var(--status-error);
  font-size: 1.25rem;
}

.numeric .ml-4 {
  margin-left: 4px;
}
.numeric .active {
  cursor: pointer;
}
.numeric .inactive {
  opacity: 0.5;
  cursor: not-allowed !important;
}
.numeric .error-icon {
  color: var(--status-error);
  margin-top: 2px;
}
.numeric .tick-icon {
  color: var(--status-success);
  margin-top: 2px;
}
.numeric .small-variant-action {
  display: flex;
  flex-direction: column;
  background-color: var(--grey-200);
  border-left: 1px solid var(--grey-400);
}
.numeric .small-variant-action .square-icon:hover {
  background-color: var(--grey-200);
}
.numeric .small-variant-action .square-icon:active {
  background-color: var(--grey-300);
}
.numeric .small-variant-action .border-top {
  border-top: 1px solid var(--grey-400);
  border-radius: 0;
}
.numeric .small-variant-action .size-32 {
  padding: 2.5px;
}
.numeric .small-variant-action .size-40 {
  padding: 4px;
}
.numeric .disabled {
  background-color: var(--grey-200);
  cursor: not-allowed;
  pointer-events: none;
}
.numeric .disabled .prefix,
.numeric .disabled .end-adornment,
.numeric .disabled .suffix {
  color: var(--grey-500);
}
.numeric .disabled .disabled {
  opacity: 0.6;
}

.MuiTableCell-root.MuiTablePagination-root {
  border-bottom: none;
  color: var(--text-primary-color);
  font-family: "ABBVoice", Verdana;
  width: 100%;
  overflow: hidden;
  display: flex;
}
.MuiTableCell-root.MuiTablePagination-root.add-border {
  border-top: 1px solid var(--grey-500);
}
.MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar {
  min-height: 56px;
  padding-left: 32px;
  padding-right: 32px;
  background-color: var(--white);
  display: flex;
  flex-direction: row;
  font-family: "ABBVoice", Verdana;
  justify-content: space-between;
  align-items: center;
}
.MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar .MuiTablePagination-spacer {
  display: none;
}
.MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar .pagination-wrapper {
  font-family: "ABBVoice", Verdana;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 8px;
}
.MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar .MuiTablePagination-displayedRows {
  display: none;
}
.MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar .pagination-actions {
  font-family: "ABBVoice", Verdana;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
}
.MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar .pagination-actions .arrow {
  color: var(--text-primary-color);
  padding: 0 8px;
}
.MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar .pagination-actions .arrow.disabled {
  color: var(--grey-600);
  cursor: not-allowed;
}
.MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar .pagination-actions .ml-4 {
  margin-left: 4px;
}
.MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar .pagination-actions .mr-4 {
  margin-right: 4px;
}
.MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar .pagination-actions .text {
  font-family: "ABBVoice", Verdana;
  text-wrap: nowrap;
  margin-left: 8px;
}

.MuiRadioGroup-root .MuiFormControlLabel-root.MuiFormControlLabel-label.Mui-disabled {
  color: var(--text-primary-color);
}
.MuiRadioGroup-root .MuiFormControlLabel-root.Mui-disabled {
  opacity: 0.6;
  cursor: not-allowed;
  color: var(--text-primary-color);
}
.MuiRadioGroup-root .MuiButtonBase-root.MuiRadio-root {
  padding: 4px 8px;
}

.blank-radio {
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--grey-500);
  border-radius: 50%;
  background: transparent;
  z-index: 20;
  cursor: pointer;
}
.blank-radio:hover {
  border: 2px solid var(--grey-600);
  background-color: var(--grey-300);
}
.blank-radio.hover {
  border: 2px solid var(--grey-600);
  background-color: var(--grey-300);
}
.blank-radio.disabled {
  border: 2px solid var(--grey-400);
  background-color: var(--grey-300);
}
.blank-radio:active {
  border: 2px solid var(--grey-700);
  background-color: var(--grey-400);
}
.blank-radio:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.blank-radio.size-16 {
  width: 16px;
  height: 16px;
}
.blank-radio.size-24 {
  width: 24px;
  height: 24px;
}

.selected-container {
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--primary-default);
  border-radius: 50%;
  background: var(--primary-default);
  z-index: 20;
  cursor: pointer;
}
.selected-container .checked {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: var(--white);
}
.selected-container .size-8 {
  width: 8px;
  height: 8px;
}
.selected-container .size-6 {
  width: 6px;
  height: 6px;
}
.selected-container.size-16 {
  width: 16px;
  height: 16px;
}
.selected-container.size-24 {
  width: 24px;
  height: 24px;
}
.selected-container:hover {
  border: 2px solid var(--primary-hover);
  background-color: var(--primary-hover);
}
.selected-container.hover {
  border: 2px solid var(--primary-hover);
  background-color: var(--primary-hover);
}
.selected-container.disabled {
  border: 2px solid var(--primary-disabled);
  background: var(--primary-disabled);
}
.selected-container:active {
  border: 2px solid var(--primary-active);
  background-color: var(--primary-active);
}
.selected-container:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}

.radio-container {
  display: flex;
  flex-direction: row;
  align-items: start;
  cursor: pointer;
}
.radio-container.disabled {
  cursor: not-allowed;
}
.radio-container .MuiTypography-root {
  font-size: 0.875rem;
  font-family: "ABBVoice", Verdana;
  color: var(--text-primary-color);
  text-wrap: nowrap;
  cursor: pointer;
}
.radio-container .MuiTypography-root.MuiFormControlLabel-label.Mui-disabled {
  cursor: not-allowed;
  color: var(--grey-700);
}

.segmented-control {
  background: var(--white);
  border-radius: 12px;
  opacity: 1;
  display: flex;
  align-items: center;
  padding: 4px;
  gap: 4px;
  font-weight: 400;
  font-size: 0.875rem;
  box-sizing: border-box;
}
.segmented-control .control-item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  cursor: pointer;
}
.segmented-control.size-32 {
  height: 32px;
}
.segmented-control.size-32 .control-item {
  min-height: 24px;
  padding: 0 12px;
}
.segmented-control.size-32 .control-item.icon-only {
  padding: 0 6.25px;
}
.segmented-control.size-40 {
  height: 40px;
}
.segmented-control.size-40 .control-item {
  min-height: 32px;
  padding: 0 16px;
}
.segmented-control.size-40 .control-item.icon-only {
  padding: 0 10px;
}
.segmented-control.vertical {
  flex-direction: column;
  padding: 3px;
  height: 100%;
}
.segmented-control.vertical .control-item {
  padding: 0 8px;
  min-height: 18px;
}
.segmented-control.bg-primary {
  background-color: var(--white);
  border: 0.5px solid var(--grey-400);
  color: var(--text-primary-color);
}
.segmented-control.bg-primary .control-item:hover {
  background-color: var(--segmented-control-hover);
}
.segmented-control.bg-primary .control-item.selected {
  background-color: var(--primary-default);
  font-weight: 500;
  color: var(--white);
  cursor: default;
}
.segmented-control.bg-primary .control-item.selected.disabled {
  cursor: not-allowed;
  background: var(--primary-disabled);
  color: var(--white);
}
.segmented-control.bg-primary .control-item.disabled {
  color: var(--grey-600);
  background-color: var(--white);
  cursor: not-allowed;
}
.segmented-control.bg-white {
  background: var(--grey-400);
  border: 0.5px solid var(--grey-400);
  color: var(--text-primary-color);
}
.segmented-control.bg-white .control-item:hover {
  background-color: var(--segmented-control-hover);
}
.segmented-control.bg-white .control-item.selected {
  background-color: var(--white);
  color: var(--text-primary-color);
  font-weight: 500;
  cursor: default;
}
.segmented-control.bg-white .control-item.selected.disabled {
  cursor: not-allowed;
  background: var(--grey-200);
  color: var(--grey-600);
}
.segmented-control.bg-white .control-item.disabled {
  color: var(--grey-600);
  background: transparent;
  cursor: not-allowed;
}
.segmented-control.bg-light-blue {
  background-color: var(--white);
  border: 0.5px solid var(--grey-400);
  color: var(--text-primary-color);
}
.segmented-control.bg-light-blue .control-item:hover {
  background-color: var(--segmented-control-hover);
}
.segmented-control.bg-light-blue .control-item.selected {
  background-color: var(--accordion-expanded-bg);
  color: var(--text-primary-color);
  font-weight: 500;
  cursor: default;
}
.segmented-control.bg-light-blue .control-item.selected.disabled {
  cursor: not-allowed;
  background: var(--accordion-expanded-bg);
  color: var(--grey-600);
}
.segmented-control.bg-light-blue .control-item.disabled {
  color: var(--grey-600);
  background: var(--white);
  cursor: not-allowed;
}

.css-1jejjfu-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border: 1px solid var(--primary-default) !important;
}

.MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.MuiSelect-select {
  padding: 0;
}

.MuiFormControl-root.MuiTextField-root {
  width: 100%;
}

.MuiAutocomplete-inputRoot {
  padding-right: 0;
}

.mt-0 {
  margin-top: 0 !important;
}

.css-clttge-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
  padding: 0% 0px 0px 0px !important;
}

.MuiAutocomplete-root.MuiAutocomplete-tag {
  margin: 0;
}
.MuiAutocomplete-root.MuiOutlinedInput-root {
  padding: 0;
}

.MuiButtonBase-root.MuiMenuItem-root.Mui-selected {
  background-color: var(--accordion-expanded-bg) !important;
}
.MuiButtonBase-root.MuiMenuItem-root.Mui-disabled {
  background-color: var(--white);
  color: var(--grey-600);
  cursor: not-allowed;
  opacity: 1;
}
.MuiButtonBase-root.MuiMenuItem-root .option-name {
  line-height: 24px;
}

.MuiPaper-root.MuiPaper-elevation {
  margin-top: 4px;
  background-color: var(--white);
  box-shadow: 0 6px 12px var(--shadow-grey-200);
}
.MuiPaper-root.MuiPaper-elevation .input-wrapper.discreet {
  min-width: auto;
}

.end-adornment {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}
.end-adornment .tag-badge {
  display: flex;
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background-color: var(--grey-500);
  margin-left: 6px;
}
.end-adornment .mr-4 {
  margin-right: 4px;
}
.end-adornment .icon-close {
  border-right: 1px solid var(--grey-500);
  padding-left: 4px;
}
.end-adornment .icon-close.tag {
  padding-left: 0;
}

.prefix {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-right: solid 1px var(--grey-500);
  padding-right: 8px;
  font-size: 0.875rem;
  color: var(--grey-700);
  margin-right: 8px;
}

.m-4 {
  margin: 4px 0px;
}

.select-menu-header {
  font-weight: 400;
  font-size: 1rem;
  color: var(--text-primary-color);
  padding: 8px;
}

.slider-container.MuiBox-root {
  width: 100%;
}
.slider-container.MuiBox-root .slider-title {
  font-size: 0.875rem;
  font-weight: 500;
  font-family: "ABBVoice", Verdana;
  color: var(--text-primary-color);
}
.slider-container.MuiBox-root .slider-description {
  font-size: 0.875rem;
  line-height: 1.3125rem;
  font-family: "ABBVoice", Verdana;
  color: var(--text-primary-color);
}
.slider-container.MuiBox-root .slider-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  width: 100%;
}
.slider-container.MuiBox-root .disabled {
  background-color: var(--grey-200);
  cursor: not-allowed;
  pointer-events: none;
}
.slider-container.MuiBox-root .disabled .prefix, .slider-container.MuiBox-root .disabled .end-adornment, .slider-container.MuiBox-root .disabled .suffix {
  color: var(--grey-500);
}
.slider-container.MuiBox-root .disabled .disabled {
  opacity: 0.6;
}
.slider-container.MuiBox-root .small-variant-action {
  display: flex;
  flex-direction: column;
  background-color: var(--grey-200);
  border-left: 1px solid var(--grey-400);
}
.slider-container.MuiBox-root .small-variant-action .square-icon:hover {
  background-color: var(--grey-200);
}
.slider-container.MuiBox-root .small-variant-action .square-icon:active {
  background-color: var(--grey-300);
}
.slider-container.MuiBox-root .small-variant-action .border-top {
  border-top: 1px solid var(--grey-400);
  border-radius: 0;
}
.slider-container.MuiBox-root .small-variant-action .p-4 {
  padding: 4px;
}
.slider-container.MuiBox-root .MuiSlider-root {
  color: var(--primary-default);
  padding: 12px 0;
}
.slider-container.MuiBox-root .MuiSlider-root .MuiSlider-rail {
  background-color: var(--grey-400);
  opacity: 1;
  width: 100%;
  height: 4px;
}
.slider-container.MuiBox-root .MuiSlider-root .MuiSlider-mark {
  background: var(--grey-400);
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.slider-container.MuiBox-root .MuiSlider-root .MuiSlider-mark.MuiSlider-markActive {
  background: var(--primary-default);
}
.slider-container.MuiBox-root .MuiSlider-root.MuiSlider-trackInverted .MuiSlider-rail {
  background-color: var(--primary-default);
  opacity: 1;
}
.slider-container.MuiBox-root .MuiSlider-root.MuiSlider-trackInverted .MuiSlider-track {
  background-color: var(--grey-400);
  opacity: 1;
  border-color: var(--grey-400);
}
.slider-container.MuiBox-root .MuiSlider-root.Mui-disabled {
  color: var(--grey-600);
}
.slider-container.MuiBox-root .MuiSlider-root.Mui-disabled .MuiSlider-markActive {
  background: var(--grey-600);
}
.slider-container.MuiBox-root .MuiSlider-root.Mui-disabled .MuiSlider-thumb {
  background-color: var(--white);
  border: 2px solid var(--grey-600);
}
.slider-container.MuiBox-root .MuiSlider-root .MuiSlider-thumb {
  width: 1rem;
  height: 1rem;
  background-color: var(--white);
  border: 2px solid var(--primary-default);
}
.slider-container.MuiBox-root .MuiSlider-root .MuiSlider-thumb.Mui-focusVisible {
  background-color: var(--primary-default);
  border: 2px solid var(--primary-default);
}
.slider-container.MuiBox-root .MuiSlider-root .MuiSlider-thumb.Mui-active {
  background-color: var(--primary-default);
  border: 2px solid var(--primary-default);
}
.slider-container.MuiBox-root .MuiSlider-root .MuiSlider-markLabel {
  font-size: 0.875rem;
  font-weight: 400;
  font-family: "ABBVoice", Verdana;
  color: var(--text-primary-color);
}
.slider-container.MuiBox-root .MuiSlider-root .MuiSlider-valueLabelOpen {
  border: solid 1px var(--text-primary-color);
  font-family: "ABBVoice", Verdana;
  color: var(--white);
  padding: 3px 8px;
  background-color: var(--text-primary-color);
  border-radius: 8px;
  line-height: 1.15;
}
.slider-container.MuiBox-root .MuiSlider-root .MuiSlider-valueLabelOpen::before {
  width: 0;
  height: 0;
}
.slider-container.MuiBox-root .read-only {
  color: var(--text-primary-color);
}
.slider-container.MuiBox-root .read-only .MuiSlider-root .MuiSlider-thumb {
  display: none;
}

.switch-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.switch-container .indeterminate {
  background-color: var(--primary-default);
  color: var(--white);
  border-radius: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
}
.switch-container .indeterminate.size-16 {
  width: 28px;
  padding: 0;
  height: 16px;
}
.switch-container .indeterminate.size-24 {
  width: 42px;
  padding: 0;
  height: 24px;
}
.switch-container .indeterminate.size-24 .icon-minus {
  font-size: 1.5rem;
}
.switch-container .indeterminate.size-32 {
  width: 56px;
  padding: 0;
  height: 32px;
}
.switch-container .indeterminate.size-32 .icon-minus {
  font-size: 2rem;
}
.switch-container .indeterminate:hover {
  background-color: var(--primary-hover);
}
.switch-container .indeterminate.disabled {
  background-color: var(--primary-disabled);
  cursor: not-allowed;
}
.switch-container .MuiSwitch-root:hover .MuiSwitch-track {
  background-color: var(--grey-800);
}
.switch-container.switch-container-hovered .MuiSwitch-root .MuiSwitch-track {
  background-color: var(--grey-800);
}
.switch-container.switch-container-hovered .MuiSwitch-root .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
  background-color: var(--primary-hover);
}
.switch-container.switch-container-hovered .indeterminate {
  background-color: var(--primary-hover);
}
.switch-container.toggle .MuiSwitch-root .MuiSwitch-track {
  background-color: var(--primary-default);
}
.switch-container.toggle .MuiSwitch-root .Mui-disabled {
  color: var(--white);
  opacity: 1;
}
.switch-container.toggle .MuiSwitch-root .Mui-disabled + .MuiSwitch-track {
  background-color: var(--primary-disabled);
  opacity: 1;
}
.switch-container.toggle.switch-container-hovered .MuiSwitch-root .MuiSwitch-track {
  background-color: var(--primary-hover);
}
.switch-container .MuiSwitch-switchBase {
  color: var(--white);
}
.switch-container .MuiSwitch-switchBase + .MuiSwitch-track {
  opacity: 1;
  background-color: var(--grey-600);
}
.switch-container .MuiSwitch-switchBase + .MuiSwitch-track:hover {
  background-color: var(--grey-800);
}
.switch-container .MuiSwitch-switchBase .MuiSwitch-thumb {
  display: flex;
  justify-content: center;
  align-items: center;
}
.switch-container .MuiSwitch-switchBase .MuiSwitch-thumb::before {
  color: var(--text-primary-color);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -2px;
}
.switch-container .MuiSwitch-switchBase.Mui-disabled {
  color: var(--white);
  box-shadow: none !important;
  cursor: not-allowed;
}
.switch-container .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track {
  background-color: var(--grey-400);
  opacity: 1;
  cursor: not-allowed;
}
.switch-container .MuiSwitch-switchBase.Mui-disabled .MuiSwitch-thumb::before {
  color: var(--grey-500);
  cursor: not-allowed;
}
.switch-container .MuiSwitch-switchBase.Mui-checked {
  color: var(--white);
}
.switch-container .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
  opacity: 1;
  background-color: var(--primary-default);
}
.switch-container .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track:hover {
  background-color: var(--primary-hover);
}
.switch-container .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb {
  display: flex;
  justify-content: center;
  align-items: center;
}
.switch-container .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb::before {
  color: var(--primary-default);
  display: flex;
  justify-content: center;
  align-items: center;
}
.switch-container .MuiSwitch-switchBase.Mui-checked.Mui-disabled {
  color: var(--white);
  opacity: 1;
  cursor: not-allowed;
}
.switch-container .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track {
  background-color: var(--primary-disabled);
  opacity: 1;
  cursor: not-allowed;
}
.switch-container .size-24 {
  width: 42px;
  padding: 0;
  height: 24px;
  border-radius: 20px;
}
.switch-container .size-24 .MuiButtonBase-root.MuiSwitch-switchBase {
  padding: 3px 6%;
}
.switch-container .size-24 .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked {
  padding: 3px 4%;
}
.switch-container .size-24 .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb::before {
  font-size: 16px;
  margin-left: 0;
  margin-top: 1px;
}
.switch-container .size-24 .MuiSwitch-thumb {
  width: 18px;
  height: 18px;
}
.switch-container .size-24 .MuiSwitch-thumb::before {
  font-size: 16px;
  margin-left: -2px;
  margin-top: 0;
}
.switch-container .size-16 {
  width: 28px;
  padding: 0;
  height: 16px;
  border-radius: 20px;
}
.switch-container .size-16 .MuiButtonBase-root.MuiSwitch-switchBase {
  padding: 6% 9%;
}
.switch-container .size-16 .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked {
  left: -8px;
}
.switch-container .size-16 .MuiSwitch-thumb {
  width: 12px;
  height: 12px;
}
.switch-container .size-16 .MuiSwitch-thumb::before {
  font-size: 12px;
  margin-left: 0;
  margin-top: 0;
}
.switch-container .size-32 {
  width: 56px;
  padding: 0;
  height: 32px;
  border-radius: 20px;
}
.switch-container .size-32 .MuiButtonBase-root.MuiSwitch-switchBase {
  padding: 7%;
}
.switch-container .size-32 .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked {
  padding: 3px 8px;
}
.switch-container .size-32 .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb::before {
  font-size: 18px;
  margin-left: 0;
  margin-top: 1px;
}
.switch-container .size-32 .MuiSwitch-thumb {
  width: 24px;
  height: 24px;
}
.switch-container .size-32 .MuiSwitch-thumb::before {
  font-size: 18px;
}
.switch-container .label {
  color: var(--text-primary-color);
  display: flex;
  align-items: center;
  font-weight: 400;
  text-wrap: nowrap;
  cursor: pointer;
}
.switch-container .label.size-16 {
  font-size: 0.875rem;
}
.switch-container .label.size-24 {
  font-size: 1rem;
}
.switch-container .label.size-32 {
  font-size: 1rem;
}
.switch-container .label.disabled {
  cursor: not-allowed;
  color: var(--grey-800);
}

.MuiTabs-root {
  border-bottom: 1px solid var(--grey-500);
  min-height: auto !important;
}
.MuiTabs-root.border {
  border-bottom: none;
}
.MuiTabs-root .MuiButtonBase-root.MuiTab-root {
  color: var(--text-primary-color);
  box-sizing: border-box;
  font-family: "ABBVoice", Verdana;
  letter-spacing: normal;
  text-transform: capitalize;
  font-size: 0.875rem;
  font-weight: 400;
  height: 32px;
  cursor: pointer;
  align-items: end;
  padding: 8px 24px 7px;
  min-height: auto;
  min-width: auto;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  gap: 32px;
}
.MuiTabs-root .MuiButtonBase-root.MuiTab-root:hover {
  background: var(--grey-400);
  border-radius: 4px;
}
.MuiTabs-root .MuiButtonBase-root.MuiTab-root:focus-visible {
  background-color: transparent;
  border-radius: 4px;
  border: 2px solid var(--primary-active);
}
.MuiTabs-root .MuiButtonBase-root.MuiTab-root.Mui-disabled {
  cursor: not-allowed;
  background: transparent;
  pointer-events: inherit;
  color: var(--grey-600);
}
.MuiTabs-root .MuiButtonBase-root.MuiTab-root.Mui-selected {
  font-weight: 700;
  background-color: transparent;
}
.MuiTabs-root .MuiButtonBase-root.MuiTab-root .MuiTab-iconWrapper {
  margin-left: 32px;
  margin-bottom: 3px;
}
.MuiTabs-root .MuiButtonBase-root.MuiTab-root .label-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 8px;
}
.MuiTabs-root .MuiButtonBase-root.MuiTab-root .label-container .icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
.MuiTabs-root .MuiTabs-indicator {
  height: 4px;
  background-color: var(--primary-default);
}

.MuiInputBase-root.MuiOutlinedInput-root {
  background-color: var(--white);
  padding-right: 8px;
  padding-left: 8px;
  color: var(--text-primary-color);
  font-size: 0.875rem;
  font-family: "ABBVoice", Verdana !important;
}
.MuiInputBase-root.MuiOutlinedInput-root.placeholder-text {
  color: var(--grey-800) !important;
}
.MuiInputBase-root.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: var(--text-primary-color);
}
.MuiInputBase-root.MuiOutlinedInput-root:focus-visible {
  outline-offset: 1px;
  outline: 2px solid var(--primary-active);
}
.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-multiline {
  padding: 8px;
}
.MuiInputBase-root.MuiOutlinedInput-root.Mui-focused {
  caret-color: var(--primary-default);
}
.MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled:hover {
  border-color: var(--grey-400);
}
.MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
  background-color: var(--grey-200) !important;
  border-color: var(--grey-400);
  cursor: not-allowed;
}
.MuiInputBase-root.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  border-color: var(--grey-400);
}
.MuiInputBase-root.MuiOutlinedInput-root.Mui-focused {
  caret-color: var(--primary-default);
}
.MuiInputBase-root.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border: 1px solid var(--primary-default);
}
.MuiInputBase-root.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
  border-color: var(--status-error) !important;
}
.MuiInputBase-root.MuiOutlinedInput-root.Mui-error:hover {
  border-color: var(--status-error) !important;
}
.MuiInputBase-root .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled {
  border-radius: 4px;
  color: var(--grey-600) !important;
  opacity: 0.8;
  cursor: not-allowed;
}

.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: var(--text-primary-color) !important;
}

.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border: 1px solid var(--primary-default) !important;
  caret-color: var(--primary-default);
}

.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
  border: 1px solid var(--grey-500) !important;
}

.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
  border-color: var(--status-error) !important;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  font-family: "ABBVoice", Verdana !important;
  gap: 4px;
  width: 100%;
}
.input-wrapper.row {
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.input-wrapper .icon {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.input-wrapper .pr-8 {
  padding-right: 8px;
}
.input-wrapper .divider {
  border-left: 1px solid var(--grey-500);
}
.input-wrapper .end-icon {
  padding-right: 6px;
  padding-left: 6px;
}
.input-wrapper .star {
  color: var(--status-error);
}
.input-wrapper .disabled {
  background-color: var(--grey-200);
  cursor: not-allowed;
  pointer-events: none;
}
.input-wrapper .disabled .disabled {
  opacity: 0.6;
}
.input-wrapper.read-only .MuiInputBase-root.MuiInput-root {
  font-size: 0.875rem;
  font-family: "ABBVoice", Verdana !important;
  color: var(--text-primary-color);
}
.input-wrapper.read-only .MuiInputBase-root.MuiInput-root.MuiInput-underline::before {
  border-bottom: none;
}
.input-wrapper.read-only .MuiInputBase-root.MuiInput-root.MuiInput-underline:hover::before {
  border-bottom: none;
}
.input-wrapper.read-only .MuiInputBase-root.MuiInput-root.MuiInput-underline::after {
  border-bottom: none;
}
.input-wrapper.read-only .MuiFormControl-root.MuiTextField-root {
  min-width: 250px;
}
.input-wrapper.read-only .MuiFormControl-root.MuiTextField-root .css-1eed5fa-MuiInputBase-root-MuiInput-root::before {
  border-bottom: none;
}
.input-wrapper.read-only .MuiFormControl-root.MuiTextField-root .css-1eed5fa-MuiInputBase-root-MuiInput-root::after {
  border-bottom: none;
}
.input-wrapper.read-only .MuiFormControl-root.MuiTextField-root .css-1x51dt5-MuiInputBase-input-MuiInput-input {
  color: var(--text-primary-color);
  font-family: "ABBVoice", Verdana !important;
}
.input-wrapper.discreet-edit {
  caret-color: var(--primary-default);
}
.input-wrapper.discreet-edit .MuiInputBase-root.MuiInput-root {
  padding: 0 12px;
  color: var(--text-primary-color);
  font-size: 0.875rem;
  font-family: "ABBVoice", Verdana !important;
}
.input-wrapper.discreet-edit .MuiInputBase-root.MuiInput-root.MuiInput-underline::before {
  border-bottom: 1px solid var(--grey-400);
}
.input-wrapper.discreet-edit .MuiInputBase-root.MuiInput-root.MuiInput-underline:hover::before {
  border-bottom: 1px solid var(--text-primary-color);
}
.input-wrapper.discreet-edit .MuiInputBase-root.MuiInput-root.MuiInput-underline::after {
  border-bottom: 1px solid var(--primary-default);
}
.input-wrapper.discreet-edit .css-1x51dt5-MuiInputBase-input-MuiInput-input {
  color: var(--text-primary-color);
  min-width: 50px;
  font-family: "ABBVoice", Verdana !important;
}
.input-wrapper.discreet-edit .css-1eed5fa-MuiInputBase-root-MuiInput-root::before {
  border-bottom: solid 1px var(--grey-500);
}
.input-wrapper.discreet-edit .css-1eed5fa-MuiInputBase-root-MuiInput-root:hover::before {
  border-bottom: solid 1px var(--text-primary-color);
}
.input-wrapper.discreet-edit .css-1eed5fa-MuiInputBase-root-MuiInput-root::after {
  border-bottom: 1px solid var(--primary-default);
}
.input-wrapper.discreet {
  caret-color: var(--primary-default);
}
.input-wrapper.discreet .MuiInputBase-root.MuiInput-root {
  color: var(--text-primary-color);
  font-size: 0.875rem;
  font-family: "ABBVoice", Verdana !important;
}
.input-wrapper.discreet .MuiInputBase-root.MuiInput-root.MuiInput-underline::before {
  border-bottom: 1px solid var(--grey-400);
}
.input-wrapper.discreet .MuiInputBase-root.MuiInput-root.MuiInput-underline:hover::before {
  border-bottom: 1px solid var(--text-primary-color);
}
.input-wrapper.discreet .MuiInputBase-root.MuiInput-root.MuiInput-underline::after {
  border-bottom: 1px solid var(--primary-default);
}
.input-wrapper.discreet .css-1x51dt5-MuiInputBase-input-MuiInput-input {
  color: var(--text-primary-color);
  font-family: "ABBVoice", Verdana !important;
}
.input-wrapper.discreet .css-1eed5fa-MuiInputBase-root-MuiInput-root::before {
  border-bottom: solid 1px var(--grey-500);
}
.input-wrapper.discreet .css-1eed5fa-MuiInputBase-root-MuiInput-root:hover::before {
  border-bottom: solid 1px var(--text-primary-color);
}
.input-wrapper.discreet .css-1eed5fa-MuiInputBase-root-MuiInput-root::after {
  border-bottom: 1px solid var(--primary-default);
}
.input-wrapper.default-with-prefix-and-suffix .MuiInputBase-root.MuiOutlinedInput-root {
  padding-left: 8px;
  padding-right: 8px;
}
.input-wrapper.default-with-prefix-and-suffix .MuiInputBase-root.MuiOutlinedInput-root .prefix {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-right: solid 1px var(--grey-500);
  padding-right: 8px;
  font-size: 0.875rem;
  color: var(--grey-700);
}
.input-wrapper.default-with-prefix-and-suffix .MuiInputBase-root.MuiOutlinedInput-root .gap-0 {
  gap: 0 !important;
}
.input-wrapper.default-with-prefix-and-suffix .MuiInputBase-root.MuiOutlinedInput-root .end-adornment {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
}
.input-wrapper.default-with-prefix-and-suffix .MuiInputBase-root.MuiOutlinedInput-root .suffix {
  border-left: solid 1px var(--grey-500);
  padding-left: 8px;
  font-size: 0.875rem;
  color: var(--grey-700);
}
.input-wrapper.default-with-prefix-and-suffix .MuiInputBase-root.MuiOutlinedInput-root .icon {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 1rem;
}
.input-wrapper.default-with-prefix-and-suffix .css-2ehmn7-MuiInputBase-root-MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: var(--text-primary-color) !important;
}
.input-wrapper.default-with-prefix-and-suffix .css-2ehmn7-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border: 1px solid var(--primary-default) !important;
}
.input-wrapper.default-with-prefix-and-suffix .css-2ehmn7-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
  border: 1px solid var(--grey-500) !important;
}
.input-wrapper.default-with-prefix-and-suffix .css-2ehmn7-MuiInputBase-root-MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
  border: 1px solid var(--status-error) !important;
}
.input-wrapper .input-label {
  font-weight: 500;
  font-size: 0.875rem;
  color: var(--text-primary-color);
}
.input-wrapper .input-label.disabled {
  opacity: 0.6;
  background: transparent;
}
.input-wrapper .input-description {
  font-size: 0.75rem;
  line-height: 0.875rem;
  color: var(--grey-800);
  font-weight: 400;
  margin-top: 4px;
}
.input-wrapper .input-description.mt-0 {
  margin-top: 0;
}
.input-wrapper .input-description.disabled {
  opacity: 0.6;
}
.input-wrapper .gap-0 {
  gap: 6px;
}
.input-wrapper .textfield-container {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
}
.input-wrapper .textfield-container .wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.input-wrapper .textfield-container .discreet-edit-icons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: var(--text-primary-color);
}
.input-wrapper .textfield-container .discreet-edit-icons .icon.disabled {
  color: var(--grey-500);
}
.input-wrapper .msg-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 0.75rem;
}
.input-wrapper .msg-container .mt-4 {
  margin-top: 4px;
}
.input-wrapper .msg-container .success {
  color: var(--status-success);
}
.input-wrapper .msg-container .error {
  color: var(--status-error);
}
.input-wrapper .msg-container .error-text {
  color: var(--status-error);
  font-size: 0.75rem;
  margin-top: 4px;
}
.input-wrapper.disabled .MuiAutocomplete-root {
  pointer-events: none;
}
.input-wrapper.disabled .MuiAutocomplete-root .MuiOutlinedInput-notchedOutline {
  border: 1px solid var(--grey-500) !important;
}

.input-styles {
  color: var(--text-primary-color) !important;
}

.placeholder-style {
  color: var(--grey-800) !important;
}

input[type=text] {
  padding-block: 0;
  padding-inline: 0;
}

input::placeholder {
  color: var(--grey-800) !important;
  opacity: 1 !important;
}

textarea::placeholder {
  color: var(--grey-800) !important;
  opacity: 1 !important;
}
textarea::-webkit-input-placeholder {
  color: var(--grey-800) !important;
  opacity: 1 !important;
}

.css-dpjnhs-MuiInputBase-root-MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
  border-color: var(--status-error) !important;
}

.suffix {
  border-left: solid 1px var(--grey-500);
  padding-left: 8px;
  font-size: 0.875rem;
  color: var(--grey-700);
}

.time-container {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  gap: 16px;
  margin: 60px 24px 24px 8px;
}
.time-container .segmented-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.time-container.m-0 {
  margin: 0;
  padding-left: 24px;
  padding-right: 0;
  padding-bottom: 16px;
  gap: 8px;
}
.time-container.pb-24 {
  padding-bottom: 24px;
}
.time-container.range-picker {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 8px;
  gap: 8px;
}
.time-container .time-part {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 24px 24px 24px 16px;
  background-color: var(--grey-200);
  border-radius: 6px;
}
.time-container .time-part.custom-picker {
  padding: 12px 8px 12px 0px;
  min-height: 46px;
  min-width: 245px;
  display: flex;
  justify-content: center;
}
.time-container .time-part .colon {
  color: var(--text-primary-color);
  font-size: 1rem;
  font-weight: 500;
}
.time-container.big-container .time-part {
  padding: 52px 24px 52px 16px;
}
.time-container .time-picker-button-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  justify-content: end;
  width: 100%;
}

.title-container {
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  place-content: flex-start;
  align-items: flex-start;
}
.title-container .top-red-line {
  height: 1rem;
}
.title-container .top-red-line::before {
  content: "—";
  font-size: 2rem;
  color: var(--status-error);
  display: block;
  font-weight: 700;
  line-height: 0;
}
.title-container .title {
  font-family: "ABBVoice", Verdana;
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary-color);
}
.title-container .secondary-text {
  font-family: "ABBVoice", Verdana;
  font-size: 2rem;
  font-weight: 200;
  color: var(--text-primary-color);
}

.title-info-container {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: flex-start;
  align-items: end;
}
.title-info-container .separator-line {
  height: 32px;
  border-left: 1px solid var(--grey-500);
  margin: 0 16px;
}
.title-info-container .title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary-color);
}
.title-info-container .ml-8 {
  margin-left: 12px;
}
.title-info-container .mr-8 {
  margin-right: 12px;
}
.title-info-container .secondary-text {
  font-size: 2rem;
  font-weight: 200;
  color: var(--text-primary-color);
}
.title-info-container .info {
  font-size: 1rem;
  color: var(--primary-default);
  margin-right: 4px;
}
.title-info-container .mt-20 {
  margin-top: 24px;
}
.title-info-container .info-text {
  font-size: 0.875rem;
  color: var(--primary-default);
}

.MuiToggleButtonGroup-root {
  font-family: "ABBVoice", Verdana;
}
.MuiToggleButtonGroup-root .MuiToggleButtonGroup-grouped {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 4px;
  color: var(--text-primary-color);
  text-transform: capitalize;
  border: 0.5px solid var(--grey-400);
  background-color: var(--toolbar-bg);
}
.MuiToggleButtonGroup-root .MuiToggleButtonGroup-grouped .toolbar-label {
  font-family: "ABBVoice", Verdana;
  font-size: 0.875rem;
  font-weight: 400;
}
.MuiToggleButtonGroup-root .MuiToggleButtonGroup-grouped .size {
  font-size: 1rem;
}
.MuiToggleButtonGroup-root .MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-middleButton {
  border-left: 0.5px solid var(--grey-400);
}
.MuiToggleButtonGroup-root .MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-lastButton {
  border-left: 0.5px solid var(--grey-400);
}
.MuiToggleButtonGroup-root .MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-lastButton.Mui-disabled {
  border-left: 0.5px solid var(--grey-400);
}
.MuiToggleButtonGroup-root .MuiToggleButtonGroup-grouped:hover {
  background-color: var(--grey-300);
}
.MuiToggleButtonGroup-root .MuiToggleButtonGroup-grouped.Mui-selected {
  color: var(--primary-default);
  background: var(--white);
}
.MuiToggleButtonGroup-root .MuiToggleButtonGroup-grouped.Mui-selected:hover {
  background-color: var(--grey-300);
}
.MuiToggleButtonGroup-root .MuiToggleButtonGroup-grouped.Mui-disabled {
  background-color: var(--grey-200);
  color: var(--grey-600);
  border-left: 1px solid var(--grey-400) !important;
  cursor: not-allowed;
}
.MuiToggleButtonGroup-root.discreet .MuiToggleButtonGroup-grouped {
  border: none;
  background-color: transparent;
  border-radius: 8px;
  margin: 0 2px;
}
.MuiToggleButtonGroup-root.discreet .MuiToggleButtonGroup-grouped:hover {
  background-color: var(--grey-300);
}
.MuiToggleButtonGroup-root.discreet .MuiToggleButtonGroup-grouped.Mui-selected {
  color: var(--primary-default);
  background: var(--grey-300);
}
.MuiToggleButtonGroup-root.discreet .MuiToggleButtonGroup-grouped.Mui-selected:hover {
  background-color: var(--grey-300);
}

.MuiTooltip-popper .MuiTooltip-tooltip {
  font-family: "ABBVoice", Verdana;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border-radius: 6px;
  font-weight: 400;
  padding: 8px;
}
.MuiTooltip-popper .MuiTooltip-tooltip.theme-light {
  background: var(--white);
  border: solid 0.5px var(--grey-400);
  color: var(--text-primary-color);
}
.MuiTooltip-popper .MuiTooltip-tooltip.theme-light.popover {
  border: none;
  padding: 16px;
  box-shadow: 0 6px 12px var(--shadow-grey-200);
}
.MuiTooltip-popper .MuiTooltip-tooltip.theme-light .MuiTooltip-arrow::before {
  color: var(--white);
}
.MuiTooltip-popper .MuiTooltip-tooltip.theme-dark {
  background: var(--grey-900);
  color: var(--white);
}
.MuiTooltip-popper .MuiTooltip-tooltip.theme-dark.popover {
  border: none;
  padding: 16px;
  box-shadow: 0 6px 12px var(--shadow-grey-200);
}
.MuiTooltip-popper .MuiTooltip-tooltip.theme-dark .MuiTooltip-arrow {
  color: var(--grey-900);
}
.MuiTooltip-popper .MuiTooltip-tooltipPlacementTop {
  margin-bottom: 8px !important;
}
.MuiTooltip-popper .MuiTooltip-tooltipPlacementBottom {
  margin-top: 8px !important;
}
.MuiTooltip-popper .MuiTooltip-tooltipPlacementRight {
  margin-left: 8px !important;
}
.MuiTooltip-popper .MuiTooltip-tooltipPlacementLeft {
  margin-right: 8px !important;
}

.MuiRichTreeView-root {
  min-width: 300px;
  width: 100%;
}
.MuiRichTreeView-root .MuiTreeItem-label {
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--text-primary-color);
  font-family: "ABBVoice", Verdana;
}
.MuiRichTreeView-root .MuiCollapse-vertical.MuiTreeItem-groupTransition {
  padding-left: 0;
}
.MuiRichTreeView-root .MuiTreeItem-root.size-24 .MuiTreeItem-content {
  padding: 4px 8px;
  min-height: 24px;
}
.MuiRichTreeView-root .MuiTreeItem-root.size-32 .MuiTreeItem-content {
  padding: 8px 16px;
  min-height: 32px;
}
.MuiRichTreeView-root .MuiTreeItem-root.size-40 .MuiTreeItem-content {
  padding: 12px 20px;
  min-height: 40px;
}
.MuiRichTreeView-root .MuiTreeItem-root.divider .MuiTreeItem-content {
  border-bottom: 1px solid var(--grey-400);
}
.MuiRichTreeView-root .MuiTreeItem-root .MuiTreeItem-content {
  border-radius: 0;
  border-left: 4px solid transparent;
}
.MuiRichTreeView-root .MuiTreeItem-root .MuiTreeItem-content:hover {
  background-color: var(--grey-300);
}
.MuiRichTreeView-root .MuiTreeItem-root .MuiTreeItem-content:active {
  background-color: var(--grey-400);
}
.MuiRichTreeView-root .MuiTreeItem-root .MuiTreeItem-content.Mui-focused {
  outline: 1px solid var(--primary-active);
  background-color: var(--white);
}
.MuiRichTreeView-root .MuiTreeItem-root .MuiTreeItem-content.Mui-selected {
  outline: none;
  background-color: var(--accordion-expanded-bg);
  border-left: 4px solid var(--primary-default);
  color: var(--text-primary-color);
}
.MuiRichTreeView-root .MuiTreeItem-root .MuiTreeItem-content.Mui-disabled {
  cursor: not-allowed;
  background-color: var(--white);
  opacity: 0.5;
  pointer-events: none;
}
.MuiRichTreeView-root .MuiTreeItem-root .MuiTreeItem-content .MuiTreeItem-iconContainer {
  color: var(--text-primary-color);
}
.MuiRichTreeView-root .MuiTreeItem-root .MuiTreeItem-content .tree-content-container {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.MuiRichTreeView-root .MuiTreeItem-root .MuiTreeItem-content .tree-content-container .checkbox-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.MuiRichTreeView-root .MuiTreeItem-root .MuiTreeItem-content .tree-content-container .tree-icon {
  font-size: 1rem;
}

.tree-heading {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  color: var(--text-primary-color);
  font-weight: 500;
}

.wizard-content {
  border-radius: 4px;
  background: var(--white);
  min-height: 42vh;
  padding: 20px 32px;
  margin-top: 20px;
  min-width: 48vw;
}
.wizard-content.w-54 {
  min-width: 40vw;
  min-height: 56vh;
}

.stepper-grey-bg {
  background: var(--grey-400);
  color: var(--text-primary-color);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stepper-grey-bg:hover {
  background: var(--grey-500);
}
.stepper-grey-bg .size {
  font-size: 1.5rem;
  cursor: pointer;
}

.menu-vertical-line {
  border-left: 1px solid var(--grey-500);
  height: 48px;
  width: 7%;
  margin-left: 36px;
}

.MuiStepper-root.vertical {
  margin-right: 24px;
}
.MuiStepper-root .MuiStep-root {
  padding: 0;
}
.MuiStepper-root .MuiStep-root:not(:has(.row)) {
  padding: 16px 24px;
}
.MuiStepper-root .MuiStep-root:not(.no-hover):not(:has(.Mui-disabled)):hover {
  background-color: var(--grey-400);
  border-radius: 4px;
}
.MuiStepper-root .MuiStep-root .Mui-disabled {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.7;
}
.MuiStepper-root .MuiStep-root .row {
  padding: 16px;
}
.MuiStepper-root .MuiStep-root .vertical {
  padding: 0px 16px;
}
.MuiStepper-root .MuiStep-root .sub-step-container {
  padding: 0;
}
.MuiStepper-root .sub-step-container {
  padding: 0;
}
.MuiStepper-root .sub-step-container .sub-step-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0;
  margin-left: 29px;
}
.MuiStepper-root .sub-step-container .sub-step-title .MuiStepLabel-labelContainer .MuiStepLabel-label {
  font-weight: 400;
  font-size: 0.875rem;
  color: var(--text-primary-color);
}
.MuiStepper-root .sub-step-container .sub-step-title.active .MuiStepLabel-labelContainer .MuiStepLabel-label {
  font-weight: 500;
  font-size: 1rem;
}
.MuiStepper-root .sub-step-container .sub-step-title .default-sub-icon {
  border: 2px solid var(--grey-500);
  border-radius: 50%;
  width: 0.8rem;
  height: 0.8rem;
  background-color: var(--white);
}
.MuiStepper-root .MuiStepLabel-root {
  display: flex;
  flex-direction: column;
}
.MuiStepper-root .MuiStepLabel-root.hide-label .MuiStepLabel-labelContainer {
  display: none;
}
.MuiStepper-root .MuiStepLabel-root.hide-label.ml-2 {
  margin-left: -2px;
}
.MuiStepper-root .MuiStepLabel-root.row {
  flex-direction: row;
  align-items: center;
  gap: 8px;
  justify-content: start;
  min-height: 56px;
}
.MuiStepper-root .MuiStepLabel-root.row .MuiStepLabel-iconContainer .MuiStepIcon-root {
  margin-bottom: 0;
}
.MuiStepper-root .MuiStepLabel-root.row .MuiStepLabel-iconContainer .completion-icon {
  margin-bottom: 0;
}
.MuiStepper-root .MuiStepLabel-root.hover:hover {
  background-color: var(--grey-400);
  border-radius: 4px;
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-iconContainer {
  padding-right: 0;
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-iconContainer .completion-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border: 3px solid var(--status-success);
  border-radius: 50%;
  margin-bottom: 8px;
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-iconContainer .completion-icon .success {
  color: var(--status-success);
  font-size: 2rem;
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-iconContainer .completion-icon.small {
  border: 1px solid var(--status-success);
  border-radius: 50%;
  width: 14px;
  height: 14px;
  background-color: var(--white);
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-iconContainer .completion-icon.small .success {
  font-size: 0.75rem;
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-iconContainer .MuiStepIcon-root {
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  margin-bottom: 8px;
  color: var(--white);
  font-family: "ABBVoice", Verdana;
  border: 2px solid var(--grey-500);
  border-radius: 50%;
  cursor: pointer;
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-iconContainer .MuiStepIcon-root:hover {
  border: 2px solid var(--primary-default);
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-iconContainer .MuiStepIcon-root .MuiStepIcon-text {
  fill: var(--text-primary-color);
  font-weight: 600;
  font-family: "ABBVoice", Verdana;
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-iconContainer .MuiStepIcon-root.Mui-active {
  color: var(--primary-default);
  border: none;
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-iconContainer .MuiStepIcon-root.Mui-active:hover {
  color: var(--primary-hover);
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-iconContainer .MuiStepIcon-root.Mui-active .MuiStepIcon-text {
  font-family: "ABBVoice", Verdana;
  fill: var(--white);
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-iconContainer .MuiStepIcon-root.Mui-completed {
  border: 2px solid var(--status-success);
  color: var(--white);
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-label {
  font-weight: 700;
  font-size: 1rem;
  text-wrap: nowrap;
  font-family: "ABBVoice", Verdana;
  color: var(--grey-700);
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-label.Mui-active {
  color: var(--text-primary-color);
}
.MuiStepper-root .MuiStepLabel-root .MuiStepLabel-label.Mui-completed {
  color: var(--text-primary-color);
}
.MuiStepper-root .MuiStepLabel-root .step-description {
  font-size: 0.75rem;
  color: var(--grey-800);
  font-weight: 400;
  line-height: 1rem !important;
  padding-top: 4px;
  white-space: initial;
  font-family: "ABBVoice", Verdana;
}
.MuiStepper-root .MuiStepConnector-line {
  border-color: var(--grey-500);
  margin-bottom: 28px;
}
.MuiStepper-root.row .MuiStepConnector-line {
  margin-bottom: 0;
}
.MuiStepper-root.vertical .MuiStepConnector-line {
  margin-left: 24px;
}

/* Light Theme */
:root.light-theme {
  --icon-filter: none;
  --icon-color: black;
  --icon-filter-header: var(--icon-filter-light);
  --main-background-color: #EBEBEB !important;
  --main-text-color: #000000;
  --blocks-background-color: #f5f5f5;
  --blocks-image-background-color: #ffffff;
  --blocks-hover-background-color: #3366ff29;
  --blocks-hover-border-color: #2934ff;
  --text-primary-color: #000000;
  --text-primary-hover-color: #fff;
  --drop-down-text-primary-color: #000000;
  --drop-down-text-primary-background-color: #ffffff;
  --accordion-expanded-bg: #DEE6FF;
  --container-background-color: #fff;
  --search-background-color: #fff;
  --search-boarder-color: #bababa;
  --input-field-color: #fff;
  --input-text-color: #9f9f9f;
  --dropdown-background-color: #fff;
  --dropdown-background-color-hover: #373737;
  --btn-background-color: #fff;
  --btn-border-color: #36F;
  --btn-text-color: #000000;
  --label-color: #333;
  --table-background-color: #fff;
  --input-field-border-color: #dbdbdb;
  --table-header-color: #DBDBDB;
  --session-blocks-background-color: #f5f5f5;
  --title-container-background: #f5f5f5;
  --title-container-text: #000000;
  --table-container-background: #ffffff;
  --table-background-color: #FFFFFF;
  --table-btn-color: #ebebeb;
  --toggle-close-icon-background: #ebebeb;
  --toggle-close-icon-color: #686868;
  --content-container-background: #fff;
  --checkbox-description-text-color: #1f1f1f;
  --pagination-background-color: #fff;
  --contact-abb-blocks-background-color: #ebebeb;
  --sub-headings-color: #0F0F0F;
  --dialogue-box-background-color: #fff;
  --dialogue-text-color: #1f1f1f;
  --dialogue-icon-color: #1f1f1f;
  --dialogue-box-button-color: #fff;
  --input-description-text-color: #696969;
  --app-reg-container-background: #f5f5f5;
  --app-reg-first-container: #fff;
  --app-reg-sub-heading-background: #f5f5f5;
  --app-reg-type-name-background: rgb(222, 230, 255);
  --app-reg-type-active-background: rgb(222, 255, 229);
  --input-disabled-background: #f5f5f5;
  --input-disable-text-color: #B2B2B2;
  --format-message-case-creation: #555;
  --privacy-policy-link-color: #531B9B;
}
@supports (color: rgb(0, 0, 0, 0)){
:root.light-theme {
  --icon-color: rgb(0, 0, 0, 0.25);
}
}

/* Dark Theme */
:root.dark-theme {
  --icon-filter: invert(1);
  --icon-color: #fff;
  --icon-filter-header: var(--icon-filter-dark);
  --icon-color: var(--icon-color-dark);
  --icon-filter-header: var(--icon-filter-dark);
  --main-background-color: #1F1F1F;
  --main-text-color: #ffffff;
  --blocks-background-color: #333333;
  --blocks-border-color: #525252;
  --blocks-name-text-color: #ffffff;
  --blocks-image-background-color: #000000;
  --blocks-hover-background-color: #3366ff29;
  --blocks-hover-border-color: #2934ff;
  --content-container-color: #696969;
  --text-primary-color: #ffffff;
  --text-primary-hover-color: #000000;
  --drop-down-text-primary-color: #ffffff;
  --drop-down-text-primary-background-color: #000000;
  --accordion-expanded-bg: #696969;
  --search-background-color: #1F1F1F;
  --search-boarder-color: #696969;
  --icon-sort-color: rgb(186,186,186);
  --block-active-class-color: rgb(123,123,123);
  --input-field-color: #1f1f1f;
  --input-background-color: #ad4141;
  --input-text-color: #fff;
  --input-field-border-color: #373737;
  --dropdown-background-color: #1F1F1F;
  --dropdown-background-color-hover: #373737;
  --modal-popup-bordertop: #00ff08;
  --text-primary-color: #FFF;
  --blocks-hover-color: rgb(77,84,100);
  --btn-background-color: #36F;
  --btn-border-color: #FFF;
  --btn-text-color: #000000;
  --title-container-color: #404040;
  --main-text-hover-color: rgb(31,31,31);
  --session-blocks-background-color: #424242;
  --container-background-color: #1F1F1F;
  --title-container-background: #424242;
  --title-container-text: #ffffff;
  --label-color: #ffffff;
  --alphabet-text-color: #ffffff;
  --table-background-color: #525252;
  --table-container-background: #525252;
  --content-container-background: #1F1F1F;
  --table-btn-color: #36F;
  --toggle-close-icon-background: #36f;
  --toggle-close-icon-color: #000000;
  --ag-background-color: #00ff08;
  --checkbox-description-text-color: #fff;
  --pagination-background-color: #0F0F0F;
  --table-header-color: #525252;
  --contact-abb-blocks-background-color: #333333;
  --sub-headings-color: #fff;
  --icon-color: #fff;
  --dialogue-box-background-color: #333333;
  --dialogue-text-color: #fff;
  --dialogue-icon-color: #fff;
  --dialogue-box-button-color: #333333;
  --input-description-text-color: #bdb4b4;
  --app-reg-container-background: #424242;
  --app-reg-first-container: #1F1F1F;
  --app-reg-sub-heading-background: #525252;
  --app-reg-type-name-background: #525252;
  --app-reg-type-active-backgroung: rgb(222, 255, 229);
  --input-disabled-background: #525252;
  --input-disable-text-color: #B2B2B2;
  --format-message-case-creation: #bdb4b4;
  --privacy-policy-link-color: #36f;
}

@font-face {
  font-family: "ABBVoice";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  /* Safari, Android, iOS */
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "ABBVoice";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
  /* Safari, Android, iOS */
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "ABBVoice";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
  /* Safari, Android, iOS */
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "ABBVoice";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("truetype");
  /* Safari, Android, iOS */
  font-weight: 700;
  font-style: normal;
}
html,
body {
  height: 100%;
  font-family: "ABBVoice", Verdana;
  font-weight: 400;
  margin: 0;
  font-size: 12px;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.asterisk {
  color: rgb(217, 83, 79);
  font-size: 18px;
  font-family: ABBVoice-bold;
}

.new-role-alert-fail-forbidden {
  color: #ff000f;
  text-align: center;
}

.user-permission-message {
  color: #ff000f;
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px;
}

.app-list-container .app-list-content .app_list .app_box {
  width: min-content !important;
}

.main-container > .content-container {
  padding: 0 !important;
}

.iframe-wrapper iframe::-webkit-scrollbar {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/base/_theme.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/base/_reset.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_accordion.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/default-theme/_variables.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_avatar.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_badge.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_breadcrumb.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_button.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_card.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_chip.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_counter.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_checkbox.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_dataGrid.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_datePicker.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_dateRangePicker.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_dialog.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_emptyState.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_fileUploader.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_header.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_icon.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_inputGroup.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_leftNavigation.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_link.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_list.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_loadingIndicator.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_menu.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_notification.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_numeric-input.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_pagination.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_radioButton.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_segmented-control.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_select.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_slider.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_switch.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_tab.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_textfield.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_timePicker.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_title.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_toolbar.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_tooltip.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_treeView.scss","webpack://./node_modules/@abb/abb-arcadia-ui-react/core-scss/components/_wizard.scss","webpack://./src/assets/styles/light-theme.scss","webpack://./src/assets/styles/dark-theme.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,sDAAA;ACAA;EACI,6BAAA;EACA,+BAAA;EACA,0BAAA;EACA,cAAA;EACA,0BAAA;EACA,wBAAA;EACA,yBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kCAAA;EACA,qBAAA;EACA,wBAAA;EACA,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,+BAAA;EACA,qCAAA;EACA,yBAAA;EACA,+BAAA;EACA,qCAAA;EACA,uBAAA;EACA,6BAAA;EACA,mCAAA;EACA,sBAAA;EACA,4BAAA;EACA,kCAAA;AD0BJ;;ACvBA;EACE,6BAAA;EACA,+BAAA;EACA,0BAAA;EACA,cAAA;EACA,0BAAA;EACA,wBAAA;EACA,yBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,6BAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kCAAA;EACA,wBAAA;EACA,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,+BAAA;EACA,qCAAA;EACA,yBAAA;EACA,+BAAA;EACA,qCAAA;EACA,uBAAA;EACA,6BAAA;EACA,mCAAA;EACA,sBAAA;EACA,4BAAA;EACA,kCAAA;AD0BF;;AC/GA;EACI,6BAAA;EACA,+BAAA;EACA,0BAAA;EACA,cAAA;EACA,0BAAA;EACA,wBAAA;EACA,yBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kCAAA;EACA,qBAAA;EACA,wBAAA;EACA,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,+BAAA;EACA,qCAAA;EACA,yBAAA;EACA,+BAAA;EACA,qCAAA;EACA,uBAAA;EACA,6BAAA;EACA,mCAAA;EACA,sBAAA;EACA,4BAAA;EACA,kCAAA;ADkHJ;;AC/GA;EACE,6BAAA;EACA,+BAAA;EACA,0BAAA;EACA,cAAA;EACA,0BAAA;EACA,wBAAA;EACA,yBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,6BAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kCAAA;EACA,wBAAA;EACA,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,+BAAA;EACA,qCAAA;EACA,yBAAA;EACA,+BAAA;EACA,qCAAA;EACA,uBAAA;EACA,6BAAA;EACA,mCAAA;EACA,sBAAA;EACA,4BAAA;EACA,kCAAA;ADkHF;;AEvMA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFI,SAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,wBAAA;AF0MJ;;AEvMA;EACE,0BAAA;AF0MF;;AEtMA;;;;;;;;;;;EAWI,cAAA;AFyMJ;;AEtMA;EACI,cAAA;AFyMJ;;AEtMA;;EAEI,gBAAA;AFyMJ;;AEtMA;;EAEI,YAAA;AFyMJ;;AEtMA;;;;EAII,WAAA;EACA,aAAA;AFyMJ;;AEtMA;EAEI,iBAAA;AFwMJ;;AEpMA;EACI,WAAA;EACA,WAAA;EACA,cAAA;AFuMJ;;AEpMA;EACI,sBAAA;AFuMJ;;AEnMA;;EAEI,YAAA;EACA,WAAA;AFsMJ;;AEnMA;EACI,eAAA;AFsMJ;;AEnMA;EACI,iBAAA;AFsMJ;;AEnMA;EACI,eAAA;AFsMJ;;AGtWI;EACI,gBAAA;EACA,WAAA;AHyWR;AGvWQ;EACI,uBAAA;EACA,6BAAA;EACA,gCCNa;EDOb,gBAAA;AHyWZ;AGvWY;EACI,iCCED;EDDC,eAAA;AHyWhB;AGvWgB;EACI,kBAAA;EACA,uBAAA;EACA,0BAAA;AHyWpB;AGvWoB;EACI,UAAA;AHyWxB;AGpWoB;EACI,wBAAA;EACA,0BAAA;AHsWxB;AGjWY;EACI,eAAA;EACA,gCCjCS;EDkCT,gBAAA;EACA,eAAA;EACA,8BC5BJ;ED6BI,iCAAA;EACA,aAAA;EACA,kBAAA;AHmWhB;AGhWY;EACI,eAAA;AHkWhB;AG/VY;EACI,gCC/CS;EDgDT,gBAAA;EACA,eAAA;AHiWhB;AG/VgB;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,6BAAA;AHiWpB;AG/VoB;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AHiWxB;AG/VwB;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AHiW5B;AG9VwB;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AHgW5B;AG5VoB;EACI,iBAAA;EACA,iBAAA;AH8VxB;AG3VoB;EACI,8CC9DI;ED+DJ,yCAAA;AH6VxB;AG1VoB;EACI,8CCnEI;EDoEJ,yCAAA;AH4VxB;;AGpVA;EACI,gBAAA;EACA,gBAAA;AHuVJ;AGrVI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AHuVR;AGrVQ;EACI,mBAAA;EACA,eAAA;EACA,6BCxGU;AJ+btB;AGrVY;EACI,kBAAA;AHuVhB;AGpVY;EACI,0BAAA;AHsVhB;;AGhVA;EACI,aAAA;EACA,mBAAA;AHmVJ;AGjVI;EACI,sBAAA;EACA,iBAAA;AHmVR;AGhVI;EACI,8BC3HI;AJ6cZ;AGhVQ;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCCzIa;ED0Ib,kBAAA;EACA,gBAAA;AHkVZ;;AK/dA;EACI,gCDCqB;ECArB,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;ALkeJ;AKheI;EACI,iCDGO;AJ+df;AK/dI;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;ALieR;AK9dI;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ALgeR;AK7dI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AL+dR;AK5dI;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AL8dR;AK3dI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AL6dR;AK1dI;EACI,aAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AL4dR;AKzdI;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AL2dR;AKxdI;EACI,cAAA;EACA,eAAA;EACA,iBAAA;AL0dR;AKvdI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;ALydR;AKtdI;EACI,aAAA;EACA,cAAA;EACA,mBAAA;ALwdR;AKrdI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;ALudR;AKpdI;EACI,aAAA;EACA,cAAA;EACA,kBAAA;ALsdR;AKndI;EACI,8BAAA;ALqdR;AKldI;EACI,gCDhGiB;ECiGjB,kBAAA;EACA,eAAA;EACA,iCAAA;ALodR;AKhdI;EACI,mBAAA;EACA,wCAAA;ALkdR;AK/cI;EACI,sBD/FO;ECgGP,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;ALidR;AK/cQ;EACI,aAAA;ALidZ;;AK5cA;EACI,aAAA;EACA,mBAAA;AL+cJ;;AM5kBA;EACI,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,QAAA;AN+kBJ;AM7kBI;EACI,eAAA;AN+kBR;AM5kBI;EACI,oCF2BU;EE1BV,mBFJI;AJklBZ;AM5kBQ;EACI,oCAAA;EACA,yBFsBM;EErBN,8BFTA;AJulBZ;AM3kBQ;EACI,oCAAA;EACA,yBFgBM;EEfN,0CFiBkB;AJ4jB9B;AM1kBQ;EACI,6BAAA;EACA,gCF5Ba;EE6Bb,YAAA;AN4kBZ;AM3kBY;EACI,kBAAA;EACA,eAAA;EACA,yBFKE;AJwkBlB;AMxkBI;EACI,iCAAA;EACA,gCFxCiB;EEyCjB,iCF7BO;AJumBf;AMxkBQ;EACI,iCAAA;EACA,gCF7Ca;EE8Cb,8BFtCA;AJgnBZ;AMvkBQ;EACI,iCAAA;EACA,gCFnDa;EEoDb,2BFxCG;AJinBf;AMxkBY;EACI,sBFxCD;AJknBf;AMvkBQ;EACI,6BAAA;EACA,gCF3Da;EE4Db,YAAA;ANykBZ;AMxkBY;EACI,sBFhDD;EEiDC,kBAAA;EACA,eAAA;AN0kBhB;AMrkBI;EACI,uCFzCa;EE0Cb,mBF/DI;AJsoBZ;AMrkBQ;EACI,uCAAA;EACA,4BF9CS;EE+CT,8BFpEA;AJ2oBZ;AMpkBQ;EACI,uCAAA;EACA,4BFpDS;EEqDT,6CFnDqB;AJynBjC;AMpkBQ;EACI,6BAAA;EACA,gCFtFa;EEuFb,YAAA;ANskBZ;AMrkBY;EACI,4BF5DK;EE6DL,kBAAA;EACA,eAAA;ANukBhB;AMlkBI;EACI,uCFjEa;EEkEb,mBF1FI;AJ8pBZ;AMlkBQ;EACI,uCAAA;EACA,4BFtES;EEuET,8BF/FA;AJmqBZ;AMjkBQ;EACI,uCAAA;EACA,4BF5ES;EE6ET,6CF3EqB;AJ8oBjC;AMjkBQ;EACI,6BAAA;EACA,gCFjHa;EEkHb,YAAA;ANmkBZ;AMlkBY;EACI,4BFpFK;EEqFL,kBAAA;EACA,eAAA;ANokBhB;AM/jBI;EACI,qCFzFW;EE0FX,mBFrHI;AJsrBZ;AM/jBQ;EACI,qCAAA;EACA,0BF9FO;EE+FP,8BF1HA;AJ2rBZ;AM9jBQ;EACI,qCAAA;EACA,0BFpGO;EEqGP,2CFnGmB;AJmqB/B;AM9jBQ;EACI,6BAAA;EACA,gCF5Ia;EE6Ib,YAAA;ANgkBZ;AM/jBY;EACI,0BF5GG;EE6GH,kBAAA;EACA,eAAA;ANikBhB;AM3jBI;EACI,8BFhJI;EEiJJ,sBF3IO;EE4IP,iCAAA;AN6jBR;AM1jBI;EACI,WAAA;EACA,UAAA;EACA,mBAAA;AN4jBR;AMzjBI;EACI,WAAA;EACA,UAAA;EACA,mBAAA;AN2jBR;AMxjBI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AN0jBR;AMvjBI;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;ANyjBR;AMtjBI;EACI,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;ANwjBR;AMrjBI;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,6BAAA;ANujBR;AMpjBI;EACI,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,mBAAA;ANsjBR;AMnjBI;EACI,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,mBAAA;ANqjBR;AMljBI;EACI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,6BAAA;EACA,mBAAA;ANojBR;AMljBI;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;ANojBR;;AOhyBA;EACI,gCAAA;APmyBJ;AOlyBI;EACI,qBAAA;EACA,oBAAA;EACA,mBAAA;APoyBR;;AOhyBA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gCHXqB;EGYrB,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;APmyBJ;AOjyBI;EACI,eAAA;EACA,gBAAA;EACA,gCHpBiB;AJuzBzB;;AO/xBA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;EACA,gCAAA;APkyBJ;AOhyBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;APkyBR;AOhyBQ;EACI,8BHlCA;AJo0BZ;AO/xBQ;EACI,iCHnCG;AJo0Bf;AO9xBQ;EACI,eAAA;EACA,gCHnDa;AJm1BzB;AO5xBI;EACI,gCAAA;EACA,mBAAA;EACA,gCH1DiB;EG2DjB,gBAAA;EACA,iBAAA;EACA,qBAAA;AP8xBR;;AO1xBA;EACI,gCHlEqB;AJ+1BzB;;AO1xBA;EACI,gCHtEqB;EGuErB,eAAA;AP6xBJ;;AQt2BA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;ARy2BJ;AQv2BI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;ARy2BR;AQt2BI;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCJuCqB;AJi0B7B;AQr2BI;EACI,aAAA;EACA,4BAAA;EACA,QAAA;EACA,+BAAA;EACA,uBAAA;EACA,mBAAA;ARu2BR;AQr2BQ;EACI,gBAAA;EACA,gCAAA;ARu2BZ;AQp2BQ;EACI,gBAAA;EACA,gBAAA;EACA,sBAAA;ARs2BZ;AQj2BI;EACI,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;ARm2BR;AQj2BQ;EACI,gBAAA;EACA,oBAAA;ARm2BZ;AQh2BQ;EACI,gBAAA;EACA,sBAAA;ARk2BZ;AQ91BI;EACI,qBAAA;ARg2BR;AQ71BI;EACI,eAAA;AR+1BR;AQ51BI;EACI,eAAA;AR81BR;AQ31BI;EACI,YAAA;AR61BR;AQ31BQ;EACI,gBAAA;AR61BZ;AQ11BQ;EACI,gBAAA;AR41BZ;AQx1BI;EACI,kBAAA;EACA,aAAA;EACA,eAAA;AR01BR;AQv1BI;EACI,wCJ1Fc;EI2Fd,mBJvFI;AJg7BZ;AQv1BQ;EACI,sCJ7FQ;AJs7BpB;AQt1BQ;EACI,uCJhGS;AJw7BrB;AQr1BQ;EACI,mBAAA;EACA,wCAAA;ARu1BZ;AQp1BQ;EACI,yCJxGW;EIyGX,oBAAA;EACA,mBAAA;ARs1BZ;AQl1BI;EACI,iCJ1GO;EI2GP,gCJvHiB;AJ28BzB;AQl1BQ;EACI,iCJ7GG;AJi8Bf;AQj1BQ;EACI,mBAAA;EACA,wCAAA;ARm1BZ;AQh1BQ;EACI,iCJrHG;AJu8Bf;AQ/0BQ;EACI,iCJ3HG;EI4HH,sBJ1HG;EI2HH,oBAAA;EACA,mBAAA;ARi1BZ;AQ70BI;EACI,6BAAA;EACA,gCJhJiB;EIiJjB,iCAAA;AR+0BR;AQ70BQ;EACI,iCJxIG;EIyIH,iCAAA;AR+0BZ;AQ50BQ;EACI,mBAAA;EACA,wCAAA;AR80BZ;AQ30BQ;EACI,iCJjJG;EIkJH,iCAAA;AR60BZ;AQ10BQ;EACI,sBJrJG;EIsJH,iCAAA;EACA,oBAAA;EACA,mBAAA;AR40BZ;AQ30BY;EACI,6BAAA;EACA,sBJ3JD;EI4JC,oBAAA;EACA,iCAAA;AR60BhB;AQv0BI;EACI,6BAAA;EACA,gCJnLiB;AJ4/BzB;AQv0BQ;EACI,iCJ1KG;AJm/Bf;AQt0BQ;EACI,mBAAA;EACA,wCAAA;ARw0BZ;AQr0BQ;EACI,iCJlLG;AJy/Bf;AQp0BQ;EACI,sBJrLG;EIsLH,oBAAA;EACA,6BAAA;EACA,mBAAA;ARs0BZ;AQl0BI;EACI,uCJ9Ka;EI+Kb,mBJpMI;AJwgCZ;AQl0BQ;EACI,6CJjLe;AJq/B3B;AQj0BQ;EACI,mBAAA;EACA,wCAAA;ARm0BZ;AQ/zBI;EACI,qCJtLW;EIuLX,mBJlNI;AJmhCZ;AQ/zBQ;EACI,2CJzLa;AJ0/BzB;AQ9zBQ;EACI,mBAAA;EACA,wCAAA;ARg0BZ;AQ5zBI;EACI,uCJvMa;EIwMb,mBJhOI;AJ8hCZ;AQ5zBQ;EACI,6CJ1Me;AJwgC3B;AQ3zBQ;EACI,mBAAA;EACA,wCAAA;AR6zBZ;AQzzBI;EACI,gBAAA;EACA,gBAAA;EACA,0BAAA;AR2zBR;AQvzBI;EACI,gBAAA;EACA,gBAAA;EACA,0BAAA;ARyzBR;AQtzBI;EACI,wCJ9Pc;EI+Pd,wCAAA;EACA,mBJ5PI;EI6PJ,qBAAA;ARwzBR;AQtzBQ;EACI,8BJhQA;AJwjCZ;AQrzBQ;EACI,sCAAA;ARuzBZ;AQpzBQ;EACI,uCAAA;ARszBZ;AQnzBQ;EACI,mBAAA;EACA,wCAAA;ARqzBZ;AQjzBY;EACI,sCJrRI;AJwkCpB;AQhzBY;EACI,uCJxRK;AJ0kCrB;AQ/yBY;EACI,yCJ3RO;EI4RP,oBAAA;ARizBhB;AQ5yBY;EACI,sCJpSI;AJklCpB;AQ3yBY;EACI,uCJvSK;AJolCrB;AQ1yBY;EACI,yCJ1SO;EI2SP,oBAAA;AR4yBhB;AQxyBQ;EACI,yCJhTW;EIiTX,yCAAA;EACA,oBAAA;EACA,mBAAA;AR0yBZ;AQtyBI;EACI,iCJnTO;EIoTP,iCAAA;EACA,gCJjUiB;EIkUjB,qBAAA;ARwyBR;AQtyBQ;EACI,iCJvTG;AJ+lCf;AQryBQ;EACI,mBAAA;EACA,wCAAA;ARuyBZ;AQnyBY;EACI,wCJnTM;AJwlCtB;AQlyBY;EACI,iCJtUD;AJ0mCf;AQjyBY;EACI,iCJ3UD;EI4UC,sBJzUD;EI0UC,oBAAA;ARmyBhB;AQ9xBY;EACI,wCJnUM;AJmmCtB;AQ7xBY;EACI,iCJtVD;AJqnCf;AQ5xBY;EACI,iCJ3VD;EI4VC,sBJzVD;EI0VC,mBAAA;EACA,oBAAA;AR8xBhB;AQ1xBQ;EACI,iCJnWG;EIoWH,sBJjWG;EIkWH,iCAAA;EACA,mBAAA;EACA,oBAAA;AR4xBZ;;ASjpCA;EACI,aAAA;EACA,gCLqBU;EKpBV,sBAAA;EACA,uBAAA;EACA,wFAAA;EACA,kBAAA;EACA,UAAA;EACA,iCAAA;EACA,YAAA;EACA,iBAAA;ATopCJ;ASlpCI;EACI,0CAAA;EACA,mCLUS;EKTT,yCAAA;EACA,eAAA;ATopCR;ASlpCQ;EACI,mCLKK;AJ+oCjB;AShpCI;EACI,yCAAA;ATkpCR;AS7oCI;EACI,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,wBL3BI;EK4BJ,qBAAA;EACA,gBAAA;EACA,6BAAA;EACA,wCAAA;AT+oCR;AS7oCQ;EACI,UAAA;AT+oCZ;AS5oCQ;EACI,UAAA;AT8oCZ;AS3oCQ;EACI,sBLlCG;EKmCH,mBAAA;EACA,iBAAA;AT6oCZ;AS1oCQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCL3Da;AJusCzB;ASzoCQ;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gCLlEa;EKmEb,UAAA;EACA,gBAAA;EACA,iBAAA;AT2oCZ;ASxoCQ;EACI,sBLzDG;EK0DH,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AT0oCZ;ASvoCQ;EACI,0CAAA;EACA,mCL5DK;EK6DL,yCAAA;EACA,eAAA;ATyoCZ;AStoCQ;EACI,yCAAA;ATwoCZ;ASjoCI;EACI,YAAA;EACA,8BAAA;ATmoCR;AShoCI;EACI,wBL7FI;AJ+tCZ;AS9nCI;EACI,wBLlGI;AJkuCZ;AS7nCI;EACI,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,QAAA;AT+nCR;AS7nCQ;EACI,SAAA;AT+nCZ;AS5nCQ;EACI,sBL3GG;EK4GH,mBAAA;EACA,0BAAA;EACA,iBAAA;AT8nCZ;AS3nCQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCLrIa;AJkwCzB;AS1nCQ;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gCL5Ia;EK6Ib,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AT4nCZ;ASvnCI;EACI,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,eAAA;EACA,8BAAA;EACA,+BAAA;ATynCR;ASvnCQ;EACI,2BLxJG;AJixCf;AStnCQ;EACI,sBLtJG;EKuJH,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ATwnCZ;;ASnnCA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;ATsnCJ;ASpnCI;EACI,mBAAA;EACA,kBAAA;ATsnCR;;AU9yCA;EACI,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,yBAAA;EACA,gBAAA;EACA,iCNOW;EMNX,mCAAA;EACA,gCNPqB;EMQrB,gCNmDyB;EMlDzB,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;AVizCJ;AU/yCI;EACI,UAAA;AVizCR;AU9yCI;EACI,SAAA;EACA,eAAA;AVgzCR;AU7yCI;EACI,2BNbO;EMcP,gCNzBiB;AJw0CzB;AU9yCQ;EACI,gCN3Ba;AJ20CzB;AU5yCI;EACI,gBAAA;AV8yCR;AU3yCI;EACI,eAAA;EACA,SAAA;EACA,gCNtCiB;AJm1CzB;AU3yCQ;EACI,mBAAA;AV6yCZ;AUzyCI;EACI,gCN9CiB;AJy1CzB;AU1yCQ;EACI,mBAAA;AV4yCZ;AUxyCI;EACI,2BNzCO;EM0CP,sBNxCO;EMyCP,mBAAA;EACA,uBAAA;EACA,UAAA;AV0yCR;AUzyCQ;EACI,sBN7CG;AJw1Cf;AUvyCQ;EACI,sBNlDG;AJ21Cf;AUpyCI;EACI,YAAA;EACA,cAAA;AVsyCR;AUnyCI;EACI,YAAA;EACA,eAAA;AVqyCR;AUlyCI;EACI,YAAA;EACA,eAAA;AVoyCR;AUhyCI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;AVkyCR;AUjyCQ;EACI,kBAAA;AVmyCZ;AUjyCQ;EACI,uCAAA;AVmyCZ;AU/xCI;EACI,eAAA;EACA,gDN7DsB;EM8DtB,6BNlGc;EMmGd,wCAAA;EACA,gBAAA;AViyCR;AUhyCQ;EACI,6BNtGU;AJw4CtB;AU/xCY;EACI,8CAAA;AViyChB;AU9xCQ;EACI,6BN9GU;AJ84CtB;AU7xCQ;EACI,wCNnGgB;AJk4C5B;;AWv5CA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AX05CJ;AWx5CI;EACI,QAAA;AX05CR;AWv5CI;EACI,eAAA;EACA,gCPXiB;AJo6CzB;;AYt6CA;EACI,gBAAA;AZy6CJ;;AYt6CA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;AZy6CJ;AYv6CI;EACI,iCAAA;EACA,iCRLO;AJ86Cf;AYt6CI;EACI,iCAAA;EACA,iCRVO;AJk7Cf;AYr6CI;EACI,iCAAA;EACA,iCRfO;AJs7Cf;AYp6CI;EACI,iCAAA;EACA,iCRnBO;AJy7Cf;AYn6CI;EACI,mBAAA;EACA,wCAAA;AZq6CR;AYl6CI;EACI,WAAA;EACA,YAAA;AZo6CR;AYj6CI;EACI,WAAA;EACA,YAAA;AZm6CR;;AY/5CA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,wCAAA;EACA,kBAAA;EACA,kCRvDkB;EQwDlB,mBRpDQ;EQqDR,WAAA;EACA,eAAA;AZk6CJ;AYh6CI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AZk6CR;AY/5CI;EACI,yCAAA;EACA,yCRjEe;AJk+CvB;AY95CI;EACI,eAAA;AZg6CR;AY75CI;EACI,cAAA;AZ+5CR;AY55CI;EACI,WAAA;EACA,YAAA;AZ85CR;AY35CI;EACI,WAAA;EACA,YAAA;AZ65CR;AY15CI;EACI,sCAAA;EACA,sCR1FY;AJs/CpB;AYz5CI;EACI,sCAAA;EACA,sCR/FY;AJ0/CpB;AYx5CI;EACI,uCAAA;EACA,uCRnGa;AJ6/CrB;AYv5CI;EACI,mBAAA;EACA,wCAAA;AZy5CR;;AYr5CA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AZw5CJ;AYt5CI;EACI,eAAA;AZw5CR;AYr5CI;EACI,mBAAA;AZu5CR;AYp5CI;EACI,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCRpIiB;EQqIjB,iBAAA;EACA,eAAA;AZs5CR;AYp5CQ;EACI,sBR1HG;EQ2HH,mBAAA;AZs5CZ;;AaliDA;EACI,8BTSQ;ESRR,gBAAA;AbqiDJ;AaniDI;EACI,gBAAA;AbqiDR;AaliDI;EACI,iCAAA;AboiDR;AajiDI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AbmiDR;AahiDI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AbkiDR;AahiDQ;EACI,iBAAA;AbkiDZ;Aa/hDQ;EACI,mBAAA;EACA,2CAAA;EACA,gCThCa;AJikDzB;Aa/hDY;EACI,wCAAA;AbiiDhB;Aa/hDY;EACI,kDAAA;AbiiDhB;Aa/hDY;EACI,+CAAA;AbiiDhB;Aa7hDQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;Ab+hDZ;Aa1hDQ;EACI,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCT1Da;ES2Db,kDAAA;Ab4hDZ;Aa1hDY;EACI,iCTnDD;AJ+kDf;AazhDY;EACI,UAAA;Ab2hDhB;AaxhDY;EACI,UAAA;Ab0hDhB;AaxhDgB;EACI,8BTjER;AJ2lDZ;AathDY;EACI,gBAAA;AbwhDhB;AarhDY;EACI,wCAAA;AbuhDhB;AaphDY;EACI,oCAAA;AbshDhB;AanhDY;EACI,wCAAA;EACA,uCAAA;AbqhDhB;AalhDY;EACI,kBAAA;AbohDhB;AajhDY;EACI,8BT3FJ;AJ8mDZ;AajhDgB;EACI,iCT3FL;AJ8mDf;AahhDgB;EACI,yCAAA;AbkhDpB;Aa9gDY;EACI,iCTrGD;AJqnDf;Aa9gDgB;EACI,iCTvGL;AJunDf;Aa7gDgB;EACI,4CAAA;Ab+gDpB;Aa1gDQ;EACI,gCT5Ha;ES6Hb,YAAA;Ab4gDZ;AaxgDQ;EACI,iBAAA;Ab0gDZ;AavgDQ;EACI,+CAAA;AbygDZ;AargDY;EACI,gCT3IS;AJkpDzB;AapgDY;EACI,gCT/IS;AJqpDzB;Aa7/CY;EACI,8BTjJJ;AJgpDZ;Aa5/CY;EACI,8BTrJJ;AJmpDZ;Aa3/CY;EACI,iCTvJD;AJopDf;Aaz/CY;EACI,iCT7JD;AJwpDf;Aax/CY;EACI,iCT/JD;AJypDf;Aav/CY;EACI,yCAAA;Aby/ChB;Aat/CY;EACI,8CT/JY;AJupD5B;Aar/CY;EACI,UAAA;Abu/ChB;Aal/CI;EACI,2CAAA;EACA,mBAAA;EACA,iBAAA;EACA,gCT/LiB;ESgMjB,wCAAA;Abo/CR;Aal/CQ;EACI,sBAAA;Abo/CZ;Aaj/CQ;EACI,iCT5LG;AJ+qDf;Aah/CQ;EACI,WAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;Abk/CZ;Aa/+CQ;EACI,YAAA;EACA,eAAA;Abi/CZ;Aa9+CQ;EACI,YAAA;EACA,eAAA;Abg/CZ;Aa7+CQ;EACI,YAAA;EACA,eAAA;Ab++CZ;Aa5+CQ;EACI,YAAA;EACA,eAAA;Ab8+CZ;Aa3+CQ;EACI,YAAA;EACA,eAAA;Ab6+CZ;Aa1+CQ;EACI,uCAAA;Ab4+CZ;Aaz+CQ;EACI,wBAAA;EACA,0BAAA;Ab2+CZ;Aax+CQ;EACI,mBAAA;Ab0+CZ;Aav+CQ;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;Aby+CZ;Aav+CY;EACI,wCT1PM;AJmuDtB;Aat+CY;EACI,uCTlOK;AJ0sDrB;Aar+CY;EACI,qCTnOG;AJ0sDnB;Aap+CY;EACI,uCT7OK;AJmtDrB;Aan+CY;EACI,YAAA;Abq+ChB;Aal+CY;EACI,YAAA;Abo+ChB;Aaj+CY;EACI,YAAA;Abm+ChB;Aah+CY;EACI,YAAA;Abk+ChB;Aa/9CY;EACI,YAAA;Abi+ChB;Aa79CQ;EACI,gBAAA;EACA,OAAA;EACA,sCAAA;EACA,WAAA;Ab+9CZ;Aa79CY;EACI,sCAAA;Ab+9ChB;Aa39CQ;EACI,6BT1SU;AJuwDtB;Aa39CY;EACI,0BAAA;Ab69ChB;;Aav9CA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,gCT5TqB;AJsxDzB;Aax9CI;EACI,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;Ab09CR;;Aat9CA;EACI,kBAAA;Aby9CJ;Aav9CI;EACI,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;Aby9CR;Aar9CI;EACI,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gCTvViB;ESwVjB,wCAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;Abu9CR;Aar9CQ;EACI,gCTjWa;ESkWb,YAAA;EACA,mBAAA;Abu9CZ;Aap9CQ;EACI,+CAAA;Abs9CZ;Aaj9CI;EACI,wCAAA;EACA,kBAAA;EACA,eAAA;Abm9CR;Aah9CI;EACI,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,8BT9WI;AJg0DZ;Aah9CQ;EACI,8CTtWgB;ESuWhB,wCAAA;Abk9CZ;Aa/8CQ;EACI,6CAAA;Abi9CZ;Aa98CQ;EACI,4CAAA;Abg9CZ;Aa78CQ;EACI,0CAAA;Ab+8CZ;Aa58CQ;EACI,4CAAA;Ab88CZ;Aa38CQ;EACI,iCTnYG;AJg1Df;Aax8CI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gCTvZiB;AJi2DzB;Aat8CI;EACI,WAAA;EACA,sBAAA;EACA,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCTlaiB;ESmajB,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,iCAAA;EACA,iCThaO;ESiaP,kBAAA;Abw8CR;Aar8CI;EACI,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gCTnbiB;ESobjB,aAAA;EACA,mBAAA;EACA,sBAAA;Abu8CR;Aap8CI;EACI,6BTtbc;AJ43DtB;Aap8CQ;EACI,0BAAA;Abs8CZ;;Acr4DA;EACE,kBAAA;EACA,oBAAA;Adw4DF;Act4DE;EACE,gCVHqB;AJ24DzB;Acr4DE;EACE,UAAA;EACA,SAAA;Adu4DJ;;Acn4DA;EACE,2CAAA;Ads4DF;Acp4DE;EACE,aAAA;Ads4DJ;Acn4DE;EACE,YAAA;EACA,YAAA;EACA,aAAA;Adq4DJ;Acl4DE;EACE,SAAA;Ado4DJ;Acl4DI;EACE,8CVVsB;AJ84D5B;Acl4DM;EACE,wCVboB;AJi5D5B;Ach4DI;EACE,6BAAA;EACA,gCAAA;EACA,mBV/BM;AJi6DZ;Ach4DM;EACE,uBAAA;Adk4DR;Ac93DI;EACE,4BAAA;EACA,+BAAA;EACA,wCV7CgB;EU8ChB,mBV1CM;AJ06DZ;Ac93DM;EACE,uBAAA;Adg4DR;Ac33DE;EACE,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;Ad63DJ;Ac33DI;EACE,gCVnEmB;AJg8DzB;Ac33DM;EACE,uBAAA;Ad63DR;Acz3DI;EACE,kBAAA;EACA,iBAAA;Ad23DN;Acx3DI;EACE,iBAAA;Ad03DN;Acv3DI;EACE,gBAAA;EACA,eAAA;EACA,gCVtFmB;EUuFnB,2CAAA;Ady3DN;Acv3DM;EACE,0BAAA;Ady3DR;Acl3DI;EACE,kBAAA;EACA,gBAAA;EACA,gCVpGmB;EUqGnB,2CAAA;EACA,YAAA;EACA,WAAA;Ado3DN;Ach3DE;EACE,mDAAA;EACA,wCAAA;Adk3DJ;Ac/2DE;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCVvHqB;EUwHrB,2CAAA;Adi3DJ;Ac/2DI;EACE,iCVhHS;AJi+Df;Ac92DI;EACE,sBVnHS;AJm+Df;Ac92DM;EACE,iCVvHO;AJu+Df;Ac52DI;EACE,mDAAA;EACA,mBVhIM;AJ8+DZ;Ac12DE;EACE,2CAAA;EACA,WAAA;EACA,YAAA;EACA,gCVhJqB;AJ4/DzB;Ac12DI;EACE,mDAAA;EACA,mBV5IM;AJw/DZ;Acx2DE;EACE,2CAAA;EACA,WAAA;EACA,YAAA;EACA,gCV5JqB;AJsgEzB;Acx2DI;EACE,mDAAA;EACA,mBVxJM;AJkgEZ;Act2DE;EACE,aAAA;EACA,YAAA;Adw2DJ;Acr2DE;EACE,eAAA;Adu2DJ;Acp2DE;EACE,iBAAA;Ads2DJ;;Acj2DE;EACE,eAAA;Ado2DJ;;Ac/1DA;EACE,wBAAA;Adk2DF;;Ac/1DA;EACE,kBAAA;Adk2DF;Ach2DE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;Adk2DJ;;AeviEA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,2BAAA;Af0iEJ;AexiEI;EACI,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;Af0iER;AeviEI;EACI,kBAAA;AfyiER;AetiEI;EACI,aAAA;AfwiER;AetiEQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AfwiEZ;AetiEY;EACI,eAAA;AfwiEhB;AeriEY;EACI,gCX/BS;AJskEzB;AepiEY;EACI,gBAAA;EACA,eAAA;EACA,gCXrCS;EWsCT,gCAAA;AfsiEhB;AejiEI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AfmiER;AejiEQ;EACI,gCXjDa;AJolEzB;;Ae9hEA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;AfiiEJ;Ae/hEI;EACI,gBAAA;EACA,kBAAA;AfiiER;Ae9hEI;EACI,kBAAA;EACA,gBAAA;EACA,gCXrEiB;EWsEjB,2CAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AfgiER;;Ae5hEA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;Af+hEJ;Ae7hEI;EACI,oBAAA;Af+hER;Ae5hEI;EACI,mBAAA;Af8hER;Ae3hEI;EACI,aAAA;EACA,mBAAA;Af6hER;;AezhEA;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;Af4hEJ;Ae1hEI;EACI,aAAA;EACA,gCAAA;EACA,sBAAA;EACA,YAAA;Af4hER;Ae1hEQ;EACI,8BXvGA;EWwGA,aAAA;EACA,gCXjHa;EWkHb,mBAAA;EACA,gBAAA;EACA,uCAAA;Af4hEZ;AezhEQ;EACI,YAAA;EACA,iCX/GG;EWgHH,uCAAA;Af2hEZ;AezhEY;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCXpIS;EWqIT,kCAAA;EACA,eAAA;Af2hEhB;AezhEgB;EACE,iCX9HH;AJypEf;AexhEgB;EACI,8CX1HQ;EW2HR,6CAAA;Af0hEpB;AephEI;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AfshER;AephEQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,oBAAA;AfshEZ;AenhEQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AfqhEZ;AenhEY;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AfqhEhB;AelhEY;EACI,gCXpLS;EWqLT,gBAAA;EACA,mBAAA;AfohEhB;AehhEQ;EACI,sBX3KG;EW4KH,gBAAA;EACA,mBAAA;EACA,gBAAA;AfkhEZ;Ae/gEQ;EACI,aAAA;EACA,mBAAA;AfihEZ;Ae9gEQ;EACI,aAAA;EACA,mBAAA;AfghEZ;Ae9gEY;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AfghEhB;Ae9gEgB;EACI,gCXjNK;EWkNL,gBAAA;EACA,mBAAA;AfghEpB;;AezgEA;EACI,WAAA;EACA,YAAA;Af4gEJ;;AezgEA;EACI,iCXpNW;EWqNX,mBAAA;EACA,8BAAA;Af4gEJ;;AezgEA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;Af4gEJ;Ae1gEI;EACI,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gCXnPiB;EWoPjB,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;Af4gER;Ae1gEQ;EACI,iCXnPG;AJ+vEf;AezgEQ;EACI,wCX9PU;EW+PV,mBX3PA;AJswEZ;;AergEI;EACI,iBAAA;EACA,iBAAA;AfwgER;AergEI;EACI,eAAA;EACA,gBAAA;AfugER;;AengEA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AfsgEJ;AepgEI;EACI,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gCXpSiB;EWqSjB,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AfsgER;AepgEQ;EACI,iCXpSG;AJ0yEf;AengEQ;EACI,wCX/SU;EWgTV,mBX5SA;AJizEZ;;AehgEA;EACI,aAAA;EACA,eAAA;AfmgEJ;AejgEI;EACI,0BAAA;AfmgER;AehgEI;EACI,0BAAA;AfkgER;Ae//DI;EACI,8CXnToB;AJozE5B;Ae9/DI;EACI,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gCXhViB;EWiVjB,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AfggER;Ae9/DQ;EACI,iCX5UG;AJ40Ef;Ae7/DQ;EACI,wCAAA;Af+/DZ;Ae5/DQ;EACI,sBXlVG;AJg1Ef;Ae3/DQ;EACI,wCX/VU;EWgWV,kBAAA;EACA,mBX7VA;AJ01EZ;Ae3/DY;EACI,mDAAA;Af6/DhB;Aet/DY;EACI,8CX7VY;AJq1E5B;;AgBz2EI;EACI,qCAAA;AhB42ER;;AgBx2EA;EACI,gCZgBU;EYfV,eAAA;AhB22EJ;;AgBv2EI;EACI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AhB02ER;AgBx2EQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gCZvBa;EYwBb,iBAAA;AhB02EZ;AgBv2EQ;EACI,eAAA;EACA,aAAA;AhBy2EZ;AgBv2EY;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gCZnCS;AJ44EzB;AgBr2EQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AhBu2EZ;AgBr2EY;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AhBu2EhB;AgBp2EY;EACI,wCAAA;EACA,oBAAA;EACA,mBAAA;AhBs2EhB;AgBn2EY;EACI,eAAA;AhBq2EhB;AgBl2EY;EACI,kBAAA;EACA,gBAAA;EACA,gCZnES;EYoET,qBAAA;AhBo2EhB;AgBj2EY;EACI,iBAAA;EACA,gBAAA;EACA,gCZ1ES;AJ66EzB;AgBh2EY;EACI,sBZ9DD;EY+DC,mBAAA;EACA,sCAAA;EACA,gBAAA;EACA,kBAAA;AhBk2EhB;AgB71EY;EACI,yBZlDE;AJi5ElB;AgB11EY;EACI,0BZ3DG;AJu5EnB;AgBv1EY;EACI,4BZvEK;AJg6ErB;AgBp1EY;EACI,4BZ1EK;AJg6ErB;AgBj1EY;EACI,gCZhHS;AJm8EzB;AgB/0EQ;EACI,mBAAA;EACA,gBAAA;EACA,gCZvHa;EYwHb,qBAAA;EACA,iBAAA;EACA,mBAAA;AhBi1EZ;AgB90EQ;EACI,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iCZzHG;AJy8Ef;AgB70EQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,QAAA;AhB+0EZ;;AiB79EA;EACI,8BbSQ;EaRR,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;AjBg+EJ;AiB99EI;EACI,gBAAA;EACA,mBAAA;EACA,gCbXiB;AJ2+EzB;AiB79EI;EACI,gBAAA;EACA,eAAA;EACA,gCbjBiB;AJg/EzB;AiB59EI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AjB89ER;AiB39EI;EACI,SAAA;AjB69ER;;AkB7/EA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AlBggFJ;AkB9/EI;EACI,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gCdRiB;AJwgFzB;AkB7/EI;EACI,gCAAA;EACA,mBAAA;EACA,sBAAA;EACA,kCddmB;AJ6gF3B;AkB5/EI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AlB8/ER;AkB5/EQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AlB8/EZ;AkB5/EY;EACI,kBAAA;EACA,0BdIG;AJ0/EnB;AkB3/EY;EACI,0CdZc;Ecad,kBAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCd5CS;AJyiFzB;AkB3/EgB;EACI,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AlB6/EpB;AkBz/EgB;EACI,4CAAA;AlB2/EpB;AkBx/EgB;EACI,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AlB0/EpB;;AkBl/EA;EACI,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,uDAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,iCAAA;AlBq/EJ;AkBn/EI;EACI,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,gCd9FiB;AJmlFzB;AkBn/EQ;EACI,4CAAA;AlBq/EZ;AkBl/EQ;EACI,8BAAA;AlBo/EZ;AkBj/EQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gCd5Ga;AJ+lFzB;AkBj/EY;EACI,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AlBm/EhB;AkBh/EY;EACI,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AlBk/EhB;AkB9+EQ;EACI,gCAAA;EACA,mBAAA;EACA,sBdlHG;AJkmFf;;AmBlnFA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,8BfEQ;EeDR,wCAAA;EACA,qCAAA;EACA,gCfTqB;AJ8nFzB;AmBnnFI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AnBqnFR;AmBnnFQ;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AnBqnFZ;AmBjnFQ;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCf9Ba;Ee+Bb,gBAAA;AnBmnFZ;AmBhnFQ;EACI,YAAA;EACA,UAAA;EACA,2BfxBG;AJ0oFf;AmB/mFQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCf9Ca;Ee+Cb,kBAAA;AnBinFZ;AmB9mFQ;EACI,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnBgnFZ;AmB7mFQ;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,qCflEa;EemEb,kBAAA;EACA,UAAA;EACA,OAAA;EACA,oBAAA;EACA,eAAA;AnB+mFZ;AmB5mFQ;EACI,UAAA;AnB8mFZ;AmB3mFQ;EACI,WAAA;AnB6mFZ;AmB1mFQ;EACI,WAAA;AnB4mFZ;AmBzmFQ;EACI,SAAA;EACA,wBAAA;EACA,OAAA;AnB2mFZ;AmBxmFQ;EACI,QAAA;EACA,UAAA;AnB0mFZ;AmBvmFQ;EACI,yBAAA;EACA,SAAA;EACA,OAAA;AnBymFZ;AmBrmFI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AnBumFR;AmBrmFQ;EACI,wCAAA;EACA,eAAA;EACA,mBAAA;EACA,gCfjHa;EekHb,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;EACA,uBAAA;AnBumFZ;AmBrmFY;EACI,eAAA;AnBumFhB;AmBpmFY;EACI,gBAAA;AnBsmFhB;AmBnmFY;EACI,gBAAA;AnBqmFhB;AmBhmFQ;EACI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,wCfvIU;EewIV,0BAAA;AnBkmFZ;AmB9lFI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AnBgmFR;AmB9lFQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AnBgmFZ;AmB9lFY;EACI,kBAAA;EACA,QAAA;EACA,WAAA;AnBgmFhB;AmB7lFY;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AnB+lFhB;AmB7lFgB;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,mEAAA;EACA,2BAAA;AnB+lFpB;AmB5lFgB;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,wBAAA;AnB8lFpB;AmB1lFY;EACI,kBAAA;AnB4lFhB;AmBzlFY;EACI,0BAAA;EACA,iCfzLD;Ee0LC,kBAAA;AnB2lFhB;AmBzlFgB;EACI,eAAA;AnB2lFpB;AmBtlFQ;EACI,YAAA;EACA,UAAA;EACA,2BfnMG;AJ2xFf;AmBrlFQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AnBulFZ;AmBplFQ;EACI,iBAAA;EACA,WAAA;AnBslFZ;AmBnlFQ;EACI,eAAA;AnBqlFZ;AmBllFQ;EACI,sBAAA;AnBolFZ;;AmB7kFA;EACI,qBAAA;EACA,eAAA;EACA,eAAA;AnBglFJ;AmB9kFI;EACI,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;AnBglFR;AmB7kFI;EACI,iCAAA;AnB+kFR;;AmB1kFA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AnB6kFJ;AmB3kFI;EACI,UAAA;EACA,8Bf5PI;Ee6PJ,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AnB6kFR;AmB3kFQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AnB6kFZ;AmB3kFY;EACI,MAAA;EACA,aAAA;AnB6kFhB;AmBzkFQ;EACI,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCf7Ra;AJw2FzB;AmBxkFQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AnB0kFZ;AmBxkFY;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,kCAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,4BAAA;AnB0kFhB;AmBxkFgB;EACI,iCf5SL;AJs3Ff;AmBvkFgB;EACI,6CAAA;EACA,8CfzSQ;AJk3F5B;AmBpkFQ;EACI,WAAA;EACA,YAAA;AnBskFZ;AmBjkFI;EACI,UAAA;EACA,iCfhUO;EeiUP,aAAA;AnBmkFR;AmBjkFQ;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;AnBmkFZ;AmBhkFQ;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;AnBkkFZ;AmBhkFY;EACI,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,8Bf5VJ;Ee6VI,oDAAA;AnBkkFhB;AmBhkFgB;EACI,UAAA;EACA,eAAA;AnBkkFpB;AmB/jFgB;EACI,8Cf1VQ;Ee2VR,wCAAA;EACA,eAAA;AnBikFpB;AmB5jFY;EACI,mBAAA;EACA,gBAAA;EACA,gCfvXS;AJq7FzB;AmB5jFgB;EACI,gBAAA;EACA,eAAA;AnB8jFpB;AmBzjFQ;EACI,eAAA;EACA,gBAAA;EACA,gCfnYa;EeoYb,mBAAA;AnB2jFZ;;AoBj8FA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,gChBHqB;EgBIrB,eAAA;EACA,kBAAA;ApBo8FJ;AoBl8FI;EACI,iBAAA;EACA,iBAAA;ApBo8FR;AoBj8FI;EACI,kBAAA;EACA,gBAAA;ApBm8FR;AoBh8FI;EACI,eAAA;EACA,iBAAA;ApBk8FR;AoB/7FI;EACI,iBAAA;EACA,eAAA;ApBi8FR;AoB97FI;EACI,eAAA;EACA,gBAAA;ApBg8FR;AoB77FI;EACI,4CAAA;ApB+7FR;AoB37FQ;EACI,8CAAA;ApB67FZ;AoBz7FI;EACI,4CAAA;ApB27FR;AoBx7FI;EACI,yDAAA;ApB07FR;AoBv7FI;EACI,sBhBrCO;EgBsCP,6BAAA;EACA,mBAAA;ApBy7FR;;AqB7+FY;EACI,mBAAA;EACA,wCAAA;ArBg/FhB;AqB3+FQ;EACI,iBAAA;EACA,kBAAA;ArB6+FZ;AqB1+FQ;EACI,iBAAA;EACA,kBAAA;ArB4+FZ;AqBx+FI;EACI,iCjBVO;EiBWP,mBAAA;EACA,oBAAA;ArB0+FR;AqBz+FQ;EACI,YAAA;ArB2+FZ;AqBv+FI;EACI,mBAAA;EACA,gCjB9BiB;EiB+BjB,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;ArBy+FR;AqBv+FQ;EACI,sCAAA;ArBy+FZ;AqBp+FQ;EACI,wCAAA;ArBs+FZ;AqBn+FQ;EACI,kDAAA;ArBq+FZ;AqBl+FQ;EACI,+CAAA;ArBo+FZ;;AsB3hGA;EACI,aAAA;EAGA,YAAA;EACA,sBAAA;EACA,8BAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iCAAA;EACA,uCAAA;EACA,4CAAA;EACA,2BAAA;AtB4hGJ;AsB1hGI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AtB4hGR;AsBzhGI;EACI,gBAAA;EACA,SAAA;EACA,4BAAA;AtB2hGR;AsBxhGI;EACI,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,8BlBzBI;EkB0BJ,gClBlCiB;EkBmCjB,eAAA;AtB0hGR;AsBxhGQ;EACI,iClB3BG;AJqjGf;AsBvhGQ;EACI,8ClBvBgB;EkBwBhB,gBAAA;AtByhGZ;AsBthGQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;AtBwhGZ;AsBrhGQ;EACI,aAAA;EACA,mBAAA;AtBuhGZ;AsBphGQ;EACI,6CAAA;AtBshGZ;AsBnhGQ;EACI,kCAAA;AtBqhGZ;AsBhhGI;EACI,eAAA;AtBkhGR;AsB/gGI;EACI,mBAAA;AtBihGR;AsB9gGI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,gClBpFiB;EkBqFjB,wCAAA;EACA,kBAAA;AtBghGR;AsB9gGQ;EACI,iClB7EG;AJ6lGf;AsB7gGQ;EACI,sBAAA;EACA,kBAAA;AtB+gGZ;AsB5gGQ;EACI,kBAAA;AtB8gGZ;AsBzgGY;EACI,cAAA;AtB2gGhB;AsBxgGY;EACI,aAAA;AtB0gGhB;AsBrgGQ;EACI,eAAA;EACA,gClBnHa;AJ0nGzB;AsBngGI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,kCAAA;EACA,gClBjIiB;AJsoGzB;AsBngGQ;EACI,iClBxHG;EkByHH,gCAAA;AtBqgGZ;AsBlgGQ;EACI,8ClBtHgB;AJ0nG5B;AsBlgGY;EACI,6CAAA;AtBogGhB;AsBhgGQ;EACI,8BlBzIA;AJ2oGZ;AsBhgGY;EACI,6CAAA;AtBkgGhB;AsB9/FQ;EACI,8BAAA;AtBggGZ;AsB7/FQ;EACI,kBAAA;AtB+/FZ;AsB3/FQ;EACI,sBlBpJG;EkBqJH,iClB1JG;EkB2JH,mBAAA;AtB6/FZ;AsB1/FQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AtB4/FZ;AsBz/FQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;AtB2/FZ;AsBv/FQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AtBy/FZ;AsBt/FQ;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AtBw/FZ;AsBt/FY;EACI,mBAAA;AtBw/FhB;AsBr/FY;EACI,kBAAA;AtBu/FhB;AsBp/FY;EACI,wBAAA;EACA,iCAAA;AtBs/FhB;AsBn/FY;EACI,iCAAA;AtBq/FhB;AsBj/FQ;EACI,kBAAA;EACA,eAAA;EACA,gClBzNa;AJ4sGzB;AsBj/FY;EACI,6BlBxNM;AJ2sGtB;AsBh/FY;EACI,sBlBlND;EkBmNC,iClBxND;EkByNC,mBAAA;AtBk/FhB;AsB7+FQ;EACI,mBAAA;EACA,gBAAA;EACA,gClB1Oa;EkB2Ob,mBAAA;EACA,gBAAA;AtB++FZ;AsB7+FY;EACI,6BlB3OM;EkB4ON,gBAAA;AtB++FhB;AsB5+FY;EACI,cAAA;AtB8+FhB;AsB3+FY;EACI,aAAA;AtB6+FhB;AsB1+FY;EACI,sBlB9OD;EkB+OC,iClBpPD;EkBqPC,mBAAA;AtB4+FhB;AsBt+FI;EACI,YAAA;AtBw+FR;AsBr+FI;EACI,WAAA;AtBu+FR;;AuBlvGA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,eAAA;EACA,gCAAA;EACA,qBAAA;EACA,iBAAA;AvBqvGJ;AuBnvGI;EACI,kBAAA;AvBqvGR;AuBlvGI;EACI,qCAAA;AvBovGR;AuBjvGI;EACI,qBAAA;EACA,2CAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;AvBmvGR;AuBhvGI;EACI,kBAAA;EACA,kBAAA;AvBkvGR;AuB/uGI;EACI,mBAAA;AvBivGR;AuB9uGI;EACI,sBAAA;AvBgvGR;AuB7uGI;EACI,kBAAA;AvB+uGR;AuB5uGI;EACI,mBAAA;AvB8uGR;AuB3uGI;EACI,eAAA;AvB6uGR;;AwB/xGA;EACI,gCpBsBU;EoBrBV,kBAAA;EACA,sBAAA;EACA,gBAAA;AxBkyGJ;AwBhyGI;EACI,UAAA;AxBkyGR;AwBhyGQ;EACI,mCpBgBK;AJkxGjB;AwB/xGQ;EACI,8BpBJA;AJqyGZ;AwB7xGY;EACI,gBAAA;EACA,eAAA;AxB+xGhB;AwB3xGY;EACI,gBAAA;EACA,eAAA;AxB6xGhB;AwB1xGY;EACI,gBAAA;EACA,eAAA;AxB4xGhB;AwBxxGgB;EACI,sBAAA;AxB0xGpB;AwBvxGgB;EACI,sBAAA;AxByxGpB;AwBtxGgB;EACI,qBAAA;AxBwxGpB;AwB/wGI;EACI,2BpBxCO;AJyzGf;AwB9wGI;EACI,UAAA;AxBgxGR;AwB7wGY;EACI,gCAAA;EACA,gCpB7DS;EoB8DT,mBAAA;EACA,gBAAA;EACA,kCAAA;AxB+wGhB;AwB7wGgB;EACI,iCpBxDL;AJu0Gf;AwB5wGgB;EACI,8CpBpDQ;AJk0G5B;AwB5wGoB;EACI,kCAAA;AxB8wGxB;AwB3wGoB;EACI,6CAAA;AxB6wGxB;AwBzwGgB;EACI,UAAA;AxB2wGpB;AwBxwGgB;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gCpB1FK;AJo2GzB;AwBvwGgB;EACI,gCAAA;EACA,gCpB/FK;EoBgGL,mBAAA;EACA,gBAAA;EACA,qBAAA;AxBywGpB;AwBtwGgB;EACI,gCAAA;EACA,sBpBvFL;EoBwFK,mBAAA;EACA,qBAAA;AxBwwGpB;;AyBn3GA;EACI,gBAAA;AzBs3GJ;;AyBn3GA;EACI,sBrBaW;EqBZX,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AzBs3GJ;AyBp3GI;EACI,kBAAA;AzBs3GR;AyBn3GI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;AzBq3GR;;AyBj3GA;EACI,sBrBRW;EqBSX,kBAAA;EACA,gBAAA;AzBo3GJ;;AyBj3GA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AzBo3GJ;AyBl3GI;EACI,4BrBTa;AJ63GrB;;AyBh3GA;EACI,iCrB/BW;EqBgCX,kBAAA;EACA,WAAA;AzBm3GJ;AyBj3GI;EACI,WAAA;AzBm3GR;AyBh3GI;EACI,WAAA;AzBk3GR;AyB/2GI;EACI,WAAA;AzBi3GR;AyB92GI;EACI,wCrBxDc;AJw6GtB;AyB52GQ;EACI,uCrBpCS;AJk5GrB;AyBz2GQ;EACI,iCrBzDG;AJo6Gf;;AyBt2GA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AzBy2GJ;AyBv2GI;EACI,4BrBtDa;EqBuDb,kBAAA;EACA,MAAA;EACA,OAAA;AzBy2GR;AyBv2GQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AzBy2GZ;AyBt2GQ;EACE,SAAA;EACA,UAAA;EACA,eAAA;AzBw2GV;AyBr2GQ;EACE,QAAA;EACA,SAAA;EACA,iBAAA;AzBu2GV;;AyBl2GA;EACI,6BrBzGkB;AJ88GtB;AyBn2GI;EACI,sBrBpGO;AJy8Gf;AyBl2GI;EACI,4BrBvFa;AJ27GrB;AyBj2GI;EACI,sBrB1GO;AJ68Gf;;AyB/1GA;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCrB9HkB;EqB+HlB,6BrB/HkB;EqBgIlB,kDAAA;EACA,wCAAA;EACA,sBAAA;AzBk2GJ;;AyB/1GE;;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCrB9IkB;EqB+IlB,6BrB/IkB;AJi/GtB;;AyB/1GE;EACE,kDAAA;EACA,8CAAA;EACA,mBAAA;AzBk2GJ;;AyB/1GE;EACE,mDAAA;EACA,6CAAA;EACA,qBAAA;AzBk2GJ;;AyB/1GE;EACE;IACE,kDAAA;EzBk2GJ;EyB/1GE;IACE,iDAAA;EzBi2GJ;EyB91GE;IAEE,kDAAA;EzB+1GJ;AACF;AyB51GE;EACE;IACE,kDAAA;EzB81GJ;EyB31GE;IACE,iDAAA;EzB61GJ;EyB11GE;IAEE,kDAAA;EzB21GJ;AACF;AyBx1GE;EACE;IACE,mDAAA;EzB01GJ;EyBv1GE;IACE,kDAAA;EzBy1GJ;EyBt1GE;IAEE,mDAAA;EzBu1GJ;AACF;A0BriHA;EACI,gBAAA;A1BuiHJ;;A0BniHI;EACI,gCtBJiB;EsBKjB,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,QAAA;A1BsiHR;A0BriHQ;EACI,iCtBHG;AJ0iHf;A0BpiHQ;EACI,gBAAA;EACA,iBAAA;A1BsiHZ;A0BniHQ;EACI,gBAAA;EACA,iBAAA;A1BqiHZ;A0BjiHQ;EACI,gBAAA;EACA,eAAA;A1BmiHZ;A0BhiHQ;EACI,8CtBfgB;AJijH5B;A0B/hHQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;A1BiiHZ;A0B/hHY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,sBAAA;A1BiiHhB;A0B9hHY;EACI,aAAA;EACA,sBAAA;A1BgiHhB;A0B9hHgB;EACI,mBAAA;EACA,gCtB1DK;AJ0lHzB;A0B7hHgB;EACI,kBAAA;EACA,sBtB/CL;EsBgDK,gCAAA;A1B+hHpB;A0BzhHI;EACI,SAAA;A1B2hHR;;A0BthHI;EACI,sBtBjEO;EsBkEP,SAAA;A1ByhHR;;A2BxmHI;EACI,oBAAA;EACA,qBAAA;A3B2mHR;A2BzmHI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCvBjBiB;EuBkBjB,4CAAA;A3B2mHR;A2BzmHQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;A3B2mHZ;A2BxmHQ;EACI,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;A3B0mHZ;A2BvmHQ;EACI,YAAA;EACA,YAAA;EACA,kBAAA;A3BymHZ;A2BvmHY;EACI,SAAA;A3BymHhB;A2BrmHQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;A3BumHZ;A2BrmHY;EACI,gCvBnDS;EuBoDT,kBAAA;EACA,gBAAA;A3BumHhB;A2BnmHQ;EACI,8BvBlDA;AJupHZ;A2BlmHQ;EACI,iCvBpDG;EuBqDH,iCAAA;A3BomHZ;A2BjmHQ;EACI,8BvB3DA;EuB4DA,0BAAA;EACA,wCAAA;A3BmmHZ;A2BjmHY;EACI,yBvBlCE;EuBmCF,kBAAA;A3BmmHhB;A2B/lHQ;EACI,gDvBtCkB;EuBuClB,oCAAA;A3BimHZ;A2B/lHY;EACI,yBvB5CE;EuB6CF,kBAAA;A3BimHhB;A2B7lHQ;EACI,8BvBhFA;EuBiFA,0BAAA;EACA,2CAAA;A3B+lHZ;A2B7lHY;EACI,4BvBhEK;EuBiEL,kBAAA;A3B+lHhB;A2B3lHQ;EACI,mDvBpEqB;EuBqErB,uCAAA;A3B6lHZ;A2B3lHY;EACI,4BvB1EK;EuB2EL,kBAAA;A3B6lHhB;A2BxlHQ;EACI,8BvBtGA;EuBuGA,0BAAA;EACA,2CAAA;A3B0lHZ;A2BxlHY;EACI,4BvBnFK;EuBoFL,kBAAA;A3B0lHhB;A2BtlHQ;EACI,mDvBvFqB;EuBwFrB,uCAAA;A3BwlHZ;A2BtlHY;EACI,4BvB7FK;EuB8FL,kBAAA;A3BwlHhB;A2BnlHQ;EACI,8BvB5HA;EuB6HA,0BAAA;EACA,yCAAA;A3BqlHZ;A2BnlHY;EACI,0BvBtGG;EuBuGH,kBAAA;A3BqlHhB;A2BjlHQ;EACI,iDvB1GmB;EuB2GnB,qCAAA;A3BmlHZ;A2BjlHY;EACI,0BvBhHG;EuBiHH,kBAAA;A3BmlHhB;;A4BxuHI;EACI,gBAAA;A5B2uHR;A4BxuHI;EACI,eAAA;A5B0uHR;A4BvuHI;EACI,YAAA;EACA,8BAAA;A5ByuHR;A4BtuHI;EACI,0BxBsBW;EwBrBX,eAAA;A5BwuHR;A4BruHI;EACI,4BxBWa;EwBVb,eAAA;A5BuuHR;A4BpuHI;EACI,aAAA;EACA,sBAAA;EACA,iCxBfO;EwBgBP,sCAAA;A5BsuHR;A4BnuHY;EACI,iCxBpBD;AJyvHf;A4BnuHY;EACI,iCxBtBD;AJ2vHf;A4BjuHQ;EACI,qCAAA;EACA,gBAAA;A5BmuHZ;A4BhuHQ;EACI,cAAA;A5BkuHZ;A4B/tHQ;EACI,YAAA;A5BiuHZ;A4B7tHI;EACI,iCxB1CO;EwB2CP,mBAAA;EACA,oBAAA;A5B+tHR;A4B7tHQ;;;EAGI,sBxB9CG;AJ6wHf;A4B5tHQ;EACI,YAAA;A5B8tHZ;;A6B/xHA;EACI,mBAAA;EACA,gCAAA;EACA,gCAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;A7BkyHJ;A6BhyHI;EACI,qCAAA;A7BkyHR;A6B/xHI;EACI,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BzBNI;EyBOJ,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,8BAAA;EACA,mBAAA;A7BiyHR;A6B/xHQ;EACI,aAAA;A7BiyHZ;A6B9xHQ;EACI,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;A7BgyHZ;A6B7xHQ;EACI,aAAA;A7B+xHZ;A6B5xHQ;EACI,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;A7B8xHZ;A6B5xHY;EACI,gCzB9CS;EyB+CT,cAAA;A7B8xHhB;A6B5xHgB;EACI,sBzBpCL;EyBqCK,mBAAA;A7B8xHpB;A6B1xHY;EACI,gBAAA;A7B4xHhB;A6BzxHY;EACI,iBAAA;A7B2xHhB;A6BxxHY;EACI,gCAAA;EACA,iBAAA;EACA,gBAAA;A7B0xHhB;;A8B51HQ;EACI,gC1BDa;AJg2HzB;A8B31HQ;EACI,YAAA;EACA,mBAAA;EACA,gC1BRa;AJq2HzB;A8Bx1HQ;EACI,gBAAA;A9B01HZ;;A8Br1HA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;A9Bw1HJ;A8Bt1HI;EACI,iCAAA;EACA,iC1BtBO;AJ82Hf;A8Br1HI;EACI,iCAAA;EACA,iC1B3BO;AJk3Hf;A8Bp1HI;EACI,iCAAA;EACA,iC1BhCO;AJs3Hf;A8Bn1HI;EACI,iCAAA;EACA,iC1BpCO;AJy3Hf;A8Bl1HI;EACI,mBAAA;EACA,wCAAA;A9Bo1HR;A8Bj1HI;EACI,WAAA;EACA,YAAA;A9Bm1HR;A8Bh1HI;EACI,WAAA;EACA,YAAA;A9Bk1HR;;A8B90HA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,kBAAA;EACA,kC1BvEkB;E0BwElB,WAAA;EACA,eAAA;A9Bi1HJ;A8B/0HI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8B1B5EI;AJ65HZ;A8B90HI;EACI,UAAA;EACA,WAAA;A9Bg1HR;A8B70HI;EACI,UAAA;EACA,WAAA;A9B+0HR;A8B50HI;EACI,WAAA;EACA,YAAA;A9B80HR;A8B30HI;EACI,WAAA;EACA,YAAA;A9B60HR;A8B10HI;EACI,sCAAA;EACA,sC1BxGY;AJo7HpB;A8Bz0HI;EACI,sCAAA;EACA,sC1B7GY;AJw7HpB;A8Bx0HI;EACI,yCAAA;EACA,mC1BhHe;AJ07HvB;A8Bv0HI;EACI,uCAAA;EACA,uC1BtHa;AJ+7HrB;A8Bt0HI;EACI,mBAAA;EACA,wCAAA;A9Bw0HR;;A8Bp0HA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;A9Bu0HJ;A8Br0HI;EACI,mBAAA;A9Bu0HR;A8Bp0HI;EACI,mBAAA;EACA,gCAAA;EACA,gC1BlJiB;E0BmJjB,iBAAA;EACA,eAAA;A9Bs0HR;A8Bn0HY;EACI,mBAAA;EACA,sB1B1ID;AJ+8Hf;;A+Bh+HA;EACI,wB3BSQ;E2BRR,mBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;A/Bm+HJ;A+Bj+HI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;A/Bm+HR;A+Bh+HI;EACI,YAAA;A/Bk+HR;A+Bh+HQ;EACI,gBAAA;EACA,eAAA;A/Bk+HZ;A+Bh+HY;EACI,iBAAA;A/Bk+HhB;A+B79HI;EACI,YAAA;A/B+9HR;A+B79HQ;EACI,gBAAA;EACA,eAAA;A/B+9HZ;A+B79HY;EACI,eAAA;A/B+9HhB;A+B19HI;EACI,sBAAA;EACA,YAAA;EACA,YAAA;A/B49HR;A+B19HQ;EACI,cAAA;EACA,gBAAA;A/B49HZ;A+Bx9HI;EACI,8B3BlDI;E2BmDJ,mCAAA;EACA,gC3B5DiB;AJshIzB;A+Bv9HY;EACI,gD3BzCc;AJkgI9B;A+Bt9HY;EACI,wC3BhEM;E2BiEN,gBAAA;EACA,mB3B9DJ;E2B+DI,eAAA;A/Bw9HhB;A+Bt9HgB;EACI,mBAAA;EACA,mC3BpEG;E2BqEH,mB3BpER;AJ4hIZ;A+Bp9HY;EACI,sB3BnED;E2BoEC,8B3B1EJ;E2B2EI,mBAAA;A/Bs9HhB;A+Bj9HI;EACI,2B3B7EO;E2B8EP,mCAAA;EACA,gC3B3FiB;AJ8iIzB;A+Bh9HY;EACI,gD3BxEc;AJ0hI9B;A+B/8HY;EACI,8B3B3FJ;E2B4FI,gC3BpGS;E2BqGT,gBAAA;EACA,eAAA;A/Bi9HhB;A+B/8HgB;EACI,mBAAA;EACA,2B3BhGL;E2BiGK,sB3B7FL;AJ8iIf;A+B78HY;EACI,sB3BlGD;E2BmGC,uBAAA;EACA,mBAAA;A/B+8HhB;A+Bx8HI;EACI,8B3BlHI;E2BmHJ,mCAAA;EACA,gC3B5HiB;AJskIzB;A+Bv8HY;EACI,gD3BzGc;AJkjI9B;A+Bt8HY;EACI,8C3BjHY;E2BkHZ,gC3BrIS;E2BsIT,gBAAA;EACA,eAAA;A/Bw8HhB;A+Bt8HgB;EACI,mBAAA;EACA,wC3BxHQ;E2ByHR,sB3B9HL;AJskIf;A+Bp8HY;EACI,sB3BnID;E2BoIC,wB3B1IJ;E2B2II,mBAAA;A/Bs8HhB;;AgC3lIE;EACE,mDAAA;AhC8lIJ;;AgC1lII;EACE,UAAA;AhC6lIN;;AgCxlIE;EACE,WAAA;AhC2lIJ;;AgCxlIE;EACE,gBAAA;AhC2lIJ;;AgCxlIE;EACE,wBAAA;AhC2lIJ;;AgCxlIE;EACE,kCAAA;AhC2lIJ;;AgCvlII;EACE,SAAA;AhC0lIN;AgCvlII;EACE,UAAA;AhCylIN;;AgCplII;EACE,yDAAA;AhCulIN;AgCplII;EACE,8B5BjCM;E4BkCN,sB5B5BS;E4B6BT,mBAAA;EACA,UAAA;AhCslIN;AgCnlII;EACE,iBAAA;AhCqlIN;;AgChlIE;EACE,eAAA;EACA,8B5B/CQ;E4BgDR,6CAAA;AhCmlIJ;AgCjlII;EACE,eAAA;AhCmlIN;;AgC/kIE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AhCklIJ;AgChlII;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iC5BjES;E4BkET,gBAAA;AhCklIN;AgC/kII;EACE,iBAAA;AhCilIN;AgC9kII;EACE,uCAAA;EACA,iBAAA;AhCglIN;AgC9kIM;EACE,eAAA;AhCglIR;;AgCzkIE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sB5B1FW;E4B2FX,iBAAA;AhC4kIJ;;AgCzkIE;EACE,eAAA;AhC4kIJ;;AgCzkIE;EACE,gBAAA;EACA,eAAA;EACA,gC5BpHqB;E4BqHrB,YAAA;AhC4kIJ;;AiCnsIA;EACI,WAAA;AjCssIJ;AiCpsII;EACI,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,gC7BLiB;AJ2sIzB;AiCnsII;EACI,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,gC7BZiB;AJitIzB;AiClsII;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AjCosIR;AiChsII;EACI,iC7BfO;E6BgBP,mBAAA;EACA,oBAAA;AjCksIR;AiChsIQ;EACG,sB7BjBI;AJmtIf;AiC/rIQ;EACI,YAAA;AjCisIZ;AiC7rII;EACI,aAAA;EACA,sBAAA;EACA,iC7B/BO;E6BgCP,sCAAA;AjC+rIR;AiC5rIY;EACI,iC7BpCD;AJkuIf;AiC5rIY;EACI,iC7BtCD;AJouIf;AiC1rIQ;EACI,qCAAA;EACA,gBAAA;AjC4rIZ;AiCzrIQ;EACI,YAAA;AjC2rIZ;AiCvrII;EACI,6B7B5Dc;E6B6Dd,eAAA;AjCyrIR;AiCvrIQ;EACI,iC7BxDG;E6ByDH,UAAA;EACA,WAAA;EACA,WAAA;AjCyrIZ;AiCtrIQ;EACI,2B7B/DG;E6BgEH,UAAA;EACA,WAAA;EACA,kBAAA;AjCwrIZ;AiCtrIY;EACI,kC7B7EM;AJqwItB;AiCnrIY;EACI,wC7BnFM;E6BoFN,UAAA;AjCqrIhB;AiClrIY;EACI,iC7BhFD;E6BiFC,UAAA;EACA,6B7BlFD;AJswIf;AiChrIQ;EACI,sB7BrFG;AJuwIf;AiChrIY;EACI,2B7BxFD;AJ0wIf;AiC/qIY;EACI,8B7BlGJ;E6BmGI,iCAAA;AjCirIhB;AiC7qIQ;EACI,WAAA;EACA,YAAA;EACA,8B7B1GA;E6B2GA,wCAAA;AjC+qIZ;AiC9qIY;EACI,wC7BjHM;E6BkHN,wCAAA;AjCgrIhB;AiC9qIY;EACI,wC7BrHM;E6BsHN,wCAAA;AjCgrIhB;AiC1qIQ;EACI,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,gC7BpIa;AJgzIzB;AiCzqIQ;EACI,2CAAA;EACA,gCAAA;EACA,mB7BlIA;E6BmIA,gBAAA;EACA,2C7B5Ia;E6B6Ib,kBAAA;EACA,iBAAA;AjC2qIZ;AiCxqIQ;EACI,QAAA;EACA,SAAA;AjC0qIZ;AiCtqIK;EACG,gC7BxJiB;AJg0IzB;AiCtqIY;EACE,aAAA;AjCwqId;;AkCr0IA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AlCw0IF;AkCt0IE;EACE,wC9BFkB;E8BGlB,mB9BCQ;E8BAR,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AlCw0IJ;AkCt0II;EACE,WAAA;EACA,UAAA;EACA,YAAA;AlCw0IN;AkCp0II;EACE,WAAA;EACA,UAAA;EACA,YAAA;AlCs0IN;AkCp0IM;EACE,iBAAA;AlCs0IR;AkCl0II;EACE,WAAA;EACA,UAAA;EACA,YAAA;AlCo0IN;AkCl0IM;EACE,eAAA;AlCo0IR;AkCh0II;EACE,sC9BrCc;AJu2IpB;AkC/zII;EACE,yC9BvCiB;E8BwCjB,mBAAA;AlCi0IN;AkC7zIE;EACE,iC9BpCW;AJm2If;AkC1zIM;EACE,iC9B1CO;AJs2If;AkCzzIM;EACE,sC9BzDY;AJo3IpB;AkCvzII;EACE,sC9B9Dc;AJu3IpB;AkCnzIM;EACE,wC9BtEc;AJ23ItB;AkClzIM;EACE,mB9BtEI;E8BuEJ,UAAA;AlCozIR;AkClzIQ;EACE,yC9B3Ea;E8B4Eb,UAAA;AlCozIV;AkC7yIQ;EACE,sC9BtFU;AJq4IpB;AkCzyIE;EACE,mB9B1FQ;AJq4IZ;AkCzyII;EACE,UAAA;EACA,iC9BxFS;AJm4If;AkCzyIM;EACE,iC9BzFO;AJo4If;AkCvyII;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AlCyyIN;AkCvyIM;EACE,gC9BnHiB;E8BoHjB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AlCyyIR;AkCryII;EACE,mB9BpHM;E8BqHN,2BAAA;EACA,mBAAA;AlCuyIN;AkCryIM;EACE,iC9BrHO;E8BsHP,UAAA;EACA,mBAAA;AlCuyIR;AkCnyIQ;EACE,sB9B3HK;E8B4HL,mBAAA;AlCqyIV;AkChyII;EACE,mB9BvIM;AJy6IZ;AkChyIM;EACE,UAAA;EACA,wC9B/Ic;AJi7ItB;AkChyIQ;EACE,sC9BjJU;AJm7IpB;AkC9xIM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AlCgyIR;AkC9xIQ;EACE,6B9B5JY;E8B6JZ,aAAA;EACA,uBAAA;EACA,mBAAA;AlCgyIV;AkC5xIM;EACE,mB9BhKI;E8BiKJ,UAAA;EACA,mBAAA;AlC8xIR;AkC5xIQ;EACE,yC9BtKa;E8BuKb,UAAA;EACA,mBAAA;AlC8xIV;AkCxxIE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;AlC0xIJ;AkCxxII;EACE,eAAA;AlC0xIN;AkCxxIM;EACE,eAAA;AlC0xIR;AkCvxIU;EACE,eAAA;EACA,cAAA;EACA,eAAA;AlCyxIZ;AkCnxII;EACE,WAAA;EACA,YAAA;AlCqxIN;AkCnxIM;EACE,eAAA;EACA,iBAAA;EACA,aAAA;AlCqxIR;AkChxIE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;AlCkxIJ;AkChxII;EACE,cAAA;AlCkxIN;AkChxIM;EACE,UAAA;AlCkxIR;AkC9wII;EACE,WAAA;EACA,YAAA;AlCgxIN;AkC9wIM;EACE,eAAA;EACA,cAAA;EACA,aAAA;AlCgxIR;AkC3wIE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;AlC6wIJ;AkC3wII;EACE,WAAA;AlC6wIN;AkC3wIM;EACE,gBAAA;AlC6wIR;AkC1wIU;EACE,eAAA;EACA,cAAA;EACA,eAAA;AlC4wIZ;AkCtwII;EACE,WAAA;EACA,YAAA;AlCwwIN;AkCtwIM;EACE,eAAA;AlCwwIR;AkCnwIE;EACE,gC9BlRqB;E8BmRrB,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AlCqwIJ;AkCnwII;EACE,mBAAA;AlCqwIN;AkClwII;EACE,eAAA;AlCowIN;AkCjwII;EACE,eAAA;AlCmwIN;AkChwII;EACE,mBAAA;EACA,sB9BvRS;AJyhJf;;AmC3iJA;EACI,wCAAA;EACA,2BAAA;AnC8iJJ;AmC5iJI;EACI,mBAAA;AnC8iJR;AmC3iJI;EACI,gC/BPiB;E+BQjB,sBAAA;EACA,gCAAA;EACA,sBAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AnC6iJR;AmC3iJQ;EACI,2B/BdG;E+BeH,kBAAA;AnC6iJZ;AmC1iJQ;EACI,6BAAA;EACA,kBAAA;EACA,uCAAA;AnC4iJZ;AmCziJQ;EACI,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,sB/B1BG;AJqkJf;AmCxiJQ;EACI,gBAAA;EACA,6BAAA;AnC0iJZ;AmCviJQ;EACI,iBAAA;EACA,kBAAA;AnCyiJZ;AmCtiJQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AnCwiJZ;AmCtiJY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AnCwiJhB;AmCniJI;EACI,WAAA;EACA,wC/BlEc;AJumJtB;;AoC5mJI;EACI,8BhCQI;EgCPJ,kBAAA;EACA,iBAAA;EACA,gChCHiB;EgCIjB,mBAAA;EACA,2CAAA;ApC+mJR;AoC7mJQ;EACI,iCAAA;ApC+mJZ;AoC3mJY;EACI,uChCbS;AJ0nJzB;AoCzmJQ;EACI,mBAAA;EACA,wCAAA;ApC2mJZ;AoCxmJQ;EACI,YAAA;ApC0mJZ;AoCvmJQ;EACI,mChCvBU;AJgoJtB;AoCrmJY;EACI,6BhCpBD;AJ2nJf;AoCpmJY;EACI,4CAAA;EACA,6BhCzBD;EgC0BC,mBAAA;ApCsmJhB;AoClmJQ;EACI,6BhC/BG;AJmoJf;AoCjmJQ;EACI,mChC3CU;AJ8oJtB;AoClmJY;EACI,wCAAA;ApComJhB;AoC/lJY;EACI,4CAAA;ApCimJhB;AoC9lJY;EACI,4CAAA;ApCgmJhB;AoCtlJY;EACI,kBAAA;EACA,iCAAA;EACA,YAAA;EACA,mBAAA;ApCwlJhB;;AoCllJA;EACI,kDAAA;ApCqlJJ;;AoCllJA;EACI,mDAAA;EACA,mChCjFkB;AJsqJtB;;AoCllJA;EACI,4CAAA;ApCqlJJ;;AoCllJA;EACI,4CAAA;ApCqlJJ;;AoCllJA;EACI,aAAA;EACA,sBAAA;EACA,2CAAA;EACA,QAAA;EACA,WAAA;ApCqlJJ;AoCnlJI;EACI,mBAAA;EACA,mBAAA;EACA,QAAA;ApCqlJR;AoCllJI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;ApColJR;AoCjlJI;EACI,kBAAA;ApCmlJR;AoChlJI;EACI,sCAAA;ApCklJR;AoC/kJI;EACI,kBAAA;EACA,iBAAA;ApCilJR;AoC9kJI;EACI,0BhC9FW;AJ8qJnB;AoC7kJI;EACI,iChC3HO;EgC4HP,mBAAA;EACA,oBAAA;ApC+kJR;AoC9kJQ;EACI,YAAA;ApCglJZ;AoC3kJQ;EACI,mBAAA;EACA,2CAAA;EACA,gChCjJa;AJ8tJzB;AoC1kJY;EACI,mBAAA;ApC4kJhB;AoC1kJY;EACI,mBAAA;ApC4kJhB;AoC1kJY;EACI,mBAAA;ApC4kJhB;AoCxkJQ;EACI,gBAAA;ApC0kJZ;AoCvkJY;EACI,mBAAA;ApCykJhB;AoCtkJY;EACI,mBAAA;ApCwkJhB;AoCrkJY;EACI,gChC5KS;EgC6KT,2CAAA;ApCukJhB;AoCjkJI;EACI,mChChLc;AJmvJtB;AoCjkJQ;EACI,eAAA;EACA,gChCxLa;EgCyLb,mBAAA;EACA,2CAAA;ApCmkJZ;AoChkJY;EACI,wCAAA;ApCkkJhB;AoChkJY;EACI,kDAAA;ApCkkJhB;AoChkJY;EACI,+CAAA;ApCkkJhB;AoC9jJQ;EACI,gChCzMa;EgC0Mb,eAAA;EACA,2CAAA;ApCgkJZ;AoC7jJQ;EACI,wCAAA;ApC+jJZ;AoC5jJQ;EACI,kDAAA;ApC8jJZ;AoC3jJQ;EACI,+CAAA;ApC6jJZ;AoCzjJI;EACI,mChCxNc;AJmxJtB;AoCzjJQ;EACI,gChC/Na;EgCgOb,mBAAA;EACA,2CAAA;ApC2jJZ;AoCvjJY;EACI,wCAAA;ApCyjJhB;AoCvjJY;EACI,kDAAA;ApCyjJhB;AoCvjJY;EACI,+CAAA;ApCyjJhB;AoCrjJQ;EACI,gChCjPa;EgCkPb,2CAAA;ApCujJZ;AoCpjJQ;EACI,wCAAA;ApCsjJZ;AoCnjJQ;EACI,kDAAA;ApCqjJZ;AoCljJQ;EACI,+CAAA;ApCojJZ;AoC9iJY;EACI,iBAAA;EACA,kBAAA;ApCgjJhB;AoC9iJgB;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBhChQL;AJgzJf;AoC5iJgB;EACI,iBAAA;ApC8iJpB;AoC3iJgB;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;ApC6iJpB;AoC1iJgB;EACI,sCAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBhCnRL;AJ+zJf;AoCxiJgB;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;ApC0iJpB;AoCriJQ;EACI,kDAAA;ApCuiJZ;AoCpiJQ;EACI,mDAAA;ApCsiJZ;AoCniJQ;EACI,4CAAA;ApCqiJZ;AoCliJQ;EACI,gDAAA;ApCoiJZ;AoChiJI;EACI,gBAAA;EACA,mBAAA;EACA,gChCnUiB;AJq2JzB;AoChiJQ;EACI,YAAA;EACA,uBAAA;ApCkiJZ;AoC9hJI;EACI,kBAAA;EACA,qBAAA;EACA,sBhC9TO;EgC+TP,gBAAA;EACA,eAAA;ApCgiJR;AoC9hJQ;EACI,aAAA;ApCgiJZ;AoC7hJQ;EACI,YAAA;ApC+hJZ;AoC3hJI;EACI,QAAA;ApC6hJR;AoC1hJI;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;ApC4hJR;AoC3hJQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;ApC6hJZ;AoC1hJQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gChChXa;AJ44JzB;AoCxhJgB;EACI,sBhCxWL;AJk4Jf;AoCphJI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;ApCshJR;AoCphJQ;EACI,eAAA;ApCshJZ;AoCnhJQ;EACI,4BhC1WS;AJ+3JrB;AoClhJQ;EACI,0BhCxWO;AJ43JnB;AoCjhJQ;EACI,0BhC5WO;EgC6WP,kBAAA;EACA,eAAA;ApCmhJZ;AoC9gJQ;EACI,oBAAA;ApCghJZ;AoC/gJY;EACI,4CAAA;ApCihJhB;;AoC3gJA;EACI,2CAAA;ApC8gJJ;;AoC3gJA;EACI,iCAAA;ApC8gJJ;;AoC3gJA;EACI,gBAAA;EACA,iBAAA;ApC8gJJ;;AoC1gJI;EACI,iCAAA;EACA,qBAAA;ApC6gJR;;AoClgJI;EACI,iCAAA;EACA,qBAAA;ApCygJR;AoCtgJI;EACI,iCAAA;EACA,qBAAA;ApCwgJR;;AoCngJA;EACI,4CAAA;ApCsgJJ;;AoCngJA;EACI,sCAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBhC/bW;AJq8Jf;;AqCt9JA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;EACA,SAAA;EACA,0BAAA;ArCy9JJ;AqCv9JI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;ArCy9JR;AqCt9JI;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,QAAA;ArCw9JR;AqCr9JI;EACI,oBAAA;ArCu9JR;AqCp9JI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;ArCs9JR;AqCn9JI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,iCjC5BO;EiC6BP,kBAAA;ArCq9JR;AqCn9JQ;EACI,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ArCq9JZ;AqCl9JQ;EACI,gCjClDa;EiCmDb,eAAA;EACA,gBAAA;ArCo9JZ;AqC/8JQ;EACI,4BAAA;ArCi9JZ;AqC78JI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,WAAA;ArC+8JR;;AsCrhKA;EACI,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;AtCwhKJ;AsCthKI;EACI,YAAA;AtCwhKR;AsCthKQ;EACI,YAAA;EACA,eAAA;EACA,0BlCwBO;EkCvBP,cAAA;EACA,gBAAA;EACA,cAAA;AtCwhKZ;AsCphKI;EACI,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,gClCtBiB;AJ4iKzB;AsCnhKI;EACI,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,gClC7BiB;AJkjKzB;;AsCjhKA;EACI,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;AtCohKJ;AsClhKI;EACI,YAAA;EACA,sCAAA;EACA,cAAA;AtCohKR;AsCjhKI;EACI,eAAA;EACA,gBAAA;EACA,gClCjDiB;AJokKzB;AsChhKI;EACI,iBAAA;AtCkhKR;AsC/gKI;EACI,kBAAA;AtCihKR;AsC9gKI;EACI,eAAA;EACA,gBAAA;EACA,gClC/DiB;AJ+kKzB;AsC7gKI;EACI,eAAA;EACA,6BlChEc;EkCiEd,iBAAA;AtC+gKR;AsC5gKI;EACI,gBAAA;AtC8gKR;AsC3gKI;EACI,mBAAA;EACA,6BlC1Ec;AJulKtB;;AuC7lKA;EACI,gCAAA;AvCgmKJ;AuC9lKI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gCnCNiB;EmCOjB,0BAAA;EACA,mCAAA;EACA,mCnCeS;AJilKjB;AuC9lKQ;EACI,gCAAA;EACA,mBAAA;EACA,gBAAA;AvCgmKZ;AuC7lKQ;EACI,eAAA;AvC+lKZ;AuC5lKQ;EACI,wCAAA;AvC8lKZ;AuC3lKQ;EACI,wCAAA;AvC6lKZ;AuC5lKY;EACI,wCAAA;AvC8lKhB;AuC1lKQ;EACI,iCnCtBG;AJknKf;AuCzlKQ;EACI,6BnCjCU;EmCkCV,wBnC9BA;AJynKZ;AuCzlKY;EACI,iCnC9BD;AJynKf;AuCvlKQ;EACI,iCnCpCG;EmCqCH,sBnCjCG;EmCkCH,iDAAA;EACA,mBAAA;AvCylKZ;AuCplKQ;EACI,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;AvCslKZ;AuCplKY;EACI,iCnClDD;AJwoKf;AuCnlKY;EACI,6BnC7DM;EmC8DN,2BnCvDD;AJ4oKf;AuCnlKgB;EACI,iCnC1DL;AJ+oKf;;AwC3pKA;EACI,gCAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AxC8pKJ;AwC7pKI;EACI,wBpCCI;EoCAJ,mCAAA;EACA,gCpCTiB;AJwqKzB;AwC9pKQ;EACI,YAAA;EACA,aAAA;EACA,6CAAA;AxCgqKZ;AwC9pKQ;EACI,mBpCRA;AJwqKZ;AwC7pKI;EACI,2BpCHO;EoCIP,mBpCbI;AJ4qKZ;AwC9pKQ;EACI,YAAA;EACA,aAAA;EACA,6CAAA;AxCgqKZ;AwC9pKQ;EACI,sBpCXG;AJ2qKf;AwC3pKA;EACI,6BAAA;AxC6pKJ;AwC3pKA;EACI,0BAAA;AxC6pKJ;AwC3pKA;EACI,2BAAA;AxC6pKJ;AwC3pKA;EACI,4BAAA;AxC6pKJ;;AyC1sKA;EACI,gBAAA;EACA,WAAA;AzC6sKJ;AyC3sKI;EACI,mBAAA;EACA,gBAAA;EACA,gCrCLiB;EqCMjB,gCAAA;AzC6sKR;AyCzsKI;EACI,eAAA;AzC2sKR;AyCtsKY;EACI,gBAAA;EACA,gBAAA;AzCwsKhB;AyCnsKY;EACI,iBAAA;EACA,gBAAA;AzCqsKhB;AyChsKY;EACI,kBAAA;EACA,gBAAA;AzCksKhB;AyC7rKY;EACI,wCAAA;AzC+rKhB;AyC3rKQ;EACI,gBAAA;EACA,kCAAA;AzC6rKZ;AyC3rKY;EACI,iCrCpCD;AJiuKf;AyC1rKY;EACI,iCrCvCD;AJmuKf;AyCzrKY;EACI,wCAAA;EACA,8BrChDJ;AJ2uKZ;AyCxrKY;EACI,aAAA;EACA,8CrC1CY;EqC2CZ,6CAAA;EACA,gCrC/DS;AJyvKzB;AyCvrKY;EACI,mBAAA;EACA,8BrC5DJ;EqC6DI,YAAA;EACA,oBAAA;AzCyrKhB;AyCtrKY;EACI,gCrC1ES;AJkwKzB;AyCrrKY;EACI,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AzCurKhB;AyCrrKgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AzCurKpB;AyCprKgB;EACI,eAAA;AzCsrKpB;;AyC/qKA;EACI,eAAA;EACA,qBAAA;EACA,gCrCpGqB;EqCqGrB,gBAAA;AzCkrKJ;;A0CzxKA;EACI,kBAAA;EACA,wBtCQQ;EsCPR,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;A1C4xKJ;A0C1xKI;EACI,eAAA;EACA,gBAAA;A1C4xKR;;A0CxxKA;EACI,2BtCDW;EsCEX,gCtCdqB;EsCerB,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1C2xKJ;A0CzxKI;EACI,2BtCXO;AJsyKf;A0CxxKI;EACI,iBAAA;EACA,eAAA;A1C0xKR;;A0CtxKA;EACI,sCAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;A1CyxKJ;;A0CpxKI;EACI,kBAAA;A1CuxKR;A0CpxKI;EACI,UAAA;A1CsxKR;A0CpxKQ;EACI,kBAAA;A1CsxKZ;A0CnxKQ;EACI,iCtC1CG;EsC2CH,kBAAA;A1CqxKZ;A0ClxKQ;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;A1CoxKZ;A0CjxKQ;EACI,aAAA;A1CmxKZ;A0ChxKQ;EACI,iBAAA;A1CkxKZ;A0C/wKQ;EACI,UAAA;A1CixKZ;A0C7wKI;EACI,UAAA;A1C+wKR;A0C7wKQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;A1C+wKZ;A0C5wKgB;EACI,gBAAA;EACA,mBAAA;EACA,gCtC7FK;AJ22KzB;A0CxwKoB;EACI,gBAAA;EACA,eAAA;A1C0wKxB;A0CrwKY;EACI,iCAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,8BtCvGJ;AJ82KZ;A0ClwKI;EACI,aAAA;EACA,sBAAA;A1CowKR;A0CjwKY;EACI,aAAA;A1CmwKhB;A0ChwKY;EACI,iBAAA;A1CkwKhB;A0C9vKQ;EACI,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,gBAAA;A1CgwKZ;A0C7vKgB;EACI,gBAAA;A1C+vKpB;A0C5vKgB;EACI,gBAAA;A1C8vKpB;A0CzvKQ;EACI,iCtCzIG;EsC0IH,kBAAA;A1C2vKZ;A0CxvKQ;EACI,gBAAA;A1C0vKZ;A0CxvKY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,kBAAA;EACA,kBAAA;A1C0vKhB;A0CxvKgB;EACI,4BtC1IC;EsC2ID,eAAA;A1C0vKpB;A0CvvKgB;EACI,uCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,8BtCxKR;EsCyKQ,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;A1CyvKpB;A0CvvKoB;EACI,kBAAA;A1CyvKxB;A0ChvKY;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBtC9LJ;EsC+LI,gCAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;A1CkvKhB;A0ChvKgB;EACI,wCAAA;A1CkvKpB;A0C/uKgB;EACI,+BtCjNK;EsCkNL,gBAAA;EACA,gCAAA;A1CivKpB;A0C9uKgB;EACI,6BtCnNE;EsCoNF,YAAA;A1CgvKpB;A0C9uKoB;EACI,2BtCtNJ;AJs8KpB;A0C7uKoB;EACI,gCAAA;EACA,kBtCxNZ;AJu8KZ;A0C3uKgB;EACI,uCAAA;EACA,mBtC9NR;AJ28KZ;A0CvuKQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,sBtClOG;AJ28Kf;A0CvuKY;EACI,gCtCpPS;AJ69KzB;A0CruKY;EACI,gCtCzPS;AJg+KzB;A0CnuKQ;EACI,kBAAA;EACA,sBtC/OG;EsCgPH,gBAAA;EACA,4BAAA;EACA,gBAAA;EACA,oBAAA;EACA,gCAAA;A1CquKZ;A0CjuKI;EACI,6BtC5PO;EsC6PP,mBAAA;A1CmuKR;A0C/tKQ;EACI,gBAAA;A1CiuKZ;A0C5tKQ;EACI,iBAAA;A1C8tKZ;;A2Cr/KA,gBAAA;AACA;EACE,mBAAA;EACA,mBAAA;EACA,8CAAA;EAGA,2CAAA;EACA,0BAAA;EACA,kCAAA;EACA,wCAAA;EAEA,0CAAA;EACA,oCAAA;EACA,6BAAA;EACA,gCAAA;EACA,uCAAA;EACA,kDAAA;EACA,gCAAA;EACA,kCAAA;EAEA,+BAAA;EACA,+BAAA;EACA,yBAAA;EACA,2BAAA;EACA,iCAAA;EACA,0CAAA;EAEA,4BAAA;EACA,wBAAA;EACA,yBAAA;EAEA,mBAAA;EAEA,8BAAA;EACA,mCAAA;EACA,6BAAA;EAEA,0CAAA;EACA,qCAAA;EACA,+BAAA;EACA,qCAAA;EACA,iCAAA;EACA,0BAAA;EACA,uCAAA;EACA,kCAAA;EACA,oCAAA;EACA,0CAAA;EACA,mCAAA;EACA,8CAAA;EACA,6BAAA;EAEA,qCAAA;EACA,8BAAA;EACA,8BAAA;EACA,iCAAA;EACA,uCAAA;EACA,uCAAA;EACA,+BAAA;EACA,yCAAA;EACA,kDAAA;EACA,oDAAA;EACA,oCAAA;EACA,mCAAA;EACA,oCAAA;EACA,oCAAA;A3Cg/KF;A2ChjLA;AAAA;EAkDE,gCAAA;A3C8/KF;AAAA;;A4CjjLA,eAAA;AACA;EACI,wBAAA;EACA,kBAAA;EACA,6CAAA;EACA,oCAAA;EACA,6CAAA;EAEA,gCAAA;EACA,0BAAA;EACA,kCAAA;EACA,8BAAA;EACA,iCAAA;EACA,wCAAA;EAEA,0CAAA;EACA,oCAAA;EAEA,kCAAA;EACA,6BAAA;EACA,mCAAA;EACA,uCAAA;EACA,kDAAA;EACA,gCAAA;EAEA,kCAAA;EACA,+BAAA;EACA,mCAAA;EACA,4CAAA;EACA,4BAAA;EACA,iCAAA;EACA,wBAAA;EACA,mCAAA;EACA,oCAAA;EACA,0CAAA;EACA,gCAAA;EACA,0BAAA;EAGA,oCAAA;EACA,4BAAA;EACA,wBAAA;EACA,yBAAA;EACA,gCAAA;EACA,sCAAA;EAEA,0CAAA;EACA,qCAAA;EACA,qCAAA;EACA,+BAAA;EACA,sBAAA;EACA,8BAAA;EAEA,iCAAA;EAEA,qCAAA;EACA,uCAAA;EACA,uBAAA;EACA,oCAAA;EACA,kCAAA;EACA,8BAAA;EACA,uCAAA;EACA,sCAAA;EACA,6BAAA;EAEA,8CAAA;EACA,0BAAA;EACA,kBAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,oCAAA;EACA,uCAAA;EACA,uCAAA;EACA,kCAAA;EACA,yCAAA;EACA,uCAAA;EACA,oDAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,iCAAA;A5C0iLJ;;AA/lLA;EACE,uBAAA;EACA,4CAAA;EACA,qBAAA;EACA,qPAAA;EAQA,yBAAA;EACA,gBAAA;EACA,kBAAA;AA2lLF;AAxlLA;EACE,uBAAA;EACA,4CAAA;EACA,qBAAA;EACA,qPAAA;EAQA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAmlLF;AAhlLA;EACE,uBAAA;EACA,6CAAA;EACA,qBAAA;EACA,yPAAA;EAQA,yBAAA;EACA,gBAAA;EACA,kBAAA;AA2kLF;AAxkLA;EACE,uBAAA;EACA,6CAAA;EACA,qBAAA;EACA,yPAAA;EAQA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAmkLF;AA9jLA;;EAEE,YAAA;EACA,gCALU;EAMV,gBAAA;EACA,SAAA;EACA,eAAA;AAgkLF;;AA7jLA;EACE,kBAAA;AAgkLF;;AA7jLA;EACE,cAAA;EACA,oBAAA;AAgkLF;;AA7jLA;;;EAGE,sBAAA;AAgkLF;;AA7jLA;EACE;IACE,4CAAA;EAgkLF;AACF;AA7jLA;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AA+jLF;;AA5jLA;EACE,cAAA;AA+jLF;;AA5jLA;EACE;IACE,uBAAA;EA+jLF;EA5jLA;IACE,yBAAA;EA8jLF;AACF;AA3jLA;EACE,uBAAA;EACA,eAAA;EACA,0BAAA;AA6jLF;;AA1jLA;EACE,cAAA;EACA,kBAAA;AA6jLF;;AA1jLA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;AA6jLF;;AA3jLA;EACE,6BAAA;AA8jLF;;AA5jLA;EACE,qBAAA;AA+jLF;;AA1jLI;EACE,wBAAA;AA6jLN","sourcesContent":["/* @import url(\"./assets/styles/bootstrap.min.css\"); */\n@import url(\"./assets/styles/myapps.scss\");\n@import url(\"./assets/styles/home.scss\");\n@import url(\"./assets/styles/services.scss\");\n@import url(\"./assets/styles/extended_solutions.scss\");\n@import url(\"./assets/styles/add_application.scss\");\n@import url(\"./assets/styles/carousel.scss\");\n@import url(\"./assets/styles/activitylog.scss\");\n@import url(\"./assets/styles/session_control.scss\");\n@import url(\"./assets/styles/role_definition.scss\");\n@import url(\"./assets/styles/new_role.scss\");\n@import url(\"./assets/styles/user_mapping.scss\");\n@import url(\"./assets/styles/assign_role.scss\");\n@import url(\"./assets/styles/intro.scss\");\n@import url(\"./assets/styles/application_registration.scss\");\n@import url(\"./assets/styles/banner_image.scss\");\n@import url(\"./assets/styles/common.scss\");\n@import url(\"./assets/styles/contact_abb.scss\");\n@import url(\"./assets/styles/new_uesr_request.scss\");\n@import url(\"./assets/styles/casecreationform.scss\");\n@import url(\"./assets/styles/import_export.scss\");\n@import url(\"./assets/variables/fonts.scss\");\n@import \"@abb/abb-arcadia-ui-react/default-theme/index.scss\";\n@import \"./assets/fonts/Abb_Dias_font/style.css\";\n@import \"./assets/styles/light-theme.scss\";\n@import \"./assets/styles/dark-theme.scss\";\n@import url(\"./assets/styles/my_learing.scss\");\n\n@font-face {\n  font-family: \"ABBVoice\";\n  src: url(\"./assets/fonts/ABBVoice/ABBvoice_W_Rg.eot\");\n  /* IE9 Compat Modes */\n  src: url(\"./assets/fonts/ABBVoice/ABBvoice_W_Rg.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    /* IE6-IE8 */ url(\"./assets/fonts/ABBVoice/ABBvoice_W_Rg.woff2\")\n      format(\"woff2\"),\n    /* Super Modern Browsers */\n      url(\"./assets/fonts/ABBVoice/ABBvoice_W_Rg.woff\") format(\"woff\"),\n    /* Pretty Modern Browsers */\n      url(\"./assets/fonts/ABBVoice/ABBvoice_W_Rg.ttf\") format(\"truetype\");\n  /* Safari, Android, iOS */\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"ABBVoice\";\n  src: url(\"./assets/fonts/ABBVoice/ABBvoice_W_Md.eot\");\n  /* IE9 Compat Modes */\n  src: url(\"./assets/fonts/ABBVoice/ABBvoice_W_Md.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    /* IE6-IE8 */ url(\"./assets/fonts/ABBVoice/ABBvoice_W_Md.woff2\")\n      format(\"woff2\"),\n    /* Super Modern Browsers */\n      url(\"./assets/fonts/ABBVoice/ABBvoice_W_Md.woff\") format(\"woff\"),\n    /* Pretty Modern Browsers */\n      url(\"./assets/fonts/ABBVoice/ABBvoice_W_Md.ttf\") format(\"truetype\");\n  /* Safari, Android, iOS */\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"ABBVoice\";\n  src: url(\"./assets/fonts/ABBVoice/ABBvoice_W_Lt.eot\");\n  /* IE9 Compat Modes */\n  src: url(\"./assets/fonts/ABBVoice/ABBvoice_W_Lt.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    /* IE6-IE8 */ url(\"./assets/fonts/ABBVoice/ABBvoice_W_Lt.woff2\")\n      format(\"woff2\"),\n    /* Super Modern Browsers */\n      url(\"./assets/fonts/ABBVoice/ABBvoice_W_Lt.woff\") format(\"woff\"),\n    /* Pretty Modern Browsers */\n      url(\"./assets/fonts/ABBVoice/ABBvoice_W_Lt.ttf\") format(\"truetype\");\n  /* Safari, Android, iOS */\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"ABBVoice\";\n  src: url(\"./assets/fonts/ABBVoice/ABBvoice_W_Bd.eot\");\n  /* IE9 Compat Modes */\n  src: url(\"./assets/fonts/ABBVoice/ABBvoice_W_Bd.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    /* IE6-IE8 */ url(\"./assets/fonts/ABBVoice/ABBvoice_W_Bd.woff2\")\n      format(\"woff2\"),\n    /* Super Modern Browsers */\n      url(\"./assets/fonts/ABBVoice/ABBvoice_W_Bd.woff\") format(\"woff\"),\n    /* Pretty Modern Browsers */\n      url(\"./assets/fonts/ABBVoice/ABBvoice_W_Bd.ttf\") format(\"truetype\");\n  /* Safari, Android, iOS */\n  font-weight: 700;\n  font-style: normal;\n}\n\n$base-font: \"ABBVoice\", Verdana;\n\nhtml,\nbody {\n  height: 100%;\n  font-family: $base-font;\n  font-weight: 400;\n  margin: 0;\n  font-size: 12px;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n*,\n::after,\n::before {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.asterisk {\n  color: rgb(217, 83, 79);\n  font-size: 18px;\n  font-family: ABBVoice-bold;\n}\n\n.new-role-alert-fail-forbidden {\n  color: #ff000f;\n  text-align: center;\n}\n\n.user-permission-message {\n  color: #ff000f;\n  text-align: center;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 20px;\n}\n.app-list-container .app-list-content .app_list .app_box {\n  width: min-content !important;\n}\n.main-container > .content-container {\n  padding: 0 !important;\n  //background-color: var(--main-background-color)!important;\n}\n.iframe-wrapper {\n  iframe {\n    &::-webkit-scrollbar {\n      display: none !important;\n    }\n  }\n}","html[data-theme=\"light\"] {\r\n    --text-primary-color: #1F1F1F;\r\n    --text-secondary-color: #696969;\r\n    --text-blue-color: #3366FF;\r\n    --red: #FF000F;\r\n    --primary-default: #3366FF;\r\n    --primary-hover: #4D85FF;\r\n    --primary-active: #2934FF;\r\n    --primary-disabled: #9CBDF7;\r\n    --white: #FFFFFF;\r\n    --grey-100: #FAFAFA;\r\n    --grey-200: #F5F5F5;\r\n    --grey-300: #EBEBEB;\r\n    --grey-400: #DBDBDB;\r\n    --grey-500: #BABABA;\r\n    --grey-600: #9F9F9F;\r\n    --grey-700: #868686;\r\n    --grey-800: #696969;\r\n    --grey-900: #333333;\r\n    --left-pane: #FAFAFA;\r\n    --accordion-expanded-bg: #DEE6FF;\r\n    --accordion-border: #3366ff70;\r\n    --card-bg: #FFFFFF;\r\n    --card-hover:  #DEE6FF70;\r\n    --toolbar-bg: #F5F5F5;\r\n    --segmented-control-hover: #EBEBEB;\r\n    --icon-hover: #F5F5F5;\r\n    --shadow-blue: #3366FF8F;\r\n    --shadow-grey-100: #BABABA4F;\r\n    --shadow-grey-200: #00000029;\r\n    --status-success: #21A67A;\r\n    --status-success-hover: #218C69;\r\n    --status-success-transparent: #EDF8F4;\r\n    --status-warning: #FFA200;\r\n    --status-warning-hover: #D58906;\r\n    --status-warning-transparent: #FFF8EB;\r\n    --status-error: #EF3934;\r\n    --status-error-hover: #C73430;\r\n    --status-error-transparent: #FEEFEF;\r\n    --status-info: #0052FF;\r\n    --status-info-hover: #0648D5;\r\n    --status-info-transparent: #EAEFFF;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] {\r\n  --text-primary-color: #FFFFFF;\r\n  --text-secondary-color: #DBDBDB;\r\n  --text-blue-color: #7DA7FF;\r\n  --red: #FF000F;\r\n  --primary-default: #7DA7FF;\r\n  --primary-hover: #ADC7FD;\r\n  --primary-active: #4580FF;\r\n  --primary-disabled: #4C5463;\r\n  --white: #1F1F1F;\r\n  --grey-100: #333333;\r\n  --grey-200: #0F0F0F;\r\n  --grey-300: #0F0F0F;\r\n  --grey-400: #696969;\r\n  --grey-500: #707070;\r\n  --grey-600: #DBDBDB;\r\n  --grey-700: #DCDCDC;\r\n  --grey-800: #DBDBDB;\r\n  --grey-900: #FAFAFA;\r\n  --left-pane: #333333;\r\n  --accordion-expanded-bg: #4C5463;\r\n  --accordion-border: #4580FFCC;\r\n  --card-bg: #333333;\r\n  --card-hover: #4C5463;\r\n  --toolbar-bg: #333333;\r\n  --icon-hover: #696969;\r\n  --segmented-control-hover: #333333;\r\n  --shadow-blue: #7EA8FB8F;\r\n  --shadow-grey-100: #8686864F;\r\n  --shadow-grey-200: #00000011;\r\n  --status-success: #4DB895;\r\n  --status-success-hover: #3EA483;\r\n  --status-success-transparent: #1D2D1E;\r\n  --status-warning: #FFB533;\r\n  --status-warning-hover: #E9A225;\r\n  --status-warning-transparent: #352122;\r\n  --status-error: #F2615D;\r\n  --status-error-hover: #DC514D;\r\n  --status-error-transparent: #300C0A;\r\n  --status-info: #7DA7FF;\r\n  --status-info-hover: #7BA1F1;\r\n  --status-info-transparent: #222635;\r\n}","html,\r\nbody,\r\ndiv,\r\nspan,\r\napplet,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\na,\r\nabbr,\r\nacronym,\r\naddress,\r\nbig,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nem,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\ns,\r\nsamp,\r\nsmall,\r\nstrike,\r\nstrong,\r\nsub,\r\nsup,\r\ntt,\r\nvar,\r\nb,\r\nu,\r\ni,\r\ncenter,\r\ndl,\r\ndt,\r\ndd,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd,\r\narticle,\r\naside,\r\ncanvas,\r\ndetails,\r\nembed,\r\nfigure,\r\nfigcaption,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\noutput,\r\nruby,\r\nsection,\r\nsummary,\r\ntime,\r\nmark,\r\naudio,\r\nvideo {\r\n    margin: 0;\r\n    padding: 0;\r\n    border: 0;\r\n    font: inherit 100%;\r\n    vertical-align: baseline;\r\n}\r\n\r\ntable, th {\r\n  border-right: 0 !important;\r\n}\r\n\r\n// HTML5 display-role reset for older browsers\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection {\r\n    display: block;\r\n}\r\n\r\nbody {\r\n    line-height: 1;\r\n}\r\n\r\nol,\r\nul {\r\n    list-style: none;\r\n}\r\n\r\nblockquote,\r\nq {\r\n    quotes: none;\r\n}\r\n\r\nblockquote:before,\r\nblockquote:after,\r\nq:before,\r\nq:after {\r\n    content: \"\";\r\n    content: none;\r\n}\r\n\r\ntable {\r\n    // border-collapse: collapse;\r\n    border-spacing: 0;\r\n}\r\n\r\n// reset css\r\n.clearfix::after {\r\n    content: \"\";\r\n    clear: both;\r\n    display: table;\r\n}\r\n\r\n* {\r\n    box-sizing: border-box;\r\n\r\n}\r\n\r\nhtml,\r\nbody {\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.icon_abb_16 {\r\n    font-size: 1rem;\r\n}\r\n\r\n.icon_abb_24 {\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.icon_abb_32 {\r\n    font-size: 2rem;\r\n}",".accordion-wrapper {\r\n    .MuiPaper-root {\r\n        min-width: 650px;\r\n        width: 100%;\r\n\r\n        &.MuiAccordion-root {\r\n            margin: 8px 0px 0px 0px;\r\n            background-color: transparent;\r\n            color: $abb-text-primary-color;\r\n            box-shadow: none;\r\n\r\n            .MuiAccordionSummary-root {\r\n                background-color: $abb-grey-400;\r\n                padding: 0 20px;\r\n\r\n                & .open-close-icons {\r\n                    margin-right: 10px;\r\n                    transform: rotate(0deg);\r\n                    transition-duration: 300ms;\r\n\r\n                    &+div {\r\n                        width: 60%;\r\n                    }\r\n                }\r\n\r\n                &.Mui-expanded {\r\n                    & .open-close-icons {\r\n                        transform: rotate(90deg);\r\n                        transition-duration: 300ms;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .MuiAccordionDetails-root {\r\n                margin-top: 8px;\r\n                color: $abb-text-primary-color;\r\n                font-weight: 400;\r\n                font-size: 1rem;\r\n                background-color: $abb-white;\r\n                border: 1px solid $abb-grey-400;\r\n                padding: 20px;\r\n                border-radius: 4px;\r\n            }\r\n\r\n            &.Mui-expanded {\r\n                margin: 8px 0px;\r\n            }\r\n\r\n            .MuiButtonBase-root {\r\n                color: $abb-text-primary-color;\r\n                font-weight: 400;\r\n                font-size: 1rem;\r\n\r\n                &.MuiAccordionSummary-root {\r\n                    min-height: 40px;\r\n                    border-radius: 4px;\r\n                    height: 40px;\r\n                    border: 1px solid transparent;\r\n\r\n                    .MuiAccordionSummary-content {\r\n                        display: flex;\r\n                        flex-direction: row;\r\n                        justify-content: space-between;\r\n\r\n                        .first-part {\r\n                            display: flex;\r\n                            flex-direction: row;\r\n                            align-items: center;\r\n                        }\r\n\r\n                        .second-part {\r\n                            display: flex;\r\n                            flex-direction: row;\r\n                            align-items: center;\r\n                        }\r\n                    }\r\n\r\n                    .label {\r\n                        margin-right: 8px;\r\n                        text-wrap: nowrap;\r\n                    }\r\n\r\n                    &:hover {\r\n                        background-color: $abb-accordion-expanded-bg;\r\n                        border: 1px solid $abb-accordion-border;\r\n                    }\r\n\r\n                    &.Mui-expanded {\r\n                        background-color: $abb-accordion-expanded-bg;\r\n                        border: 1px solid $abb-accordion-border;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.accordion-wrapper {\r\n    min-width: 650px;\r\n    margin: 8px auto;\r\n\r\n    .expand-collapse-all {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-end;\r\n        margin-bottom: 8px;\r\n\r\n        .link {\r\n            font-size: .875rem;\r\n            cursor: pointer;\r\n            color: $abb-primary-default;\r\n\r\n            & svg {\r\n                font-size: inherit;\r\n            }\r\n\r\n            &:hover {\r\n                text-decoration: underline;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.edit-field-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    & p {\r\n        width: auto !important;\r\n        margin-right: 8px;\r\n    }\r\n\r\n    .MuiOutlinedInput-root {\r\n        background-color: $abb-white;\r\n\r\n        .MuiOutlinedInput-input {\r\n            height: 1.5rem;\r\n            padding: 4px 8px;\r\n            font-size: 0.875rem;\r\n            color: $abb-text-primary-color;\r\n            border-radius: 4px;\r\n            max-width: 120px;\r\n        }\r\n    }\r\n}","@import '../core-scss/base/theme';\r\n\r\n$abb-text-primary-color: var(--text-primary-color);\r\n$abb-text-secondary-color: var(--text-secondary-color);\r\n$abb-text-blue-color: var(--text-blue-color);\r\n$abb-red: var(--red);\r\n$abb-primary-default: var(--primary-default);\r\n$abb-primary-hover: var(--primary-hover);\r\n$abb-primary-active: var(--primary-active);\r\n$abb-primary-disabled: var(--primary-disabled);\r\n$abb-white: var(--white);\r\n$abb-grey-100: var(--grey-100);\r\n$abb-grey-200: var(--grey-200);\r\n$abb-grey-300: var(--grey-300);\r\n$abb-grey-400: var(--grey-400);\r\n$abb-grey-500: var(--grey-500);\r\n$abb-grey-600: var(--grey-600);\r\n$abb-grey-700: var(--grey-700);\r\n$abb-grey-800: var(--grey-800);\r\n$abb-grey-900: var(--grey-900);\r\n$abb-left-pane: var(--left-pane);\r\n$abb-accordion-expanded-bg: var(--accordion-expanded-bg);\r\n$abb-accordion-border: var(--accordion-border);\r\n$abb-card-bg: var(--card-bg);\r\n$abb-card-hover: var(--card-hover);\r\n$abb-segmented-control-hover: var(--segmented-control-hover);\r\n$abb-toolbar-bg: var(--toolbar-bg);\r\n$abb-icon-hover: var(--icon-hover);\r\n$abb-shadow-blue: var(--shadow-blue);\r\n$abb-shadow-grey-100: var(--shadow-grey-100);\r\n$abb-shadow-grey-200: var(--shadow-grey-200);\r\n$abb-status-success: var(--status-success);\r\n$abb-status-success-hover: var(--status-success-hover);\r\n$abb-status-success-transparent: var(--status-success-transparent);\r\n$abb-status-warning: var(--status-warning);\r\n$abb-status-warning-hover: var(--status-warning-hover);\r\n$abb-status-warning-transparent: var(--status-warning-transparent);\r\n$abb-status-error: var(--status-error);\r\n$abb-status-error-hover: var(--status-error-hover);\r\n$abb-status-error-transparent: var(--status-error-transparent);\r\n$abb-status-info: var(--status-info);\r\n$abb-status-info-hover: var(--status-info-hover);\r\n$abb-status-info-transparent: var(--status-info-transparent);\r\n$abb-size-2: 0.125rem;\r\n$abb-size-4: 0.25rem;\r\n$abb-size-8: 0.5rem;\r\n$abb-size-10: 0.625rem;\r\n$abb-size-12: 0.75rem;\r\n$abb-size-14: 0.875rem;\r\n$abb-size-16: 1rem;\r\n$abb-size-18: 1.125rem;\r\n$abb-size-20: 1.25rem;\r\n$abb-size-24: 1.5rem;\r\n$abb-size-28: 1.75rem;\r\n$abb-size-30: 1.875rem;\r\n$abb-size-32: 2rem;\r\n$abb-size-40: 2.5rem;\r\n$abb-size-48: 3rem;\r\n$abb-size-56: 3.5rem;\r\n$abb-size-64: 4rem;\r\n$abb-size-72: 4.5rem;\r\n$abb-typography-font-family: 'ABBVoice', Verdana;\r\n$abb-typography-font-size-12: 0.75rem;\r\n$abb-typography-font-size-14: 0.875rem;\r\n$abb-typography-font-size-16: 1rem;\r\n$abb-typography-font-size-18: 1.125rem;\r\n$abb-typography-font-size-21: 1.3125rem;\r\n$abb-typography-font-size-24: 1.5rem;\r\n$abb-typography-font-size-32: 2rem;\r\n$abb-typography-font-size-40: 2.5rem;\r\n$abb-typography-font-size-42: 2.625rem;\r\n$abb-typography-font-size-48: 3rem;\r\n$abb-typography-font-weight-300: 300;\r\n$abb-typography-font-weight-400: 400;\r\n$abb-typography-font-weight-500: 500;\r\n$abb-typography-font-weight-700: 700;\r\n\r\n",".avatar {\r\n    color: $abb-text-primary-color ;\r\n    border-radius: 50%;\r\n    font-weight: 500;\r\n    line-height: 2.54rem;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border: 2px solid transparent;\r\n\r\n    &.initials{\r\n        background-color: $abb-grey-400;\r\n    }\r\n\r\n    .size-128 {\r\n        width: 8rem;\r\n        height: 8rem;\r\n        font-size: 3rem;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .size-68 {\r\n        width: 4.25rem;\r\n        height: 4.25rem;\r\n        font-size: 1.5rem;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .size-48 {\r\n        width: 3rem;\r\n        height: 3rem;\r\n        font-size: 1.125rem;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .size-40 {\r\n        width: 2.5rem;\r\n        height: 2.5rem;\r\n        font-size: 0.875rem;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .size-32 {\r\n        width: 2rem;\r\n        height: 2rem;\r\n        font-size: 0.875rem;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .size-24 {\r\n        width: 1.5rem;\r\n        height: 1.5rem;\r\n        font-size: 0.75rem;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    &.size-128 {\r\n        width: 8rem;\r\n        height: 8rem;\r\n        font-size: 3rem;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    &.size-68 {\r\n        width: 4.25rem;\r\n        height: 4.25rem;\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    &.size-48 {\r\n        width: 3rem;\r\n        height: 3rem;\r\n        font-size: 1.125rem;\r\n    }\r\n\r\n    &.size-40 {\r\n        width: 2.5rem;\r\n        height: 2.5rem;\r\n        font-size: 0.875rem;\r\n    }\r\n\r\n    &.size-32 {\r\n        width: 2rem;\r\n        height: 2rem;\r\n        font-size: 0.875rem;\r\n    }\r\n\r\n    &.size-24 {\r\n        width: 1.5rem;\r\n        height: 1.5rem;\r\n        font-size: 0.75rem;\r\n    }\r\n\r\n    &.white-border{\r\n        border: 2px solid $abb-white;\r\n    }\r\n\r\n    &:hover {\r\n        color: $abb-text-primary-color ;\r\n        border-radius: 50%;\r\n        cursor: pointer;\r\n        border: 2px solid $abb-grey-600;\r\n    }\r\n\r\n\r\n    &:focus-visible {\r\n        outline-offset: 1px;\r\n        outline: 2px solid $abb-primary-active;\r\n    }\r\n\r\n    &.disabled {\r\n        color: $abb-grey-600 ;\r\n        opacity: 0.7;\r\n        border-radius: 50%;\r\n        cursor: not-allowed;\r\n        border: none;\r\n\r\n        &:focus-visible {\r\n            outline: none;\r\n        }\r\n    }\r\n}\r\n\r\n.avatar-group{\r\n    display: flex;\r\n    flex-direction: row;\r\n}",".badge {\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    box-sizing: border-box;\r\n    align-items: center;\r\n    display: inline-flex;\r\n    gap: 4px;\r\n\r\n    &.mt-4{\r\n        margin-top: 4px;\r\n    }\r\n\r\n    &.primary {\r\n        background-color: $abb-status-info;\r\n        color: $abb-white;\r\n\r\n        &.outlined-square-badge {\r\n            border: 1px solid $abb-status-info;\r\n            color: $abb-status-info;\r\n            background-color: $abb-white;\r\n        }\r\n\r\n        &.filled-square-badge {\r\n            border: 1px solid $abb-status-info;\r\n            color: $abb-status-info;\r\n            background: $abb-status-info-transparent;\r\n        }\r\n\r\n        &.without-bg{\r\n            background-color: transparent;\r\n            color: $abb-text-primary-color;\r\n            border: none;\r\n            .leading-icon{\r\n                font-size: 0.75rem;\r\n                margin-top: 2px;\r\n                color: $abb-status-info;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.secondary {\r\n        border: 1px solid $abb-grey-500;\r\n        color: $abb-text-primary-color;\r\n        background-color: $abb-grey-400;\r\n\r\n        &.outlined-square-badge {\r\n            border: 1px solid $abb-grey-500;\r\n            color: $abb-text-primary-color;\r\n            background-color: $abb-white;\r\n        }\r\n\r\n        &.filled-square-badge {\r\n            border: 1px solid $abb-grey-500;\r\n            color: $abb-text-primary-color;\r\n            background: $abb-grey-400;\r\n            .leading-icon{\r\n                color: $abb-grey-600;\r\n            }\r\n        }\r\n        &.without-bg{\r\n            background-color: transparent;\r\n            color: $abb-text-primary-color;\r\n            border: none;\r\n            .leading-icon{\r\n                color: $abb-grey-600;\r\n                font-size: 0.75rem;\r\n                margin-top: 2px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.positive {\r\n        background-color: $abb-status-success;\r\n        color: $abb-white;\r\n\r\n        &.outlined-square-badge {\r\n            border: 1px solid $abb-status-success;\r\n            color: $abb-status-success;\r\n            background-color: $abb-white;\r\n        }\r\n\r\n        &.filled-square-badge {\r\n            border: 1px solid $abb-status-success;\r\n            color: $abb-status-success;\r\n            background: $abb-status-success-transparent;\r\n        }\r\n        &.without-bg{\r\n            background-color: transparent;\r\n            color: $abb-text-primary-color;\r\n            border: none;\r\n            .leading-icon{\r\n                color: $abb-status-success;\r\n                font-size: 0.75rem;\r\n                margin-top: 2px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.warning {\r\n        background-color: $abb-status-warning;\r\n        color: $abb-white;\r\n\r\n        &.outlined-square-badge {\r\n            border: 1px solid $abb-status-warning;\r\n            color: $abb-status-warning;\r\n            background-color: $abb-white;\r\n        }\r\n\r\n        &.filled-square-badge {\r\n            border: 1px solid $abb-status-warning;\r\n            color: $abb-status-warning;\r\n            background: $abb-status-warning-transparent;\r\n        }\r\n        &.without-bg{\r\n            background-color: transparent;\r\n            color: $abb-text-primary-color;\r\n            border: none;\r\n            .leading-icon{\r\n                color: $abb-status-warning;\r\n                font-size: 0.75rem;\r\n                margin-top: 2px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.negative {\r\n        background-color: $abb-status-error;\r\n        color: $abb-white;\r\n\r\n        &.outlined-square-badge {\r\n            border: 1px solid $abb-status-error;\r\n            color: $abb-status-error;\r\n            background-color: $abb-white;\r\n        }\r\n\r\n        &.filled-square-badge {\r\n            border: 1px solid $abb-status-error;\r\n            color: $abb-status-error;\r\n            background: $abb-status-error-transparent;\r\n        }\r\n        &.without-bg{\r\n            background-color: transparent;\r\n            color: $abb-text-primary-color;\r\n            border: none;\r\n            .leading-icon{\r\n                color: $abb-status-error;\r\n                font-size: 0.75rem;\r\n                margin-top: 2px;\r\n            }\r\n        }\r\n        \r\n    }\r\n\r\n    &.neutral {\r\n        background-color: $abb-white;\r\n        color: $abb-grey-600;\r\n        border: 1px solid $abb-grey-600;\r\n    }\r\n\r\n    &.size-4 {\r\n        height: 4px;\r\n        width: 4px;\r\n        border-radius: 20px;\r\n    }\r\n\r\n    &.size-8 {\r\n        height: 8px;\r\n        width: 8px;\r\n        border-radius: 20px;\r\n    }\r\n\r\n    &.size-16 {\r\n        height: 16px;\r\n        width: 16px;\r\n        border-radius: 20px;\r\n        font-size: 0.75rem;\r\n    }\r\n\r\n    &.size-24 {\r\n        height: 1.5rem;\r\n        width: 1.5rem;\r\n        border-radius: 20px;\r\n        font-weight: 400 !important;\r\n        line-height: 1.375rem;\r\n        font-size: 0.75rem !important;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    &.rounded-small-badge {\r\n        padding: 2.5px 0.5rem;\r\n        height: 16px;\r\n        border-radius: 20px;\r\n        line-height: 1.375rem;\r\n        font-weight: 400 !important;\r\n        font-size: 0.75rem !important;\r\n        white-space: nowrap;\r\n        min-width: 24px;\r\n    }\r\n\r\n    &.rounded-badge {\r\n        padding: 2.5px 8px;\r\n        min-height: 20px;\r\n        border-radius: 20px;\r\n        font-weight: 400 !important;\r\n        font-size: 0.75rem !important;\r\n    }\r\n\r\n    &.square-badge {\r\n        padding: 4.5px 8px;\r\n        min-height: 24px;\r\n        border-radius: 0.375rem;\r\n        font-weight: 400 !important;\r\n        font-size: 0.75rem !important;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    &.outlined-square-badge {\r\n        padding: 4.5px 8px;\r\n        min-height: 24px;\r\n        border-radius: 0.375rem;\r\n        font-weight: 400 !important;\r\n        font-size: 0.75rem !important;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    &.filled-square-badge {\r\n        padding: 4.5px 8px;\r\n        border-radius: 0.375rem;\r\n        height: 24px;\r\n        font-weight: 400 !important;\r\n        font-size: 0.75rem !important;\r\n        white-space: nowrap;\r\n    }\r\n    &.without-bg{\r\n        font-weight: 400 ;\r\n        font-size: 0.75rem;\r\n        margin-top: 2px;\r\n    }\r\n}",".MuiBreadcrumbs-ol {\r\n    font-family: \"ABBVoice\", Verdana;\r\n    .MuiBreadcrumbs-separator {\r\n        margin-left: 0.375rem;\r\n        margin-right: 0.5rem;\r\n        margin-top: 0.25rem;\r\n    }\r\n}\r\n\r\n.current-page {\r\n    display: flex;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    color: $abb-text-primary-color;\r\n    font-weight: 400;\r\n    font-size: 0.75rem;\r\n    margin-top: 2px;\r\n    font-family: \"ABBVoice\", Verdana;\r\n\r\n    .down-icon {\r\n        margin-top: 2px;\r\n        margin-left: 4px;\r\n        color: $abb-text-primary-color;\r\n    }\r\n}\r\n\r\n.previous-label-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    gap: 8px;\r\n    font-family: \"ABBVoice\", Verdana;\r\n\r\n    .icon {\r\n        width: 2rem;\r\n        height: 2rem;\r\n        border-radius: 50%;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        &.bg-white {\r\n            background-color: $abb-white;\r\n        }\r\n\r\n        &.bg-gray {\r\n            background-color: $abb-grey-300;\r\n        }\r\n\r\n        .icon-left {\r\n            margin-top: 2px;\r\n            color: $abb-text-primary-color;\r\n        }\r\n    }\r\n\r\n    .previous-label {\r\n        font-family: \"ABBVoice\", Verdana;\r\n        font-size: 0.875rem;\r\n        color: $abb-text-primary-color;\r\n        font-weight: 400;\r\n        line-height: 1.15;\r\n        display: inline-block;\r\n    }\r\n}\r\n\r\n.icon-right {\r\n    color: $abb-text-primary-color;\r\n}\r\n\r\n.ellipsis-icon {\r\n    color: $abb-text-primary-color;\r\n    cursor: pointer;\r\n}",".MuiButtonBase-root.MuiButton-root {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    box-sizing: border-box;\r\n    width: fit-content;\r\n    flex-shrink: 0;\r\n    text-align: center;\r\n    border-radius: 20px;\r\n    text-transform: capitalize;\r\n\r\n    .btn {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        gap: 4px;\r\n    }\r\n\r\n    .label{\r\n        font-size: 0.875rem;\r\n        text-wrap: nowrap;\r\n        font-weight: 500;\r\n        font-family: $abb-typography-font-family;\r\n    }\r\n\r\n    .btn-section {\r\n        display: flex;\r\n        border-top-left-radius: 20px;\r\n        gap: 4px;\r\n        border-bottom-left-radius: 20px;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        &.size-32 {\r\n            min-height: 32px;\r\n            padding: 0 8px 0 16px !important;\r\n        }\r\n\r\n        &.size-40 {\r\n            min-height: 40px;\r\n            max-height: 48px;\r\n            padding: 0 12px 0 20px;\r\n        }\r\n\r\n    }\r\n\r\n    .icon-section {\r\n        padding: 0 12px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        border-top-right-radius: 20px;\r\n        border-bottom-right-radius: 20px;\r\n\r\n        &.size-32 {\r\n            min-height: 32px;\r\n            padding: 0 8px 0 8px;\r\n        }\r\n\r\n        &.size-40 {\r\n            min-height: 40px;\r\n            padding: 0 12px 0 12px;\r\n        }\r\n    }\r\n\r\n    &.split {\r\n        padding: 0 !important;\r\n    }\r\n\r\n    .icon {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .icon-down {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .divider {\r\n        width: 0.5px;\r\n\r\n        &.size-32 {\r\n            min-height: 32px;\r\n        }\r\n\r\n        &.size-40 {\r\n            min-height: 40px;\r\n        }\r\n    }\r\n\r\n    &.round {\r\n        border-radius: 50%;\r\n        padding: 12px;\r\n        min-width: auto;\r\n    }\r\n\r\n    &.primary {\r\n        background-color: $abb-primary-default;\r\n        color: $abb-white;\r\n\r\n        &:hover {\r\n            background-color: $abb-primary-hover;\r\n        }\r\n\r\n        &:active {\r\n            background-color: $abb-primary-active;\r\n        }\r\n\r\n        &:focus-visible {\r\n            outline-offset: 1px;\r\n            outline: 2px solid $abb-primary-active;\r\n        }\r\n\r\n        &.disabled {\r\n            background-color: $abb-primary-disabled;\r\n            pointer-events: none;\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n\r\n    &.secondary {\r\n        background-color: $abb-grey-400;\r\n        color: $abb-text-primary-color;\r\n\r\n        &:hover {\r\n            background-color: $abb-grey-500;\r\n        }\r\n\r\n        &:focus-visible {\r\n            outline-offset: 1px;\r\n            outline: 2px solid $abb-primary-active;\r\n        }\r\n\r\n        &:active {\r\n            background-color: $abb-grey-600;\r\n        }\r\n\r\n        &.disabled {\r\n            background-color: $abb-grey-400;\r\n            color: $abb-grey-600;\r\n            pointer-events: none;\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n\r\n    &.ghost {\r\n        background-color: transparent;\r\n        color: $abb-text-primary-color;\r\n        border: 2px solid $abb-grey-500;\r\n\r\n        &:hover {\r\n            background-color: $abb-grey-400;\r\n            border: 2px solid $abb-grey-700;\r\n        }\r\n\r\n        &:focus-visible {\r\n            outline-offset: 1px;\r\n            outline: 2px solid $abb-primary-active;\r\n        }\r\n\r\n        &:active {\r\n            background-color: $abb-grey-500;\r\n            border: 2px solid $abb-grey-700;\r\n        }\r\n\r\n        &.disabled {\r\n            color: $abb-grey-600;\r\n            border: 2px solid $abb-grey-500;\r\n            pointer-events: none;\r\n            cursor: not-allowed;\r\n            &:hover {\r\n                background-color: transparent;\r\n                color: $abb-grey-600;\r\n                pointer-events: none;\r\n                border: 2px solid $abb-grey-500;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    &.discreet {\r\n        background-color: transparent;\r\n        color: $abb-text-primary-color;\r\n\r\n        &:hover {\r\n            background-color: $abb-grey-400;\r\n        }\r\n\r\n        &:focus-visible {\r\n            outline-offset: 1px;\r\n            outline: 2px solid $abb-primary-active;\r\n        }\r\n\r\n        &:active {\r\n            background-color: $abb-grey-500;\r\n        }\r\n\r\n        &.disabled {\r\n            color: $abb-grey-600;\r\n            pointer-events: none;\r\n            background-color: transparent;\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n\r\n    &.success {\r\n        background-color: $abb-status-success;\r\n        color: $abb-white;\r\n\r\n        &:hover {\r\n            background-color: $abb-status-success-hover;\r\n        }\r\n\r\n        &:focus-visible {\r\n            outline-offset: 1px;\r\n            outline: 2px solid $abb-primary-active;\r\n        }\r\n    }\r\n\r\n    &.error {\r\n        background-color: $abb-status-error;\r\n        color: $abb-white;\r\n\r\n        &:hover {\r\n            background-color: $abb-status-error-hover;\r\n        }\r\n\r\n        &:focus-visible {\r\n            outline-offset: 1px;\r\n            outline: 2px solid $abb-primary-active;\r\n        }\r\n    }\r\n\r\n    &.warning {\r\n        background-color: $abb-status-warning;\r\n        color: $abb-white;\r\n\r\n        &:hover {\r\n            background-color: $abb-status-warning-hover;\r\n        }\r\n\r\n        &:focus-visible {\r\n            outline-offset: 1px;\r\n            outline: 2px solid $abb-primary-active;\r\n        }\r\n    }\r\n\r\n    &.size-32 {\r\n        min-height: 32px;\r\n        max-height: 32px;\r\n        padding: 0 16px !important;\r\n\r\n    }\r\n\r\n    &.size-40 {\r\n        min-height: 40px;\r\n        max-height: 40px;\r\n        padding: 0 20px !important;\r\n    }\r\n\r\n    &.primary-split-button {\r\n        background-color: $abb-primary-default;\r\n        border: solid 2px $abb-primary-default;\r\n        color: $abb-white;\r\n        padding: 0 !important;\r\n\r\n        .divider {\r\n            background-color: $abb-white;\r\n        }\r\n\r\n        &:hover {\r\n            border: solid 2px $abb-primary-hover;\r\n        }\r\n\r\n        &:active {\r\n            border: solid 2px $abb-primary-active;\r\n        }\r\n\r\n        &:focus-visible {\r\n            outline-offset: 1px;\r\n            outline: 2px solid $abb-primary-active;\r\n        }\r\n\r\n        .btn-section {\r\n            &:hover {\r\n                background-color: $abb-primary-hover;\r\n            }\r\n\r\n            &:active {\r\n                background-color: $abb-primary-active;\r\n            }\r\n\r\n            &.disabled {\r\n                background-color: $abb-primary-disabled;\r\n                pointer-events: none;\r\n            }\r\n        }\r\n\r\n        .icon-section {\r\n            &:hover {\r\n                background-color: $abb-primary-hover;\r\n            }\r\n\r\n            &:active {\r\n                background-color: $abb-primary-active;\r\n            }\r\n\r\n            &.disabled {\r\n                background-color: $abb-primary-disabled;\r\n                pointer-events: none;\r\n            }\r\n        }\r\n\r\n        &.disabled {\r\n            background-color: $abb-primary-disabled;\r\n            border: solid 2px $abb-primary-disabled;\r\n            pointer-events: none;\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n\r\n    &.secondary-split-button {\r\n        background-color: $abb-grey-400;\r\n        border: solid 1px $abb-grey-600;\r\n        color: $abb-text-primary-color;\r\n        padding: 0 !important;\r\n\r\n        .divider {\r\n            background-color: $abb-grey-600;\r\n        }\r\n\r\n        &:focus-visible {\r\n            outline-offset: 1px;\r\n            outline: 2px solid $abb-primary-active;\r\n        }\r\n\r\n        .btn-section {\r\n            &:hover {\r\n                background-color: $abb-shadow-grey-200;\r\n            }\r\n\r\n            &:active {\r\n                background-color: $abb-grey-500;\r\n            }\r\n\r\n            &.disabled {\r\n                background-color: $abb-grey-400;\r\n                color: $abb-grey-700;\r\n                pointer-events: none;\r\n            }\r\n        }\r\n\r\n        .icon-section {\r\n            &:hover {\r\n                background-color: $abb-shadow-grey-200;\r\n            }\r\n\r\n            &:active {\r\n                background-color: $abb-grey-500;\r\n            }\r\n\r\n            &.disabled {\r\n                background-color: $abb-grey-400;\r\n                color: $abb-grey-700;\r\n                cursor: not-allowed;\r\n                pointer-events: none;\r\n            }\r\n        }\r\n\r\n        &.disabled {\r\n            background-color: $abb-grey-400;\r\n            color: $abb-grey-700;\r\n            border: solid 1px $abb-grey-500;\r\n            cursor: not-allowed;\r\n            pointer-events: none;\r\n        }\r\n    }\r\n\r\n\r\n}",".cards-container {\r\n    display: flex;\r\n    background-color: $abb-card-bg;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    box-shadow: #0000001a 0 1px 3px, #0000000f 0 1px 2px;\r\n    border-radius: 8px;\r\n    opacity: 1;\r\n    border: 1px solid $abb-grey-300;\r\n    height: 100%;\r\n    min-height: 120px;\r\n\r\n    &:not(.no-hover):not(.disabled):hover {\r\n        box-shadow: 1px 1px 5px $abb-shadow-blue;\r\n        background-color: $abb-card-hover;\r\n        border: 1px solid $abb-accordion-border;\r\n        cursor: pointer;\r\n\r\n        .gray {\r\n            background-color: $abb-card-hover;\r\n        }\r\n    }\r\n\r\n    &.selected{\r\n        border: 1px solid $abb-accordion-border;\r\n    }\r\n\r\n\r\n\r\n    &.align {\r\n        flex-direction: row;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        min-height: 60px;\r\n        padding: 8px 24px;\r\n        box-shadow: none;\r\n        box-sizing: border-box;\r\n        background: $abb-white;\r\n        line-height: 2.188rem;\r\n        border-radius: 0;\r\n        border: 2px solid transparent;\r\n        border-bottom: 1px solid $abb-grey-500;\r\n\r\n        .w-15 {\r\n            width: 15%;\r\n        }\r\n\r\n        .w-25 {\r\n            width: 25%;\r\n        }\r\n\r\n        .secondary-text {\r\n            color: $abb-grey-800;\r\n            font-size: .875rem;\r\n            line-height: 1.15;\r\n        }\r\n\r\n        .title {\r\n            font-size: 1rem;\r\n            font-weight: 500;\r\n            line-height: 1.15;\r\n            color: $abb-text-primary-color;\r\n        }\r\n\r\n        .description {\r\n            text-align: left;\r\n            font-size: .875rem;\r\n            letter-spacing: 0;\r\n            color: $abb-text-primary-color;\r\n            opacity: 1;\r\n            overflow: hidden;\r\n            line-height: 1.15;\r\n        }\r\n\r\n        .supporting-text {\r\n            color: $abb-grey-800;\r\n            text-transform: capitalize;\r\n            font-size: .75rem;\r\n            overflow: hidden;\r\n            line-height: 1.15;\r\n        }\r\n\r\n        &:not(.disabled):hover {\r\n            box-shadow: 1px 1px 5px $abb-shadow-blue;\r\n            background-color: $abb-card-hover;\r\n            border: 1px solid $abb-accordion-border;\r\n            cursor: pointer;\r\n        }\r\n\r\n        &.selected{\r\n            border: 1px solid $abb-accordion-border;\r\n        }\r\n\r\n    }\r\n\r\n\r\n\r\n    &.disabled {\r\n        opacity: .6;\r\n        cursor: not-allowed !important;\r\n    }\r\n\r\n    &:hover .image-container {\r\n        background: $abb-white;\r\n    }\r\n\r\n\r\n    &:hover .hover {\r\n        background: $abb-white;\r\n    }\r\n\r\n    .top-content {\r\n        flex-direction: column;\r\n        box-sizing: border-box;\r\n        justify-content: center;\r\n        display: flex;\r\n        flex: 1 1 1e-09px;\r\n        padding: 6px 16px 16px;\r\n        gap: 8px;\r\n\r\n        &.gap-12 {\r\n            gap: 12px;\r\n        }\r\n\r\n        .secondary-text {\r\n            color: $abb-grey-800;\r\n            font-size: .875rem;\r\n            text-transform: capitalize;\r\n            line-height: 1.15;\r\n        }\r\n\r\n        .title {\r\n            font-size: 1rem;\r\n            font-weight: 500;\r\n            line-height: 1.15;\r\n            color: $abb-text-primary-color;\r\n        }\r\n\r\n        .description {\r\n            text-align: left;\r\n            font-size: .875rem;\r\n            letter-spacing: 0;\r\n            color: $abb-text-primary-color;\r\n            opacity: 1;\r\n            overflow: hidden;\r\n            line-height: 1.15;\r\n            margin-top: 8px;\r\n        }\r\n\r\n    }\r\n\r\n    .bottom-content {\r\n        flex-direction: row;\r\n        box-sizing: border-box;\r\n        display: flex;\r\n        place-content: center space-between;\r\n        align-items: center;\r\n        padding: 8px 16px;\r\n        border-top: 1px solid $abb-grey-400;\r\n        min-width: 100%;\r\n        border-bottom-left-radius: 8px;\r\n        border-bottom-right-radius: 8px;\r\n\r\n        &.gray {\r\n            background: $abb-grey-200;\r\n        }\r\n\r\n        .supporting-text {\r\n            color: $abb-grey-800;\r\n            text-transform: capitalize;\r\n            font-size: .75rem;\r\n            overflow: hidden;\r\n            line-height: 1.15;\r\n        }\r\n    }\r\n}\r\n\r\n.list-card-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n\r\n    .align{\r\n        border-bottom: none;\r\n        border-radius: 4px;\r\n    }\r\n}",".MuiButtonBase-root.MuiChip-root {\r\n    box-sizing: border-box;\r\n    border-radius: 20px;\r\n    font-size: 0.875rem;\r\n    margin-right: 4px !important;\r\n    margin-left: 0 !important;\r\n    font-weight: 400;\r\n    background-color: $abb-grey-400;\r\n    border: 1.5px solid $abb-grey-400;\r\n    color: $abb-text-primary-color;\r\n    font-family: $abb-typography-font-family;\r\n    flex-direction: row;\r\n    gap: 4px;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    .MuiChip-label {\r\n        padding: 0;\r\n    }\r\n\r\n    .MuiChip-icon {\r\n        margin: 0;\r\n        font-size: 1rem;\r\n    }\r\n\r\n    &:hover {\r\n        background: $abb-grey-300;\r\n        color: $abb-text-primary-color;\r\n        .MuiChip-deleteIcon{\r\n            color: $abb-text-primary-color;\r\n        }\r\n    }\r\n\r\n    &:active{\r\n        box-shadow: none;\r\n    }\r\n\r\n    .MuiChip-deleteIcon {\r\n        font-size: 12px;\r\n        margin: 0;\r\n        color: $abb-text-primary-color;\r\n\r\n        &.disabled{\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n\r\n    .leadingIconName{\r\n        color: $abb-text-primary-color;\r\n        &.disabled{\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n\r\n    &.disabled {\r\n        background: $abb-grey-400;\r\n        color: $abb-grey-600;\r\n        cursor: not-allowed;\r\n        pointer-events: inherit;\r\n        opacity: 1;\r\n        .MuiChip-icon {\r\n            color: $abb-grey-600;\r\n\r\n        }\r\n\r\n        .MuiChip-deleteIcon {\r\n            color: $abb-grey-600;\r\n\r\n        }\r\n    }\r\n\r\n    &.size-24 {\r\n        height: 24px;\r\n        padding: 0 8px;\r\n    }\r\n\r\n    &.size-32 {\r\n        height: 32px;\r\n        padding: 0 12px;\r\n    }\r\n\r\n    &.size-40 {\r\n        height: 40px;\r\n        padding: 0 16px;\r\n\r\n    }\r\n\r\n    .end-icon-container{\r\n        display: flex;\r\n        flex-direction: row;\r\n        gap: 4px;\r\n        justify-content: center;\r\n        align-items: center;\r\n        .down-icon{\r\n            padding-right: 4px;\r\n        }\r\n        .border{\r\n            border-right: 1px solid $abb-grey-700;\r\n        }\r\n    }\r\n\r\n    &.clicked-chip {\r\n        cursor: pointer;\r\n        background-color: $abb-status-info-transparent;\r\n        color: $abb-primary-default;\r\n        border: 1px solid $abb-primary-default;\r\n        font-weight: 500;\r\n        .MuiChip-icon {\r\n            color: $abb-primary-default;\r\n        }\r\n        .end-icon-container{\r\n            .border{\r\n                border-right: 1px solid $abb-primary-default;\r\n            }\r\n        }\r\n        .MuiChip-deleteIcon {\r\n            color: $abb-primary-default;\r\n        }\r\n\r\n        &:hover {\r\n            background: $abb-accordion-expanded-bg;\r\n        }\r\n    }\r\n}",".counter {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 16px;\r\n    padding: 0 8px;\r\n\r\n    &.custom {\r\n        gap: 8px;\r\n    }\r\n\r\n    .icon {\r\n        cursor: pointer;\r\n        color: $abb-text-primary-color;\r\n    }\r\n}",".MuiButtonBase-root.MuiCheckbox-root {\r\n    padding: 4px 0px;\r\n}\r\n\r\n.blank-checkbox {\r\n    display: flex;\r\n    box-sizing: border-box;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border: 2px solid $abb-grey-500;\r\n    border-radius: 4px;\r\n    background: transparent;\r\n    z-index: 20;\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n        border: 2px solid $abb-grey-600;\r\n        background-color: $abb-grey-300;\r\n    }\r\n\r\n    &.disabled {\r\n        border: 2px solid $abb-grey-400;\r\n        background-color: $abb-grey-300;\r\n    }\r\n\r\n    &.hover {\r\n        border: 2px solid $abb-grey-600;\r\n        background-color: $abb-grey-300;\r\n    }\r\n\r\n    &:active {\r\n        border: 2px solid $abb-grey-700;\r\n        background-color: $abb-grey-400;\r\n    }\r\n\r\n    &:focus-visible {\r\n        outline-offset: 1px;\r\n        outline: 2px solid $abb-primary-active;\r\n    }\r\n\r\n    &.size-16 {\r\n        width: 16px;\r\n        height: 16px;\r\n    }\r\n\r\n    &.size-24 {\r\n        width: 24px;\r\n        height: 24px;\r\n    }\r\n}\r\n\r\n.checked-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    box-sizing: border-box;\r\n    align-items: center;\r\n    padding: 2px;\r\n    justify-content: center;\r\n    border: 2px solid $abb-primary-default;\r\n    border-radius: 4px;\r\n    background: $abb-primary-default;\r\n    color: $abb-white;\r\n    z-index: 20;\r\n    cursor: pointer;\r\n\r\n    .checked {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n\r\n    &.disabled {\r\n        border: 2px solid $abb-primary-disabled;\r\n        background-color: $abb-primary-disabled;\r\n    }\r\n\r\n    .size-16 {\r\n        font-size: 16px;\r\n    }\r\n\r\n    .size-8 {\r\n        font-size: 8px;\r\n    }\r\n\r\n    &.size-16 {\r\n        width: 16px;\r\n        height: 16px;\r\n    }\r\n\r\n    &.size-24 {\r\n        width: 24px;\r\n        height: 24px;\r\n    }\r\n\r\n    &:hover {\r\n        border: 2px solid $abb-primary-hover;\r\n        background-color: $abb-primary-hover;\r\n    }\r\n\r\n    &.hover {\r\n        border: 2px solid $abb-primary-hover;\r\n        background-color: $abb-primary-hover;\r\n    }\r\n\r\n    &:active {\r\n        border: 2px solid $abb-primary-active;\r\n        background-color: $abb-primary-active;\r\n    }\r\n\r\n    &:focus-visible {\r\n        outline-offset: 1px;\r\n        outline: 2px solid $abb-primary-active;\r\n    }\r\n}\r\n\r\n.checkbox-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    cursor: pointer;\r\n\r\n    .size-16{\r\n        font-size: 1rem;\r\n    }\r\n\r\n    &.disabled {\r\n        cursor: not-allowed;    \r\n    }\r\n\r\n    .checkbox-label {\r\n        font-family: 'ABBVoice', Verdana;\r\n        font-size: 0.875rem;\r\n        margin-left: 8px;\r\n        color: $abb-text-primary-color;\r\n        text-wrap: nowrap;\r\n        cursor: pointer;\r\n\r\n        &.disabled {\r\n            color: $abb-grey-700;\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n}",".table-wrapper {\r\n    background-color: $abb-white;\r\n    overflow-x: auto;\r\n\r\n    .MuiTable-root {\r\n        min-width: 550px;\r\n    }\r\n\r\n    &.border {\r\n        border: 1px solid $abb-grey-500;\r\n    }\r\n\r\n    .table-title {\r\n        font-size: 1rem;\r\n        font-weight: 700;\r\n        margin: 1.125rem;\r\n    }\r\n\r\n    .data-grid-input-wrapper{\r\n        display: flex;\r\n        align-items: center;\r\n        flex-direction: row;\r\n        gap: 8px;\r\n        min-width: 125px;\r\n        max-width: 200px;\r\n        width: 60%;\r\n\r\n        &.end{\r\n            justify-self: end;\r\n        }\r\n\r\n        .MuiInputBase-root.MuiInput-root.MuiInput-underline{\r\n            font-size: 0.875rem;\r\n            font-family: \"ABBVoice\", Verdana !important;\r\n            color: $abb-text-primary-color;\r\n            \r\n            &::before{\r\n                border-bottom: 1px solid $abb-grey-400;\r\n            }\r\n            &:hover::before{\r\n                border-bottom: 1px solid $abb-text-primary-color;\r\n            }\r\n            &::after{\r\n                border-bottom: 1px solid $abb-primary-default;\r\n            }\r\n        }\r\n\r\n        .discreet-edit-icons{\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            gap: 4px;\r\n        }\r\n    }\r\n\r\n    .MuiTableHead-root {\r\n        .MuiTableCell-root {\r\n            font-family: 'ABBVoice', Verdana;\r\n            font-weight: 500;\r\n            font-size: 0.875rem;\r\n            color: $abb-text-primary-color;\r\n            border-bottom: 1px solid $abb-text-primary-color;\r\n\r\n            &:hover {\r\n                background-color: $abb-grey-300;\r\n            }\r\n\r\n            .MuiButtonBase-root.MuiCheckbox-root {\r\n                padding: 0;\r\n            }\r\n\r\n            &.status {\r\n                padding: 0;\r\n\r\n                &:hover {\r\n                    background-color: $abb-white;\r\n                }\r\n            }\r\n\r\n            &.main-header {\r\n                font-weight: 500;\r\n            }\r\n\r\n            &.gray-border {\r\n                border-bottom: 1px solid $abb-grey-500;\r\n            }\r\n\r\n            .transparent-border{\r\n                border-bottom: 1px solid transparent;\r\n            }\r\n\r\n            &.topHeader {\r\n                border-bottom: 1px solid $abb-grey-500;\r\n                border-right: 1px solid $abb-grey-500;\r\n            }\r\n\r\n            &.topHeader:last-child {\r\n                border-right: none;\r\n            }\r\n\r\n            &.bg-white {\r\n                background-color: $abb-white;\r\n\r\n                &:hover {\r\n                    background-color: $abb-grey-300;\r\n                }\r\n\r\n                &.no-hover {\r\n                    background-color: $abb-white !important;\r\n                }\r\n            }\r\n\r\n            &.bg-gray {\r\n                background-color: $abb-grey-200;\r\n\r\n                &:hover {\r\n                    background-color: $abb-grey-300;\r\n                }\r\n\r\n                &.no-hover {\r\n                    background-color: $abb-grey-200 !important;\r\n                }\r\n            }\r\n        }\r\n\r\n        .light {\r\n            color: $abb-text-primary-color;\r\n            opacity: 0.6;\r\n\r\n        }\r\n\r\n        .sort-icon {\r\n            font-size: 1.2rem;\r\n        }\r\n\r\n        .blue-border {\r\n            border-bottom: 2px solid $abb-primary-default;\r\n        }\r\n\r\n        .MuiTableSortLabel-root {\r\n            &:hover {\r\n                color: $abb-text-primary-color;\r\n            }\r\n\r\n            &:focus {\r\n                color: $abb-text-primary-color;\r\n            }\r\n        }\r\n\r\n\r\n    }\r\n\r\n    .MuiTableBody-root {\r\n        .MuiTableRow-root {\r\n            &.Mui-selected {\r\n                background-color: $abb-white;\r\n            }\r\n\r\n            &.bg-white {\r\n                background-color: $abb-white;\r\n            }\r\n\r\n            &.bg-gray {\r\n                background-color: $abb-grey-200;\r\n            }\r\n\r\n\r\n            &.zebra {\r\n                background-color: $abb-grey-100;\r\n            }\r\n\r\n            &:hover {\r\n                background-color: $abb-grey-300;\r\n            }\r\n\r\n            &.no-hover {\r\n                background-color: $abb-white !important;\r\n            }\r\n\r\n            &.bg-blue{\r\n                background-color: $abb-accordion-expanded-bg;\r\n            }\r\n\r\n            .MuiButtonBase-root.MuiCheckbox-root {\r\n                padding: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    .MuiTableCell-root {\r\n        font-family: 'ABBVoice', Verdana !important;\r\n        font-size: 0.875rem;\r\n        text-wrap: nowrap;\r\n        color: $abb-text-primary-color;\r\n        border-bottom: 1px solid $abb-grey-500;\r\n\r\n        &.checkbox-cell {\r\n            padding: 0 10px 0 20px;\r\n        }\r\n\r\n        &.hovered {\r\n            background-color: $abb-grey-300;\r\n        }\r\n\r\n        &.status {\r\n            width: auto;\r\n            min-width: 10px;\r\n            max-width: 10px;\r\n            padding: 0 0 0 4px;\r\n        }\r\n\r\n        &.size-24 {\r\n            height: 24px;\r\n            padding: 0 12px;\r\n        }\r\n\r\n        &.size-32 {\r\n            height: 32px;\r\n            padding: 0 16px;\r\n        }\r\n\r\n        &.size-40 {\r\n            height: 40px;\r\n            padding: 0 20px;\r\n        }\r\n\r\n        &.size-48 {\r\n            height: 48px;\r\n            padding: 0 20px;\r\n        }\r\n\r\n        &.size-60 {\r\n            height: 60px;\r\n            padding: 0 20px;\r\n        }\r\n\r\n        &.border-right {\r\n            border-right: 1px solid $abb-grey-500;\r\n        }\r\n\r\n        .open {\r\n            transform: rotate(90deg);\r\n            transition-duration: 300ms;\r\n        }\r\n\r\n        &.remove-border {\r\n            border-bottom: none;\r\n        }\r\n\r\n        .status-indicator {\r\n            height: 100%;\r\n            margin: 4px 0px;\r\n            border-radius: 4px;\r\n            width: 4px;\r\n\r\n            &.primary {\r\n                background-color: $abb-primary-default;\r\n            }\r\n\r\n            &.warning {\r\n                background-color: $abb-status-warning;\r\n            }\r\n\r\n            &.negative {\r\n                background-color: $abb-status-error;\r\n            }\r\n\r\n            &.positive {\r\n                background-color: $abb-status-success;\r\n            }\r\n\r\n            &.size-24 {\r\n                height: 16px;\r\n            }\r\n\r\n            &.size-32 {\r\n                height: 24px;\r\n            }\r\n\r\n            &.size-40 {\r\n                height: 32px;\r\n            }\r\n\r\n            &.size-48 {\r\n                height: 40px;\r\n            }\r\n\r\n            &.size-60 {\r\n                height: 52px;\r\n            }\r\n        }\r\n\r\n        &.sticky {\r\n            position: sticky;\r\n            left: 0;\r\n            background: $abb-grey-300 !important;\r\n            z-index: 99;\r\n\r\n            &:hover {\r\n                background: $abb-grey-200 !important;\r\n            }\r\n        }\r\n\r\n        &.text-link {\r\n            color: $abb-primary-default;\r\n\r\n            &:hover {\r\n                text-decoration: underline;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.table-with-toolbar {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    gap: 16px;\r\n    color: $abb-text-primary-color;\r\n\r\n    .first-part {\r\n        gap: 8px;\r\n        align-items: center;\r\n        margin-right: 16px;\r\n        padding-left: 16px;\r\n    }\r\n}\r\n\r\n.data-grid-container {\r\n    position: relative;\r\n\r\n    .action-container{\r\n        max-width: 80px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        padding: 0 20px;\r\n    }\r\n\r\n\r\n    .header-cell {\r\n        font-family: 'ABBVoice', Verdana;\r\n        font-weight: 500;\r\n        padding: 0 20px;\r\n        font-size: 0.875rem;\r\n        color: $abb-text-primary-color;\r\n        border-bottom: 1px solid $abb-grey-500;\r\n        background-color: transparent;\r\n        margin-bottom: 4px;\r\n        display: flex;\r\n        align-items: center;\r\n        cursor: pointer;\r\n        gap: 8px;\r\n\r\n        .light {\r\n            color: $abb-text-primary-color;\r\n            opacity: 0.6;\r\n            font-size: 1.313rem;\r\n        }\r\n\r\n        &.blue-border {\r\n            border-bottom: 2px solid $abb-primary-default;\r\n        }\r\n\r\n    }\r\n\r\n    .border {\r\n        border-bottom: 1px solid $abb-grey-500;\r\n        margin-bottom: 4px;\r\n        padding: 0 20px;\r\n    }\r\n\r\n    .data-row {\r\n        margin-bottom: 4px;\r\n        border-radius: 4px;\r\n        border: 1px solid $abb-grey-300;\r\n        background-color: $abb-white;\r\n\r\n        &.selected {\r\n            background-color: $abb-accordion-expanded-bg;\r\n            border: 1px solid $abb-primary-default\r\n        }\r\n\r\n        &.primary {\r\n            border-left: 4px solid $abb-primary-default;\r\n        }\r\n\r\n        &.warning {\r\n            border-left: 4px solid $abb-status-warning;\r\n        }\r\n\r\n        &.negative {\r\n            border-left: 4px solid $abb-status-error;\r\n        }\r\n\r\n        &.positive {\r\n            border-left: 4px solid $abb-status-success;\r\n        }\r\n\r\n        &:hover{\r\n            background-color: $abb-grey-300;\r\n        }\r\n\r\n    }\r\n\r\n    .filter-icon {\r\n        position: absolute;\r\n        top: 22px;\r\n        right: 20px;\r\n        color: $abb-text-primary-color;\r\n    }\r\n\r\n\r\n    .filter-container {\r\n        width: 100%;\r\n        box-sizing: border-box;\r\n        font-family: 'ABBVoice', Verdana;\r\n        font-weight: 400;\r\n        padding: 8px 20px;\r\n        font-size: 0.875rem;\r\n        color: $abb-text-primary-color;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: start;\r\n        margin-bottom: 8px;\r\n        border-radius: 8px;\r\n        gap: 8px;\r\n        border: 1px solid $abb-grey-200;\r\n        background-color: $abb-grey-200;\r\n        border-radius: 8px;\r\n    }\r\n\r\n    .data-cell {\r\n        font-family: 'ABBVoice', Verdana;\r\n        font-weight: 400;\r\n        padding: 0 20px;\r\n        font-size: 0.875rem;\r\n        color: $abb-text-primary-color;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: start;\r\n    }\r\n\r\n    &.text-link {\r\n        color: $abb-primary-default;\r\n\r\n        &:hover {\r\n            text-decoration: underline;\r\n        }\r\n    }\r\n}",".MuiInputAdornment-root {\r\n  padding-right: 2px;\r\n  margin: 0 !important;\r\n\r\n  .calender-icon {\r\n    color: $abb-text-primary-color;\r\n  }\r\n\r\n  .MuiButtonBase-root.MuiIconButton-root {\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n.MuiPickersLayout-root {\r\n  font-family: \"ABBVoice\", Verdana !important;\r\n\r\n  ::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n\r\n  .MuiDateCalendar-root {\r\n    height: auto;\r\n    width: 256px;\r\n    padding: 24px;\r\n  }\r\n\r\n  .MuiDayCalendar-weekContainer {\r\n    margin: 0;\r\n\r\n    .dayIsBetween {\r\n      background-color: $abb-accordion-expanded-bg;\r\n\r\n      &:hover {\r\n        background: $abb-accordion-expanded-bg;\r\n      }\r\n    }\r\n\r\n    .isFirstDay {\r\n      border-top-left-radius: '50%';\r\n      border-bottom-left-radius: '50%';\r\n      color: $abb-white;\r\n\r\n      &:hover {\r\n        background: transparent;\r\n      }\r\n    }\r\n\r\n    .isLastDay {\r\n      border-top-right-radius: 50%;\r\n      border-bottom-right-radius: 50%;\r\n      background-color: $abb-primary-default;\r\n      color: $abb-white;\r\n\r\n      &:hover {\r\n        background: transparent;\r\n      }\r\n    }\r\n  }\r\n\r\n  .MuiPickersCalendarHeader-root {\r\n    padding: 0 0px 8px 7px;\r\n    margin: 0;\r\n    min-height: auto;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    .MuiButtonBase-root.MuiIconButton-root {\r\n      color: $abb-text-primary-color;\r\n\r\n      &:hover {\r\n        background: transparent;\r\n      }\r\n    }\r\n\r\n    .pr-8 {\r\n      padding-right: 8px;\r\n      font-size: 1.1rem;\r\n    }\r\n\r\n    .pl-8{\r\n      font-size: 1.1rem;\r\n    }\r\n\r\n    .MuiPickersCalendarHeader-labelContainer {\r\n      font-weight: 500;\r\n      font-size: 1rem;\r\n      color: $abb-text-primary-color;\r\n      font-family: \"ABBVoice\", Verdana !important;\r\n\r\n      &.MuiPickersCalendarHeader-label {\r\n        margin-right: 0 !important;\r\n      }\r\n\r\n    }\r\n  }\r\n\r\n  .MuiDayCalendar-header {\r\n    .MuiTypography-root.MuiTypography-caption.MuiDayCalendar-weekDayLabel {\r\n      font-size: 0.75rem;\r\n      font-weight: 400;\r\n      color: $abb-text-primary-color;\r\n      font-family: \"ABBVoice\", Verdana !important;\r\n      height: 24px;\r\n      width: 36px;\r\n    }\r\n  }\r\n\r\n  .MuiPickersDay-today {\r\n    border: 1px solid $abb-primary-default !important;\r\n    background-color: transparent !important;\r\n  }\r\n\r\n  .MuiPickersDay-root {\r\n    height: 28px;\r\n    width: 28px;\r\n    padding: 4px;\r\n    margin: 4px;\r\n    font-weight: 500;\r\n    font-size: 0.875rem;\r\n    color: $abb-text-primary-color;\r\n    font-family: \"ABBVoice\", Verdana !important;\r\n\r\n    &:hover {\r\n      background-color: $abb-grey-300;\r\n    }\r\n\r\n    &.MuiPickersDay-dayOutsideMonth {\r\n      color: $abb-grey-400;\r\n\r\n      &:hover {\r\n        background-color: $abb-grey-300;\r\n      }\r\n    }\r\n\r\n    &.Mui-selected {\r\n      background-color: $abb-primary-default !important;\r\n      color: $abb-white\r\n    }\r\n  }\r\n\r\n  .MuiPickersYear-yearButton {\r\n    font-family: \"ABBVoice\", Verdana !important;\r\n    width: 60px;\r\n    height: 36px;\r\n    color: $abb-text-primary-color;\r\n\r\n    &.Mui-selected {\r\n      background-color: $abb-primary-default !important;\r\n      color: $abb-white\r\n    }\r\n  }\r\n\r\n  .MuiPickersMonth-monthButton {\r\n    font-family: \"ABBVoice\", Verdana !important;\r\n    width: 60px;\r\n    height: 36px;\r\n    color: $abb-text-primary-color;\r\n\r\n    &.Mui-selected {\r\n      background-color: $abb-primary-default !important;\r\n      color: $abb-white\r\n    }\r\n  }\r\n\r\n  .MuiYearCalendar-root {\r\n    height: 256px;\r\n    width: 256px;\r\n  }\r\n\r\n  .MuiPickersMonth-root {\r\n    flex-basis: 26%;\r\n  }\r\n\r\n  .MuiPickersSlideTransition-root.MuiDayCalendar-slideTransition {\r\n    min-height: 212px;\r\n  }\r\n}\r\n\r\n.MuiPickersLayout-contentWrapper {\r\n  .MuiDivider-root {\r\n    border-width: 0;\r\n  }\r\n\r\n}\r\n\r\n.MuiPickersLayout-actionBar {\r\n  display: none !important;\r\n}\r\n\r\n.date-range-wrapper {\r\n  position: relative;\r\n\r\n  .position-date-range-close {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n  }\r\n}",".header-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 24px 30px 8px 30px;\r\n\r\n    &.mt-0 {\r\n        padding-top: 16px;\r\n        padding-bottom: 0;\r\n        padding-right: 4px;\r\n        padding-left: 28px;\r\n    }\r\n\r\n    &.padding {\r\n        padding-left: 30px;\r\n    }\r\n\r\n    .first-part {\r\n        display: flex;\r\n\r\n        .year-month-toggle {\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            gap: 8px;\r\n            cursor: pointer;\r\n\r\n            .mt-2 {\r\n                margin-top: 2px;\r\n            }\r\n\r\n            .arrow-icon {\r\n                color: $abb-text-primary-color;\r\n            }\r\n\r\n            .year-month {\r\n                font-weight: 500;\r\n                font-size: 1rem;\r\n                color: $abb-text-primary-color;\r\n                font-family: \"ABBVoice\", Verdana;\r\n            }\r\n        }\r\n    }\r\n\r\n    .second-part {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 16px;\r\n\r\n        .arrow-icon {\r\n            color: $abb-text-primary-color;\r\n        }\r\n    }\r\n}\r\n\r\n.day-name-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: start;\r\n    padding: 8px 16px 8px 24px;\r\n\r\n    &.custom-picker {\r\n        padding-right: 0;\r\n        padding-left: 20px;\r\n    }\r\n\r\n    .day-name {\r\n        font-size: 0.75rem;\r\n        font-weight: 400;\r\n        color: $abb-text-primary-color;\r\n        font-family: \"ABBVoice\", Verdana !important;\r\n        height: 24px;\r\n        width: 36px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n}\r\n\r\n.days-container {\r\n    height: 215px;\r\n    padding-left: 24px;\r\n    padding-bottom: 8px;\r\n\r\n    &.pb-24 {\r\n        padding-bottom: 24px;\r\n    }\r\n\r\n    &.mt-0 {\r\n        padding-bottom: 8px;\r\n    }\r\n\r\n    .week-container {\r\n        display: flex;\r\n        flex-direction: row;\r\n    }\r\n}\r\n\r\n.date-range-container {\r\n    width: 300px;\r\n    height: 328px;\r\n    display: flex;\r\n    flex-direction: row;\r\n\r\n    .defined-range-container {\r\n        display: flex;\r\n        font-family: \"ABBVoice\", Verdana;\r\n        flex-direction: column;\r\n        width: 200px;\r\n\r\n        .defined-range-title {\r\n            background-color: $abb-white;\r\n            padding: 16px;\r\n            color: $abb-text-primary-color;\r\n            font-size: 0.875rem;\r\n            font-weight: 500;\r\n            border-right: 1px solid $abb-grey-400;\r\n        }\r\n\r\n        .list-item-container {\r\n            height: 100%;\r\n            background-color: $abb-grey-200;\r\n            border-right: 1px solid $abb-grey-400;\r\n\r\n            .list-item {\r\n                display: flex;\r\n                align-items: center;\r\n                box-sizing: border-box;\r\n                padding: 0 16px;\r\n                font-weight: 400;\r\n                font-size: 0.875rem;\r\n                height: 32px;\r\n                color: $abb-text-primary-color;\r\n                border-left: 4px solid transparent;\r\n                cursor: pointer;\r\n\r\n                &:hover {\r\n                  background-color: $abb-grey-300;\r\n                }\r\n\r\n                &.selected {\r\n                    background-color: $abb-accordion-expanded-bg;\r\n                    border-left: 4px solid $abb-primary-default;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .calender-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: space-between;\r\n        padding-right: 24px;\r\n        box-sizing: border-box;\r\n\r\n        .time-picker-button-container {\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            gap: 8px;\r\n            justify-content: end;\r\n            padding-bottom: 24px;\r\n        }\r\n\r\n        .text-field-container {\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            gap: 8px;\r\n            padding-left: 24px;\r\n\r\n            .text-field {\r\n                display: flex;\r\n                flex-direction: column;\r\n                gap: 4px;\r\n                margin-top: 16px;\r\n            }\r\n\r\n            .label {\r\n                color: $abb-text-primary-color;\r\n                font-weight: 500;\r\n                font-size: 0.875rem;\r\n            }\r\n        }\r\n\r\n        .to {\r\n            color: $abb-grey-800;\r\n            font-weight: 500;\r\n            font-size: 0.875rem;\r\n            margin-top: 32px;\r\n        }\r\n\r\n        .calender-part {\r\n            display: flex;\r\n            flex-direction: row;\r\n        }\r\n\r\n        .calender-time-container {\r\n            display: flex;\r\n            flex-direction: row;\r\n\r\n            .time-range-container {\r\n                display: flex;\r\n                flex-direction: column;\r\n                padding-top: 24px;\r\n                padding-bottom: 4px;\r\n\r\n                .from-to-label {\r\n                    color: $abb-text-primary-color;\r\n                    font-weight: 400;\r\n                    font-size: 0.875rem;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n*::-webkit-scrollbar {\r\n    width: 10px;\r\n    height: 10px;\r\n}\r\n\r\n*::-webkit-scrollbar-thumb {\r\n    background-color: $abb-grey-400;\r\n    border-radius: 20px;\r\n    border: 2px solid $abb-white;\r\n}\r\n\r\n.month-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px 0px 24px 24px;\r\n    max-width: 262px;\r\n\r\n    .month {\r\n        width: 59px;\r\n        border-radius: 20px;\r\n        margin: 8px;\r\n        height: 36px;\r\n        color: $abb-text-primary-color;\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: center;\r\n        font-weight: 400;\r\n        font-size: 1rem;\r\n        line-height: 1.75;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n            background-color: $abb-grey-300;\r\n        }\r\n\r\n        &.selected {\r\n            background-color: $abb-primary-default;\r\n            color: $abb-white;\r\n        }\r\n    }\r\n}\r\n\r\n.date-range-picker {\r\n    .calender-icon {\r\n        font-size: 1.5rem;\r\n        margin-right: 8px;\r\n    }\r\n\r\n    .mt-2 {\r\n        margin-top: 2px;\r\n        margin-left: 6px;\r\n    }\r\n}\r\n\r\n.year-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px 0px 24px 24px;\r\n    height: 200px;\r\n    overflow-y: auto;\r\n    max-width: 262px;\r\n\r\n    .year {\r\n        width: 68px;\r\n        border-radius: 20px;\r\n        margin: 4px;\r\n        height: 36px;\r\n        color: $abb-text-primary-color;\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: center;\r\n        font-weight: 400;\r\n        font-size: 1rem;\r\n        line-height: 1.75;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n            background-color: $abb-grey-300;\r\n        }\r\n\r\n        &.selected {\r\n            background-color: $abb-primary-default;\r\n            color: $abb-white;\r\n        }\r\n    }\r\n}\r\n\r\n.day-button-container {\r\n    display: flex;\r\n    cursor: pointer;\r\n\r\n    &.left-border-radius {\r\n        border-radius: 50% 0 0 50%;\r\n    }\r\n\r\n    &.right-border-radius {\r\n        border-radius: 0 50% 50% 0;\r\n    }\r\n\r\n    &.highlighted {\r\n        background-color: $abb-accordion-expanded-bg;\r\n    }\r\n\r\n    .button {\r\n        height: 28px;\r\n        width: 28px;\r\n        margin: 4px;\r\n        font-weight: 500;\r\n        font-size: 0.875rem;\r\n        font-family: \"ABBVoice\", Verdana !important;\r\n        color: $abb-text-primary-color;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        border-radius: 50%;\r\n\r\n        &:hover {\r\n            background-color: $abb-grey-300;\r\n        }\r\n\r\n        &.outlined {\r\n            border: 1px solid $abb-primary-default;\r\n        }\r\n\r\n        &.outOfCurrentMonth {\r\n            color: $abb-grey-500;\r\n        }\r\n\r\n        &.filled {\r\n            background-color: $abb-primary-default;\r\n            border-radius: 50%;\r\n            color: $abb-white;\r\n\r\n            &:hover {\r\n                background-color: $abb-primary-default !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.highlighted {\r\n        .button {\r\n            &:hover {\r\n                background-color: $abb-accordion-expanded-bg;\r\n            }\r\n        }\r\n    }\r\n}",".MuiDialog-root {\r\n    .MuiBackdrop-root.MuiModal-backdrop {\r\n        background-color: rgba(0, 0, 0, 0.32);\r\n    }\r\n}\r\n\r\n.MuiPaper-root.MuiPaper-elevation.MuiDialog-paper {\r\n    background-color: $abb-card-bg;\r\n    max-width: none;\r\n}\r\n\r\n.MuiDialog-paper {\r\n    .modal-container {\r\n        border-radius: 4px;\r\n        padding: 32px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        min-width: 350px;\r\n        max-width: 350px;\r\n        position: relative;\r\n\r\n        .close-icon {\r\n            position: absolute;\r\n            top: 24px;\r\n            right: 24px;\r\n            color: $abb-text-primary-color;\r\n            font-size: 1.2rem;\r\n        }\r\n\r\n        &.default-modal {\r\n            max-width: none;\r\n            padding: 32px;\r\n\r\n            .close-icon {\r\n                position: absolute;\r\n                top: 32px;\r\n                right: 32px;\r\n                color: $abb-text-primary-color;\r\n            }\r\n        }\r\n\r\n        .heading {\r\n            display: flex;\r\n            flex-direction: row;\r\n            gap: 8px;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            margin-bottom: 6px;\r\n\r\n            .heading-left {\r\n                display: flex;\r\n                flex-direction: row;\r\n                align-items: center;\r\n                gap: 8px;\r\n            }\r\n\r\n            &.border-bottom {\r\n                border-bottom: 1px solid $abb-grey-400;\r\n                padding-bottom: 16px;\r\n                margin-bottom: 16px;\r\n            }\r\n\r\n            .heading-icon {\r\n                font-size: 24px;\r\n            }\r\n\r\n            .heading-text {\r\n                font-size: 1.25rem;\r\n                font-weight: 700;\r\n                color: $abb-text-primary-color;\r\n                line-height: 1.563rem;\r\n            }\r\n\r\n            .dialog-title {\r\n                font-size: 1.5rem;\r\n                font-weight: 700;\r\n                color: $abb-text-primary-color;\r\n            }\r\n\r\n            .subtitle {\r\n                color: $abb-grey-800;\r\n                font-size: .875rem;\r\n                border-left: 1px solid $abb-grey-500;\r\n                margin-left: 8px;\r\n                padding-left: 16px;\r\n            }\r\n        }\r\n\r\n        &.information {\r\n            .heading-icon {\r\n                color: $abb-status-info;\r\n            }\r\n        }\r\n\r\n        &.error {\r\n            .heading-icon {\r\n                color: $abb-status-error;\r\n            }\r\n        }\r\n\r\n        &.success {\r\n            .heading-icon {\r\n                color: $abb-status-success;\r\n            }\r\n        }\r\n\r\n        &.warning {\r\n            .heading-icon {\r\n                color: $abb-status-warning;\r\n            }\r\n        }\r\n\r\n        &.default {\r\n            .heading-icon {\r\n                color: $abb-text-primary-color;\r\n            }\r\n        }\r\n\r\n        .content {\r\n            font-size: .875rem;\r\n            font-weight: 400;\r\n            color: $abb-text-primary-color;\r\n            line-height: 1.313rem;\r\n            margin-left: 32px;\r\n            margin-bottom: 16px;\r\n        }\r\n\r\n        .content-container {\r\n            min-width: 520px;\r\n            min-height: 22.75rem;\r\n            overflow-y: auto;\r\n            padding-top: 16px;\r\n            margin-bottom: 16px;\r\n            padding-bottom: 16px;\r\n            background-color: $abb-grey-300;\r\n        }\r\n\r\n        .modal-button-container {\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            justify-content: end;\r\n            gap: 8px;\r\n        }\r\n\r\n    }\r\n}",".empty-state {\r\n    background-color: $abb-white;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    gap: 4px;\r\n\r\n    .primary-text {\r\n        font-weight: 500;\r\n        font-size: 1.313rem;\r\n        color: $abb-text-primary-color;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-weight: 300;\r\n        font-size: 1rem;\r\n        color: $abb-text-primary-color;\r\n    }\r\n\r\n    .empty-state-button-container {\r\n        display: flex;\r\n        align-items: center;\r\n        flex-direction: row;\r\n        justify-content: center;\r\n        gap: 8px;\r\n        margin-top: 4px;\r\n    }\r\n\r\n    .empty-image {\r\n        width: 8%;\r\n    }\r\n}",".multi-file-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 2px;\r\n\r\n    .uploader-label {\r\n        font-family: 'ABBVoice', Verdana;\r\n        font-size: .875rem;\r\n        font-weight: 500;\r\n        letter-spacing: .16px;\r\n        color: $abb-text-primary-color;\r\n    }\r\n\r\n    .uploader-description {\r\n        font-family: 'ABBVoice', Verdana;\r\n        font-size: .875rem;\r\n        letter-spacing: .16px;\r\n        color: $abb-text-secondary-color;\r\n    }\r\n\r\n    .button-upload-content {\r\n        display: flex;\r\n        flex-direction: row;\r\n        gap: 16px;\r\n        margin-top: 8px;\r\n\r\n        .uploaded-file-container {\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: 8px;\r\n\r\n            .error-text {\r\n                font-size: 0.75rem;\r\n                color: $abb-status-error;\r\n            }\r\n\r\n            .file-content {\r\n                background: $abb-segmented-control-hover;\r\n                border-radius: 4px;\r\n                padding: 0 12px 0px 12px;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: space-between;\r\n                height: 34px;\r\n                max-width: 200px;\r\n                min-width: 200px;\r\n                color: $abb-text-primary-color;\r\n\r\n                .text-overflow {\r\n                    text-overflow: ellipsis;\r\n                    overflow: hidden;\r\n                    white-space: nowrap;\r\n                    max-width: 190px;\r\n                }\r\n\r\n\r\n                &.error {\r\n                    border-bottom: 2px solid $abb-status-error;\r\n                }\r\n\r\n                .file-name {\r\n                    text-overflow: ellipsis;\r\n                    overflow: hidden;\r\n                    white-space: nowrap;\r\n                    max-width: 173px;\r\n                    padding-right: 16px;\r\n                    font-size: .875rem;\r\n                    line-height: 1.5rem\r\n                }\r\n\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.parent-container {\r\n    min-width: 276px;\r\n    max-width: 276px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    box-sizing: border-box;\r\n    background: $abb-grey-200 0% 0% no-repeat padding-box;\r\n    border-radius: 4px;\r\n    opacity: 1;\r\n    height: 40px;\r\n    border: 1px solid $abb-grey-200;\r\n\r\n    .single-file-container {\r\n        display: flex;\r\n        font-family: 'ABBVoice', Verdana;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        padding: 0 16px;\r\n        min-height: 36px;\r\n        gap: 8px;\r\n        color: $abb-text-primary-color;\r\n\r\n        &.error {\r\n            border-bottom: 2px solid $abb-status-error;\r\n        }\r\n\r\n        &.space-between {\r\n            justify-content: space-between;\r\n        }\r\n\r\n        .icon-name-container {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 8px;\r\n            color: $abb-text-primary-color;\r\n\r\n            .text-overflow {\r\n                text-overflow: ellipsis;\r\n                overflow: hidden;\r\n                white-space: nowrap;\r\n                max-width: 190px;\r\n            }\r\n\r\n            .file-name {\r\n                text-overflow: ellipsis;\r\n                overflow: hidden;\r\n                white-space: nowrap;\r\n                max-width: 190px;\r\n            }\r\n        }\r\n\r\n        .dragndrop {\r\n            font-family: 'ABBVoice', Verdana;\r\n            font-size: .875rem;\r\n            color: $abb-grey-600;\r\n        }\r\n    }\r\n}",".app-header {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    box-sizing: border-box;\r\n    min-width: 939px;\r\n    align-items: center;\r\n    height: 64px;\r\n    background-color: $abb-white;\r\n    border-bottom: 1px solid $abb-grey-500;\r\n    border-top: 1px solid $abb-grey-500;\r\n    color: $abb-text-primary-color;\r\n\r\n    .first-part {\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        margin-left: 20px;\r\n\r\n        .abb-logo {\r\n            width: 4.25rem;\r\n            height: 1.625rem;\r\n            min-width: 4.25rem;\r\n            margin: 0 12px 0 0;\r\n\r\n        }\r\n\r\n        .header-text {\r\n            padding-right: 12px;\r\n            display: flex;\r\n            align-items: center;\r\n            font-size: 0.875rem;\r\n            color: $abb-text-primary-color;\r\n            font-weight: 400;\r\n        }\r\n\r\n        .divider {\r\n            height: 36px;\r\n            width: 1px;\r\n            background: $abb-grey-500;\r\n        }\r\n\r\n        .app-title {\r\n            display: flex;\r\n            flex-direction: column;\r\n            justify-content: center;\r\n            line-height: 1.5;\r\n            font-size: 0.875rem;\r\n            color: $abb-text-primary-color;\r\n            padding-left: 12px;\r\n        }\r\n\r\n        #nav-icon {\r\n            margin-right: 20px;\r\n            cursor: pointer;\r\n            width: 24px;\r\n            height: 24px;\r\n            position: relative;\r\n            position: relative;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n        }\r\n\r\n        #nav-icon span {\r\n            position: absolute;\r\n            height: 1.5px;\r\n            width: 22px;\r\n            background: $abb-text-primary-color;\r\n            border-radius: 9px;\r\n            opacity: 1;\r\n            left: 0;\r\n            transition: all .4s;\r\n            cursor: pointer;\r\n        }\r\n\r\n        #nav-icon span:nth-child(1) {\r\n            top: 6.5px;\r\n        }\r\n\r\n        #nav-icon span:nth-child(2) {\r\n            top: 12.5px;\r\n        }\r\n\r\n        #nav-icon span:nth-child(3) {\r\n            top: 18.5px;\r\n        }\r\n\r\n        #nav-icon.open span:nth-child(1) {\r\n            top: 12px;\r\n            transform: rotate(45deg);\r\n            left: 0;\r\n        }\r\n\r\n        #nav-icon.open span:nth-child(2) {\r\n            width: 0;\r\n            opacity: 0;\r\n        }\r\n\r\n        #nav-icon.open span:nth-child(3) {\r\n            transform: rotate(-45deg);\r\n            top: 12px;\r\n            left: 0;\r\n        }\r\n    }\r\n\r\n    .tab-container {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        .tab-text {\r\n            border-bottom: 0.25rem solid transparent;\r\n            cursor: pointer;\r\n            font-size: 0.875rem;\r\n            color: $abb-text-primary-color;\r\n            display: inline-flex;\r\n            align-items: center;\r\n            place-content: center;\r\n            gap: 8px;\r\n            height: 100%;\r\n            padding: 1.9rem 2.25rem;\r\n\r\n            .down-icon {\r\n                margin-top: 2px;\r\n            }\r\n\r\n            &:hover {\r\n                font-weight: 500;\r\n            }\r\n\r\n            &.active {\r\n                font-weight: 500;\r\n            }\r\n        }\r\n\r\n\r\n        .active-tab-indicator {\r\n            position: absolute;\r\n            bottom: 10px;\r\n            height: 0.25rem;\r\n            background-color: $abb-primary-default;\r\n            transition: left 0.3s ease;\r\n        }\r\n    }\r\n\r\n    .second-part {\r\n        position: relative;\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        margin-right: 20px;\r\n        gap: 0.75rem;\r\n\r\n        .part-one {\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            gap: 0.75rem;\r\n\r\n            .position {\r\n                position: absolute;\r\n                top: 9px;\r\n                right: 69px;\r\n            }\r\n\r\n            .search-container {\r\n                display: flex;\r\n                align-items: center;\r\n                position: relative;\r\n\r\n                .header-search-bar {\r\n                    position: absolute;\r\n                    top: 0;\r\n                    right: 24px;\r\n                    width: 0;\r\n                    z-index: 2;\r\n                    opacity: 0;\r\n                    transition: transform 0.3s ease, opacity 0.3s ease, width 0.3s ease;\r\n                    transform: translateX(100%);\r\n                }\r\n\r\n                .header-search-bar.active {\r\n                    opacity: 1;\r\n                    right: 30px;\r\n                    width: 160px;\r\n                    top: 0px;\r\n                    z-index: 99;\r\n                    transform: translateX(0);\r\n                }\r\n            }\r\n\r\n            .notification {\r\n                position: relative;\r\n            }\r\n\r\n            .copilot {\r\n                padding: 6px 12px 4px 12px;\r\n                background-color: $abb-grey-300;\r\n                border-radius: 8px;\r\n\r\n                .copilot-img {\r\n                    max-width: 80px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .divider {\r\n            height: 36px;\r\n            width: 1px;\r\n            background: $abb-grey-500;\r\n        }\r\n\r\n        .part-two {\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            gap: 0.75rem;\r\n        }\r\n\r\n        .header-icon {\r\n            font-size: 1.5rem;\r\n            z-index: 10;\r\n        }\r\n\r\n        .global-icon {\r\n            font-size: 2rem;\r\n        }\r\n\r\n        .pr-12 {\r\n            padding-right: 0.75rem;\r\n        }\r\n\r\n\r\n    }\r\n}\r\n\r\n.p-0 {\r\n    padding: 0 !important;\r\n    max-width: none;\r\n    min-width: 68vw;\r\n\r\n    .css-1d3ml05-MuiPopper-root-MuiTooltip-popper .MuiTooltip-arrow  {\r\n        width: 11em !important;\r\n        height: 1.9em !important;\r\n        margin-top: -1.9em;\r\n        margin-left: 4em;\r\n    }\r\n\r\n    &.MuiTooltip-tooltip.theme-light .MuiTooltip-arrow::before {\r\n        color: $abb-grey-200 !important;\r\n    }\r\n\r\n}\r\n\r\n.header-navigation-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    min-width: 68vw;\r\n\r\n    .left-part {\r\n        width: 40%;\r\n        background-color: $abb-white;\r\n        display: flex;\r\n        align-items: center;\r\n        height: 100%;\r\n        justify-content: center;\r\n        flex-direction: column;\r\n        gap: 24px;\r\n        padding: 24px;\r\n\r\n        .top {\r\n            display: flex;\r\n            flex-direction: column;\r\n            align-items: center;\r\n            gap: 8px;\r\n\r\n            .text-link {\r\n                gap: 0;\r\n                display: flex;\r\n            }\r\n        }\r\n\r\n        .heading {\r\n            font-size: 1.313rem;\r\n            font-weight: 500;\r\n            text-wrap: nowrap;\r\n            color: $abb-text-primary-color;\r\n        }\r\n\r\n        .list-container {\r\n            display: flex;\r\n            flex-direction: column;\r\n            justify-content: center;\r\n            width: 100%;\r\n\r\n            .nav-list-item {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: start;\r\n                height: 32px;\r\n                font-size: 0.875rem;\r\n                font-weight: 500;\r\n                width: 88%;\r\n                border-left: 4px solid transparent;\r\n                padding: 0 16px;\r\n                cursor: pointer;\r\n                margin-bottom: .5rem;\r\n                border-radius: 8px;\r\n                border-top-left-radius: 0;\r\n                border-bottom-left-radius: 0;\r\n\r\n                &:hover {\r\n                    background-color: $abb-grey-300;\r\n                }\r\n\r\n                &.selected {\r\n                    border-left: 4px solid $abb-primary-default;\r\n                    background-color: $abb-accordion-expanded-bg;\r\n                }\r\n            }\r\n        }\r\n\r\n        .digital-img {\r\n            width: 52px;\r\n            height: 52px;\r\n        }\r\n\r\n    }\r\n\r\n    .right-part {\r\n        width: 60%;\r\n        background-color: $abb-grey-200;\r\n        padding: 24px;\r\n\r\n        .card-container {\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n            gap: 16px;\r\n            height: 200px;\r\n            overflow-y: auto;\r\n        }\r\n\r\n        .app-item {\r\n            width: 48%;\r\n            display: flex;\r\n            align-items: center;\r\n            border: 0;\r\n            box-shadow: none;\r\n            gap: 16px;\r\n            background: transparent;\r\n\r\n            .icon-container {\r\n                border-radius: 12px;\r\n                box-sizing: border-box;\r\n                width: 56px;\r\n                height: 56px;\r\n                border: 1px solid transparent;\r\n                background-color: $abb-white;\r\n                box-shadow: 1px 1px 10px #0000000d;\r\n\r\n                .icon {\r\n                    width: 54%;\r\n                    cursor: default;\r\n                }\r\n\r\n                &.hover {\r\n                    background-color: $abb-accordion-expanded-bg;\r\n                    border: 1px solid $abb-primary-default;\r\n                    cursor: pointer;\r\n\r\n                }\r\n            }\r\n\r\n            .content {\r\n                font-size: .875rem;\r\n                font-weight: 400;\r\n                color: $abb-text-primary-color;\r\n\r\n                &.hover {\r\n                    font-weight: 500;\r\n                    cursor: pointer;\r\n                }\r\n            }\r\n        }\r\n\r\n        .heading {\r\n            font-size: 1rem;\r\n            font-weight: 500;\r\n            color: $abb-text-primary-color;\r\n            margin-bottom: 16px;\r\n        }\r\n    }\r\n}",".icon-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: transparent !important;\r\n    color: $abb-text-primary-color;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n\r\n    &.size-8 {\r\n        font-size: 0.5rem;\r\n        padding: 0.188rem;\r\n    }\r\n\r\n    &.size-12 {\r\n        font-size: 0.75rem;\r\n        padding: 0.25rem;\r\n    }\r\n\r\n    &.size-16 {\r\n        font-size: 1rem;\r\n        padding: 0.375rem;\r\n    }\r\n\r\n    &.size-24 {\r\n        font-size: 1.5rem;\r\n        padding: 0.5rem;\r\n    }\r\n\r\n    &.size-32 {\r\n        font-size: 2rem;\r\n        padding: 0.75rem;\r\n    }\r\n\r\n    &:not(.disable-hover):not(.disabled):hover {\r\n        background-color:  $abb-grey-200 !important;\r\n    }\r\n\r\n    &.list{\r\n        &:not(.disable-hover):not(.disabled):hover {\r\n            background-color: $abb-icon-hover !important;\r\n        }\r\n    }\r\n\r\n    &:not(.disable-hover):not(.disabled):active {\r\n        background-color: $abb-grey-300 !important;\r\n    }\r\n\r\n    &.selected {\r\n        background-color: $abb-accordion-expanded-bg !important;\r\n    }\r\n\r\n    &.disabled {\r\n        color: $abb-grey-600;\r\n        background-color: transparent;\r\n        cursor: not-allowed;\r\n    }\r\n}",".input-group {\r\n    .middle {\r\n        .MuiFormControl-root.MuiTextField-root {\r\n            &:focus-visible{\r\n                outline-offset: 1px;\r\n                outline: 2px solid $abb-primary-active;\r\n            }\r\n\r\n        }\r\n\r\n        .Mui-focused{\r\n            border-left: none;\r\n            border-right: none;\r\n        }\r\n\r\n        .MuiOutlinedInput-notchedOutline{\r\n            border-left: none;\r\n            border-right: none;\r\n        }\r\n    }\r\n\r\n    .disabled{\r\n        background-color: $abb-grey-200;\r\n        cursor: not-allowed;\r\n        pointer-events: none;\r\n        .disabled{\r\n            opacity: 0.6;\r\n        }\r\n    }\r\n\r\n    .read-only-input-group{\r\n        font-size: 0.875rem;\r\n        color: $abb-text-primary-color;\r\n        font-weight: 400;\r\n        box-sizing: border-box;\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: start;\r\n\r\n        &.border{\r\n            border-left: 1px solid $abb-grey-500\r\n        }\r\n    }\r\n\r\n    .MuiInputBase-root.MuiInput-root.MuiInput-underline {\r\n        &::before {\r\n            border-bottom: 1px solid $abb-grey-400;\r\n        }\r\n\r\n        &:hover:not(.Mui-disabled, .Mui-error):before {\r\n            border-bottom: 1px solid $abb-text-primary-color;\r\n        }\r\n\r\n        &::after{\r\n            border-bottom: 1px solid $abb-primary-default;\r\n        }\r\n    }\r\n}",".leftNav {\r\n    display: flex;\r\n    // position: fixed;\r\n    // height: 100vh;\r\n    height: 100%;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    overflow: auto;\r\n    z-index: 100;\r\n    overflow-x: hidden;\r\n    min-height: 600px;\r\n    background-color: $abb-grey-100;\r\n    border-width: 2px solid $abb-grey-400;\r\n    box-shadow: 0 3px 6px $abb-shadow-grey-200;\r\n    transition: width 0.5s ease;\r\n\r\n    .nav-container-submenu {\r\n        display: flex;\r\n        flex-direction: column;\r\n        width: 100%\r\n    }\r\n\r\n    .submenu {\r\n        overflow: hidden;\r\n        height: 0;\r\n        transition: height 0.3s ease;\r\n    }\r\n\r\n    .submenu-item {\r\n        padding: 16px 38px 16px 54px;\r\n        display: flex;\r\n        align-items: center;\r\n        flex-direction: row;\r\n        justify-content: space-between;\r\n        gap: 8px;\r\n        background-color: $abb-white;\r\n        color: $abb-text-primary-color;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n            background-color: $abb-grey-300;\r\n        }\r\n\r\n        &.selected {\r\n            background-color: $abb-accordion-expanded-bg;\r\n            font-weight: 500;\r\n        }\r\n\r\n        .submenu-content {\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            justify-content: start;\r\n            gap: 8px;\r\n        }\r\n\r\n        .badge-container{\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n\r\n        &.border-color {\r\n            border-left: 4px solid $abb-primary-default;\r\n        }\r\n\r\n        &.border-transparent {\r\n            border-left: 4px solid transparent;\r\n        }\r\n\r\n    }\r\n\r\n    .submenu-icon {\r\n        font-size: 16px;\r\n    }\r\n\r\n    .submenu-label {\r\n        font-size: 0.875rem;\r\n    }\r\n\r\n    .hierarchy {\r\n        display: flex;\r\n        align-items: center;\r\n        overflow: hidden;\r\n        min-height: 64px;\r\n        gap: 16px;\r\n        cursor: pointer;\r\n        color: $abb-text-primary-color;\r\n        border-bottom: 1px solid $abb-grey-400;\r\n        margin-bottom: 4px;\r\n\r\n        &:hover {\r\n            background-color: $abb-grey-400;\r\n        }\r\n\r\n        &.justify-start {\r\n            justify-content: start;\r\n            padding-left: 20px;\r\n        }\r\n\r\n        &.justify-center {\r\n            padding-left: 20px;\r\n\r\n        }\r\n\r\n        .hierarchy-text {\r\n            &.visible {\r\n                display: block;\r\n            }\r\n\r\n            &.hidden {\r\n                display: none;\r\n            }\r\n\r\n        }\r\n\r\n        .nav-icon {\r\n            font-size: 24px;\r\n            color: $abb-text-primary-color;\r\n        }\r\n    }\r\n\r\n    .navigation {\r\n        position: relative;\r\n        display: flex;\r\n        align-items: center;\r\n        overflow: hidden;\r\n        min-height: 64px;\r\n        height: auto;\r\n        gap: 16px;\r\n        cursor: pointer;\r\n        border-left: 4px solid transparent;\r\n        color: $abb-text-primary-color;\r\n\r\n        &:hover {\r\n            background-color: $abb-grey-400;\r\n            transition: all 0.2s ease-in-out;\r\n        }\r\n\r\n        &.bg-highlight {\r\n            background-color: $abb-accordion-expanded-bg;\r\n\r\n            &.border-left {\r\n                border-left: 4px solid $abb-primary-default;\r\n            }\r\n        }\r\n\r\n        &.bg-white {\r\n            background-color: $abb-white;\r\n\r\n            &.border-left {\r\n                border-left: 4px solid $abb-primary-default;\r\n            }\r\n        }\r\n\r\n        &.justify-start {\r\n            justify-content: space-between;\r\n        }\r\n\r\n        &.pl-16 {\r\n            padding-left: 16px;\r\n\r\n        }\r\n\r\n        &.disabled {\r\n            color: $abb-grey-600;\r\n            background-color: $abb-grey-100;\r\n            cursor: not-allowed;\r\n        }\r\n\r\n        .left-nav-badge-position {\r\n            position: absolute;\r\n            right: 12px;\r\n            top: 16px;\r\n        }\r\n\r\n        .nav-content-container {\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            justify-content: start;\r\n            gap: 16px;\r\n\r\n        }\r\n\r\n        .nav-wrapper-container {\r\n            display: flex;\r\n            flex-direction: row;\r\n            justify-content: space-between;\r\n            width: 100%;\r\n        }\r\n\r\n        .nav-content-left {\r\n            padding-right: 16px;\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            gap: 8px;\r\n\r\n            .visible {\r\n                visibility: visible;\r\n            }\r\n\r\n            .hidden {\r\n                visibility: hidden;\r\n            }\r\n\r\n            .rotate-arrow {\r\n                transform: rotate(90deg);\r\n                transition: transform 0.3s linear;\r\n            }\r\n\r\n            .right-arrow {\r\n                transition: transform 0.3s linear;\r\n            }\r\n        }\r\n\r\n        .nav-icon {\r\n            position: relative;\r\n            font-size: 24px;\r\n            color: $abb-text-primary-color;\r\n\r\n            &.icon-blue {\r\n                color: $abb-primary-default;\r\n            }\r\n\r\n            &.disabled {\r\n                color: $abb-grey-600;\r\n                background-color: $abb-grey-100;\r\n                cursor: not-allowed;\r\n            }\r\n\r\n        }\r\n\r\n        .nav-text {\r\n            font-size: 0.875rem;\r\n            font-weight: 400;\r\n            color: $abb-text-primary-color;\r\n            white-space: nowrap;\r\n            overflow: hidden;\r\n\r\n            &.text-blue {\r\n                color: $abb-primary-default;\r\n                font-weight: 500;\r\n            }\r\n\r\n            &.visible {\r\n                display: block;\r\n            }\r\n\r\n            &.hidden {\r\n                display: none;\r\n            }\r\n\r\n            &.disabled {\r\n                color: $abb-grey-600;\r\n                background-color: $abb-grey-100;\r\n                cursor: not-allowed;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    &.w-80 {\r\n        width: 300px;\r\n    }\r\n\r\n    &.w-64 {\r\n        width: 64px;\r\n    }\r\n}",".text-link {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 8px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: $abb-text-blue-color !important;\r\n    cursor: pointer;\r\n    text-decoration: none !important;\r\n    display: inline-block;\r\n    text-wrap: nowrap;\r\n\r\n    &.mb-4 {\r\n        margin-bottom: 4px;\r\n    }\r\n\r\n    &:hover {\r\n        text-decoration: underline !important;\r\n    }\r\n\r\n    &.disabled {\r\n        cursor: 'not-allowed';\r\n        color: $abb-text-primary-color !important;\r\n        opacity: 50%;\r\n        cursor: not-allowed;\r\n        text-decoration: none !important;\r\n    }\r\n\r\n    .icon {\r\n        margin-bottom: 4px;\r\n        padding-right: 8px;\r\n    }\r\n\r\n    .trailing-icon{\r\n        margin-bottom: -2px;\r\n    }\r\n\r\n    .text {\r\n        margin-right: 0.125rem;\r\n    }\r\n\r\n    &.size-12 {\r\n        font-size: 0.75rem;\r\n    }\r\n\r\n    &.size-14 {\r\n        font-size: 0.875rem;\r\n    }\r\n\r\n    &.size-16 {\r\n        font-size: 1rem;\r\n    }\r\n}",".MuiList-root {\r\n    background-color: $abb-card-bg;\r\n    border-radius: 4px;\r\n    box-sizing: border-box;\r\n    min-width: 300px;\r\n\r\n    &.MuiList-root {\r\n        padding: 0;\r\n\r\n        .zebra-stripe {\r\n            background-color: $abb-toolbar-bg;\r\n        }\r\n\r\n        .zebra-white{\r\n            background-color: $abb-white;\r\n        }\r\n\r\n        .MuiListItem-root {\r\n            .size-40 {\r\n                min-height: 40px;\r\n                padding: 0 20px;\r\n\r\n            }\r\n\r\n            .size-32 {\r\n                min-height: 32px;\r\n                padding: 0 16px;\r\n            }\r\n\r\n            .size-24 {\r\n                min-height: 24px;\r\n                padding: 0 12px;\r\n            }\r\n\r\n            &.pl-less{\r\n                .size-40 {\r\n                    padding: 0 14px 0 20px;\r\n                }\r\n    \r\n                .size-32 {\r\n                    padding: 0 10px 0 16px;\r\n                }\r\n    \r\n                .size-24 {\r\n                    padding: 0 6px 0 12px;\r\n                }\r\n            }\r\n\r\n\r\n        }\r\n\r\n    }\r\n\r\n    .MuiDivider-root {\r\n        background: $abb-grey-400;\r\n    }\r\n\r\n    .MuiListItem-root {\r\n        padding: 0;\r\n\r\n        .MuiButtonBase-root {\r\n            &.MuiListItemButton-root {\r\n                font-family: 'ABBVoice', Verdana;\r\n                color: $abb-text-primary-color;\r\n                font-size: 0.875rem;\r\n                font-weight: 400;\r\n                border-left: 4px solid transparent;\r\n\r\n                &:hover {\r\n                    background-color: $abb-grey-300;\r\n                }\r\n\r\n                &.Mui-selected {\r\n                    background-color: $abb-accordion-expanded-bg;\r\n\r\n                    &.multi {\r\n                        border-left: 4px solid transparent;\r\n                    }\r\n\r\n                    &.single {\r\n                        border-left: 4px solid $abb-primary-default;\r\n                    }\r\n                }\r\n\r\n                .MuiCheckbox-root {\r\n                    padding: 0;\r\n                }\r\n\r\n                .MuiListItemIcon-root {\r\n                    min-width: 0;\r\n                    padding-right: 8px;\r\n                    font-size: 1rem;\r\n                    color: $abb-text-primary-color;\r\n                }\r\n\r\n                .MuiListItemText-primary {\r\n                    font-family: 'ABBVoice', Verdana;\r\n                    color: $abb-text-primary-color;\r\n                    font-size: 0.875rem;\r\n                    font-weight: 400;\r\n                    line-height: 1.313rem;\r\n                }\r\n\r\n                .MuiListItemText-secondary {\r\n                    font-family: 'ABBVoice', Verdana;\r\n                    color: $abb-grey-800;\r\n                    font-size: 0.875rem;\r\n                    line-height: 1.313rem;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}",".loading-indicator-container {\r\n    min-width: 350px;\r\n}\r\n\r\n.loading-indicator-label {\r\n    color: $abb-grey-800;\r\n    font-size: 0.875rem;\r\n    font-weight: 400;\r\n    font-family: 'ABBVoice', Verdana;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    min-width: 64px;\r\n\r\n    .mr-20 {\r\n        margin-right: 20px;\r\n    }\r\n\r\n    &.large {\r\n        position: absolute;\r\n        top: 38px;\r\n        left: 34px;\r\n    }\r\n}\r\n\r\n.loading-indicator-description {\r\n    color: $abb-grey-800;\r\n    font-size: 0.75rem;\r\n    font-weight: 400;\r\n}\r\n\r\n.progress-bar-container {\r\n    display: flex;\r\n    width: 100%;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    gap: 8px;\r\n\r\n    .success {\r\n        color: $abb-status-success;\r\n    }\r\n}\r\n\r\n.MuiLinearProgress-root.MuiLinearProgress-colorPrimary {\r\n    background-color: $abb-grey-400;\r\n    border-radius: 4px;\r\n    width: 100%;\r\n\r\n    &.size-small {\r\n        height: 4px;\r\n    }\r\n\r\n    &.size-medium {\r\n        height: 6px;\r\n    }\r\n\r\n    &.size-large {\r\n        height: 8px;\r\n    }\r\n\r\n    .MuiLinearProgress-bar {\r\n        background-color: $abb-primary-default;\r\n    }\r\n\r\n    &.green-bg {\r\n        .MuiLinearProgress-bar {\r\n            background-color: $abb-status-success;\r\n        }\r\n    }\r\n\r\n    &.disabled {\r\n        .MuiLinearProgress-bar {\r\n            background-color: $abb-grey-600;\r\n        }\r\n    }\r\n}\r\n\r\n.circular-progress-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 8px;\r\n    position: relative;\r\n\r\n    .tick-icon {\r\n        color: $abb-status-success;\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n\r\n        &.small {\r\n            font-size: 0.75rem;\r\n            top: 3px;\r\n            left: 2px;\r\n        }\r\n\r\n        &.large {\r\n          top: 12px;\r\n          left: 12px;\r\n          font-size: 5rem;\r\n        }\r\n\r\n        &.medium {\r\n          top: 6px;\r\n          left: 4px;\r\n          font-size: 2.5rem;\r\n        }\r\n    }\r\n}\r\n\r\n.MuiCircularProgress-root.MuiCircularProgress-colorPrimary {\r\n    color: $abb-primary-default;\r\n\r\n    &.bg-circle-radial {\r\n        color: $abb-grey-400;\r\n    }\r\n\r\n    &.green-bg {\r\n        color: $abb-status-success;\r\n    }\r\n\r\n    &.disabled {\r\n        color: $abb-grey-600;\r\n    }\r\n}\r\n\r\n.dot-pulse {\r\n    position: relative;\r\n    left: -9999px;\r\n    width: 1rem;\r\n    height: 1rem;\r\n    border-radius: 50%;\r\n    background-color: $abb-primary-default;\r\n    color: $abb-primary-default;\r\n    box-shadow: 9999px 0 0 -5px $abb-primary-default;\r\n    animation: dotPulse 1.5s infinite linear;\r\n    animation-delay: 0.25s;\r\n  }\r\n  \r\n  .dot-pulse::before,\r\n  .dot-pulse::after {\r\n    content: \"\";\r\n    display: inline-block;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 1rem;\r\n    height: 1rem;\r\n    border-radius: 50%;\r\n    background-color: $abb-primary-default;\r\n    color: $abb-primary-default;\r\n  }\r\n  \r\n  .dot-pulse::before {\r\n    box-shadow: 9984px 0 0 -5px $abb-primary-default;\r\n    animation: dotPulseBefore 1.5s infinite linear;\r\n    animation-delay: 0s;\r\n  }\r\n  \r\n  .dot-pulse::after {\r\n    box-shadow: 10014px 0 0 -5px $abb-primary-default;\r\n    animation: dotPulseAfter 1.5s infinite linear;\r\n    animation-delay: 0.5s;\r\n  }\r\n  \r\n  @keyframes dotPulseBefore {\r\n    0% {\r\n      box-shadow: 9984px 0 0 -5px $abb-primary-default;\r\n    }\r\n  \r\n    30% {\r\n      box-shadow: 9984px 0 0 2px $abb-primary-default;\r\n    }\r\n  \r\n    60%,\r\n    100% {\r\n      box-shadow: 9984px 0 0 -5px $abb-primary-default;\r\n    }\r\n  }\r\n  \r\n  @keyframes dotPulse {\r\n    0% {\r\n      box-shadow: 9999px 0 0 -5px $abb-primary-default;\r\n    }\r\n  \r\n    30% {\r\n      box-shadow: 9999px 0 0 2px $abb-primary-default;\r\n    }\r\n  \r\n    60%,\r\n    100% {\r\n      box-shadow: 9999px 0 0 -5px $abb-primary-default;\r\n    }\r\n  }\r\n  \r\n  @keyframes dotPulseAfter {\r\n    0% {\r\n      box-shadow: 10014px 0 0 -5px $abb-primary-default;\r\n    }\r\n  \r\n    30% {\r\n      box-shadow: 10014px 0 0 2px $abb-primary-default;\r\n    }\r\n  \r\n    60%,\r\n    100% {\r\n      box-shadow: 10014px 0 0 -5px $abb-primary-default;\r\n    }\r\n  }\r\n  ",".MuiMenu-list {\r\n    min-width: 200px;\r\n}\r\n\r\n.MuiButtonBase-root {\r\n    &.MuiMenuItem-root {\r\n        color: $abb-text-primary-color;\r\n        font-size: 0.875rem;\r\n        font-family: \"ABBVoice\", Verdana;\r\n        font-weight: 400;\r\n        display: flex;\r\n        align-items: center;\r\n        box-sizing: border-box;\r\n        justify-content: start;\r\n        gap: 8px;\r\n        &:hover {\r\n            background-color: $abb-grey-300;\r\n        }\r\n\r\n        &.size-40 {\r\n            min-height: 40px;\r\n            padding: 4px 20px;\r\n        }\r\n\r\n        &.size-32 {\r\n            min-height: 32px;\r\n            padding: 4px 16px;\r\n\r\n        }\r\n\r\n        &.size-24 {\r\n            min-height: 24px;\r\n            padding: 0 12px;\r\n        }\r\n\r\n        &.selected {\r\n            background-color: $abb-accordion-expanded-bg;\r\n        }\r\n\r\n        .menu-item {\r\n            display: flex;\r\n            flex-direction: row;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n            width: 100%;\r\n\r\n            .first-part {\r\n                display: flex;\r\n                flex-direction: row;\r\n                gap: 8px;\r\n                align-items: center;\r\n                justify-content: start;\r\n            }\r\n\r\n            .label {\r\n                display: flex;\r\n                flex-direction: column;\r\n\r\n                .title {\r\n                    font-size: 0.875rem;\r\n                    color: $abb-text-primary-color;\r\n                }\r\n\r\n                .description {\r\n                    font-size: 0.75rem;\r\n                    color: $abb-grey-800;\r\n                    font-family: \"ABBVoice\", Verdana;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.MuiMenuItem-root+.MuiDivider-root {\r\n        margin: 0;\r\n    }\r\n}\r\n\r\n.MuiList-root {\r\n    .MuiDivider-root {\r\n        color: $abb-grey-400;\r\n        margin: 0;\r\n    }\r\n}",".MuiSnackbar-root {\r\n    &.position{\r\n        top: 64px !important;\r\n        right: 8px !important;\r\n    }\r\n    .notification-container {\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        box-sizing: border-box;\r\n        padding: 16px;\r\n        border-radius: 4px;\r\n        min-width: 300px;\r\n        min-height: 24px;\r\n        height: 56px;\r\n        font-size: 1rem;\r\n        font-weight: 500;\r\n        position: relative;\r\n        color: $abb-text-primary-color;\r\n        box-shadow: 0 3px 6px $abb-shadow-grey-200;\r\n\r\n        .container {\r\n            display: flex;\r\n            flex-direction: row;\r\n            gap: 8px;\r\n            justify-content: center;\r\n        }\r\n\r\n        &.sm {\r\n            padding: 10px 16px;\r\n            height: 36px;\r\n            font-size: 0.875rem;\r\n            min-height: 6px;\r\n        }\r\n\r\n        &.banner {\r\n            width: 100vw;\r\n            height: auto;\r\n            position: absolute;\r\n\r\n            .w-4 {\r\n                width: 4%;\r\n            }\r\n        }\r\n\r\n        .content-container {\r\n            display: flex;\r\n            flex-direction: column;\r\n            justify-content: center;\r\n            gap: 4px;\r\n\r\n            .secondary-text {\r\n                color: $abb-text-primary-color;\r\n                font-size: .75rem;\r\n                font-weight: 300;\r\n            }\r\n        }\r\n\r\n        &.neutral {\r\n            background-color: $abb-white;\r\n        }\r\n\r\n        &.neutral-sm {\r\n            background-color: $abb-grey-200;\r\n            border: 1px solid $abb-grey-500\r\n        }\r\n\r\n        &.primary {\r\n            background-color: $abb-white;\r\n            border-radius: 0 0 5px 5px;\r\n            border-top: 4px solid $abb-status-info;\r\n\r\n            .notification-icon {\r\n                color: $abb-status-info;\r\n                font-size: 1.75rem;\r\n            }\r\n        }\r\n\r\n        &.primary-sm {\r\n            background-color: $abb-status-info-transparent;\r\n            border: 1px solid $abb-status-info;\r\n\r\n            .notification-icon {\r\n                color: $abb-status-info;\r\n                font-size: 1.25rem;\r\n            }\r\n        }\r\n\r\n        &.success {\r\n            background-color: $abb-white;\r\n            border-radius: 0 0 5px 5px;\r\n            border-top: 4px solid $abb-status-success;\r\n\r\n            .notification-icon {\r\n                color: $abb-status-success;\r\n                font-size: 1.75rem;\r\n            }\r\n        }\r\n\r\n        &.success-sm {\r\n            background-color: $abb-status-success-transparent;\r\n            border: 1px solid $abb-status-success;\r\n\r\n            .notification-icon {\r\n                color: $abb-status-success;\r\n                font-size: 1.25rem;\r\n\r\n            }\r\n        }\r\n\r\n        &.warning {\r\n            background-color: $abb-white;\r\n            border-radius: 0 0 5px 5px;\r\n            border-top: 4px solid $abb-status-warning;\r\n\r\n            .notification-icon {\r\n                color: $abb-status-warning;\r\n                font-size: 1.75rem;\r\n            }\r\n        }\r\n\r\n        &.warning-sm {\r\n            background-color: $abb-status-warning-transparent;\r\n            border: 1px solid $abb-status-warning;\r\n\r\n            .notification-icon {\r\n                color: $abb-status-warning;\r\n                font-size: 1.25rem;\r\n\r\n            }\r\n        }\r\n\r\n        &.error {\r\n            background-color: $abb-white;\r\n            border-radius: 0 0 5px 5px;\r\n            border-top: 4px solid $abb-status-error;\r\n\r\n            .notification-icon {\r\n                color: $abb-status-error;\r\n                font-size: 1.75rem;\r\n            }\r\n        }\r\n\r\n        &.error-sm {\r\n            background-color: $abb-status-error-transparent;\r\n            border: 1px solid $abb-status-error;\r\n\r\n            .notification-icon {\r\n                color: $abb-status-error;\r\n                font-size: 1.25rem;\r\n            }\r\n        }\r\n    }\r\n}",".numeric {\r\n    .ml-4 {\r\n        margin-left: 4px;\r\n    }\r\n\r\n    .active {\r\n        cursor: pointer;\r\n    }\r\n\r\n    .inactive {\r\n        opacity: 0.5;\r\n        cursor: not-allowed !important;\r\n    }\r\n\r\n    .error-icon {\r\n        color: $abb-status-error;\r\n        margin-top: 2px;\r\n    }\r\n\r\n    .tick-icon {\r\n        color: $abb-status-success;\r\n        margin-top: 2px;\r\n    }\r\n\r\n    .small-variant-action {\r\n        display: flex;\r\n        flex-direction: column;\r\n        background-color: $abb-grey-200;\r\n        border-left: 1px solid $abb-grey-400;\r\n\r\n        .square-icon{\r\n            &:hover{\r\n                background-color: $abb-grey-200;\r\n            }\r\n            &:active{\r\n                background-color: $abb-grey-300;\r\n            }\r\n        }\r\n\r\n        .border-top {\r\n            border-top: 1px solid $abb-grey-400;\r\n            border-radius: 0;\r\n        }\r\n\r\n        .size-32 {\r\n            padding: 2.5px;\r\n        }\r\n\r\n        .size-40 {\r\n            padding: 4px;\r\n        }\r\n    }\r\n\r\n    .disabled {\r\n        background-color: $abb-grey-200;\r\n        cursor: not-allowed;\r\n        pointer-events: none;\r\n\r\n        .prefix,\r\n        .end-adornment,\r\n        .suffix {\r\n            color: $abb-grey-500;\r\n        }\r\n\r\n        .disabled {\r\n            opacity: 0.6;\r\n        }\r\n    }\r\n}",".MuiTableCell-root.MuiTablePagination-root {\r\n    border-bottom: none;\r\n    color: $abb-text-primary-color;\r\n    font-family: 'ABBVoice', Verdana;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    display: flex;\r\n\r\n    &.add-border {\r\n        border-top: 1px solid $abb-grey-500;\r\n    }\r\n\r\n    .MuiTablePagination-toolbar {\r\n        min-height: 56px;\r\n        padding-left: 32px;\r\n        padding-right: 32px;\r\n        background-color: $abb-white;\r\n        display: flex;\r\n        flex-direction: row;\r\n        font-family: 'ABBVoice', Verdana;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n\r\n        .MuiTablePagination-spacer {\r\n            display: none;\r\n        }\r\n\r\n        .pagination-wrapper {\r\n            font-family: 'ABBVoice', Verdana;\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            justify-content: start;\r\n            gap: 8px;\r\n        }\r\n\r\n        .MuiTablePagination-displayedRows {\r\n            display: none;\r\n        }\r\n\r\n        .pagination-actions {\r\n            font-family: 'ABBVoice', Verdana;\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            justify-content: end;\r\n            \r\n            .arrow {\r\n                color: $abb-text-primary-color;\r\n                padding: 0 8px;\r\n\r\n                &.disabled {\r\n                    color: $abb-grey-600;\r\n                    cursor: not-allowed;\r\n                }\r\n            }\r\n\r\n            .ml-4 {\r\n                margin-left: 4px;\r\n            }\r\n\r\n            .mr-4 {\r\n                margin-right: 4px;\r\n            }\r\n\r\n            .text {\r\n                font-family: 'ABBVoice', Verdana;\r\n                text-wrap: nowrap;\r\n                margin-left: 8px;\r\n            }\r\n        }\r\n    }\r\n}\r\n",".MuiRadioGroup-root {\r\n    .MuiFormControlLabel-root {\r\n        &.MuiFormControlLabel-label.Mui-disabled {\r\n            color: $abb-text-primary-color;\r\n\r\n        }\r\n\r\n        &.Mui-disabled {\r\n            opacity: 0.6;\r\n            cursor: not-allowed;\r\n            color: $abb-text-primary-color;\r\n        }\r\n    }\r\n\r\n    .MuiButtonBase-root {\r\n        &.MuiRadio-root {\r\n            padding: 4px 8px;\r\n        }\r\n    }\r\n}\r\n\r\n.blank-radio {\r\n    display: flex;\r\n    box-sizing: border-box;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border: 2px solid $abb-grey-500;\r\n    border-radius: 50%;\r\n    background: transparent;\r\n    z-index: 20;\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n        border: 2px solid $abb-grey-600;\r\n        background-color: $abb-grey-300;\r\n    }\r\n\r\n    &.hover {\r\n        border: 2px solid $abb-grey-600;\r\n        background-color: $abb-grey-300;\r\n    }\r\n\r\n    &.disabled {\r\n        border: 2px solid $abb-grey-400;\r\n        background-color: $abb-grey-300;\r\n    }\r\n\r\n    &:active {\r\n        border: 2px solid $abb-grey-700;\r\n        background-color: $abb-grey-400;\r\n    }\r\n\r\n    &:focus-visible {\r\n        outline-offset: 1px;\r\n        outline: 2px solid $abb-primary-active;\r\n    }\r\n\r\n    &.size-16 {\r\n        width: 16px;\r\n        height: 16px;\r\n    }\r\n\r\n    &.size-24 {\r\n        width: 24px;\r\n        height: 24px;\r\n    }\r\n}\r\n\r\n.selected-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    box-sizing: border-box;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border: 2px solid $abb-primary-default;\r\n    border-radius: 50%;\r\n    background: $abb-primary-default;\r\n    z-index: 20;\r\n    cursor: pointer;\r\n\r\n    .checked {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        border-radius: 50%;\r\n        background-color: $abb-white;\r\n    }\r\n\r\n    .size-8 {\r\n        width: 8px;\r\n        height: 8px;\r\n    }\r\n\r\n    .size-6 {\r\n        width: 6px;\r\n        height: 6px;\r\n    }\r\n\r\n    &.size-16 {\r\n        width: 16px;\r\n        height: 16px;\r\n    }\r\n\r\n    &.size-24 {\r\n        width: 24px;\r\n        height: 24px;\r\n    }\r\n\r\n    &:hover {\r\n        border: 2px solid $abb-primary-hover;\r\n        background-color: $abb-primary-hover;\r\n    }\r\n\r\n    &.hover {\r\n        border: 2px solid $abb-primary-hover;\r\n        background-color: $abb-primary-hover;\r\n    }\r\n\r\n    &.disabled {\r\n        border: 2px solid $abb-primary-disabled;\r\n        background: $abb-primary-disabled;\r\n    }\r\n\r\n    &:active {\r\n        border: 2px solid $abb-primary-active;\r\n        background-color: $abb-primary-active;\r\n    }\r\n\r\n    &:focus-visible {\r\n        outline-offset: 1px;\r\n        outline: 2px solid $abb-primary-active;\r\n    }\r\n}\r\n\r\n.radio-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: start;\r\n    cursor: pointer;\r\n\r\n    &.disabled {\r\n        cursor: not-allowed;\r\n    }\r\n\r\n    .MuiTypography-root {\r\n        font-size: 0.875rem;\r\n        font-family: 'ABBVoice', Verdana;\r\n        color: $abb-text-primary-color;\r\n        text-wrap: nowrap;\r\n        cursor: pointer;\r\n\r\n        &.MuiFormControlLabel-label {\r\n            &.Mui-disabled {\r\n                cursor: not-allowed;\r\n                color: $abb-grey-700;\r\n            }\r\n        }\r\n    }\r\n}",".segmented-control {\r\n    background: $abb-white;\r\n    border-radius: 12px;\r\n    opacity: 1;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 4px;\r\n    gap: 4px;\r\n    font-weight: 400;\r\n    font-size: 0.875rem;\r\n    box-sizing: border-box;\r\n\r\n    .control-item {\r\n        display: flex;\r\n        flex-direction: row;\r\n        justify-content: center;\r\n        align-items: center;\r\n        gap: 8px;\r\n        border-radius: 8px;\r\n        cursor: pointer;\r\n    }\r\n\r\n    &.size-32 {\r\n        height: 32px;\r\n\r\n        .control-item {\r\n            min-height: 24px;\r\n            padding: 0 12px;\r\n\r\n            &.icon-only {\r\n                padding: 0 6.25px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.size-40 {\r\n        height: 40px;\r\n\r\n        .control-item {\r\n            min-height: 32px;\r\n            padding: 0 16px;\r\n\r\n            &.icon-only {\r\n                padding: 0 10px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.vertical {\r\n        flex-direction: column;\r\n        padding: 3px;\r\n        height: 100%;\r\n\r\n        .control-item {\r\n            padding: 0 8px;\r\n            min-height: 18px;\r\n        }\r\n    }\r\n\r\n    &.bg-primary {\r\n        background-color: $abb-white;\r\n        border: .5px solid $abb-grey-400;\r\n        color: $abb-text-primary-color;\r\n\r\n        .control-item {\r\n            &:hover {\r\n                background-color: $abb-segmented-control-hover;\r\n            }\r\n\r\n            &.selected {\r\n                background-color: $abb-primary-default;\r\n                font-weight: 500;\r\n                color: $abb-white;\r\n                cursor: default;\r\n\r\n                &.disabled {\r\n                    cursor: not-allowed;\r\n                    background: $abb-primary-disabled;\r\n                    color: $abb-white;\r\n                }\r\n            }\r\n\r\n            &.disabled {\r\n                color: $abb-grey-600;\r\n                background-color: $abb-white;\r\n                cursor: not-allowed;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.bg-white {\r\n        background: $abb-grey-400;\r\n        border: .5px solid $abb-grey-400;\r\n        color: $abb-text-primary-color;\r\n\r\n        .control-item {\r\n            &:hover {\r\n                background-color: $abb-segmented-control-hover;\r\n            }\r\n\r\n            &.selected {\r\n                background-color: $abb-white;\r\n                color: $abb-text-primary-color;\r\n                font-weight: 500;\r\n                cursor: default;\r\n\r\n                &.disabled {\r\n                    cursor: not-allowed;\r\n                    background: $abb-grey-200;\r\n                    color: $abb-grey-600;\r\n                }\r\n            }\r\n\r\n            &.disabled {\r\n                color: $abb-grey-600;\r\n                background: transparent;\r\n                cursor: not-allowed;\r\n            }\r\n        }\r\n\r\n\r\n    }\r\n\r\n    &.bg-light-blue {\r\n        background-color: $abb-white;\r\n        border: .5px solid $abb-grey-400;\r\n        color: $abb-text-primary-color;\r\n\r\n        .control-item {\r\n            &:hover {\r\n                background-color: $abb-segmented-control-hover;\r\n            }\r\n\r\n            &.selected {\r\n                background-color: $abb-accordion-expanded-bg;\r\n                color: $abb-text-primary-color;\r\n                font-weight: 500;\r\n                cursor: default;\r\n\r\n                &.disabled {\r\n                    cursor: not-allowed;\r\n                    background: $abb-accordion-expanded-bg;\r\n                    color: $abb-grey-600;\r\n                }\r\n            }\r\n\r\n            &.disabled {\r\n                color: $abb-grey-600;\r\n                background: $abb-white;\r\n                cursor: not-allowed;\r\n            }\r\n        }\r\n\r\n\r\n    }\r\n}","  .css-1jejjfu-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n    border: 1px solid $abb-primary-default !important;\r\n  }\r\n\r\n  .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input {\r\n    &.MuiSelect-select {\r\n      padding: 0;\r\n      //   padding-top: 1%;\r\n    }\r\n  }\r\n\r\n  .MuiFormControl-root.MuiTextField-root {\r\n    width: 100%;\r\n  }\r\n\r\n  .MuiAutocomplete-inputRoot {\r\n    padding-right: 0;\r\n  }\r\n\r\n  .mt-0 {\r\n    margin-top: 0 !important;\r\n  }\r\n\r\n  .css-clttge-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {\r\n    padding: 0% 0px 0px 0px !important;\r\n  }\r\n\r\n  .MuiAutocomplete-root {\r\n    &.MuiAutocomplete-tag {\r\n      margin: 0;\r\n    }\r\n\r\n    &.MuiOutlinedInput-root {\r\n      padding: 0;\r\n    }\r\n  }\r\n\r\n  .MuiButtonBase-root.MuiMenuItem-root {\r\n    &.Mui-selected {\r\n      background-color: $abb-accordion-expanded-bg !important;\r\n    }\r\n\r\n    &.Mui-disabled {\r\n      background-color: $abb-white;\r\n      color: $abb-grey-600;\r\n      cursor: not-allowed;\r\n      opacity: 1;\r\n    }\r\n\r\n    .option-name {\r\n      line-height: 24px;\r\n    }\r\n  }\r\n\r\n\r\n  .MuiPaper-root.MuiPaper-elevation {\r\n    margin-top: 4px;\r\n    background-color: $abb-white;\r\n    box-shadow: 0 6px 12px $abb-shadow-grey-200;\r\n\r\n    .input-wrapper.discreet {\r\n      min-width: auto;\r\n    }\r\n  }\r\n\r\n  .end-adornment {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    gap: 4px;\r\n\r\n    .tag-badge {\r\n      display: flex;\r\n      width: 24px;\r\n      height: 24px;\r\n      box-sizing: border-box;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      align-items: center;\r\n      border-radius: 12px;\r\n      background-color: $abb-grey-500;\r\n      margin-left: 6px;\r\n    }\r\n\r\n    .mr-4{\r\n      margin-right: 4px;\r\n    }\r\n\r\n    .icon-close {\r\n      border-right: 1px solid $abb-grey-500;\r\n      padding-left: 4px;\r\n\r\n      &.tag{\r\n        padding-left: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n\r\n  .prefix {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    border-right: solid 1px $abb-grey-500;\r\n    padding-right: 8px;\r\n    font-size: 0.875rem;\r\n    color: $abb-grey-700;\r\n    margin-right: 8px;\r\n  }\r\n\r\n  .m-4 {\r\n    margin: 4px 0px;\r\n  }\r\n\r\n  .select-menu-header {\r\n    font-weight: 400;\r\n    font-size: 1rem;\r\n    color: $abb-text-primary-color;\r\n    padding: 8px;\r\n  }\r\n\r\n",".slider-container.MuiBox-root {\r\n    width: 100%;\r\n\r\n    .slider-title {\r\n        font-size: 0.875rem;\r\n        font-weight: 500;\r\n        font-family: \"ABBVoice\", Verdana;\r\n        color: $abb-text-primary-color;\r\n    }\r\n\r\n    .slider-description {\r\n        font-size: 0.875rem;\r\n        line-height: 1.3125rem;\r\n        font-family: \"ABBVoice\", Verdana;\r\n        color: $abb-text-primary-color;\r\n    }\r\n\r\n    .slider-content {\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        gap: 24px;\r\n        width: 100%;\r\n    }\r\n\r\n\r\n    .disabled{\r\n        background-color: $abb-grey-200;\r\n        cursor: not-allowed;\r\n        pointer-events: none;\r\n    \r\n        .prefix, .end-adornment, .suffix{\r\n           color: $abb-grey-500;\r\n        }\r\n    \r\n        .disabled{\r\n            opacity: 0.6;\r\n        }\r\n    }\r\n\r\n    .small-variant-action {\r\n        display: flex;\r\n        flex-direction: column;\r\n        background-color: $abb-grey-200;\r\n        border-left: 1px solid $abb-grey-400;\r\n\r\n        .square-icon{\r\n            &:hover{\r\n                background-color: $abb-grey-200;\r\n            }\r\n            &:active{\r\n                background-color: $abb-grey-300;\r\n            }\r\n        }\r\n\r\n        .border-top {\r\n            border-top: 1px solid $abb-grey-400;\r\n            border-radius: 0;\r\n        }\r\n\r\n        .p-4 {\r\n            padding: 4px;\r\n        }\r\n    }\r\n\r\n    .MuiSlider-root {\r\n        color: $abb-primary-default;\r\n        padding: 12px 0;\r\n\r\n        .MuiSlider-rail {\r\n            background-color: $abb-grey-400;\r\n            opacity: 1;\r\n            width: 100%;\r\n            height: 4px;\r\n        }\r\n\r\n        .MuiSlider-mark {\r\n            background: $abb-grey-400 ;\r\n            width: 8px;\r\n            height: 8px;\r\n            border-radius: 50%;\r\n\r\n            &.MuiSlider-markActive {\r\n                background: $abb-primary-default;\r\n            }\r\n        }\r\n\r\n        &.MuiSlider-trackInverted {\r\n            .MuiSlider-rail {\r\n                background-color: $abb-primary-default;\r\n                opacity: 1;\r\n            }\r\n\r\n            .MuiSlider-track {\r\n                background-color: $abb-grey-400;\r\n                opacity: 1;\r\n                border-color:$abb-grey-400 ;\r\n            }\r\n        }\r\n\r\n        &.Mui-disabled{\r\n            color: $abb-grey-600;\r\n\r\n            .MuiSlider-markActive{\r\n                background: $abb-grey-600;\r\n            }\r\n\r\n            .MuiSlider-thumb{\r\n                background-color: $abb-white;\r\n                border: 2px solid $abb-grey-600;\r\n            }\r\n        }\r\n\r\n        .MuiSlider-thumb {\r\n            width: 1rem;\r\n            height: 1rem;\r\n            background-color: $abb-white;\r\n            border: 2px solid $abb-primary-default;\r\n            &.Mui-focusVisible{\r\n                background-color: $abb-primary-default;\r\n                border: 2px solid $abb-primary-default;\r\n            }\r\n            &.Mui-active{\r\n                background-color: $abb-primary-default;\r\n                border: 2px solid $abb-primary-default;\r\n            }\r\n\r\n        }\r\n\r\n\r\n        .MuiSlider-markLabel {\r\n            font-size: 0.875rem;\r\n            font-weight: 400;\r\n            font-family: \"ABBVoice\", Verdana;\r\n            color: $abb-text-primary-color;\r\n        }\r\n\r\n        .MuiSlider-valueLabelOpen {\r\n            border: solid 1px $abb-text-primary-color;\r\n            font-family: \"ABBVoice\", Verdana;\r\n            color: $abb-white;\r\n            padding: 3px 8px;\r\n            background-color: $abb-text-primary-color;\r\n            border-radius: 8px;\r\n            line-height: 1.15;\r\n        }\r\n\r\n        .MuiSlider-valueLabelOpen::before {\r\n            width: 0;\r\n            height: 0;\r\n        }\r\n    }\r\n\r\n     .read-only{\r\n        color: $abb-text-primary-color;\r\n        .MuiSlider-root {\r\n            .MuiSlider-thumb {\r\n              display: none;\r\n            }\r\n        }\r\n     }\r\n\r\n}",".switch-container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n\r\n  .indeterminate {\r\n    background-color: $abb-primary-default;\r\n    color: $abb-white;\r\n    border-radius: 20px;\r\n    display: flex;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    align-items: center;\r\n\r\n    &.size-16 {\r\n      width: 28px;\r\n      padding: 0;\r\n      height: 16px;\r\n\r\n    }\r\n\r\n    &.size-24 {\r\n      width: 42px;\r\n      padding: 0;\r\n      height: 24px;\r\n\r\n      .icon-minus {\r\n        font-size: 1.5rem;\r\n      }\r\n    }\r\n\r\n    &.size-32 {\r\n      width: 56px;\r\n      padding: 0;\r\n      height: 32px;\r\n\r\n      .icon-minus {\r\n        font-size: 2rem;\r\n      }\r\n    }\r\n\r\n    &:hover {\r\n      background-color: $abb-primary-hover;\r\n    }\r\n\r\n    &.disabled {\r\n      background-color: $abb-primary-disabled;\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n\r\n  .MuiSwitch-root:hover .MuiSwitch-track {\r\n    background-color: $abb-grey-800;\r\n  }\r\n\r\n  &.switch-container-hovered {\r\n    .MuiSwitch-root {\r\n      .MuiSwitch-track {\r\n        background-color: $abb-grey-800;\r\n      }\r\n\r\n      .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track {\r\n        background-color: $abb-primary-hover;\r\n      }\r\n    }\r\n\r\n    .indeterminate {\r\n      background-color: $abb-primary-hover;\r\n    }\r\n  }\r\n\r\n  &.toggle {\r\n    .MuiSwitch-root {\r\n      .MuiSwitch-track {\r\n        background-color: $abb-primary-default;\r\n      }\r\n\r\n      .Mui-disabled {\r\n        color: $abb-white;\r\n        opacity: 1;\r\n\r\n        &+.MuiSwitch-track {\r\n          background-color: $abb-primary-disabled;\r\n          opacity: 1;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.switch-container-hovered {\r\n      .MuiSwitch-root {\r\n        .MuiSwitch-track {\r\n          background-color: $abb-primary-hover;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .MuiSwitch-switchBase {\r\n    color: $abb-white;\r\n\r\n    &+.MuiSwitch-track {\r\n      opacity: 1;\r\n      background-color: $abb-grey-600;\r\n\r\n      &:hover {\r\n        background-color: $abb-grey-800;\r\n      }\r\n    }\r\n\r\n    .MuiSwitch-thumb {\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n\r\n      &::before {\r\n        color: $abb-text-primary-color;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        margin-left: -2px;\r\n      }\r\n    }\r\n\r\n    &.Mui-disabled {\r\n      color: $abb-white;\r\n      box-shadow: none !important;\r\n      cursor: not-allowed;\r\n\r\n      &+.MuiSwitch-track {\r\n        background-color: $abb-grey-400;\r\n        opacity: 1;\r\n        cursor: not-allowed;\r\n      }\r\n\r\n      .MuiSwitch-thumb {\r\n        &::before {\r\n          color: $abb-grey-500;\r\n          cursor: not-allowed;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.Mui-checked {\r\n      color: $abb-white;\r\n\r\n      &+.MuiSwitch-track {\r\n        opacity: 1;\r\n        background-color: $abb-primary-default;\r\n\r\n        &:hover {\r\n          background-color: $abb-primary-hover;\r\n        }\r\n      }\r\n\r\n      .MuiSwitch-thumb {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        &::before {\r\n          color: $abb-primary-default;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        }\r\n      }\r\n\r\n      &.Mui-disabled {\r\n        color: $abb-white;\r\n        opacity: 1;\r\n        cursor: not-allowed;\r\n\r\n        &+.MuiSwitch-track {\r\n          background-color: $abb-primary-disabled;\r\n          opacity: 1;\r\n          cursor: not-allowed;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .size-24 {\r\n    width: 42px;\r\n    padding: 0;\r\n    height: 24px;\r\n    border-radius: 20px;\r\n\r\n    .MuiButtonBase-root.MuiSwitch-switchBase {\r\n      padding: 3px 6%;\r\n\r\n      &.Mui-checked {\r\n        padding: 3px 4%;\r\n\r\n        .MuiSwitch-thumb {\r\n          &::before {\r\n            font-size: 16px;\r\n            margin-left: 0;\r\n            margin-top: 1px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .MuiSwitch-thumb {\r\n      width: 18px;\r\n      height: 18px;\r\n\r\n      &::before {\r\n        font-size: 16px;\r\n        margin-left: -2px;\r\n        margin-top: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .size-16 {\r\n    width: 28px;\r\n    padding: 0;\r\n    height: 16px;\r\n    border-radius: 20px;\r\n\r\n    .MuiButtonBase-root.MuiSwitch-switchBase {\r\n      padding: 6% 9%;\r\n\r\n      &.Mui-checked {\r\n        left: -8px;\r\n      }\r\n    }\r\n\r\n    .MuiSwitch-thumb {\r\n      width: 12px;\r\n      height: 12px;\r\n\r\n      &::before {\r\n        font-size: 12px;\r\n        margin-left: 0;\r\n        margin-top: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .size-32 {\r\n    width: 56px;\r\n    padding: 0;\r\n    height: 32px;\r\n    border-radius: 20px;\r\n\r\n    .MuiButtonBase-root.MuiSwitch-switchBase {\r\n      padding: 7%;\r\n\r\n      &.Mui-checked {\r\n        padding: 3px 8px;\r\n\r\n        .MuiSwitch-thumb {\r\n          &::before {\r\n            font-size: 18px;\r\n            margin-left: 0;\r\n            margin-top: 1px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .MuiSwitch-thumb {\r\n      width: 24px;\r\n      height: 24px;\r\n\r\n      &::before {\r\n        font-size: 18px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .label {\r\n    color: $abb-text-primary-color;\r\n    display: flex;\r\n    align-items: center;\r\n    font-weight: 400;\r\n    text-wrap: nowrap;\r\n    cursor: pointer;\r\n\r\n    &.size-16 {\r\n      font-size: 0.875rem;\r\n    }\r\n\r\n    &.size-24 {\r\n      font-size: 1rem;\r\n    }\r\n\r\n    &.size-32 {\r\n      font-size: 1rem;\r\n    }\r\n\r\n    &.disabled {\r\n      cursor: not-allowed;\r\n      color: $abb-grey-800;\r\n    }\r\n  }\r\n}",".MuiTabs-root {\r\n    border-bottom: 1px solid $abb-grey-500;\r\n    min-height: auto !important;\r\n\r\n    &.border {\r\n        border-bottom: none;\r\n    }\r\n\r\n    .MuiButtonBase-root.MuiTab-root {\r\n        color: $abb-text-primary-color;\r\n        box-sizing: border-box;\r\n        font-family: \"ABBVoice\", Verdana;\r\n        letter-spacing: normal;\r\n        text-transform: capitalize;\r\n        font-size: 0.875rem;\r\n        font-weight: 400;\r\n        height: 32px;\r\n        cursor: pointer;\r\n        align-items: end;\r\n        padding: 8px 24px 7px;\r\n        min-height: auto;\r\n        min-width: auto;\r\n        border: 1px solid transparent;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 32px;\r\n\r\n        &:hover {\r\n            background: $abb-grey-400;\r\n            border-radius: 4px;\r\n        }\r\n\r\n        &:focus-visible {\r\n            background-color: transparent;\r\n            border-radius: 4px;\r\n            border: 2px solid $abb-primary-active;\r\n        }\r\n\r\n        &.Mui-disabled {\r\n            cursor: not-allowed;\r\n            background: transparent;\r\n            pointer-events: inherit;\r\n            color: $abb-grey-600;\r\n        }\r\n\r\n        &.Mui-selected {\r\n            font-weight: 700;\r\n            background-color: transparent;\r\n        }\r\n\r\n        .MuiTab-iconWrapper {\r\n            margin-left: 32px;\r\n            margin-bottom: 3px;\r\n        }\r\n\r\n        .label-container {\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            flex-direction: row;\r\n            gap: 8px;\r\n\r\n            .icon {\r\n                display: flex;\r\n                justify-content: center;\r\n                align-items: center;\r\n            }\r\n        }\r\n    }\r\n\r\n    .MuiTabs-indicator {\r\n        height: 4px;\r\n        background-color: $abb-primary-default;\r\n    }\r\n}",".MuiInputBase-root {\r\n    &.MuiOutlinedInput-root {\r\n        background-color: $abb-white;\r\n        padding-right: 8px;\r\n        padding-left: 8px;\r\n        color: $abb-text-primary-color;\r\n        font-size: 0.875rem;\r\n        font-family: \"ABBVoice\", Verdana !important;\r\n\r\n        &.placeholder-text {\r\n            color: $abb-grey-800 !important;\r\n        }\r\n\r\n        &:hover {\r\n            .MuiOutlinedInput-notchedOutline {\r\n                border-color: $abb-text-primary-color;\r\n            }\r\n        }\r\n\r\n        &:focus-visible {\r\n            outline-offset: 1px;\r\n            outline: 2px solid $abb-primary-active;\r\n        }\r\n\r\n        &.MuiInputBase-multiline {\r\n            padding: 8px;\r\n        }\r\n\r\n        &.Mui-focused {\r\n            caret-color: $abb-primary-default;\r\n        }\r\n\r\n        &.Mui-disabled {\r\n            &:hover {\r\n                border-color: $abb-grey-400;\r\n            }\r\n\r\n            .MuiOutlinedInput-notchedOutline {\r\n                background-color: $abb-grey-200 !important;\r\n                border-color: $abb-grey-400;\r\n                cursor: not-allowed;\r\n            }\r\n        }\r\n\r\n        .MuiOutlinedInput-notchedOutline {\r\n            border-color: $abb-grey-400;\r\n        }\r\n\r\n        &.Mui-focused {\r\n            caret-color: $abb-primary-default;\r\n            .MuiOutlinedInput-notchedOutline {\r\n                border: 1px solid $abb-primary-default;\r\n            }\r\n        }\r\n\r\n        &.Mui-error {\r\n            .MuiOutlinedInput-notchedOutline {\r\n                border-color: $abb-status-error !important;\r\n            }\r\n\r\n            &:hover {\r\n                border-color: $abb-status-error !important;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    .MuiInputBase-input {\r\n        &.MuiOutlinedInput-input {\r\n            // padding-top: 1%;\r\n\r\n            &.Mui-disabled {\r\n                border-radius: 4px;\r\n                color: $abb-grey-600 !important;\r\n                opacity: 0.8;\r\n                cursor: not-allowed;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\r\n    border-color: $abb-text-primary-color !important;\r\n}\r\n\r\n.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n    border: 1px solid $abb-primary-default !important;\r\n    caret-color: $abb-primary-default;\r\n}\r\n\r\n.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {\r\n    border: 1px solid $abb-grey-500 !important;\r\n}\r\n\r\n.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {\r\n    border-color: $abb-status-error !important;\r\n}\r\n\r\n.input-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-family: \"ABBVoice\", Verdana !important;\r\n    gap: 4px;\r\n    width: 100%;\r\n\r\n    &.row {\r\n        flex-direction: row;\r\n        align-items: center;\r\n        gap: 8px;\r\n    }\r\n\r\n    .icon {\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n    }\r\n\r\n    .pr-8 {\r\n        padding-right: 8px;\r\n    }\r\n\r\n    .divider {\r\n        border-left: 1px solid $abb-grey-500;\r\n    }\r\n\r\n    .end-icon {\r\n        padding-right: 6px;\r\n        padding-left: 6px;\r\n    }\r\n\r\n    .star {\r\n        color: $abb-status-error;\r\n    }\r\n\r\n    .disabled{\r\n        background-color: $abb-grey-200;\r\n        cursor: not-allowed;\r\n        pointer-events: none;\r\n        .disabled{\r\n            opacity: 0.6;\r\n        }\r\n    }\r\n\r\n    &.read-only {\r\n        .MuiInputBase-root.MuiInput-root {\r\n            font-size: 0.875rem;\r\n            font-family: \"ABBVoice\", Verdana !important;\r\n            color: $abb-text-primary-color;\r\n        }\r\n        .MuiInputBase-root.MuiInput-root.MuiInput-underline{\r\n            &::before{\r\n                border-bottom: none;\r\n            }\r\n            &:hover::before{\r\n                border-bottom: none;\r\n            }\r\n            &::after{\r\n                border-bottom: none;\r\n            }\r\n        }\r\n\r\n        .MuiFormControl-root.MuiTextField-root {\r\n            min-width: 250px;\r\n\r\n\r\n            .css-1eed5fa-MuiInputBase-root-MuiInput-root::before {\r\n                border-bottom: none;\r\n            }\r\n\r\n            .css-1eed5fa-MuiInputBase-root-MuiInput-root::after {\r\n                border-bottom: none;\r\n            }\r\n\r\n            .css-1x51dt5-MuiInputBase-input-MuiInput-input {\r\n                color: $abb-text-primary-color;\r\n                font-family: \"ABBVoice\", Verdana !important\r\n            }\r\n\r\n        }\r\n    }\r\n\r\n    &.discreet-edit {\r\n        caret-color: $abb-primary-default;\r\n\r\n        .MuiInputBase-root.MuiInput-root {\r\n            padding: 0 12px;\r\n            color: $abb-text-primary-color;\r\n            font-size: 0.875rem;\r\n            font-family: \"ABBVoice\", Verdana !important;\r\n        }\r\n        .MuiInputBase-root.MuiInput-root.MuiInput-underline{\r\n            &::before{\r\n                border-bottom: 1px solid $abb-grey-400;\r\n            }\r\n            &:hover::before{\r\n                border-bottom: 1px solid $abb-text-primary-color;\r\n            }\r\n            &::after{\r\n                border-bottom: 1px solid $abb-primary-default;\r\n            }\r\n        }\r\n\r\n        .css-1x51dt5-MuiInputBase-input-MuiInput-input {\r\n            color: $abb-text-primary-color;\r\n            min-width: 50px;\r\n            font-family: \"ABBVoice\", Verdana !important\r\n        }\r\n\r\n        .css-1eed5fa-MuiInputBase-root-MuiInput-root::before {\r\n            border-bottom: solid 1px $abb-grey-500;\r\n        }\r\n\r\n        .css-1eed5fa-MuiInputBase-root-MuiInput-root:hover::before {\r\n            border-bottom: solid 1px $abb-text-primary-color;\r\n        }\r\n\r\n        .css-1eed5fa-MuiInputBase-root-MuiInput-root::after {\r\n            border-bottom: 1px solid $abb-primary-default;\r\n        }\r\n    }\r\n\r\n    &.discreet {\r\n        caret-color: $abb-primary-default;\r\n\r\n        .MuiInputBase-root.MuiInput-root {\r\n            color: $abb-text-primary-color;\r\n            font-size: 0.875rem;\r\n            font-family: \"ABBVoice\", Verdana !important;\r\n        }\r\n\r\n        .MuiInputBase-root.MuiInput-root.MuiInput-underline{\r\n            &::before{\r\n                border-bottom: 1px solid $abb-grey-400;\r\n            }\r\n            &:hover::before{\r\n                border-bottom: 1px solid $abb-text-primary-color;\r\n            }\r\n            &::after{\r\n                border-bottom: 1px solid $abb-primary-default;\r\n            }\r\n        }\r\n\r\n        .css-1x51dt5-MuiInputBase-input-MuiInput-input {\r\n            color: $abb-text-primary-color;\r\n            font-family: \"ABBVoice\", Verdana !important\r\n        }\r\n\r\n        .css-1eed5fa-MuiInputBase-root-MuiInput-root::before {\r\n            border-bottom: solid 1px $abb-grey-500;\r\n        }\r\n\r\n        .css-1eed5fa-MuiInputBase-root-MuiInput-root:hover::before {\r\n            border-bottom: solid 1px $abb-text-primary-color;\r\n        }\r\n\r\n        .css-1eed5fa-MuiInputBase-root-MuiInput-root::after {\r\n            border-bottom: 1px solid $abb-primary-default;\r\n        }\r\n    }\r\n\r\n    &.default-with-prefix-and-suffix {\r\n        .MuiInputBase-root {\r\n            &.MuiOutlinedInput-root {\r\n                padding-left: 8px;\r\n                padding-right: 8px;\r\n\r\n                .prefix {\r\n                    display: flex;\r\n                    flex-direction: row;\r\n                    align-items: center;\r\n                    border-right: solid 1px $abb-grey-500;\r\n                    padding-right: 8px;\r\n                    font-size: 0.875rem;\r\n                    color: $abb-grey-700;\r\n                    // padding-top: 1%;\r\n                }\r\n\r\n                .gap-0 {\r\n                    gap: 0 !important;\r\n                }\r\n\r\n                .end-adornment {\r\n                    display: flex;\r\n                    flex-direction: row;\r\n                    align-items: center;\r\n                    gap: 2px;\r\n                }\r\n\r\n                .suffix {\r\n                    border-left: solid 1px $abb-grey-500;\r\n                    padding-left: 8px;\r\n                    font-size: 0.875rem;\r\n                    color: $abb-grey-700;\r\n                    // padding-top: 1%;\r\n                }\r\n\r\n                .icon {\r\n                    display: flex;\r\n                    flex-direction: row;\r\n                    align-items: center;\r\n                    font-size: 1rem;\r\n                }\r\n            }\r\n        }\r\n\r\n        .css-2ehmn7-MuiInputBase-root-MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\r\n            border-color: $abb-text-primary-color !important;\r\n        }\r\n\r\n        .css-2ehmn7-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n            border: 1px solid $abb-primary-default !important;\r\n        }\r\n\r\n        .css-2ehmn7-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {\r\n            border: 1px solid $abb-grey-500 !important;\r\n        }\r\n\r\n        .css-2ehmn7-MuiInputBase-root-MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {\r\n            border: 1px solid $abb-status-error !important;\r\n        }\r\n    }\r\n\r\n    .input-label {\r\n        font-weight: 500;\r\n        font-size: 0.875rem;\r\n        color: $abb-text-primary-color;\r\n\r\n        &.disabled {\r\n            opacity: 0.6;\r\n            background: transparent;\r\n        }\r\n    }\r\n\r\n    .input-description {\r\n        font-size: 0.75rem;\r\n        line-height: 0.875rem;\r\n        color: $abb-grey-800;\r\n        font-weight: 400;\r\n        margin-top: 4px;\r\n\r\n        &.mt-0 {\r\n            margin-top: 0;\r\n        }\r\n\r\n        &.disabled {\r\n            opacity: 0.6;\r\n        }\r\n    }\r\n\r\n    .gap-0 {\r\n        gap: 6px;\r\n    }\r\n\r\n    .textfield-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: start;\r\n        justify-content: center;\r\n        .wrapper {\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            width: 100%;\r\n        }\r\n\r\n        .discreet-edit-icons {\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            justify-content: center;\r\n            color: $abb-text-primary-color;\r\n\r\n            .icon {\r\n\r\n                &.disabled {\r\n                    color: $abb-grey-500;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .msg-container {\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        gap: 4px;\r\n        font-size: 0.75rem;\r\n\r\n        .mt-4 {\r\n            margin-top: 4px;\r\n        }\r\n\r\n        .success {\r\n            color: $abb-status-success;\r\n        }\r\n\r\n        .error {\r\n            color: $abb-status-error;\r\n        }\r\n\r\n        .error-text {\r\n            color: $abb-status-error;\r\n            font-size: 0.75rem;\r\n            margin-top: 4px;\r\n        }\r\n    }\r\n\r\n    &.disabled{\r\n        .MuiAutocomplete-root{\r\n            pointer-events: none;\r\n            .MuiOutlinedInput-notchedOutline{\r\n                border: 1px solid $abb-grey-500 !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.input-styles {\r\n    color: $abb-text-primary-color !important;\r\n}\r\n\r\n.placeholder-style {\r\n    color: $abb-grey-800 !important;\r\n}\r\n\r\ninput[type=\"text\"] {\r\n    padding-block: 0;\r\n    padding-inline: 0;\r\n}\r\n\r\ninput {\r\n    &::placeholder {\r\n        color: $abb-grey-800 !important;\r\n        opacity: 1 !important;\r\n    }\r\n\r\n    &::-webkit-input-placeholder {\r\n        color: $abb-grey-800 !important;\r\n        opacity: 1 !important;\r\n\r\n    }\r\n}\r\n\r\ntextarea {\r\n    &::placeholder {\r\n        color: $abb-grey-800 !important;\r\n        opacity: 1 !important;\r\n    }\r\n\r\n    &::-webkit-input-placeholder {\r\n        color: $abb-grey-800 !important;\r\n        opacity: 1 !important;\r\n\r\n    }\r\n}\r\n\r\n.css-dpjnhs-MuiInputBase-root-MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {\r\n    border-color: $abb-status-error !important;\r\n}\r\n\r\n.suffix {\r\n    border-left: solid 1px $abb-grey-500;\r\n    padding-left: 8px;\r\n    font-size: 0.875rem;\r\n    color: $abb-grey-700;\r\n    // padding-top: 1%;\r\n}",".time-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n    justify-content: space-between;\r\n    gap: 16px;\r\n    margin: 60px 24px 24px 8px;\r\n\r\n    .segmented-container {\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        width: 100%;\r\n    }\r\n\r\n    &.m-0 {\r\n        margin: 0;\r\n        padding-left: 24px;\r\n        padding-right: 0;\r\n        padding-bottom: 16px;\r\n        gap: 8px;\r\n    }\r\n\r\n    &.pb-24 {\r\n        padding-bottom: 24px;\r\n    }\r\n\r\n    &.range-picker {\r\n        padding-left: 0;\r\n        padding-right: 0;\r\n        padding-bottom: 8px;\r\n        gap: 8px;\r\n    }\r\n\r\n    .time-part {\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        padding: 24px 24px 24px 16px;\r\n        background-color: $abb-grey-200;\r\n        border-radius: 6px;\r\n\r\n        &.custom-picker {\r\n            padding: 12px 8px 12px 0px;\r\n            min-height: 46px;\r\n            min-width: 245px;\r\n            display: flex;\r\n            justify-content: center;\r\n        }\r\n\r\n        .colon {\r\n            color: $abb-text-primary-color;\r\n            font-size: 1rem;\r\n            font-weight: 500;\r\n        }\r\n    }\r\n\r\n    &.big-container {\r\n        .time-part {\r\n            padding: 52px 24px 52px 16px;\r\n        }\r\n    }\r\n\r\n    .time-picker-button-container {\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        gap: 8px;\r\n        justify-content: end;\r\n        width: 100%;\r\n    }\r\n}",".title-container {\r\n    flex-direction: column;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    place-content: flex-start;\r\n    align-items: flex-start;\r\n\r\n    .top-red-line {\r\n        height: 1rem;\r\n\r\n        &::before {\r\n            content: \"\\2014\";\r\n            font-size: 2rem;\r\n            color: $abb-status-error;\r\n            display: block;\r\n            font-weight: 700;\r\n            line-height: 0;\r\n        }\r\n    }\r\n\r\n    .title {\r\n        font-family: 'ABBVoice', Verdana;\r\n        font-size: 2rem;\r\n        font-weight: 700;\r\n        color: $abb-text-primary-color;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-family: 'ABBVoice', Verdana;\r\n        font-size: 2rem;\r\n        font-weight: 200;\r\n        color: $abb-text-primary-color;\r\n    }\r\n}\r\n\r\n.title-info-container {\r\n    flex-direction: row;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    place-content: flex-start;\r\n    align-items: end;\r\n\r\n    .separator-line {\r\n        height: 32px;\r\n        border-left: 1px solid $abb-grey-500;\r\n        margin: 0 16px;\r\n    }\r\n\r\n    .title {\r\n        font-size: 2rem;\r\n        font-weight: 700;\r\n        color: $abb-text-primary-color;\r\n    }\r\n\r\n    .ml-8 {\r\n        margin-left: 12px;\r\n    }\r\n\r\n    .mr-8 {\r\n        margin-right: 12px;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 2rem;\r\n        font-weight: 200;\r\n        color: $abb-text-primary-color;\r\n    }\r\n\r\n    .info {\r\n        font-size: 1rem;\r\n        color: $abb-primary-default;\r\n        margin-right: 4px;\r\n    }\r\n\r\n    .mt-20 {\r\n        margin-top: 24px;\r\n    }\r\n\r\n    .info-text {\r\n        font-size: .875rem;\r\n        color: $abb-primary-default;\r\n    }\r\n}",".MuiToggleButtonGroup-root {\r\n    font-family: 'ABBVoice', Verdana;\r\n\r\n    .MuiToggleButtonGroup-grouped {\r\n        display: flex;\r\n        flex-direction: row;\r\n        justify-content: center;\r\n        gap: 4px;\r\n        color: $abb-text-primary-color;\r\n        text-transform: capitalize;\r\n        border: 0.5px solid $abb-grey-400;\r\n        background-color: $abb-toolbar-bg;\r\n\r\n        .toolbar-label {\r\n            font-family: 'ABBVoice', Verdana;\r\n            font-size: 0.875rem;\r\n            font-weight: 400;\r\n        }\r\n\r\n        .size {\r\n            font-size: 1rem;\r\n        }\r\n\r\n        &.MuiToggleButtonGroup-middleButton {\r\n            border-left: 0.5px solid $abb-grey-400;\r\n        }\r\n\r\n        &.MuiToggleButtonGroup-lastButton {\r\n            border-left: 0.5px solid $abb-grey-400;\r\n            &.Mui-disabled {\r\n                border-left: 0.5px solid $abb-grey-400;\r\n            }\r\n        }\r\n\r\n        &:hover {\r\n            background-color: $abb-grey-300;\r\n        }\r\n\r\n        &.Mui-selected {\r\n            color: $abb-primary-default;\r\n            background: $abb-white;\r\n\r\n            &:hover {\r\n                background-color: $abb-grey-300;\r\n            }\r\n        }\r\n\r\n        &.Mui-disabled {\r\n            background-color: $abb-grey-200;\r\n            color: $abb-grey-600;\r\n            border-left: 1px solid $abb-grey-400 !important;\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n\r\n    &.discreet {\r\n        .MuiToggleButtonGroup-grouped {\r\n            border: none;\r\n            background-color: transparent;\r\n            border-radius: 8px;\r\n            margin: 0 2px;\r\n\r\n            &:hover {\r\n                background-color: $abb-grey-300;\r\n            }\r\n\r\n            &.Mui-selected {\r\n                color: $abb-primary-default;\r\n                background: $abb-grey-300;\r\n\r\n                &:hover {\r\n                    background-color: $abb-grey-300;\r\n                }\r\n            }\r\n        }\r\n\r\n    }\r\n}",".MuiTooltip-popper{\r\n.MuiTooltip-tooltip{\r\n    font-family: 'ABBVoice',Verdana;\r\n    font-size: 0.875rem ;\r\n    line-height: 1.25rem;\r\n    border-radius: 6px;\r\n    font-weight: 400;\r\n    padding: 8px;\r\n    &.theme-light{\r\n        background: $abb-white;\r\n        border: solid 0.5px $abb-grey-400;\r\n        color: $abb-text-primary-color;\r\n        &.popover{\r\n            border: none;\r\n            padding: 16px;\r\n            box-shadow: 0 6px 12px $abb-shadow-grey-200;\r\n        }\r\n        .MuiTooltip-arrow::before{\r\n            color: $abb-white;\r\n        }\r\n    }\r\n    &.theme-dark{\r\n        background: $abb-grey-900;\r\n        color: $abb-white;\r\n        &.popover{\r\n            border: none;\r\n            padding: 16px;\r\n            box-shadow: 0 6px 12px $abb-shadow-grey-200;\r\n        }\r\n        .MuiTooltip-arrow{\r\n            color: $abb-grey-900;\r\n        }\r\n    }\r\n    \r\n}\r\n.MuiTooltip-tooltipPlacementTop{\r\n    margin-bottom: 8px !important;\r\n}\r\n.MuiTooltip-tooltipPlacementBottom{\r\n    margin-top: 8px !important;\r\n}\r\n.MuiTooltip-tooltipPlacementRight{\r\n    margin-left: 8px !important;\r\n}\r\n.MuiTooltip-tooltipPlacementLeft{\r\n    margin-right: 8px !important;\r\n}\r\n}",".MuiRichTreeView-root {\r\n    min-width: 300px;\r\n    width: 100%;\r\n\r\n    .MuiTreeItem-label {\r\n        font-size: 0.875rem;\r\n        font-weight: 400;\r\n        color: $abb-text-primary-color;\r\n        font-family: 'ABBVoice', Verdana;\r\n\r\n    }\r\n\r\n    .MuiCollapse-vertical.MuiTreeItem-groupTransition {\r\n        padding-left: 0;\r\n    }\r\n\r\n    .MuiTreeItem-root {\r\n        &.size-24 {\r\n            .MuiTreeItem-content {\r\n                padding: 4px 8px;\r\n                min-height: 24px;\r\n            }\r\n        }\r\n\r\n        &.size-32 {\r\n            .MuiTreeItem-content {\r\n                padding: 8px 16px;\r\n                min-height: 32px;\r\n            }\r\n        }\r\n\r\n        &.size-40 {\r\n            .MuiTreeItem-content {\r\n                padding: 12px 20px;\r\n                min-height: 40px;\r\n            }\r\n        }\r\n\r\n        &.divider {\r\n            .MuiTreeItem-content {\r\n                border-bottom: 1px solid $abb-grey-400;\r\n            }\r\n        }\r\n\r\n        .MuiTreeItem-content {\r\n            border-radius: 0;\r\n            border-left: 4px solid transparent;\r\n\r\n            &:hover {\r\n                background-color: $abb-grey-300;\r\n            }\r\n\r\n            &:active {\r\n                background-color: $abb-grey-400;\r\n            }\r\n\r\n            &.Mui-focused {\r\n                outline: 1px solid $abb-primary-active;\r\n                background-color: $abb-white;\r\n            }\r\n\r\n            &.Mui-selected {\r\n                outline: none;\r\n                background-color: $abb-accordion-expanded-bg;\r\n                border-left: 4px solid $abb-primary-default;\r\n                color: $abb-text-primary-color;\r\n            }\r\n\r\n            &.Mui-disabled {\r\n                cursor: not-allowed;\r\n                background-color: $abb-white;\r\n                opacity: .5;\r\n                pointer-events: none;\r\n            }\r\n\r\n            .MuiTreeItem-iconContainer{\r\n                color: $abb-text-primary-color;\r\n            }\r\n\r\n            .tree-content-container {\r\n                justify-content: space-between;\r\n                display: flex;\r\n                flex-direction: row;\r\n                align-items: center;\r\n\r\n                .checkbox-container {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    gap: 8px;\r\n                }\r\n\r\n                .tree-icon{\r\n                    font-size: 1rem;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.tree-heading {\r\n    font-size: 1rem;\r\n    margin-bottom: .5rem;\r\n    color: $abb-text-primary-color;\r\n    font-weight: 500;\r\n}",".wizard-content {\r\n    border-radius: 4px;\r\n    background: $abb-white;\r\n    min-height: 42vh;\r\n    padding: 20px 32px;\r\n    margin-top: 20px;\r\n    min-width: 48vw;\r\n\r\n    &.w-54 {\r\n        min-width: 40vw;\r\n        min-height: 56vh;\r\n    }\r\n}\r\n\r\n.stepper-grey-bg {\r\n    background: $abb-grey-400;\r\n    color: $abb-text-primary-color;\r\n    border-radius: 50%;\r\n    width: 40px;\r\n    height: 40px;\r\n    margin-left: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    &:hover {\r\n        background: $abb-grey-500;\r\n    }\r\n\r\n    .size {\r\n        font-size: 1.5rem;\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n.menu-vertical-line {\r\n    border-left: 1px solid $abb-grey-500;\r\n    height: 48px;\r\n    width: 7%;\r\n    margin-left: 36px;\r\n}\r\n\r\n.MuiStepper-root {\r\n\r\n    &.vertical {\r\n        margin-right: 24px;\r\n    }\r\n\r\n    .MuiStep-root {\r\n        padding: 0;\r\n\r\n        &:not(:has(.row)) {\r\n            padding: 16px 24px;\r\n        }\r\n\r\n        &:not(.no-hover):not(:has(.Mui-disabled)):hover {\r\n            background-color: $abb-grey-400;\r\n            border-radius: 4px;\r\n        }\r\n\r\n        .Mui-disabled {\r\n            pointer-events: none;\r\n            cursor: not-allowed;\r\n            opacity: .7;\r\n        }\r\n\r\n        .row {\r\n            padding: 16px;\r\n        }\r\n\r\n        .vertical {\r\n            padding: 0px 16px;\r\n        }\r\n\r\n        .sub-step-container {\r\n            padding: 0;\r\n        }\r\n    }\r\n\r\n    .sub-step-container {\r\n        padding: 0;\r\n\r\n        .sub-step-title {\r\n            display: flex;\r\n            flex-direction: row;\r\n            align-items: center;\r\n            justify-content: center;\r\n            gap: 8px;\r\n            padding: 0;\r\n            margin-left: 29px;\r\n\r\n            .MuiStepLabel-labelContainer {\r\n                .MuiStepLabel-label {\r\n                    font-weight: 400;\r\n                    font-size: 0.875rem;\r\n                    color: $abb-text-primary-color;\r\n                }\r\n            }\r\n\r\n            &.active {\r\n                .MuiStepLabel-labelContainer {\r\n                    .MuiStepLabel-label {\r\n                        font-weight: 500;\r\n                        font-size: 1rem;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .default-sub-icon {\r\n                border: 2px solid $abb-grey-500;\r\n                border-radius: 50%;\r\n                width: 0.8rem;\r\n                height: 0.8rem;\r\n                background-color: $abb-white;\r\n            }\r\n        }\r\n    }\r\n\r\n    .MuiStepLabel-root {\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        &.hide-label {\r\n            .MuiStepLabel-labelContainer {\r\n                display: none;\r\n            }\r\n\r\n            &.ml-2 {\r\n                margin-left: -2px;\r\n            }\r\n        }\r\n\r\n        &.row {\r\n            flex-direction: row;\r\n            align-items: center;\r\n            gap: 8px;\r\n            justify-content: start;\r\n            min-height: 56px;\r\n\r\n            .MuiStepLabel-iconContainer {\r\n                .MuiStepIcon-root {\r\n                    margin-bottom: 0;\r\n                }\r\n\r\n                .completion-icon {\r\n                    margin-bottom: 0;\r\n                }\r\n            }\r\n        }\r\n\r\n        &.hover:hover {\r\n            background-color: $abb-grey-400;\r\n            border-radius: 4px;\r\n        }\r\n\r\n        .MuiStepLabel-iconContainer {\r\n            padding-right: 0;\r\n\r\n            .completion-icon {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                width: 35px;\r\n                height: 35px;\r\n                border: 3px solid $abb-status-success;\r\n                border-radius: 50%;\r\n                margin-bottom: 8px;\r\n\r\n                .success {\r\n                    color: $abb-status-success;\r\n                    font-size: 2rem;\r\n                }\r\n\r\n                &.small {\r\n                    border: 1px solid $abb-status-success;\r\n                    border-radius: 50%;\r\n                    width: 14px;\r\n                    height: 14px;\r\n                    background-color: $abb-white;\r\n                    margin-bottom: 0;\r\n                    display: flex;\r\n                    flex-direction: row;\r\n                    justify-content: center;\r\n                    align-items: center;\r\n\r\n                    .success {\r\n                        font-size: 0.75rem;\r\n                    }\r\n                }\r\n\r\n\r\n            }\r\n\r\n\r\n\r\n            .MuiStepIcon-root {\r\n                width: 40px;\r\n                height: 40px;\r\n                box-sizing: border-box;\r\n                margin-bottom: 8px;\r\n                color: $abb-white;\r\n                font-family: 'ABBVoice', Verdana;\r\n                border: 2px solid $abb-grey-500;\r\n                border-radius: 50%;\r\n                cursor: pointer;\r\n\r\n                &:hover {\r\n                    border: 2px solid $abb-primary-default;\r\n                }\r\n\r\n                .MuiStepIcon-text {\r\n                    fill: $abb-text-primary-color;\r\n                    font-weight: 600;\r\n                    font-family: 'ABBVoice', Verdana;\r\n                }\r\n\r\n                &.Mui-active {\r\n                    color: $abb-primary-default;\r\n                    border: none;\r\n\r\n                    &:hover {\r\n                        color: $abb-primary-hover;\r\n                    }\r\n\r\n                    .MuiStepIcon-text {\r\n                        font-family: 'ABBVoice', Verdana;\r\n                        fill: $abb-white;\r\n                    }\r\n                }\r\n\r\n                &.Mui-completed {\r\n                    border: 2px solid $abb-status-success;\r\n                    color: $abb-white;\r\n\r\n                }\r\n            }\r\n        }\r\n\r\n        .MuiStepLabel-label {\r\n            font-weight: 700;\r\n            font-size: 1rem;\r\n            text-wrap: nowrap;\r\n            font-family: 'ABBVoice', Verdana;\r\n            color: $abb-grey-700;\r\n\r\n            &.Mui-active {\r\n                color: $abb-text-primary-color;\r\n\r\n            }\r\n\r\n            &.Mui-completed {\r\n                color: $abb-text-primary-color;\r\n            }\r\n        }\r\n\r\n        .step-description {\r\n            font-size: .75rem;\r\n            color: $abb-grey-800;\r\n            font-weight: 400;\r\n            line-height: 1rem !important;\r\n            padding-top: 4px;\r\n            white-space: initial;\r\n            font-family: 'ABBVoice', Verdana;\r\n        }\r\n    }\r\n\r\n    .MuiStepConnector-line {\r\n        border-color: $abb-grey-500;\r\n        margin-bottom: 28px;\r\n    }\r\n\r\n    &.row {\r\n        .MuiStepConnector-line {\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n\r\n    &.vertical {\r\n        .MuiStepConnector-line {\r\n            margin-left: 24px;\r\n        }\r\n    }\r\n}","/* Light Theme */\n:root.light-theme {\n  --icon-filter: none;\n  --icon-color: black;\n  --icon-filter-header: var(--icon-filter-light);\n\n\n  --main-background-color: #EBEBEB !important;\n  --main-text-color: #000000;\n  --blocks-background-color: #f5f5f5;\n  --blocks-image-background-color: #ffffff;\n  //--blocks-border-color: #2934ff;\n  --blocks-hover-background-color: #3366ff29;\n  --blocks-hover-border-color: #2934ff;\n  --text-primary-color: #000000;\n  --text-primary-hover-color: #fff;\n  --drop-down-text-primary-color: #000000;\n  --drop-down-text-primary-background-color: #ffffff;\n  --accordion-expanded-bg: #DEE6FF;\n  --container-background-color: #fff;\n\n  --search-background-color: #fff;\n  --search-boarder-color: #bababa;\n  --input-field-color: #fff;\n  --input-text-color: #9f9f9f;\n  --dropdown-background-color: #fff;\n  --dropdown-background-color-hover: #373737;\n\n  --btn-background-color: #fff;\n  --btn-border-color: #36F;\n  --btn-text-color: #000000;\n\n  --label-color: #333;\n\n  --table-background-color: #fff;\n  --input-field-border-color: #dbdbdb;\n  --table-header-color: #DBDBDB;\n\n  --session-blocks-background-color: #f5f5f5;\n  --title-container-background: #f5f5f5;\n  --title-container-text: #000000;\n  --table-container-background: #ffffff;\n  --table-background-color: #FFFFFF;\n  --table-btn-color: #ebebeb;\n  --toggle-close-icon-background: #ebebeb;\n  --toggle-close-icon-color: #686868;\n  --content-container-background: #fff;\n  --checkbox-description-text-color: #1f1f1f;\n  --pagination-background-color: #fff;\n  --contact-abb-blocks-background-color: #ebebeb;\n  --sub-headings-color: #0F0F0F;\n  --icon-color: rgb(0, 0, 0, 0.25);\n  --dialogue-box-background-color: #fff;\n  --dialogue-text-color: #1f1f1f;\n  --dialogue-icon-color: #1f1f1f;\n  --dialogue-box-button-color: #fff;\n  --input-description-text-color: #696969;\n  --app-reg-container-background: #f5f5f5;\n  --app-reg-first-container: #fff;\n  --app-reg-sub-heading-background: #f5f5f5;\n  --app-reg-type-name-background: rgb(222, 230, 255);\n  --app-reg-type-active-background: rgb(222, 255, 229);\n  --input-disabled-background: #f5f5f5;\n  --input-disable-text-color: #B2B2B2;\n  --format-message-case-creation: #555;\n  --privacy-policy-link-color: #531B9B;\n\n\n\n\n}","/* Dark Theme */\n:root.dark-theme {\n    --icon-filter: invert(1);\n    --icon-color: #fff;\n    --icon-filter-header: var(--icon-filter-dark);\n    --icon-color: var(--icon-color-dark);\n    --icon-filter-header: var(--icon-filter-dark);\n\n    --main-background-color: #1F1F1F;\n    --main-text-color: #ffffff;\n    --blocks-background-color: #333333;\n    --blocks-border-color: #525252;\n    --blocks-name-text-color: #ffffff;\n    --blocks-image-background-color: #000000;\n\n    --blocks-hover-background-color: #3366ff29;\n    --blocks-hover-border-color: #2934ff;\n\n    --content-container-color: #696969;\n    --text-primary-color: #ffffff;\n    --text-primary-hover-color: #000000;\n    --drop-down-text-primary-color: #ffffff;\n    --drop-down-text-primary-background-color: #000000;\n    --accordion-expanded-bg: #696969;\n\n    --search-background-color: #1F1F1F;\n    --search-boarder-color: #696969;\n    --icon-sort-color: rgb(186,186,186);\n    --block-active-class-color: rgb(123,123,123);\n    --input-field-color: #1f1f1f;\n    --input-background-color: #ad4141;\n    --input-text-color: #fff;\n    --input-field-border-color: #373737;\n    --dropdown-background-color: #1F1F1F;\n    --dropdown-background-color-hover: #373737;\n    --modal-popup-bordertop: #00ff08;\n    --text-primary-color: #FFF;\n    \n\n    --blocks-hover-color: rgb(77,84,100);\n    --btn-background-color: #36F;\n    --btn-border-color: #FFF;\n    --btn-text-color: #000000; \n    --title-container-color: #404040;\n    --main-text-hover-color: rgb(31,31,31);\n\n    --session-blocks-background-color: #424242;\n    --container-background-color: #1F1F1F;\n    --title-container-background: #424242;\n    --title-container-text: #ffffff;\n    --label-color: #ffffff;\n    --alphabet-text-color: #ffffff;\n    \n    --table-background-color: #525252;\n    //--table-background-color: #dfec24;\n    --table-container-background: #525252;\n    --content-container-background: #1F1F1F;\n    --table-btn-color: #36F;\n    --toggle-close-icon-background: #36f;\n    --toggle-close-icon-color: #000000;\n    --ag-background-color: #00ff08;\n    --checkbox-description-text-color: #fff;\n    --pagination-background-color: #0F0F0F;\n    --table-header-color: #525252;\n\n    --contact-abb-blocks-background-color: #333333;\n    --sub-headings-color: #fff;\n    --icon-color: #fff;\n    --dialogue-box-background-color: #333333;\n    --dialogue-text-color: #fff;\n    --dialogue-icon-color: #fff;\n    --dialogue-box-button-color: #333333;\n    --input-description-text-color: #bdb4b4;\n    --app-reg-container-background: #424242;\n    --app-reg-first-container: #1F1F1F;\n    --app-reg-sub-heading-background: #525252;\n    --app-reg-type-name-background: #525252;\n    --app-reg-type-active-backgroung: rgb(222, 255, 229);\n    --input-disabled-background: #525252;\n    --input-disable-text-color: #B2B2B2;\n    --format-message-case-creation: #bdb4b4;\n    --privacy-policy-link-color: #36f;\n  \n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
